import { p as wQ, A as Jg, i as HB, a as mB, b as VB, c as JB, d as bB, e as OB, f as je, g as jB, h as LB, j as Le, k as We, l as yE, m as zE, n as WB, o as tE, q as YE, r as bg, s as Og, t as Xe, u as cQ, v as aQ } from "./parser-entry-jUjojdlK.js";
import { w as AI, x as EI } from "./parser-entry-jUjojdlK.js";
import * as I from "three";
import { ShapeUtils as jg, Vector2 as oQ, ShapePath as iQ } from "three";
import { NURBSCurve as IQ } from "three/addons/curves/NURBSCurve.js";
import { MapControls as FQ } from "three/addons/controls/MapControls.js";
import { EffectComposer as RQ } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass as ht } from "three/addons/postprocessing/RenderPass.js";
import { TAARenderPass as CQ } from "three/addons/postprocessing/TAARenderPass.js";
import { SSAARenderPass as DQ } from "three/addons/postprocessing/SSAARenderPass.js";
import { SMAAPass as lQ } from "three/addons/postprocessing/SMAAPass.js";
import { FXAAPass as xQ } from "three/addons/postprocessing/FXAAPass.js";
import { OutputPass as TQ } from "three/addons/postprocessing/OutputPass.js";
const Lg = `(function(){"use strict";class F{_pointer=0;_eof=!1;_data;lastReadGroup;constructor(e){this._data=e}next(){if(!this.hasNext())throw this._eof?new Error("Cannot call 'next' after EOF group has been read"):new Error("Unexpected end of input: EOF group not read before end of file. Ended on code "+this._data[this._pointer]);const e={code:parseInt(this._data[this._pointer])};return this._pointer++,e.value=w(e.code,this._data[this._pointer].trim()),this._pointer++,e.code===0&&e.value==="EOF"&&(this._eof=!0),this.lastReadGroup=e,e}peek(){if(!this.hasNext())throw this._eof?new Error("Cannot call 'peek' after EOF group has been read"):new Error("Unexpected end of input: EOF group not read before end of file. Ended on code "+this._data[this._pointer]);const e={code:parseInt(this._data[this._pointer])};return e.value=w(e.code,this._data[this._pointer+1].trim()),e}rewind(e=1){this._pointer=this._pointer-e*2,this._eof=!1}hasNext(){return!(this._eof||this._pointer>this._data.length-2)}isEOF(){return this._eof}}function w(a,e){return a<=9?e:a>=10&&a<=59?parseFloat(e):a>=60&&a<=99?parseInt(e):a>=100&&a<=109?e:a>=110&&a<=149?parseFloat(e):a>=160&&a<=179?parseInt(e):a>=210&&a<=239||a>=240&&a<=259?parseFloat(e):a>=260&&a<=269||a>=270&&a<=289?parseInt(e):a>=290&&a<=299?e==="1":a>=300&&a<=369?e:a>=370&&a<=389?parseInt(e):a>=390&&a<=399?e:a>=400&&a<=409?parseInt(e):a>=410&&a<=419?e:a>=420&&a<=429?parseInt(e):a>=430&&a<=439?e:a>=440&&a<=459?parseInt(e):a>=460&&a<=469?parseFloat(e):a>=470&&a<=481||a===999||a>=1e3&&a<=1009?e:a>=1010&&a<=1059?parseFloat(e):a>=1060&&a<=1071?parseInt(e):e}function L(a){let e=null,t=null;const l={};let i=a.next();for(;;){if(i.code===0&&i.value==="ENDSEC"){e&&(l[e]=t);break}else i.code===9?(e&&(l[e]=t),e=i.value):i.code===10?t={x:i.value}:i.code===20?t.y=i.value:i.code===30?t.z=i.value:t=i.value;i=a.next()}return i=a.next(),l}const T=[0,16711680,16776960,65280,65535,255,16711935,16777215,8421504,12632256,16711680,16744319,13369344,13395558,10027008,10046540,8323072,8339263,4980736,4990502,16727808,16752511,13382400,13401958,10036736,10051404,8331008,8343359,4985600,4992806,16744192,16760703,13395456,13408614,10046464,10056268,8339200,8347455,4990464,4995366,16760576,16768895,13408512,13415014,10056192,10061132,8347392,8351551,4995328,4997670,16776960,16777087,13421568,13421670,10000384,10000460,8355584,8355647,5000192,5000230,12582656,14679935,10079232,11717734,7510016,8755276,6258432,7307071,3755008,4344870,8388352,12582783,6736896,10079334,5019648,7510092,4161280,6258495,2509824,3755046,4194048,10485631,3394560,8375398,2529280,6264908,2064128,5209919,1264640,3099686,65280,8388479,52224,6736998,38912,5019724,32512,4161343,19456,2509862,65343,8388511,52275,6737023,38950,5019743,32543,4161359,19475,2509871,65407,8388543,52326,6737049,38988,5019762,32575,4161375,19494,2509881,65471,8388575,52377,6737074,39026,5019781,32607,4161391,19513,2509890,65535,8388607,52428,6737100,39064,5019800,32639,4161407,19532,2509900,49151,8380415,39372,6730444,29336,5014936,24447,4157311,14668,2507340,32767,8372223,26316,6724044,19608,5010072,16255,4153215,9804,2505036,16383,8364031,13260,6717388,9880,5005208,8063,4149119,4940,2502476,255,8355839,204,6710988,152,5000344,127,4145023,76,2500172,4129023,10452991,3342540,8349388,2490520,6245528,2031743,5193599,1245260,3089996,8323327,12550143,6684876,10053324,4980888,7490712,4128895,6242175,2490444,3745356,12517631,14647295,10027212,11691724,7471256,8735896,6226047,7290751,3735628,4335180,16711935,16744447,13369548,13395660,9961624,9981080,8323199,8339327,4980812,4990540,16711871,16744415,13369497,13395634,9961586,9981061,8323167,8339311,4980793,4990530,16711807,16744383,13369446,13395609,9961548,9981042,8323135,8339295,4980774,4990521,16711743,16744351,13369395,13395583,9961510,9981023,8323103,8339279,4980755,4990511,3355443,5987163,8684676,11382189,14079702,16777215];function r(a){return T[a]}function b(a){const e={};a.rewind();let t=a.next(),l=t.code;if(e.x=t.value,l+=10,t=a.next(),t.code!==l)throw new Error("Expected code for point value to be "+l+" but got "+t.code+".");return e.y=t.value,l+=10,t=a.next(),t.code!==l?(a.rewind(),e):(e.z=t.value,e)}function c(a,e){const t={},l=e.code;t.x=e.value;const i=a.next();if(i.code===l+10){t.y=i.value;const s=a.next();s.code===l+20?t.z=s.value:a.rewind()}else a.rewind();return t}function f(a,e,t){switch(e.code){case 0:a.type=e.value;break;case 5:a.handle=e.value;break;case 6:a.lineType=e.value;break;case 8:a.layer=e.value;break;case 48:a.lineTypeScale=e.value;break;case 60:a.visible=e.value===0;break;case 62:a.colorIndex=e.value;break;case 67:a.inPaperSpace=e.value!==0;break;case 100:break;case 101:for(;e.code!==0;)e=t.next();t.rewind();break;case 330:a.ownerHandle=e.value;break;case 347:a.materialObjectHandle=e.value;break;case 370:a.lineweight=e.value;break;case 420:a.color=e.value;break;case 1e3:a.extendedData||(a.extendedData={}),a.extendedData.customStrings||(a.extendedData.customStrings=[]),a.extendedData.customStrings.push(e.value);break;case 1001:a.extendedData||(a.extendedData={}),a.extendedData.applicationName=e.value;break;default:return!1}return!0}function N(a){const e={};let t=a.next();const l={VPORT:{tableRecordsProperty:"viewPorts",tableName:"viewPort",dxfSymbolName:"VPORT",parseTableRecords:()=>_(a)},LTYPE:{tableRecordsProperty:"lineTypes",tableName:"lineType",dxfSymbolName:"LTYPE",parseTableRecords:()=>I(a)},LAYER:{tableRecordsProperty:"layers",tableName:"layer",dxfSymbolName:"LAYER",parseTableRecords:()=>C(a)},STYLE:{tableRecordsProperty:"styles",tableName:"style",dxfSymbolName:"STYLE",parseTableRecords:()=>H(a)},BLOCK_RECORD:{tableRecordsProperty:"blockRecords",tableName:"blockRecord",dxfSymbolName:"BLOCK_RECORD",parseTableRecords:()=>V(a)},DIMSTYLE:{tableRecordsProperty:"dimStyles",tableName:"dimStyle",dxfSymbolName:"DIMSTYLE",parseTableRecords:()=>B(a)}};for(;t.value!=="EOF"&&!(t.code===0&&t.value==="ENDSEC");)if(t.code===0&&t.value==="TABLE"){t=a.next();const i=l[t.value];if(i)e[i.tableName]=A(a,t,i),t=a.lastReadGroup;else{for(;!a.isEOF()&&(t=a.next(),!(t.code===0&&t.value==="ENDTAB")););t=a.next()}}else t=a.next();return t=a.next(),e}function A(a,e,t){const l={};let i=a.next();for(;!(i.code===0&&i.value==="ENDTAB");)switch(i.code){case 5:l.handle=i.value,i=a.next();break;case 330:l.ownerHandle=i.value,i=a.next();break;case 100:i=a.next();break;case 70:i=a.next();break;case 0:i.value===t.dxfSymbolName?(l[t.tableRecordsProperty]=t.parseTableRecords(),i=a.lastReadGroup):i=a.next();break;default:i=a.next()}return i=a.next(),l}function C(a){const e={};let t={visible:!0,frozen:!1,locked:!1},l,i=a.next();for(;!(i.code===0&&i.value==="ENDTAB");)switch(i.code){case 2:t.name=i.value,l=i.value,i=a.next();break;case 6:t.lineType=i.value,i=a.next();break;case 62:t.visible=i.value>=0,t.colorIndex=Math.abs(i.value),t.color=r(t.colorIndex),i=a.next();break;case 70:{const s=i.value;t.frozen=(s&1)!==0,t.locked=(s&4)!==0,i=a.next();break}case 0:i.value==="LAYER"&&(e[l]=t,t={visible:!0,frozen:!1,locked:!1},l=void 0),i=a.next();break;default:i=a.next();break}return l&&(e[l]=t),e}function I(a){const e={};let t={},l=0,i="",s=a.next();for(;!(s.code===0&&s.value==="ENDTAB");)switch(s.code){case 2:t.name=s.value,i=s.value,s=a.next();break;case 3:t.description=s.value,s=a.next();break;case 73:l=s.value,l>0&&(t.pattern=[]),s=a.next();break;case 40:t.patternLength=s.value,s=a.next();break;case 49:t.pattern.push(s.value),s=a.next();break;case 0:e[i]=t,t={},s=a.next();break;default:s=a.next()}return e[i]=t,e}function H(a){const e={};let t={},l="",i=a.next();for(;!(i.code===0&&i.value==="ENDTAB");)switch(i.code){case 2:t.name=i.value,l=i.value,i=a.next();break;case 5:t.handle=i.value.toUpperCase(),i=a.next();break;case 3:t.fontFile=i.value,i=a.next();break;case 4:t.bigFont=i.value,i=a.next();break;case 40:t.fixedHeight=i.value,i=a.next();break;case 41:t.widthFactor=i.value,i=a.next();break;case 1071:{const s=i.value;s>>>25&1&&(t.bold=!0),s>>>24&1&&(t.italic=!0),i=a.next();break}case 0:i.value==="STYLE"&&(l&&(e[l]=t),t={},l=""),i=a.next();break;default:i=a.next();break}return l&&(e[l]=t),e}function _(a){const e=[];let t={},l=a.next();for(;!(l.code===0&&l.value==="ENDTAB");)switch(l.code){case 2:t.name=l.value,l=a.next();break;case 10:t.lowerLeftCorner=c(a,l),l=a.next();break;case 11:t.upperRightCorner=c(a,l),l=a.next();break;case 12:t.center=c(a,l),l=a.next();break;case 45:t.viewHeight=l.value,l=a.next();break;case 330:t.ownerHandle=l.value,l=a.next();break;case 0:l.value==="VPORT"&&(e.push(t),t={}),l=a.next();break;default:l=a.next();break}return e.push(t),e}function V(a){const e={};let t={},l="",i=a.next();for(;!(i.code===0&&i.value==="ENDTAB");)switch(i.code){case 2:t.name=i.value,l=i.value,i=a.next();break;case 5:t.handle=i.value,i=a.next();break;case 70:t.units=i.value,i=a.next();break;case 0:i.value==="BLOCK_RECORD"&&(l&&(e[l]=t),t={},l=""),i=a.next();break;default:i=a.next();break}return l&&(e[l]=t),e}function B(a){const e={};let t={},l="",i=a.next();for(;!(i.code===0&&i.value==="ENDTAB");)switch(i.code){case 2:t.name=i.value,l=i.value,i=a.next();break;case 40:t.dimscale=i.value,i=a.next();break;case 41:t.dimasz=i.value,i=a.next();break;case 44:t.dimexe=i.value,i=a.next();break;case 73:t.dimtoh=i.value,i=a.next();break;case 74:t.dimtih=i.value,i=a.next();break;case 77:t.dimtad=i.value,i=a.next();break;case 78:t.dimzin=i.value,i=a.next();break;case 140:t.dimtxt=i.value,i=a.next();break;case 142:t.dimtsz=i.value,i=a.next();break;case 147:t.dimgap=i.value,i=a.next();break;case 176:t.dimclrd=i.value,i=a.next();break;case 177:t.dimclre=i.value,i=a.next();break;case 178:t.dimclrt=i.value,i=a.next();break;case 271:t.dimdec===void 0&&(t.dimdec=i.value),i=a.next();break;case 179:t.dimadec=i.value,i=a.next();break;case 277:t.dimlunit=i.value,i=a.next();break;case 279:t.dimtmove=i.value,i=a.next();break;case 288:t.dimupt=i.value,i=a.next();break;case 289:t.dimatfit=i.value,i=a.next();break;case 340:t.dimtxstyHandle=i.value.toUpperCase(),i=a.next();break;case 341:t.dimldrblkHandle=i.value,i=a.next();break;case 342:t.dimblkHandle=i.value,i=a.next();break;case 0:i.value==="DIMSTYLE"&&(l&&(e[l]=t),t={},l=""),i=a.next();break;default:i=a.next();break}return l&&(e[l]=t),e}function G(a,e){const t={type:e.value,vertices:[]};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.vertices.unshift(b(a));break;case 11:t.vertices.push(b(a));break;case 210:t.extrusionDirection=b(a);break;case 100:break;default:f(t,e,a);break}e=a.next()}return t}function M(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.center=b(a);break;case 40:t.radius=e.value;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function z(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.center=b(a);break;case 40:t.radius=e.value;break;case 50:t.startAngle=Math.PI/180*e.value;break;case 51:t.endAngle=Math.PI/180*e.value,t.angleLength=t.endAngle-t.startAngle;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function U(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.position=b(a);break;case 39:t.thickness=e.value;break;case 210:t.extrusionDirection=b(a);break;case 100:break;default:f(t,e,a);break}e=a.next()}return t}function Y(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.center=b(a);break;case 11:t.majorAxisEndPoint=b(a);break;case 40:t.axisRatio=e.value;break;case 41:t.startAngle=e.value;break;case 42:t.endAngle=e.value;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function X(a,e){const t={type:e.value,points:[]};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.points[0]=b(a);break;case 11:t.points[1]=b(a);break;case 12:t.points[2]=b(a);break;case 13:t.points[3]=b(a);break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function W(a,e){const t={type:e.value,vertices:[]};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 70:t.edgeFlags=e.value;break;case 10:t.vertices=j(a,e),e=a.lastReadGroup;break;default:f(t,e,a);break}e=a.next()}return t}function j(a,e){const t=[];let l=!1,i=!1;const s=4;for(let n=0;n<s;n++){const o={};for(;!a.isEOF()&&!(e.code===0||i);){switch(e.code){case 10:case 11:case 12:case 13:if(l){i=!0;continue}o.x=e.value,l=!0;break;case 20:case 21:case 22:case 23:o.y=e.value;break;case 30:case 31:case 32:case 33:o.z=e.value;break;default:return t}e=a.next()}t.push(o),l=!1,i=!1}return a.rewind(),t}function K(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.startPoint=b(a);break;case 11:t.endPoint=b(a);break;case 40:t.textHeight=e.value;break;case 41:t.xScale=e.value;break;case 50:t.rotation=e.value;break;case 1:t.text=e.value;break;case 7:t.textStyle=e.value;break;case 72:t.halign=e.value;break;case 73:t.valign=e.value;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function q(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 3:t.text?t.text+=e.value:t.text=e.value;break;case 1:t.text?t.text+=e.value:t.text=e.value;break;case 7:t.textStyle=e.value;break;case 10:t.position=b(a);break;case 11:t.directionVector=b(a);break;case 40:t.height=e.value;break;case 41:t.width=e.value;break;case 50:t.rotation=e.value;break;case 71:t.attachmentPoint=e.value;break;case 72:t.drawingDirection=e.value;break;case 44:t.lineSpacingFactor=e.value;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function J(a,e){const t={type:e.value,scale:1,textStyle:"STANDARD"};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 1:t.text=e.value;break;case 2:t.tag=e.value;break;case 3:t.prompt=e.value;break;case 7:t.textStyle=e.value;break;case 10:t.startPoint=b(a);break;case 11:t.endPoint=b(a);break;case 39:t.thickness=e.value;break;case 40:t.textHeight=e.value;break;case 41:t.scale=e.value;break;case 50:t.rotation=e.value;break;case 51:t.obliqueAngle=e.value;break;case 70:t.invisible=!!(e.value&1),t.constant=!!(e.value&2),t.verificationRequired=!!(e.value&4),t.preset=!!(e.value&8);break;case 71:t.backwards=!!(e.value&2),t.mirrored=!!(e.value&4);break;case 72:t.horizontalJustification=e.value;break;case 73:t.fieldLength=e.value;break;case 74:t.verticalJustification=e.value;break;case 100:break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function Q(a,e){const t={type:e.value,scale:1,textStyle:"STANDARD"};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 1:t.text=e.value;break;case 2:t.tag=e.value;break;case 7:t.textStyle=e.value;break;case 10:t.startPoint=b(a);break;case 11:t.endPoint=b(a);break;case 39:t.thickness=e.value;break;case 40:t.textHeight=e.value;break;case 41:t.scale=e.value;break;case 50:t.rotation=e.value;break;case 51:t.obliqueAngle=e.value;break;case 70:t.invisible=!!(e.value&1),t.constant=!!(e.value&2),t.verificationRequired=!!(e.value&4),t.preset=!!(e.value&8);break;case 71:t.backwards=!!(e.value&2),t.mirrored=!!(e.value&4);break;case 72:t.horizontalJustification=e.value;break;case 73:t.fieldLength=e.value;break;case 74:t.verticalJustification=e.value;break;case 100:break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function Z(a,e){const t={type:e.value};for(e=a.next();!a.isEOF();){if(e.code===0){if(e.value==="ATTRIB"){const l=[];for(;!a.isEOF()&&e.code===0&&e.value==="ATTRIB";)l.push(Q(a,e)),e=a.lastReadGroup;l.length>0&&(t.attribs=l),e.code===0&&e.value==="SEQEND"&&(e=a.next())}break}switch(e.code){case 2:t.name=e.value;break;case 41:t.xScale=e.value;break;case 42:t.yScale=e.value;break;case 43:t.zScale=e.value;break;case 10:t.position=b(a);break;case 50:t.rotation=e.value;break;case 70:t.columnCount=e.value;break;case 71:t.rowCount=e.value;break;case 44:t.columnSpacing=e.value;break;case 45:t.rowSpacing=e.value;break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function $(a,e){let t=e.next();if(!(t.code!==1e3||t.value!=="DSTYLE")&&(t=e.next(),!(t.code!==1002||t.value!=="{")))for(t=e.next();!e.isEOF()&&!(t.code===1002&&t.value==="}")&&t.code!==0;){if(t.code===1070){const l=t.value;if(t=e.next(),t.code===0||t.code===1002&&t.value==="}")break;const i=t.value;switch(l){case 140:a.textHeight||(a.textHeight=i);break;case 41:a.arrowSize=i;break;case 40:a.dimScale=i;break;case 271:a.dimdec=i;break;case 179:a.dimadec=i;break}}t=e.next()}}function ee(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 2:t.block=e.value;break;case 3:t.styleName=e.value;break;case 10:t.anchorPoint=b(a);break;case 11:t.middleOfText=b(a);break;case 12:t.insertionPoint=b(a);break;case 13:t.linearOrAngularPoint1=b(a);break;case 14:t.linearOrAngularPoint2=b(a);break;case 15:t.diameterOrRadiusPoint=b(a);break;case 16:t.arcPoint=b(a);break;case 70:t.dimensionType=e.value;break;case 71:t.attachmentPoint=e.value;break;case 42:t.actualMeasurement=e.value;break;case 1:t.text=e.value;break;case 140:t.textHeight=e.value;break;case 50:t.angle=e.value;break;case 1001:if(e.value==="ACAD"){$(t,a),e=a.lastReadGroup;continue}f(t,e,a);break;default:f(t,e,a);break}e=a.next()}return t}function m(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.controlPoints||(t.controlPoints=[]),t.controlPoints.push(b(a));break;case 11:t.fitPoints||(t.fitPoints=[]),t.fitPoints.push(b(a));break;case 12:t.startTangent=b(a);break;case 13:t.endTangent=b(a);break;case 40:t.knotValues||(t.knotValues=[]),t.knotValues.push(e.value);break;case 41:t.weights||(t.weights=[]),t.weights.push(e.value);break;case 70:(e.value&1)!==0&&(t.closed=!0),(e.value&2)!==0&&(t.periodic=!0),(e.value&4)!==0&&(t.rational=!0),(e.value&8)!==0&&(t.planar=!0),(e.value&16)!==0&&(t.planar=!0,t.linear=!0);break;case 71:t.degreeOfSplineCurve=e.value;break;case 72:t.numberOfKnots=e.value;break;case 73:t.numberOfControlPoints=e.value;break;case 74:t.numberOfFitPoints=e.value;break;case 210:t.normalVector=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function te(a,e){const t={type:e.value,vertices:[]};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:break;case 20:break;case 30:break;case 39:t.thickness=e.value;break;case 40:t.defaultStartWidth=e.value;break;case 41:t.defaultEndWidth=e.value;break;case 70:t.shape=(e.value&1)!==0,t.includesCurveFitVertices=(e.value&2)!==0,t.includesSplineFitVertices=(e.value&4)!==0,t.is3dPolyline=(e.value&8)!==0,t.is3dPolygonMesh=(e.value&16)!==0,t.is3dPolygonMeshClosed=(e.value&32)!==0,t.isPolyfaceMesh=(e.value&64)!==0,t.hasContinuousLinetypePattern=(e.value&128)!==0;break;case 71:t.meshMVertexCount=e.value;break;case 72:t.meshNVertexCount=e.value;break;case 73:case 74:case 75:break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t.vertices=ae(a,e),t}function ae(a,e){const t=[];for(;!a.isEOF();)if(e.code===0)if(e.value==="VERTEX")t.push(ie(a,e)),e=a.lastReadGroup;else if(e.value==="SEQEND"){le(a,e);break}else break;else e=a.next();return t}function ie(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.x=e.value;break;case 20:t.y=e.value;break;case 30:t.z=e.value;break;case 40:e.value!==0&&(t.startWidth=e.value);break;case 41:e.value!==0&&(t.endWidth=e.value);break;case 42:e.value!==0&&(t.bulge=e.value);break;case 70:t.vertexFlags=e.value;break;case 50:break;case 71:t.faceA=e.value;break;case 72:t.faceB=e.value;break;case 73:t.faceC=e.value;break;case 74:t.faceD=e.value;break;default:f(t,e,a);break}e=a.next()}return t}function le(a,e){for(e=a.next();!a.isEOF()&&e.code!==0;)f({type:"SEQEND"},e,a),e=a.next()}function se(a,e){const t={type:e.value,vertices:[]};let l=0;for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 38:t.elevation=e.value;break;case 39:t.depth=e.value;break;case 70:t.shape=(e.value&1)===1,t.hasContinuousLinetypePattern=(e.value&128)===128;break;case 90:l=e.value;break;case 10:t.vertices=oe(l,a);break;case 43:e.value!==0&&(t.width=e.value);break;case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}function oe(a,e){if(!a||a<=0)throw Error("n must be greater than 0 vertices");const t=[];let l=!1,i=!1,s=e.lastReadGroup;for(let n=0;n<a;n++){const o={};for(;!e.isEOF()&&!(s.code===0||i);){switch(s.code){case 10:if(l){i=!0;continue}o.x=s.value,l=!0;break;case 20:o.y=s.value;break;case 30:o.z=s.value;break;case 40:o.startWidth=s.value;break;case 41:o.endWidth=s.value;break;case 42:s.value!==0&&(o.bulge=s.value);break;case 91:break;default:return e.rewind(),l&&t.push(o),t}s=e.next()}t.push(o),l=!1,i=!1}return e.rewind(),t}function g(a,e,t){if(e.code!==97)return e;const l=e.value,i=[];e=a.next();for(let s=0;s<l&&e.code===330;s++)i.push(String(e.value).toUpperCase()),e=a.next();return i.length>0&&(t.sourceObjectHandles=i),e}function be(a,e){const t=[];if(e.code!==93)return{path:{edges:t},curr:e};const l=e.value;e=a.next();for(let s=0;s<l&&e.code===72;s++){const n=e.value;if(e=a.next(),n===1){let o=0,d=0,v=0,k=0;for(;e.code!==0&&e.code!==72&&e.code!==92&&e.code!==93&&e.code!==97;){switch(e.code){case 10:o=e.value;break;case 20:d=e.value;break;case 11:v=e.value;break;case 21:k=e.value;break}if(e.code===21){e=a.next();break}e=a.next()}t.push({type:"line",start:{x:o,y:d},end:{x:v,y:k}})}else if(n===2){let o=0,d=0,v=0,k=0,u=0,x=!1;for(;e.code!==0&&e.code!==72&&e.code!==92&&e.code!==93&&e.code!==97;){switch(e.code){case 10:o=e.value;break;case 20:d=e.value;break;case 40:v=e.value;break;case 50:k=e.value;break;case 51:u=e.value;break;case 73:x=e.value!==0;break}if(e.code===73){e=a.next();break}e=a.next()}t.push({type:"arc",center:{x:o,y:d},radius:v,startAngle:k,endAngle:u,ccw:x})}else if(n===3){let o=0,d=0,v=0,k=0,u=1,x=0,p=0,h=!1;for(;e.code!==0&&e.code!==72&&e.code!==92&&e.code!==93&&e.code!==97;){switch(e.code){case 10:o=e.value;break;case 20:d=e.value;break;case 11:v=e.value;break;case 21:k=e.value;break;case 40:u=e.value;break;case 50:x=e.value;break;case 51:p=e.value;break;case 73:h=e.value!==0;break}if(e.code===73){e=a.next();break}e=a.next()}t.push({type:"ellipse",center:{x:o,y:d},majorAxisEndPoint:{x:v,y:k},axisRatio:u,startAngle:x,endAngle:p,ccw:h})}else if(n===4){let o=3,d=0,v=0;const k=[],u=[],x=[],p=[];for(;e.code!==0&&e.code!==72&&e.code!==92&&e.code!==93&&e.code!==75&&e.code!==76&&e.code!==98;){switch(e.code){case 94:o=e.value;break;case 73:break;case 74:break;case 95:break;case 96:d=e.value;break;case 40:k.push(e.value);break;case 10:{if(d>0&&u.length>=d)break;const y=e.value;e=a.next();const E=e.code===20?e.value:0;u.push({x:y,y:E});break}case 42:x.push(e.value);break;case 97:v=e.value;break;case 11:{if(v>0&&p.length>=v)break;const y=e.value;e=a.next();const E=e.code===21?e.value:0;p.push({x:y,y:E});break}}e=a.next()}const h={type:"spline",degree:o,knots:k,controlPoints:u};x.length>0&&(h.weights=x),p.length>0&&(h.fitPoints=p),t.push(h)}else for(;e.code!==0&&e.code!==72&&e.code!==92&&e.code!==93&&e.code!==97;)e=a.next()}const i={edges:t};return e=g(a,e,i),{path:i,curr:e}}function ne(a,e){const t=[];let l=!1;e.code===72&&(l=e.value!==0,e=a.next());let i=!1;e.code===73&&(i=e.value!==0,e=a.next());let s=0;e.code===93&&(s=e.value,e=a.next());for(let o=0;o<s;o++){let d=0,v=0,k=0;e.code===10&&(d=e.value,e=a.next()),e.code===20&&(v=e.value,e=a.next()),l&&e.code===42&&(k=e.value,e=a.next());const u={x:d,y:v};k!==0&&(u.bulge=k),t.push(u)}if(i&&t.length>0){const o=t[0];t.push({x:o.x,y:o.y,bulge:o.bulge})}const n={polylineVertices:t};return e=g(a,e,n),{path:n,curr:e}}function fe(a,e,t){const l=[];for(let i=0;i<t;i++){const s={angle:0,basePoint:{x:0,y:0},offset:{x:0,y:0},dashes:[]};let n=0;e.code===53&&(s.angle=e.value,e=a.next()),e.code===43&&(s.basePoint.x=e.value,e=a.next()),e.code===44&&(s.basePoint.y=e.value,e=a.next()),e.code===45&&(s.offset.x=e.value,e=a.next()),e.code===46&&(s.offset.y=e.value,e=a.next()),e.code===79&&(n=e.value,e=a.next());for(let o=0;o<n;o++)e.code===49&&(s.dashes.push(e.value),e=a.next());l.push(s)}return{lines:l,curr:e}}function de(a,e){const t={type:"HATCH",patternName:"",solid:!1,boundaryPaths:[]};e=a.next();let l=0,i=0;for(;!a.isEOF()&&e.code!==0;){switch(e.code){case 2:t.patternName=e.value;break;case 70:t.solid=e.value===1;break;case 91:l=e.value;break;case 92:{if(i>=l)break;const s=e.value;if(e=a.next(),s&2){const n=ne(a,e);t.boundaryPaths.push(n.path),e=n.curr}else{const n=be(a,e);t.boundaryPaths.push(n.path),e=n.curr}i++;continue}case 75:t.style=e.value;break;case 41:t.patternScale=e.value;break;case 52:t.patternAngle=e.value;break;case 78:{const s=e.value;if(s>0){e=a.next();const n=fe(a,e,s);t.patternLines=n.lines,e=n.curr;continue}break}case 210:t.extrusionDirection=b(a);break;default:f(t,e,a);break}e=a.next()}return t}const O=41;function ke(a,e){const t={type:e.value,vertices:[]};e=a.next();let l=!1,i=null;for(;!a.isEOF()&&e.code!==0;){switch(e.code){case 3:t.styleName=e.value;break;case 10:t.vertices.push(b(a));break;case 71:t.arrowHeadFlag=e.value;break;case 72:t.pathType=e.value;break;case 76:t.numVertices=e.value;break;case 340:t.annotationHandle=e.value;break;case 100:break;case 1e3:l=e.value==="DSTYLE";break;case 1002:e.value==="}"&&(l=!1,i=null);break;case 1070:l&&(i===null?i=e.value:(i===O&&(t.arrowSize=e.value),i=null));break;case 1040:l&&i!==null&&(i===O&&(t.arrowSize=e.value),i=null);break;case 1005:l&&(i=null);break;default:f(t,e,a);break}e=a.next()}return t}function P(a,e){const t={type:"MULTILEADER",leaders:[],hasArrowHead:!0};e=a.next();let l=!1,i=!1,s=!1,n=null,o=null;for(;!a.isEOF()&&e.code!==0;){switch(e.code){case 300:l=!0;break;case 301:l=!1;break;case 302:{e.value==="LEADER{"&&(i=!0,n={lines:[]});break}case 303:{i&&n&&(n.lines.length>0&&t.leaders.push(n),n=null,i=!1);break}case 304:{const d=e.value;d==="LEADER_LINE{"?(s=!0,o={vertices:[]}):i||(t.text=d);break}case 305:{s&&o&&(n&&o.vertices.length>0&&n.lines.push(o),o=null,s=!1);break}case 10:s&&o?o.vertices.push(b(a)):i&&n&&(n.lastLeaderPoint=b(a));break;case 11:i&&n&&!s&&(n.doglegVector=b(a));break;case 12:l&&!i&&(t.textPosition=b(a));break;case 40:i&&n&&!s&&(n.doglegLength=e.value);break;case 41:l&&!i&&(t.textHeight=e.value);break;case 42:l||(t.arrowSize=e.value);break;case 170:l||(t.leaderLineType=e.value);break;case 90:l&&!i?t.textColorRaw=e.value:l||(t.propertyOverrideFlag=e.value);break;case 91:l||(t.leaderLineColorRaw=e.value);break;case 340:l||(t.styleHandle=String(e.value).toUpperCase());break;case 100:break;case 171:l||(t.hasArrowHead=e.value!==0);break;default:f(t,e,a);break}e=a.next()}return t}function ve(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;)f(t,e,a),e=a.next();return t}function ue(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;)f(t,e,a),e=a.next();return t}function xe(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;)f(t,e,a),e=a.next();return t}function pe(a,e){const t={type:e.value,scale:1,justification:0,flags:0,numVertices:0,numElements:0,vertices:[]};let l=null,i=null;for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 2:t.styleName=e.value;break;case 40:t.scale=e.value;break;case 70:t.justification=e.value;break;case 71:t.flags=e.value;break;case 72:t.numVertices=e.value;break;case 73:t.numElements=e.value;break;case 10:break;case 20:case 30:break;case 11:l={x:0,y:0,z:0,direction:{x:0,y:0,z:0},miter:{x:0,y:0,z:0},elementParams:[]},t.vertices.push(l),l.x=e.value;break;case 21:l&&(l.y=e.value);break;case 31:l&&(l.z=e.value);break;case 12:l&&(l.direction=b(a));break;case 13:l&&(l.miter=b(a));break;case 74:i={params:[]},l&&l.elementParams.push(i);break;case 41:i&&i.params.push(e.value);break;case 75:case 42:break;case 210:t.extrusionDirection=b(a);break;case 100:case 340:break;default:f(t,e,a);break}e=a.next()}return t}function D(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;){switch(e.code){case 10:t.basePoint=b(a);break;case 11:t.direction=b(a);break;case 100:break;default:f(t,e,a);break}e=a.next()}return t}function he(a,e){const t={type:e.value};for(e=a.next();!a.isEOF()&&e.code!==0;)f(t,e,a),e=a.next();return t}function ce(a,e){const t={type:"REGION"};for(e=a.next();!a.isEOF()&&e.code!==0;)f(t,e,a),e=a.next();return t}const ye={LINE:G,CIRCLE:M,ARC:z,POINT:U,ELLIPSE:Y,SOLID:X,"3DFACE":W,TEXT:K,MTEXT:q,ATTDEF:J,INSERT:Z,DIMENSION:ee,SPLINE:m,HELIX:(a,e)=>{const t=m(a,{...e,value:"SPLINE"});return t.numberOfControlPoints&&t.controlPoints&&(t.controlPoints=t.controlPoints.slice(0,t.numberOfControlPoints)),t.numberOfKnots&&t.knotValues&&(t.knotValues=t.knotValues.slice(0,t.numberOfKnots)),t.numberOfFitPoints!==void 0&&t.fitPoints&&(t.fitPoints=t.fitPoints.slice(0,t.numberOfFitPoints)),t.numberOfControlPoints&&t.weights&&(t.weights=t.weights.slice(0,t.numberOfControlPoints)),t},POLYLINE:te,LWPOLYLINE:se,HATCH:de,LEADER:ke,MULTILEADER:P,MLEADER:P,VIEWPORT:ve,IMAGE:ue,WIPEOUT:xe,MLINE:pe,XLINE:D,RAY:D,"3DSOLID":he,REGION:ce};function S(a,e){const t=[],l=e?"ENDBLK":"ENDSEC";let i=0,s;for(e?s=a.lastReadGroup:s=a.next();!a.isEOF();)if(s.code===0){if(s.value===l)break;const n=ye[s.value];if(n)try{const o=n(a,s);s=a.lastReadGroup,o.handle||(o.handle=i++),t.push(o)}catch(o){for(console.warn(\`Failed to parse entity "\${s.value}":\`,o instanceof Error?o.message:o),s=a.lastReadGroup;!a.isEOF()&&s.code!==0;)s=a.next()}else{s=a.next();continue}}else s=a.next();return l==="ENDSEC"&&(s=a.next()),t}function Ee(a){const e={};let t=0,l=a.next();for(;l.value!=="EOF"&&!(l.code===0&&l.value==="ENDSEC");)if(l.code===0&&l.value==="BLOCK"){const i=we(a);l=a.lastReadGroup,i.handle||(i.handle=t++),i.name&&(e[i.name]=i)}else l=a.next();return e}function we(a){const e={};let t=a.next();for(;t.value!=="EOF";){switch(t.code){case 1:e.xrefPath=t.value,t=a.next();break;case 2:e.name=t.value,t=a.next();break;case 3:e.name2=t.value,t=a.next();break;case 5:e.handle=t.value,t=a.next();break;case 8:e.layer=t.value,t=a.next();break;case 10:e.position=c(a,t),t=a.next();break;case 67:e.paperSpace=t.value===1,t=a.next();break;case 70:t.value!==0&&(e.type=t.value),t=a.next();break;case 100:t=a.next();break;case 330:e.ownerHandle=t.value,t=a.next();break;case 0:if(t.value==="ENDBLK")break;e.entities=S(a,!0),t=a.lastReadGroup;break;default:t=a.next()}if(t.code===0&&t.value==="ENDBLK"){t=a.next();break}}return e}function me(a){const e={},t={},l=new Map;let i=a.next();for(;!a.isEOF();){if(i.code===0){if(i.value==="ENDSEC")break;if(i.value==="MLEADERSTYLE"){const o=ge(a);o.handle&&(e[o.handle.toUpperCase()]=o),i=a.lastReadGroup;continue}if(i.value==="GROUP"){const o=Oe(a);o.handle&&(t[o.handle]=o),i=a.lastReadGroup;continue}if(i.value==="DICTIONARY"){const o=Pe(a);o.handle&&l.set(o.handle,{entries:o.entries}),i=a.lastReadGroup;continue}}i=a.next()}let s;for(const{entries:o}of l.values()){const d=o.get("ACAD_GROUP");if(d){s=d.toUpperCase();break}}if(s){const o=l.get(s);if(o)for(const[d,v]of o.entries){const k=t[v.toUpperCase()];k&&(k.name=d)}}const n={mLeaderStyles:e};return Object.keys(t).length>0&&(n.groups=t),n}function ge(a){const e={handle:""};let t=a.next();for(;!a.isEOF()&&t.code!==0;){switch(t.code){case 5:e.handle=String(t.value).toUpperCase();break;case 3:e.name=String(t.value);break;case 91:e.leaderLineColorRaw=t.value;break;case 93:e.textColorRaw=t.value;break;case 94:e.blockColorRaw=t.value;break}t=a.next()}return e}function Oe(a){const e={handle:"",isUnnamed:!1,isSelectable:!1,entityHandles:[]};let t=a.next();for(;!a.isEOF()&&t.code!==0;){switch(t.code){case 5:e.handle=String(t.value).toUpperCase();break;case 300:e.description=String(t.value);break;case 70:e.isUnnamed=t.value===1;break;case 71:e.isSelectable=t.value===1;break;case 340:e.entityHandles.push(String(t.value).toUpperCase());break}t=a.next()}return e}function Pe(a){let e="";const t=new Map;let l,i=a.next();for(;!a.isEOF()&&i.code!==0;){switch(i.code){case 5:e||(e=String(i.value).toUpperCase());break;case 3:l=String(i.value);break;case 350:case 360:l!==void 0&&(t.set(l,String(i.value)),l=void 0);break}i=a.next()}return{handle:e,entries:t}}function De(a){return a.type==="HATCH"}function Se(a){return a.type==="REGION"}function R(a){if(!a||a.length===0)return;const e=new Map;for(const t of a)if(De(t))for(const l of t.boundaryPaths)for(const i of l.sourceObjectHandles??[])e.set(i,t);if(e.size!==0)for(const t of a){if(!Se(t)||t.handle==null)continue;const l=String(t.handle).toUpperCase(),i=e.get(l);if(!i)continue;const s=i.boundaryPaths.filter(n=>n.sourceObjectHandles?.includes(l));s.length!==0&&(t.contourBoundary=s,i.extrusionDirection&&(t.contourExtrusionDirection=i.extrusionDirection))}}const Re="AutoCAD Binary DXF";function Fe(a){if(a.startsWith(Re))throw new Error("Binary DXF format is not supported. Save the file as ASCII (text) DXF and try again.");const e={},t=a.split(/\\r\\n|\\r|\\n/g),l=new F(t);if(!l.hasNext())throw new Error("Empty file");let i=l.next();for(;!l.isEOF();)if(i.code===0&&i.value==="SECTION"){if(i=l.next(),i.code!==2){i=l.next();continue}i.value==="HEADER"?(e.header=L(l),i=l.lastReadGroup):i.value==="BLOCKS"?(e.blocks=Ee(l),i=l.lastReadGroup):i.value==="ENTITIES"?(e.entities=S(l,!1),i=l.lastReadGroup):i.value==="TABLES"?(e.tables=N(l),i=l.lastReadGroup):i.value==="OBJECTS"&&(e.objects=me(l),i=l.lastReadGroup)}else i=l.next();if(e.entities||(e.entities=[]),R(e.entities),e.blocks)for(const s in e.blocks)R(e.blocks[s].entities);return e}self.onmessage=a=>{const{id:e,dxfText:t}=a.data;try{const l=Fe(t);self.postMessage({id:e,success:!0,data:l})}catch(l){const i=l instanceof Error?l.message:"Unknown parsing error";self.postMessage({id:e,success:!1,error:i})}}})();
`, ut = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Lg], { type: "text/javascript;charset=utf-8" });
function hQ(A) {
  let E;
  try {
    if (E = ut && (self.URL || self.webkitURL).createObjectURL(ut), !E) throw "";
    const B = new Worker(E, {
      name: A?.name
    });
    return B.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(E);
    }), B;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Lg),
      {
        name: A?.name
      }
    );
  }
}
let iE = null, ft = !1, uQ = 0;
function fQ() {
  if (ft) return null;
  if (iE) return iE;
  try {
    return iE = new hQ(), iE;
  } catch {
    return ft = !0, null;
  }
}
function Bi(A) {
  const E = fQ();
  if (!E)
    try {
      return Promise.resolve(wQ(A));
    } catch (e) {
      const t = e instanceof Error ? e.message : "Unknown parsing error";
      return Promise.reject(new Error(`DXF file parsing error: ${t}`));
    }
  const B = ++uQ;
  return new Promise((e, t) => {
    const g = (Q) => {
      Q.data.id === B && (E.removeEventListener("message", g), E.removeEventListener("error", M), Q.data.success ? e(Q.data.data) : t(new Error(`DXF file parsing error: ${Q.data.error}`)));
    }, M = (Q) => {
      E.removeEventListener("message", g), E.removeEventListener("error", M), t(new Error(`Worker error: ${Q.message}`));
    };
    E.addEventListener("message", g), E.addEventListener("error", M), E.postMessage({ id: B, dxfText: A });
  });
}
function ei() {
  iE && (iE.terminate(), iE = null);
}
const ti = 4, gi = 350, Mi = 6, Qi = 12, si = 12, ri = 11, ni = 0.4, wi = 24, ci = 80, ai = 64, oi = 999, ii = 1e3, Ii = -2e3, Fi = 2e3, Ut = 100, zt = 1.25, Ri = "#fafafa", Ci = "#1a1a1a", Di = "#000000", li = "#ffffff", UQ = 16, XB = 5, SE = 1.5, zQ = XB * SE, YQ = 4, KB = 3, Ke = 4, Wg = 2.5, ZB = 1, WA = 64, Ze = 2, qe = 1, _e = 1.25, q = 1e-4, gE = 8, kQ = 3, dQ = 50, GQ = 2, yQ = 50, SQ = 3, Xg = 1.5, Yt = 5e4, pQ = 1e3, qB = 180, re = 32, fe = 1, PQ = 500, vQ = 100, NQ = 2e3, HQ = 5e-3;
function mQ(A, E = 1, B = 1) {
  if (!A || A.length === 0) return [];
  const e = E * B;
  return A.map((t) => t === 0 ? 0 : t * e);
}
function VQ(A, E) {
  const B = [], e = [], t = { segments: B, dots: e };
  if (A.length < 2 || E.length === 0 || !E.some((a) => a < 0)) return t;
  let g = 0, M = E[g];
  const Q = M === 0;
  let s = M >= 0 && !Q, r = M > 0 ? M : M < 0 ? Math.abs(M) : 0, w = 0, c = 0, n = 0;
  s ? (w = A[0].x, c = A[0].y, n = A[0].z ?? 0) : Q && (e.push(A[0].x, A[0].y, A[0].z ?? 0), g = (g + 1) % E.length, M = E[g], s = M > 0, r = M > 0 ? M : M < 0 ? Math.abs(M) : 0, s && (w = A[0].x, c = A[0].y, n = A[0].z ?? 0));
  for (let a = 0; a < A.length - 1; a++) {
    const o = A[a].x, D = A[a].y, R = A[a].z ?? 0, i = A[a + 1].x, C = A[a + 1].y, F = A[a + 1].z ?? 0, l = i - o, T = C - D, u = F - R, h = Math.sqrt(l * l + T * T + u * u);
    if (h < 1e-10) continue;
    const x = l / h, U = T / h, z = u / h;
    let k = 0;
    for (; k < h - 1e-10; ) {
      const P = h - k;
      if (r <= P + 1e-10) {
        k += r;
        const y = o + x * k, G = D + U * k, d = R + z * k;
        s && B.push(w, c, n, y, G, d), g = (g + 1) % E.length, M = E[g], M === 0 && (e.push(y, G, d), g = (g + 1) % E.length, M = E[g]), s = M > 0, r = M > 0 ? M : M < 0 ? Math.abs(M) : 0, s && (w = y, c = G, n = d);
      } else
        r -= P, k = h, s && (B.push(w, c, n, i, C, F), w = i, c = C, n = F);
    }
  }
  if (s) {
    const a = A[A.length - 1], o = a.x, D = a.y, R = a.z ?? 0, i = o - w, C = D - c, F = R - n;
    i * i + C * C + F * F > 1e-20 && B.push(w, c, n, o, D, R);
  }
  return { segments: B, dots: e };
}
function mA(A, E, B, e = 1, t, g = 1) {
  let M;
  const Q = A.lineType;
  if (Q) {
    const o = Q.toUpperCase();
    if (o === "CONTINUOUS") return null;
    o === "BYBLOCK" ? M = t : o === "BYLAYER" ? M = void 0 : M = Q;
  }
  if (!M) {
    const o = A.layer;
    if (o && E[o]?.lineType) {
      const D = E[o].lineType;
      if (D.toUpperCase() === "CONTINUOUS") return null;
      M = D;
    }
  }
  if (!M) return null;
  const s = M.toUpperCase(), r = Object.values(B).find(
    (o) => o.name?.toUpperCase() === s
  );
  if (!r || !r.pattern || r.pattern.length === 0 || !r.pattern.some((o) => o < 0)) return null;
  const w = A.lineTypeScale ?? 1, n = A.lineTypeScale != null ? g : e;
  return { pattern: mQ(r.pattern, w, n) };
}
function JQ(A, E) {
  if (!A) return 1;
  const B = A.$EXTMIN, e = A.$EXTMAX;
  if (!B || !e || B.x >= e.x || B.y >= e.y) return 1;
  const t = e.x - B.x, g = e.y - B.y, M = Math.max(t, g);
  if (M < vQ) return 1;
  if (E) {
    let Q = 0;
    for (const s of Object.values(E))
      if (s.pattern && s.pattern.length > 0 && s.pattern.some((r) => r < 0)) {
        const r = s.pattern.reduce((w, c) => w + Math.abs(c), 0);
        r > Q && (Q = r);
      }
    if (Q > 0 && Q / M >= HQ)
      return 1;
  }
  return Math.max(1, M / PQ);
}
const fB = "\0ACI7", xi = (A) => A ? "#ffffff" : "#000000", KA = (A) => A.charCodeAt(0) === 0;
function kt(A, E) {
  if (A === fB) return E ? "#ffffff" : "#000000";
  const B = parseInt(A.slice(4)), e = Jg[B];
  if (!E || e === void 0)
    return e !== void 0 ? _B(e) : "#000000";
  const g = 255 - (e >> 16 & 255);
  return "#" + (g << 16 | g << 8 | g).toString(16).padStart(6, "0");
}
function _B(A) {
  return "#" + (A & 16777215).toString(16).padStart(6, "0");
}
const bQ = (A) => A >= 250 && A <= 251 ? "\0ACI" + A : null;
function kE(A) {
  if (A === 7 || A === 255) return fB;
  const E = bQ(A);
  return E || _B(Jg[A]);
}
function dt(A) {
  if (A === void 0 || !Number.isFinite(A)) return null;
  const E = A < 0 ? A + 4294967296 : A;
  switch (E >>> 24 & 255) {
    case 192:
      return { method: "byLayer" };
    case 193:
      return { method: "byBlock" };
    case 194:
      return { method: "byColor", rgb: E & 16777215 };
    case 195:
      return { method: "byACI", aci: E & 255 };
    case 196:
      return { method: "byPen" };
    case 197:
      return { method: "foreground" };
    case 200:
      return { method: "none" };
    default:
      return { method: "unknown" };
  }
}
function Gt(A) {
  return A ? A.method === "byACI" && A.aci !== void 0 && A.aci >= 1 && A.aci <= 255 ? kE(A.aci) : A.method === "byColor" && A.rgb !== void 0 ? _B(A.rgb) : null : null;
}
function yt(A, E, B, e, t, g) {
  if (E) {
    const Q = Gt(dt(A));
    if (Q) return Q;
  }
  const M = Gt(dt(B));
  return M || aA(e, t, g);
}
function aA(A, E, B) {
  const e = A.colorIndex, t = A.color;
  if (e === 0)
    return B ?? fB;
  if (e !== void 0 && e >= 1 && e <= 255)
    return t !== void 0 ? _B(t) : kE(e);
  const g = A.layer;
  if ((!g || g === "0") && B !== void 0)
    return B;
  if (g && E[g]) {
    const M = E[g];
    if (M.color !== void 0 && M.color !== 0 || M.colorIndex >= 1 && M.colorIndex <= 255)
      return kE(M.colorIndex);
  }
  return fB;
}
class St {
  line = /* @__PURE__ */ new Map();
  mesh = /* @__PURE__ */ new Map();
  points = /* @__PURE__ */ new Map();
  /** Materials whose color depends on theme — maps material to its sentinel key */
  themeMaterials = /* @__PURE__ */ new Map();
  /** Current dark theme state */
  darkTheme = !1;
  /** Resolve color string — replaces theme-adaptive sentinels with concrete hex */
  resolveColor(E) {
    return KA(E) ? kt(E, this.darkTheme) : E;
  }
  /** Register a material as theme-dependent */
  trackThemeMaterial(E, B) {
    this.themeMaterials.set(E, B);
  }
  /** Update all theme-dependent materials for new theme */
  switchTheme(E) {
    this.darkTheme = E;
    for (const [B, e] of this.themeMaterials)
      B.color.set(kt(e, E));
  }
  /** Dispose all cached materials and clear the maps */
  disposeAll() {
    for (const E of this.line.values()) E.dispose();
    this.line.clear();
    for (const E of this.mesh.values()) E.dispose();
    this.mesh.clear();
    for (const E of this.points.values()) E.dispose();
    this.points.clear(), this.themeMaterials.clear();
  }
}
const PE = (A, E = !1) => A.replace(/%%[dD]/g, "°").replace(/%%[pP]/g, "±").replace(/%%[cC]/g, "⌀").replace(/%%[uUoO]/g, "").replace(/%%(\d{3})/g, (B, e) => String.fromCharCode(parseInt(e))).replace(/\^\^/g, "").replace(/\^I/g, E ? "	" : "  ").replace(/\^[A-Z]/g, "").replace(/\x04/g, "^");
function OQ(A) {
  const E = /%%[uU]/i.test(A);
  return { text: PE(A), underline: E };
}
const jQ = () => ({
  color: void 0,
  height: void 0,
  bold: !1,
  italic: !1,
  fontFamily: void 0,
  underline: !1,
  overline: !1,
  strikethrough: !1,
  widthFactor: void 0,
  obliqueAngle: void 0
}), LQ = (A) => ({ ...A }), WQ = (A, E) => {
  const B = { text: A };
  return E.color !== void 0 && (B.color = E.color), E.height !== void 0 && (B.height = E.height), E.bold && (B.bold = !0), E.italic && (B.italic = !0), E.fontFamily !== void 0 && (B.fontFamily = E.fontFamily), E.underline && (B.underline = !0), E.overline && (B.overline = !0), E.strikethrough && (B.strikethrough = !0), E.widthFactor !== void 0 && (B.widthFactor = E.widthFactor), E.obliqueAngle !== void 0 && (B.obliqueAngle = E.obliqueAngle), B;
}, XQ = (A) => A.replace(/\x01/g, "\\").replace(/\x02/g, "{").replace(/\x03/g, "}"), KQ = (A, E, B) => {
  let e = A.replace(/\\\\/g, "").replace(/\\\{/g, "").replace(/\\\}/g, "");
  e = e.replace(
    /\\U\+([0-9A-Fa-f]{4})/g,
    (c, n) => String.fromCodePoint(parseInt(n, 16))
  ), e = PE(e, !0);
  const t = jQ();
  B !== void 0 && B !== 1 && (t.widthFactor = B);
  const g = [], M = [];
  let Q = { runs: [] }, s = "";
  const r = () => {
    s.length !== 0 && (Q.runs.push(WQ(XQ(s), t)), s = "");
  }, w = () => {
    r(), M.push(Q), Q = { runs: [] };
  };
  for (let c = 0; c < e.length; ) {
    const n = e[c];
    if (n === "{") {
      r(), g.push(LQ(t)), c++;
      continue;
    }
    if (n === "}") {
      r();
      const x = g.pop();
      x && Object.assign(t, x), c++;
      continue;
    }
    if (n !== "\\") {
      s += n, c++;
      continue;
    }
    const a = e.slice(c);
    if (a.startsWith("\\P")) {
      w(), c += 2;
      continue;
    }
    if (a.startsWith("\\~")) {
      s += " ", c += 2;
      continue;
    }
    if (a.startsWith("\\N")) {
      s += " ", c += 2;
      continue;
    }
    const o = a.match(/^\\[cC](\d+);/);
    if (o) {
      r();
      const x = parseInt(o[1]);
      x === 0 || x === 256 ? t.color = void 0 : x >= 1 && x <= 255 && (t.color = kE(x)), c += o[0].length;
      continue;
    }
    const D = a.match(/^\\H([\d.]+)(x?);/i);
    if (D) {
      r();
      const x = parseFloat(D[1]), U = D[2] === "x" || D[2] === "X";
      t.height = U ? (t.height ?? E ?? 1) * x : x, c += D[0].length;
      continue;
    }
    const R = a.match(/^\\f([^;]*);/);
    if (R) {
      r();
      const x = R[1], U = x.indexOf("|"), z = (U === -1 ? x : x.slice(0, U)).trim();
      z && (t.fontFamily = z);
      const k = x.match(/\|b(\d)/), P = x.match(/\|i(\d)/);
      k && (t.bold = k[1] === "1"), P && (t.italic = P[1] === "1"), c += R[0].length;
      continue;
    }
    if (a.startsWith("\\L")) {
      r(), t.underline = !0, c += 2;
      continue;
    }
    if (a.startsWith("\\l")) {
      r(), t.underline = !1, c += 2;
      continue;
    }
    if (a.startsWith("\\O")) {
      r(), t.overline = !0, c += 2;
      continue;
    }
    if (a.startsWith("\\o")) {
      r(), t.overline = !1, c += 2;
      continue;
    }
    if (a.startsWith("\\K")) {
      r(), t.strikethrough = !0, c += 2;
      continue;
    }
    if (a.startsWith("\\k")) {
      r(), t.strikethrough = !1, c += 2;
      continue;
    }
    const i = a.match(/^\\S([^^/#;]*)([\^/#])([^;]*);/);
    if (i) {
      const x = i[1].trim(), U = i[2], z = i[3].trim();
      U === "#" ? s += `${x}/${z}` : (r(), Q.stackedTop = x, Q.stackedBottom = z), c += i[0].length;
      continue;
    }
    const C = a.match(/^\\p([^;]*);/);
    if (C) {
      const x = C[1], U = x.match(/i([+-]?[\d.]+)/);
      U && (Q.firstIndent = parseFloat(U[1]));
      const z = x.match(/l([\d.]+)/);
      z && (Q.leftMargin = parseFloat(z[1])), c += C[0].length;
      continue;
    }
    const F = a.match(/^\\W([\d.]+);/);
    if (F) {
      r();
      const x = parseFloat(F[1]);
      Number.isFinite(x) && x > 0 && (t.widthFactor = x), c += F[0].length;
      continue;
    }
    const l = a.match(/^\\Q(-?[\d.]+);/);
    if (l) {
      r();
      const x = parseFloat(l[1]);
      Number.isFinite(x) && (t.obliqueAngle = x), c += l[0].length;
      continue;
    }
    const T = a.match(/^\\[TA][^;]*;/i);
    if (T) {
      c += T[0].length;
      continue;
    }
    const u = a.match(/^\\[a-zA-Z][^;]*;/);
    if (u) {
      c += u[0].length;
      continue;
    }
    if (a.match(/^\\[a-zA-Z]/)) {
      c += 2;
      continue;
    }
    s += n, c++;
  }
  return w(), M;
}, vE = /* @__PURE__ */ new Map();
function pt(A, E, B, e) {
  const t = [];
  for (let g = 0; g < e; g++) {
    const M = g / e * Math.PI * 2;
    t.push(new oQ(A + Math.cos(M) * B, E + Math.sin(M) * B));
  }
  return t;
}
function ZQ(A, E, B, e, t) {
  const g = pt(A, E, B, t), Q = [...pt(A, E, e, t)].reverse(), s = jg.triangulateShape(g, [Q]), r = [];
  for (const c of g) r.push(c.x, c.y, 0);
  for (const c of Q) r.push(c.x, c.y, 0);
  const w = [];
  for (const [c, n, a] of s) w.push(c, n, a);
  return { positions: r, indices: w };
}
function $B(A, E, B, e, t) {
  const g = B - A, M = e - E, Q = Math.sqrt(g * g + M * M);
  if (Q === 0) return { positions: [], indices: [] };
  const s = -M / Q * t, r = g / Q * t;
  return { positions: [
    A + s,
    E + r,
    0,
    A - s,
    E - r,
    0,
    B - s,
    e - r,
    0,
    B + s,
    e + r,
    0
  ], indices: [0, 1, 2, 0, 2, 3] };
}
function Ae(A, E) {
  const B = [], e = [];
  for (const s of A) {
    const r = B.length / 3;
    for (const w of s.positions) B.push(w);
    for (const w of s.indices) e.push(w + r);
  }
  let t = 1 / 0, g = -1 / 0, M = 1 / 0, Q = -1 / 0;
  for (let s = 0; s < B.length; s += 3) {
    const r = B[s], w = B[s + 1];
    r < t && (t = r), r > g && (g = r), w < M && (M = w), w > Q && (Q = w);
  }
  return {
    positions: B,
    indices: e,
    advance: E,
    bounds: B.length > 0 ? { xMin: t, xMax: g, yMin: M, yMax: Q } : { xMin: 0, xMax: 0, yMin: 0, yMax: 0 }
  };
}
function Kg() {
  const M = ZQ(0.355, 0.35, 0.31, 0.265, 32), Q = 60 * Math.PI / 180, s = 0.31 * 1.15, r = 0.355 - Math.cos(Q) * s, w = 0.35 - Math.sin(Q) * s, c = 0.355 + Math.cos(Q) * s, n = 0.35 + Math.sin(Q) * s, a = $B(r, w, c, n, 0.045 / 2);
  return Ae([M, a], 0.73);
}
const $e = 0.571, fE = 0.056, UB = 0.514, At = 0.026, KE = 0.254, ZE = 0.451;
function LE(A) {
  return $B(fE, A, UB, A, At);
}
function Pt(A, E, B = 16) {
  const e = [];
  for (let M = 0; M < B; M++) {
    const Q = M / B, s = (M + 1) / B, r = fE + Q * (UB - fE), w = fE + s * (UB - fE), c = A + Math.sin(Q * Math.PI * 3 - Math.PI / 2) * E, n = A + Math.sin(s * Math.PI * 3 - Math.PI / 2) * E;
    e.push($B(r, c, w, n, At));
  }
  const t = [], g = [];
  for (const M of e) {
    const Q = t.length / 3;
    for (const s of M.positions) t.push(s);
    for (const s of M.indices) g.push(s + Q);
  }
  return { positions: t, indices: g };
}
function qQ() {
  const A = Pt(KE, 0.035), E = Pt(ZE, 0.035);
  return Ae([A, E], $e);
}
function _Q() {
  const A = LE(KE), E = LE(ZE), B = (fE + UB) / 2, e = 0.09, t = KE - 0.08, g = ZE + 0.08, M = $B(
    B - e,
    t,
    B + e,
    g,
    At
  );
  return Ae([A, E, M], $e);
}
function $Q() {
  const A = (KE + ZE) / 2, E = LE(KE - 0.05), B = LE(A), e = LE(ZE + 0.05);
  return Ae([E, B, e], $e);
}
vE.set("⌀", Kg);
vE.set("∅", Kg);
vE.set("≈", qQ);
vE.set("≠", _Q);
vE.set("≡", $Q);
function As(A) {
  const E = vE.get(A);
  return E ? E() : null;
}
const Es = 5, Bs = "�?";
function Zg(A, E) {
  return `${A.names.fontFamily.en ?? "font"}::${E}`;
}
const UE = /* @__PURE__ */ new Map();
let hE = null, Ue = null;
function qg(A, E) {
  const B = 1 / E, e = (A.advanceWidth ?? 0) * B, t = A.getPath(0, 0, E);
  if (t.commands.length === 0) {
    const o = {
      xMin: (A.xMin ?? 0) * B,
      xMax: (A.xMax ?? 0) * B,
      yMin: -(A.yMax ?? 0) * B,
      yMax: -(A.yMin ?? 0) * B
    };
    return { positions: [], indices: [], advance: e, bounds: o };
  }
  const g = new iQ();
  for (const o of t.commands)
    switch (o.type) {
      case "M":
        g.moveTo(o.x, o.y);
        break;
      case "L":
        g.lineTo(o.x, o.y);
        break;
      case "Q":
        g.quadraticCurveTo(o.x1, o.y1, o.x, o.y);
        break;
      case "C":
        g.bezierCurveTo(o.x1, o.y1, o.x2, o.y2, o.x, o.y);
        break;
      case "Z":
        g.currentPath && g.currentPath.closePath();
        break;
    }
  const M = g.toShapes(!0), Q = [], s = [];
  for (const o of M) {
    const D = o.extractPoints(Es), R = jg.triangulateShape(D.shape, D.holes), i = Q.length / 3;
    for (const C of D.shape)
      Q.push(C.x * B, -C.y * B, 0);
    for (const C of D.holes)
      for (const F of C)
        Q.push(F.x * B, -F.y * B, 0);
    for (const [C, F, l] of R)
      s.push(C + i, F + i, l + i);
  }
  let r = 1 / 0, w = -1 / 0, c = 1 / 0, n = -1 / 0;
  for (let o = 0; o < Q.length; o += 3) {
    const D = Q[o], R = Q[o + 1];
    D < r && (r = D), D > w && (w = D), R < c && (c = R), R > n && (n = R);
  }
  const a = Q.length > 0 ? { xMin: r, xMax: w, yMin: c, yMax: n } : { xMin: 0, xMax: 0, yMin: 0, yMax: 0 };
  return { positions: Q, indices: s, advance: e, bounds: a };
}
function es(A) {
  const E = A.names.fontFamily.en ?? "font";
  if (Ue === E) return hE;
  Ue = E, hE = null;
  for (const B of Bs) {
    const e = A.charToGlyphIndex(B);
    if (e !== 0) {
      const t = A.charToGlyph(B);
      hE = qg(t, A.unitsPerEm);
      const g = Zg(A, e);
      UE.set(g, hE);
      break;
    }
  }
  return hE;
}
function ts(A, E) {
  const B = A.charToGlyphIndex(E);
  if (B === 0) {
    const Q = `custom::${E}`, s = UE.get(Q);
    if (s) return s;
    const r = As(E);
    return r ? (UE.set(Q, r), r) : es(A);
  }
  const e = Zg(A, B), t = UE.get(e);
  if (t) return t;
  const g = A.charToGlyph(E), M = qg(g, A.unitsPerEm);
  return UE.set(e, M), M;
}
function gs() {
  UE.clear(), hE = null, Ue = null;
}
const Ms = [
  "times",
  "roman",
  "georgia",
  "garamond",
  "palatino",
  "cambria",
  "bodoni",
  "century",
  "bookman",
  "serif"
], Qs = [
  "romans",
  "romanc",
  "romand",
  "romant",
  "scripts",
  "scriptc"
], cB = /* @__PURE__ */ new Map();
function zB(A) {
  if (!A) return "sans";
  const E = cB.get(A);
  if (E) return E;
  const B = A.toLowerCase().replace(/\.shx$|\.ttf$|\.otf$/i, "");
  if (Qs.includes(B))
    return cB.set(A, "serif"), "serif";
  for (const e of Ms)
    if (B.includes(e))
      return cB.set(A, "serif"), "serif";
  return cB.set(A, "sans"), "sans";
}
function eB(A, E, B, e, t) {
  if (!B) return e;
  if (A && E) {
    const g = E[A];
    if (g?.fontFile)
      return zB(g.fontFile) === "serif" ? B : e;
  }
  return e;
}
function Et(A, E) {
  if (!A || !E) return {};
  const B = E[A];
  return B ? { bold: B.bold, italic: B.italic, widthFactor: B.widthFactor } : {};
}
var YA = /* @__PURE__ */ ((A) => (A[A.LEFT = 0] = "LEFT", A[A.CENTER = 1] = "CENTER", A[A.RIGHT = 2] = "RIGHT", A[A.ALIGNED = 3] = "ALIGNED", A[A.MIDDLE = 4] = "MIDDLE", A[A.FIT = 5] = "FIT", A))(YA || {}), tB = /* @__PURE__ */ ((A) => (A[A.BASELINE = 0] = "BASELINE", A[A.BOTTOM = 1] = "BOTTOM", A[A.MIDDLE = 2] = "MIDDLE", A[A.TOP = 3] = "TOP", A))(tB || {});
const ze = /* @__PURE__ */ new Map();
function ss() {
  ze.clear();
}
function DA(A, E) {
  const B = (A.names?.fontFamily?.en ?? "font") + "::" + E, e = ze.get(B);
  if (e) return e;
  const t = A.stringToGlyphs(E), g = [];
  let M = 0, Q = 1 / 0, s = -1 / 0, r = 1 / 0, w = -1 / 0, c = !1;
  const n = 1 / A.unitsPerEm;
  for (let o = 0; o < t.length; o++) {
    const D = ts(A, E[o]);
    if (g.push(D), D && D.positions.length > 0) {
      const R = M + D.bounds.xMin, i = M + D.bounds.xMax;
      R < Q && (Q = R), i > s && (s = i), D.bounds.yMin < r && (r = D.bounds.yMin), D.bounds.yMax > w && (w = D.bounds.yMax), c = !0;
    }
    M += D ? D.advance : (t[o].advanceWidth ?? 0) * n, o < t.length - 1 && (M += A.getKerningValue(t[o], t[o + 1]) * n);
  }
  c || (Q = 0, s = M, r = A.descender * n, w = A.ascender * n);
  const a = {
    glyphs: t,
    glyphData: g,
    totalAdvance: M,
    bounds: { xMin: Q, xMax: s, yMin: r, yMax: w }
  };
  return ze.set(B, a), a;
}
function rs(A, E, B, e = 1) {
  const t = DA(A, E), g = sE(A);
  return (t.bounds.xMax - t.bounds.xMin) * (B / g) * e;
}
function TA(A) {
  const {
    collector: E,
    layer: B,
    color: e,
    font: t,
    text: g,
    height: M,
    posZ: Q,
    transform: s,
    bold: r,
    widthFactor: w = 1,
    hAlign: c = 0,
    vAlign: n = 0,
    endPosX: a,
    endPosY: o,
    obliqueAngle: D,
    italic: R
  } = A;
  let { posX: i, posY: C, rotation: F = 0 } = A;
  if (!g || M <= 0) return;
  const l = DA(t, g);
  if (l.glyphs.length === 0) return;
  const T = sE(t), u = M / T;
  let h = u * w, x = u;
  const U = l.bounds.xMax - l.bounds.xMin;
  if (a !== void 0 && o !== void 0 && (c === 3 || c === 5)) {
    const m = a - i, b = o - C, N = Math.sqrt(m * m + b * b);
    if (F = Math.atan2(b, m), U > 0 && N > 0) {
      const f = N / U;
      c === 3 ? (h = f, x = f) : h = f;
    }
  }
  let z = 0;
  switch (c) {
    case 0:
      z = 0;
      break;
    case 1:
      z = (l.bounds.xMax + l.bounds.xMin) / 2;
      break;
    case 2:
      z = l.bounds.xMax;
      break;
    case 4:
      z = (l.bounds.xMax + l.bounds.xMin) / 2;
      break;
    case 3:
    case 5:
      z = l.bounds.xMin;
      break;
  }
  let k = 0;
  switch (n) {
    case 0:
      k = 0;
      break;
    case 1:
      k = l.bounds.yMin;
      break;
    case 2:
      k = (l.bounds.yMax + l.bounds.yMin) / 2;
      break;
    case 3:
      k = T;
      break;
  }
  c === 4 && (k = (l.bounds.yMax + l.bounds.yMin) / 2);
  const P = Math.cos(F), y = Math.sin(F), G = D ? Math.tan(D * Math.PI / 180) : R ? ws : 0;
  let d = 0;
  const S = [], v = [], j = 1 / t.unitsPerEm;
  for (let m = 0; m < l.glyphs.length; m++) {
    const b = l.glyphData[m];
    if (b && b.positions.length > 0) {
      const N = S.length / 3;
      for (let f = 0; f < b.positions.length; f += 3) {
        const p = b.positions[f] + d - z, W = b.positions[f + 1] - k, J = (G ? p + W * G : p) * h, $ = W * x;
        let QA = i + J * P - $ * y, Z = C + J * y + $ * P, _ = Q;
        if (s) {
          const MA = s[0] * QA + s[4] * Z + s[8] * _ + s[12], eA = s[1] * QA + s[5] * Z + s[9] * _ + s[13], V = s[2] * QA + s[6] * Z + s[10] * _ + s[14];
          QA = MA, Z = eA, _ = V;
        }
        S.push(QA, Z, _);
      }
      for (const f of b.indices)
        v.push(f + N);
      if (r) {
        const f = S.length / 3;
        for (let p = 0; p < b.positions.length; p += 3) {
          const W = b.positions[p] + d - z, J = b.positions[p + 1] - k, $ = ((G ? W + J * G : W) + cs) * h, QA = J * x;
          let Z = i + $ * P - QA * y, _ = C + $ * y + QA * P, MA = Q;
          if (s) {
            const eA = s[0] * Z + s[4] * _ + s[8] * MA + s[12], V = s[1] * Z + s[5] * _ + s[9] * MA + s[13], H = s[2] * Z + s[6] * _ + s[10] * MA + s[14];
            Z = eA, _ = V, MA = H;
          }
          S.push(Z, _, MA);
        }
        for (const p of b.indices)
          v.push(p + f);
      }
    }
    d += b ? b.advance : (l.glyphs[m].advanceWidth ?? 0) * j, m < l.glyphs.length - 1 && (d += t.getKerningValue(l.glyphs[m], l.glyphs[m + 1]) * j);
  }
  if (S.length >= 9 && v.length >= 3 && E.addOverlayMesh(B, e, S, v), l.totalAdvance > 0) {
    const m = sE(t);
    A.underline && ne(
      E,
      B,
      e,
      l,
      z,
      k,
      h,
      x,
      -0.15,
      i,
      C,
      Q,
      P,
      y,
      s
    ), A.strikethrough && ne(
      E,
      B,
      e,
      l,
      z,
      k,
      h,
      x,
      m * os,
      i,
      C,
      Q,
      P,
      y,
      s
    ), A.overline && ne(
      E,
      B,
      e,
      l,
      z,
      k,
      h,
      x,
      m + as,
      i,
      C,
      Q,
      P,
      y,
      s
    );
  }
}
function ne(A, E, B, e, t, g, M, Q, s, r, w, c, n, a, o) {
  const D = (e.bounds.xMin - t) * M, R = (e.bounds.xMax - t) * M, i = (s - g) * Q;
  let C = r + D * n - i * a, F = w + D * a + i * n, l = c, T = r + R * n - i * a, u = w + R * a + i * n, h = c;
  if (o) {
    const x = o[0] * C + o[4] * F + o[8] * l + o[12], U = o[1] * C + o[5] * F + o[9] * l + o[13], z = o[2] * C + o[6] * F + o[10] * l + o[14];
    C = x, F = U, l = z;
    const k = o[0] * T + o[4] * u + o[8] * h + o[12], P = o[1] * T + o[5] * u + o[9] * h + o[13], y = o[2] * T + o[6] * u + o[10] * h + o[14];
    T = k, u = P, h = y;
  }
  A.addLineSegments(E, B, [C, F, l, T, u, h]);
}
const ns = 0.7, vt = /* @__PURE__ */ new WeakMap();
function sE(A) {
  let E = vt.get(A);
  if (E !== void 0) return E;
  const e = A.tables?.os2?.sCapHeight;
  return E = e && e > 0 && A.unitsPerEm > 0 ? e / A.unitsPerEm : ns, vt.set(A, E), E;
}
const ws = Math.tan(12 * Math.PI / 180), cs = 0.02, as = 0.1, os = 0.5, is = 5 / 3, Bt = 0.6, et = 0.1, Is = 4;
function Fs(A) {
  return A === "center" ? 1 : A === "right" ? 2 : 0;
}
function Ee(A, E, B) {
  return B && A.fontFamily && zB(A.fontFamily) === "serif" ? B : E;
}
function _g(A, E, B, e) {
  if (!A.text) return 0;
  const t = Ee(A, E, B), M = (A.height ?? e) / sE(t), Q = A.widthFactor ?? 1;
  return DA(t, A.text).totalAdvance * M * Q;
}
const qE = (A, E) => ({ ...A, text: E });
function Rs(A, E, B, e, t) {
  const g = [];
  for (let s = 0; s < A.runs.length; s++) {
    const r = A.runs[s];
    if (!r.text) continue;
    const w = Ee(r, E, B), n = (r.height ?? e) / sE(w), a = r.widthFactor ?? 1, o = r.text.split(/( +)/);
    for (const D of o)
      D !== "" && g.push({
        runIdx: s,
        text: D,
        isSpace: D.charAt(0) === " ",
        adv: DA(w, D).totalAdvance * n * a
      });
  }
  if (g.length === 0) return [A];
  const M = [[]];
  let Q = 0;
  for (const s of g) {
    const r = M[M.length - 1].length === 0;
    if (!s.isSpace && !r && Q + s.adv > t * 1.02)
      M.push([s]), Q = s.adv;
    else {
      if (s.isSpace && r)
        continue;
      M[M.length - 1].push(s), Q += s.adv;
    }
  }
  return M.filter((s) => s.length > 0).map((s, r) => {
    const w = [];
    let c = -1, n = "";
    for (const a of s)
      a.runIdx !== c ? (n && w.push(qE(A.runs[c], n)), c = a.runIdx, n = a.text) : n += a.text;
    return n && w.push(qE(A.runs[c], n)), {
      runs: w,
      leftMargin: A.leftMargin,
      // Only the first wrapped line keeps the first-line indent
      firstIndent: r === 0 ? A.firstIndent : void 0
    };
  });
}
function Cs(A) {
  const E = [[]];
  for (const B of A) {
    if (!B.text) continue;
    const e = B.text.split("	");
    e[0] && E[E.length - 1].push(qE(B, e[0]));
    for (let t = 1; t < e.length; t++)
      E.push([]), e[t] && E[E.length - 1].push(qE(B, e[t]));
  }
  return E;
}
function Ds(A) {
  const {
    collector: E,
    layer: B,
    color: e,
    font: t,
    mainText: g,
    stackedTop: M,
    stackedBottom: Q,
    height: s,
    posX: r,
    posY: w,
    posZ: c,
    rotation: n,
    hAlign: a,
    transform: o,
    bold: D,
    italic: R
  } = A, i = Math.cos(n), C = Math.sin(n), F = s * Bt, l = sE(t), T = s / l, u = F / l, h = g ? DA(t, g).totalAdvance * T : 0, x = M ? DA(t, M).totalAdvance * u : 0, U = Q ? DA(t, Q).totalAdvance * u : 0, z = Math.max(x, U), k = g ? T * et : 0, P = h + k + z;
  let y = 0;
  a === "center" ? y = -P / 2 : a === "right" && (y = -P);
  const G = t.ascender / t.unitsPerEm, S = -(G * T * 0.5), v = r - S * C, j = w + S * i;
  let m = v + y * i, b = j + y * C;
  g && (TA({
    collector: E,
    layer: B,
    color: e,
    font: t,
    text: g,
    height: s,
    posX: m,
    posY: b,
    posZ: c,
    rotation: n,
    hAlign: 0,
    vAlign: 2,
    transform: o,
    bold: D,
    italic: R
  }), m += (h + k) * i, b += (h + k) * C);
  const N = s * 0.02;
  if (M) {
    const f = N, p = m - f * C, W = b + f * i;
    TA({
      collector: E,
      layer: B,
      color: e,
      font: t,
      text: M,
      height: F,
      posX: p,
      posY: W,
      posZ: c,
      rotation: n,
      hAlign: 0,
      vAlign: 0,
      transform: o,
      bold: D,
      italic: R
    });
  }
  if (Q) {
    const f = G * F, p = -N - f, W = m - p * C, J = b + p * i;
    TA({
      collector: E,
      layer: B,
      color: e,
      font: t,
      text: Q,
      height: F,
      posX: W,
      posY: J,
      posZ: c,
      rotation: n,
      hAlign: 0,
      vAlign: 0,
      transform: o,
      bold: D,
      italic: R
    });
  }
}
const $g = (A, E) => A.height ?? E;
function AM(A, E, B, e) {
  let t = 0;
  for (const g of A) t += _g(g, E, B, e);
  return t;
}
function Nt(A, E, B, e, t, g, M, Q, s, r, w, c, n, a, o, D, R) {
  if (A.length === 0) return;
  const i = AM(A, B, e, t);
  let C = 0;
  a === "center" ? C = -i / 2 : a === "right" && (C = -i);
  let F = C;
  for (const l of A) {
    if (!l.text) continue;
    const T = Ee(l, B, e), u = $g(l, t), h = Q + F * c, x = s + F * n;
    TA({
      collector: g,
      layer: M,
      color: l.color ?? E,
      font: T,
      text: l.text,
      height: u,
      posX: h,
      posY: x,
      posZ: r,
      rotation: w,
      hAlign: 0,
      vAlign: o,
      // Entity-level bold/italic is the default; an inline \f...|b0|i0; override
      // can still turn it off (or on) on a per-run basis.
      bold: l.bold ?? D,
      italic: l.italic ?? R,
      underline: l.underline,
      overline: l.overline,
      strikethrough: l.strikethrough,
      widthFactor: l.widthFactor,
      obliqueAngle: l.obliqueAngle
    }), F += _g(l, B, e, t);
  }
}
function ls(A) {
  if (A.length === 0) return A;
  const E = A.slice();
  for (; E.length > 0; ) {
    const B = E[E.length - 1], e = B.text.replace(/\t+$/, "");
    if (e === B.text) break;
    if (e === "") E.pop();
    else {
      E[E.length - 1] = qE(B, e);
      break;
    }
  }
  return E;
}
function xs(A) {
  const {
    collector: E,
    layer: B,
    color: e,
    font: t,
    lines: g,
    defaultHeight: M,
    posX: Q,
    posY: s,
    posZ: r,
    rotation: w = 0,
    attachmentPoint: c = 1,
    width: n,
    serifFont: a,
    lineSpacingFactor: o,
    bold: D,
    italic: R
  } = A;
  if (g.length === 0 || M <= 0) return;
  const i = (o || 1) * is, C = Is * M, F = [];
  for (let d = 0; d < g.length; d++) {
    const S = g[d];
    if (S.stackedTop || S.stackedBottom) {
      F.push(S);
      continue;
    }
    const v = S.runs.some((m) => m.text.includes("	"));
    let j = S.runs;
    if (v && (j = ls(j)), !v && n && n > 0) {
      const m = S.leftMargin || 0, b = n - m, N = Rs(
        S,
        t,
        a,
        M,
        b > 0 ? b : n
      );
      for (const f of N) F.push(f);
    } else
      F.push({ ...S, runs: j });
  }
  if (F.length === 0) return;
  const l = (d) => {
    let S = 0;
    for (const v of d.runs) S = Math.max(S, $g(v, M));
    return S > 0 ? S : M;
  };
  let T = 0;
  for (const d of F) T += l(d) * i;
  const u = l(F[F.length - 1]);
  T = T - u * i + u;
  const h = (c - 1) % 3, x = Math.ceil(c / 3), U = h === 1 ? "center" : h === 2 ? "right" : "left";
  let z = 0, k = 3;
  x === 2 ? (z = (T - u) / 2, k = 2) : x === 3 && (z = T - u, k = 1);
  const P = Math.cos(w), y = Math.sin(w);
  let G = 0;
  for (const d of F) {
    const S = l(d), v = d.runs[0], j = (d.leftMargin || 0) + (d.firstIndent || 0), m = z + G, b = Q - m * y + j * P, N = s + m * P + j * y;
    if (d.stackedTop || d.stackedBottom) {
      const f = d.runs.map((J) => J.text).join(""), p = v ? Ee(v, t, a) : t, W = v?.color ?? e;
      Ds({
        collector: E,
        layer: B,
        color: W,
        font: p,
        mainText: f,
        stackedTop: d.stackedTop || "",
        stackedBottom: d.stackedBottom || "",
        height: S,
        posX: b,
        posY: N,
        posZ: r,
        rotation: w,
        hAlign: U,
        bold: v?.bold ?? D,
        italic: v?.italic ?? R
      });
    } else if (d.runs.some((f) => f.text.includes("	"))) {
      const f = Cs(d.runs);
      let p = 0;
      for (let W = 0; W < f.length; W++) {
        const J = f[W];
        if (J.length > 0) {
          const $ = b + p * P, QA = N + p * y;
          Nt(
            J,
            e,
            t,
            a,
            M,
            E,
            B,
            $,
            QA,
            r,
            w,
            P,
            y,
            "left",
            k,
            D,
            R
          ), p += AM(J, t, a, M);
        }
        W < f.length - 1 && (p = Math.ceil((p + 1e-6) / C) * C);
      }
    } else
      Nt(
        d.runs,
        e,
        t,
        a,
        M,
        E,
        B,
        b,
        N,
        r,
        w,
        P,
        y,
        U,
        k,
        D,
        R
      );
    G -= S * i;
  }
}
const EM = /^(.*?)\\S([^^/#;]*)[\^/#]([^;]*);(.*)$/;
function FE(A, E, B, e = 1) {
  const t = eM(E), g = t.match(EM);
  if (g) {
    const Q = g[1].trim(), s = g[2].trim(), r = g[3].trim(), w = g[4]?.trim() || "", c = B * Bt, n = sE(A), a = B / n * e, o = c / n * e, D = Q ? DA(A, Q).totalAdvance * a : 0, R = s ? DA(A, s).totalAdvance * o : 0, i = r ? DA(A, r).totalAdvance * o : 0, C = Math.max(R, i), F = Q ? a * et : 0, l = w ? DA(A, w).totalAdvance * a : 0;
    return D + F + C + l;
  }
  const M = t.replace(/\\S[^;]*;/g, "").trim();
  return rs(A, M, B, e);
}
function OA(A) {
  const {
    collector: E,
    layer: B,
    color: e,
    font: t,
    rawText: g,
    height: M,
    posX: Q,
    posY: s,
    posZ: r,
    rotation: w = 0,
    hAlign: c = "center",
    transform: n,
    widthFactor: a = 1
  } = A, o = eM(g);
  if (!o.trim() || M <= 0) return;
  const D = o.match(EM);
  if (D) {
    const R = D[1].trim(), i = D[2].trim(), C = D[3].trim(), F = D[4]?.trim() || "", l = M * Bt, T = Math.cos(w), u = Math.sin(w), h = sE(t), x = M / h * a, U = l / h * a, z = R ? DA(t, R).totalAdvance * x : 0, k = i ? DA(t, i).totalAdvance * U : 0, P = C ? DA(t, C).totalAdvance * U : 0, y = Math.max(k, P), G = R ? x * et : 0, d = F ? DA(t, F).totalAdvance * x : 0, S = z + G + y + d;
    let v = 0;
    c === "center" ? v = -S / 2 : c === "right" && (v = -S);
    let j = Q + v * T, m = s + v * u;
    R && (TA({
      collector: E,
      layer: B,
      color: e,
      font: t,
      text: R,
      height: M,
      posX: j,
      posY: m,
      posZ: r,
      rotation: w,
      hAlign: 0,
      vAlign: 2,
      transform: n,
      widthFactor: a
    }), j += (z + G) * T, m += (z + G) * u);
    const b = M / h * 0.12, N = l / h, f = i ? DA(t, i) : null, p = C ? DA(t, C) : null, W = f ? (f.bounds.yMax - f.bounds.yMin) * N : 0, J = p ? (p.bounds.yMax - p.bounds.yMin) * N : 0, QA = (W + b + J) / 2;
    if (i && f) {
      const Z = QA - f.bounds.yMax * N, _ = (y - k) / 2, MA = j + _ * T - Z * u, eA = m + _ * u + Z * T;
      TA({
        collector: E,
        layer: B,
        color: e,
        font: t,
        text: i,
        height: l,
        posX: MA,
        posY: eA,
        posZ: r,
        rotation: w,
        hAlign: 0,
        vAlign: 0,
        transform: n,
        widthFactor: a
      });
    }
    if (C && p) {
      const Z = -QA - p.bounds.yMin * N, _ = (y - P) / 2, MA = j + _ * T - Z * u, eA = m + _ * u + Z * T;
      TA({
        collector: E,
        layer: B,
        color: e,
        font: t,
        text: C,
        height: l,
        posX: MA,
        posY: eA,
        posZ: r,
        rotation: w,
        hAlign: 0,
        vAlign: 0,
        transform: n,
        widthFactor: a
      });
    }
    if (i && C) {
      const Z = y * 0.08, _ = -Z, MA = y + Z;
      let eA = j + _ * T, V = m + _ * u, H = r, AA = j + MA * T, rA = m + MA * u, BA = r;
      if (n) {
        const tA = n[0] * eA + n[4] * V + n[8] * H + n[12], nA = n[1] * eA + n[5] * V + n[9] * H + n[13], wA = n[2] * eA + n[6] * V + n[10] * H + n[14];
        eA = tA, V = nA, H = wA;
        const iA = n[0] * AA + n[4] * rA + n[8] * BA + n[12], nE = n[1] * AA + n[5] * rA + n[9] * BA + n[13], wB = n[2] * AA + n[6] * rA + n[10] * BA + n[14];
        AA = iA, rA = nE, BA = wB;
      }
      E.addLineSegments(B, e, [eA, V, H, AA, rA, BA]);
    }
    if (F) {
      const Z = j + y * T, _ = m + y * u;
      TA({
        collector: E,
        layer: B,
        color: e,
        font: t,
        text: F,
        height: M,
        posX: Z,
        posY: _,
        posZ: r,
        rotation: w,
        hAlign: 0,
        vAlign: 2,
        transform: n,
        widthFactor: a
      });
    }
  } else {
    const R = o.replace(/\\S[^;]*;/g, "").trim();
    if (!R) return;
    const i = Fs(c);
    TA({
      collector: E,
      layer: B,
      color: e,
      font: t,
      text: R,
      height: M,
      posX: Q,
      posY: s,
      posZ: r,
      rotation: w,
      hAlign: i,
      vAlign: 2,
      transform: n,
      widthFactor: a
    });
  }
}
const Ts = /* @__PURE__ */ new Set([
  "closed-filled",
  "closed-blank",
  "open",
  "open30",
  "open-arrow",
  "datum-filled",
  "datum-blank"
]), BM = (A) => Ts.has(A), tt = (A) => {
  if (!A) return;
  let E = A.toLowerCase();
  switch (E.startsWith("_") && (E = E.slice(1)), E) {
    case "closedfilled":
      return "closed-filled";
    case "closed":
      return "closed-blank";
    case "closedblank":
      return "closed-blank";
    case "open":
      return "open";
    case "open30":
      return "open30";
    case "openarrow":
    case "open90":
      return "open-arrow";
    case "datumfilled":
      return "datum-filled";
    case "datumblank":
      return "datum-blank";
    case "dot":
      return "dot";
    case "dotsmall":
      return "dot-small";
    case "dotblank":
      return "dot-blank";
    case "dotsmallblank":
      return "dot-small-blank";
    case "origin":
      return "origin";
    case "origin2":
      return "origin2";
    case "box":
      return "box";
    case "boxfilled":
      return "box-filled";
    case "integral":
      return "integral";
    case "none":
      return "none";
    case "archtick":
    case "oblique":
    case "small":
    case "tick":
      return "tick";
    default:
      return;
  }
}, WE = 24, DE = (A, E) => {
  const B = E.x - A.x, e = E.y - A.y, t = Math.sqrt(B * B + e * e);
  return t > q ? { dirX: B / t, dirY: e / t } : { dirX: 1, dirY: 0 };
}, hs = (A, E, B, e) => {
  const { dirX: t, dirY: g } = DE(E, A), M = B / Ke, Q = g, s = -t, r = new Float32Array([
    A.x,
    A.y,
    A.z,
    A.x - t * B + Q * M,
    A.y - g * B + s * M,
    A.z,
    A.x - t * B - Q * M,
    A.y - g * B - s * M,
    A.z
  ]), w = new I.BufferGeometry();
  return w.setAttribute("position", new I.BufferAttribute(r, 3)), w.setIndex([0, 1, 2]), new I.Mesh(w, e);
}, us = (A, E, B, e) => {
  const { dirX: t, dirY: g } = DE(E, A), M = B / Ke, Q = g, s = -t, r = A.x - t * B + Q * M, w = A.y - g * B + s * M, c = A.x - t * B - Q * M, n = A.y - g * B - s * M, a = new Float32Array([
    A.x,
    A.y,
    A.z,
    r,
    w,
    A.z,
    r,
    w,
    A.z,
    c,
    n,
    A.z,
    c,
    n,
    A.z,
    A.x,
    A.y,
    A.z
  ]), o = new I.BufferGeometry();
  return o.setAttribute("position", new I.BufferAttribute(a, 3)), new I.LineSegments(o, e);
}, Ht = (A, E, B, e, t) => {
  const { dirX: g, dirY: M } = DE(E, A), Q = B / e, s = M, r = -g, w = A.x - g * B + s * Q, c = A.y - M * B + r * Q, n = A.x - g * B - s * Q, a = A.y - M * B - r * Q, o = new Float32Array([
    A.x,
    A.y,
    A.z,
    w,
    c,
    A.z,
    A.x,
    A.y,
    A.z,
    n,
    a,
    A.z
  ]), D = new I.BufferGeometry();
  return D.setAttribute("position", new I.BufferAttribute(o, 3)), new I.LineSegments(D, t);
}, mt = (A, E, B) => {
  const e = [A.x, A.y, A.z];
  for (let M = 0; M <= WE; M++) {
    const Q = M / WE * Math.PI * 2;
    e.push(A.x + E * Math.cos(Q), A.y + E * Math.sin(Q), A.z);
  }
  const t = [];
  for (let M = 1; M <= WE; M++) t.push(0, M, M + 1);
  const g = new I.BufferGeometry();
  return g.setAttribute("position", new I.Float32BufferAttribute(e, 3)), g.setIndex(t), new I.Mesh(g, B);
}, VE = (A, E, B) => {
  const e = [];
  for (let g = 0; g <= WE; g++) {
    const M = g / WE * Math.PI * 2;
    e.push(A.x + E * Math.cos(M), A.y + E * Math.sin(M), A.z);
  }
  const t = new I.BufferGeometry();
  return t.setAttribute("position", new I.Float32BufferAttribute(e, 3)), new I.Line(t, B);
}, fs = (A, E, B, e) => {
  const { dirX: t, dirY: g } = DE(E, A), M = B * 0.5, Q = (t + g) * M, s = (g - t) * M, r = new Float32Array([
    A.x - Q,
    A.y - s,
    A.z,
    A.x + Q,
    A.y + s,
    A.z
  ]), w = new I.BufferGeometry();
  return w.setAttribute("position", new I.BufferAttribute(r, 3)), new I.LineSegments(w, e);
}, Us = (A, E, B, e, t) => {
  const { dirX: g, dirY: M } = DE(B, e), Q = M, s = -g, r = [], w = [1, 1, -1, -1], c = [1, -1, -1, 1];
  for (let a = 0; a < 4; a++)
    r.push(
      A.x + g * E * w[a] + Q * E * c[a],
      A.y + M * E * w[a] + s * E * c[a],
      A.z
    );
  const n = new I.BufferGeometry();
  return n.setAttribute("position", new I.Float32BufferAttribute(r, 3)), n.setIndex([0, 1, 2, 0, 2, 3]), new I.Mesh(n, t);
}, zs = (A, E, B, e, t) => {
  const { dirX: g, dirY: M } = DE(B, e), Q = M, s = -g, r = [1, 1, -1, -1], w = [1, -1, -1, 1], c = [], n = [];
  for (let D = 0; D < 4; D++)
    c.push(A.x + g * E * r[D] + Q * E * w[D]), n.push(A.y + M * E * r[D] + s * E * w[D]);
  const a = new Float32Array([
    c[0],
    n[0],
    A.z,
    c[1],
    n[1],
    A.z,
    c[1],
    n[1],
    A.z,
    c[2],
    n[2],
    A.z,
    c[2],
    n[2],
    A.z,
    c[3],
    n[3],
    A.z,
    c[3],
    n[3],
    A.z,
    c[0],
    n[0],
    A.z
  ]), o = new I.BufferGeometry();
  return o.setAttribute("position", new I.BufferAttribute(a, 3)), new I.LineSegments(o, t);
}, Ys = (A, E, B, e) => {
  const { dirX: t, dirY: g } = DE(E, A), M = g, Q = -t, s = B * 0.5, r = B * 0.25, w = A.x - t * (s * 0.5) + M * r, c = A.y - g * (s * 0.5) + Q * r, n = A.x - t * B + t * (s * 0.5) - M * r, a = A.y - g * B + g * (s * 0.5) - Q * r, o = Math.atan2(g, t), D = [], R = 12;
  for (let C = 0; C <= R; C++) {
    const F = C / R, l = o + Math.PI * (1 - F);
    D.push(w + r * Math.cos(l), c + r * Math.sin(l), A.z);
  }
  for (let C = 0; C <= R; C++) {
    const F = C / R, l = o + Math.PI * (1 + F);
    D.push(n + r * Math.cos(l), a + r * Math.sin(l), A.z);
  }
  const i = new I.BufferGeometry();
  return i.setAttribute("position", new I.Float32BufferAttribute(D, 3)), new I.Line(i, e);
}, lE = (A) => {
  const { from: E, tip: B, size: e, kind: t, lineMaterial: g, fillMaterial: M } = A;
  switch (t) {
    case "none":
      return [];
    case "closed-filled":
    case "datum-filled":
      return [hs(B, E, e, M)];
    case "closed-blank":
    case "datum-blank":
      return [us(B, E, e, g)];
    case "open":
    case "open30":
      return [Ht(B, E, e, Ke, g)];
    case "open-arrow":
      return [Ht(B, E, e, 2, g)];
    case "tick":
      return [fs(B, E, e, g)];
    case "dot":
      return [mt(B, e / 2, M)];
    case "dot-small":
      return [mt(B, e / 4, M)];
    case "dot-blank":
      return [VE(B, e / 2, g)];
    case "dot-small-blank":
      return [VE(B, e / 4, g)];
    case "origin":
      return [VE(B, e / 2, g)];
    case "origin2":
      return [
        VE(B, e / 2, g),
        VE(B, e / 4, g)
      ];
    case "box":
      return [zs(B, e / 4, E, B, g)];
    case "box-filled":
      return [Us(B, e / 4, E, B, M)];
    case "integral":
      return [Ys(B, E, e, g)];
  }
}, qA = {
  arrowSize: KB,
  textHeight: XB,
  textGap: zQ,
  extLineDash: Ze,
  extLineGap: qe,
  extLineExtension: _e,
  arrowKind: "closed-filled",
  tickSize: 0
};
function gt(A) {
  if (!A) return { ...qA };
  const E = A.$DIMSCALE ?? 1, B = E > 0 ? E : 1, e = (A.$DIMASZ ?? KB) * B, t = (A.$DIMTXT ?? XB) * B, g = A.$DIMGAP, M = g !== void 0 ? g * B * SE * 2 : t * SE, Q = Ze * B, s = qe * B, r = (A.$DIMEXE ?? _e) * B, w = A.$DIMTSZ ?? 0, c = A.$DIMBLK, n = w > 0 ? "tick" : tt(c) ?? "closed-filled", a = n !== "tick" ? 0 : w > 0 ? w * B : e;
  return { arrowSize: e, textHeight: t, textGap: M, extLineDash: Q, extLineGap: s, extLineExtension: r, arrowKind: n, tickSize: a };
}
function ks(A, E) {
  const B = { ...A };
  if (E.textHeight !== void 0 && (B.textHeight = E.textHeight, B.textGap = E.textHeight * SE), E.arrowSize !== void 0) {
    const e = E.dimScale ?? 1;
    B.arrowSize = E.arrowSize * e;
  }
  return B;
}
function ds(A, E, B) {
  const e = { ...A }, t = B?.$DIMSCALE ?? 1, g = E.dimscale, M = (g ?? t) || 1;
  if (E.dimtxt !== void 0)
    e.textHeight = E.dimtxt * M, e.textGap = e.textHeight * SE;
  else if (g !== void 0 && g !== t) {
    const Q = B?.$DIMTXT ?? XB;
    e.textHeight = Q * M, e.textGap = e.textHeight * SE;
  }
  if (E.dimasz !== void 0)
    e.arrowSize = E.dimasz * M;
  else if (g !== void 0 && g !== t) {
    const Q = B?.$DIMASZ ?? KB;
    e.arrowSize = Q * M;
  }
  if (e.arrowKind === "tick" && e.tickSize > 0 && E.dimtsz === void 0 && (e.tickSize = e.arrowSize), g !== void 0 && g !== t && (e.extLineDash = Ze * M, e.extLineGap = qe * M), E.dimexe !== void 0)
    e.extLineExtension = E.dimexe * M;
  else if (g !== void 0 && g !== t) {
    const Q = B?.$DIMEXE ?? _e;
    e.extLineExtension = Q * M;
  }
  return e;
}
const ME = (A, E) => {
  for (const B of A)
    B.traverse((e) => {
      const t = e.material;
      t && (e.userData.dimPart = E && t === E ? "ext" : "dim");
    });
}, lA = (A, E, B, e) => {
  let t = E;
  if (e && e > 0) {
    const Q = E.x - A.x, s = E.y - A.y, r = Math.sqrt(Q * Q + s * s);
    r > q && (t = new I.Vector3(
      E.x + Q / r * e,
      E.y + s / r * e,
      E.z
    ));
  }
  const g = new I.BufferGeometry().setFromPoints([A, t]), M = new I.Line(g, B);
  return B instanceof I.LineDashedMaterial && M.computeLineDistances(), M;
}, Gs = (A) => {
  const {
    point1: E,
    point2: B,
    anchorPoint: e,
    textPos: t,
    dimLineMaterial: g,
    extensionLineMaterial: M,
    arrowMaterial: Q,
    isHorizontal: s,
    dv: r = qA
  } = A, w = [], c = (h) => s ? h.x : h.y, n = (h) => s ? h.y : h.x, a = (h, x, U) => s ? new I.Vector3(h, x, U) : new I.Vector3(x, h, U), o = Math.min(c(E), c(B)), D = Math.max(c(E), c(B)), R = n(e), i = BM(r.arrowKind) && D - o < Wg * r.arrowSize, C = r.arrowSize * (1 + ZB), F = i ? o - C : o, l = i ? D + C : D;
  if (t && !i && Math.abs(n(t) - R) < 1) {
    const h = c(t) - r.textGap / 2, x = c(t) + r.textGap / 2;
    F < h && w.push(
      lA(
        a(F, R, 0),
        a(h, R, 0),
        g
      )
    ), l > x && w.push(
      lA(
        a(x, R, 0),
        a(l, R, 0),
        g
      )
    );
  } else
    w.push(
      lA(
        a(F, R, 0),
        a(l, R, 0),
        g
      )
    );
  Math.abs(n(E) - R) > 0.1 && w.push(
    lA(
      a(c(E), n(E), 0),
      a(c(E), R, 0),
      M,
      r.extLineExtension
    )
  ), Math.abs(n(B) - R) > 0.1 && w.push(
    lA(
      a(c(B), n(B), 0),
      a(c(B), R, 0),
      M,
      r.extLineExtension
    )
  );
  const T = r.arrowKind === "tick" ? r.tickSize : r.arrowSize, u = (h, x) => {
    w.push(...lE({
      from: h,
      tip: x,
      size: T,
      kind: r.arrowKind,
      lineMaterial: g,
      fillMaterial: Q
    }));
  };
  return i ? (u(a(F, R, 0.1), a(o, R, 0.1)), u(a(l, R, 0.1), a(D, R, 0.1))) : (u(a(D, R, 0.1), a(o, R, 0.1)), u(a(o, R, 0.1), a(D, R, 0.1))), w;
}, ys = (A) => {
  const {
    point1: E,
    point2: B,
    anchorPoint: e,
    textPos: t,
    dimLineMaterial: g,
    extensionLineMaterial: M,
    arrowMaterial: Q,
    angleRad: s,
    dv: r = qA
  } = A, w = [], c = Math.cos(s), n = Math.sin(s), a = (E.x - e.x) * c + (E.y - e.y) * n, o = (B.x - e.x) * c + (B.y - e.y) * n, D = new I.Vector3(
    e.x + a * c,
    e.y + a * n,
    0
  ), R = new I.Vector3(
    e.x + o * c,
    e.y + o * n,
    0
  ), i = Math.min(a, o), C = Math.max(a, o), F = new I.Vector3(
    e.x + i * c,
    e.y + i * n,
    0
  ), l = new I.Vector3(
    e.x + C * c,
    e.y + C * n,
    0
  ), T = BM(r.arrowKind) && C - i < Wg * r.arrowSize, u = r.arrowSize * (1 + ZB), h = T ? i - u : i, x = T ? C + u : C, U = new I.Vector3(
    e.x + h * c,
    e.y + h * n,
    0
  ), z = new I.Vector3(
    e.x + x * c,
    e.y + x * n,
    0
  );
  if (t && !T) {
    const d = (t.x - e.x) * c + (t.y - e.y) * n;
    if (Math.abs(
      -(t.x - e.x) * n + (t.y - e.y) * c
    ) < 1) {
      const v = d - r.textGap / 2, j = d + r.textGap / 2;
      h < v && w.push(
        lA(
          U,
          new I.Vector3(
            e.x + v * c,
            e.y + v * n,
            0
          ),
          g
        )
      ), x > j && w.push(
        lA(
          new I.Vector3(
            e.x + j * c,
            e.y + j * n,
            0
          ),
          z,
          g
        )
      );
    } else
      w.push(lA(U, z, g));
  } else
    w.push(lA(U, z, g));
  const k = new I.Vector3(E.x, E.y, 0), P = new I.Vector3(B.x, B.y, 0);
  k.distanceTo(D) > 0.1 && w.push(lA(k, D, M, r.extLineExtension)), P.distanceTo(R) > 0.1 && w.push(lA(P, R, M, r.extLineExtension));
  const y = r.arrowKind === "tick" ? r.tickSize : r.arrowSize, G = (d, S) => {
    w.push(...lE({
      from: d,
      tip: S,
      size: y,
      kind: r.arrowKind,
      lineMaterial: g,
      fillMaterial: Q
    }));
  };
  return T ? (G(new I.Vector3(U.x, U.y, 0.1), new I.Vector3(F.x, F.y, 0.1)), G(new I.Vector3(z.x, z.y, 0.1), new I.Vector3(l.x, l.y, 0.1))) : (G(new I.Vector3(l.x, l.y, 0.1), new I.Vector3(F.x, F.y, 0.1)), G(new I.Vector3(F.x, F.y, 0.1), new I.Vector3(l.x, l.y, 0.1))), w;
}, Ss = (A, E = qA, B) => {
  let e = A.linearOrAngularPoint1, t = A.linearOrAngularPoint2;
  const g = A.anchorPoint, M = A.diameterOrRadiusPoint, Q = A.middleOfText, s = A.angle || 0;
  let r = A.text, w = !1;
  const c = (a) => B?.dimlunit === 4 ? Ns(a, B.dimzin, B.dimdec) : ZA(a, B?.dimdec, B?.dimzin);
  if (!e && !t && M && g && (e = M, t = g, w = !0), r && typeof A.actualMeasurement == "number") {
    const a = (w ? "R" : "") + c(A.actualMeasurement);
    r = r.replace(/<>/g, a);
  }
  if (!r && typeof A.actualMeasurement == "number" && (r = (w ? "R" : "") + c(A.actualMeasurement)), !r && e && t) {
    const a = t.x - e.x, o = t.y - e.y, D = (t.z || 0) - (e.z || 0), R = Math.sqrt(a * a + o * o + D * D);
    r = (w ? "R" : "") + c(R);
  }
  if (!w && r && !isNaN(parseFloat(r)) && B?.dimlunit !== 4 && (r = ZA(parseFloat(r), B?.dimdec, B?.dimzin)), !e || !t || !g || !r)
    return null;
  const n = A.textHeight || E.textHeight;
  return {
    point1: e,
    point2: t,
    anchorPoint: g,
    dimensionText: r,
    textPos: Q,
    textHeight: n,
    angle: s,
    isRadial: w
  };
}, ps = (A) => {
  const {
    point1: E,
    point2: B,
    anchorPoint: e,
    textPos: t,
    isRadial: g,
    color: M,
    angle: Q = 0,
    dv: s = qA
  } = A, r = new I.Group(), w = new I.LineBasicMaterial({ color: M }), c = new I.LineDashedMaterial({
    color: M,
    dashSize: s.extLineDash,
    gapSize: s.extLineGap
  }), n = new I.MeshBasicMaterial({
    color: M,
    side: I.DoubleSide
  });
  if (g) {
    const o = B.x, D = B.y, R = E.x, i = E.y;
    r.add(
      lA(
        new I.Vector3(o, D, 0),
        new I.Vector3(R, i, 0),
        w
      )
    );
    const C = s.arrowKind === "tick" ? s.tickSize : s.arrowSize;
    return lE({
      from: new I.Vector3(o, D, 0.1),
      tip: new I.Vector3(R, i, 0.1),
      size: C,
      kind: s.arrowKind,
      lineMaterial: w,
      fillMaterial: n
    }).forEach((l) => r.add(l)), ME([r]), r;
  }
  let a;
  if (Q !== 0 || A.forceRotated) {
    const o = Q * Math.PI / qB;
    a = ys({
      point1: E,
      point2: B,
      anchorPoint: e,
      textPos: t,
      dimLineMaterial: w,
      extensionLineMaterial: c,
      arrowMaterial: n,
      angleRad: o,
      dv: s
    });
  } else {
    const o = Math.abs(B.x - E.x), D = Math.abs(B.y - E.y), R = o >= D;
    a = Gs({
      point1: E,
      point2: B,
      anchorPoint: e,
      textPos: t,
      dimLineMaterial: w,
      extensionLineMaterial: c,
      arrowMaterial: n,
      isHorizontal: R,
      dv: s
    });
  }
  return a.forEach((o) => r.add(o)), ME([r], c), r;
}, ZA = (A, E, B) => {
  const e = E ?? YQ;
  let t = A.toFixed(e);
  const g = B === void 0 || (B & 8) !== 0, M = B !== void 0 && (B & 4) !== 0;
  return g && (t = parseFloat(t).toString()), M && (t = t.replace(/^(-?)0\./, "$1.")), t;
}, Ps = 4, vs = 8, Ns = (A, E, B) => {
  const e = A < 0 ? "-" : "", t = Math.abs(A);
  let g = Math.floor(t / 12);
  const M = t - g * 12;
  let Q = Math.floor(M);
  const s = M - Q, w = 1 << Math.min(Math.max(B ?? Ps, 0), vs);
  let c = 0, n = 1;
  if (w === 1)
    s >= 0.5 && (Q++, Q >= 12 && (g++, Q -= 12));
  else if (s > 1 / (w * 2))
    if (c = Math.round(s * w), n = w, c >= n)
      c = 0, Q++, Q >= 12 && (g++, Q -= 12);
    else {
      let R = c, i = n;
      for (; i; ) {
        const C = i;
        i = R % C, R = C;
      }
      c /= R, n /= R;
    }
  const a = c > 0, o = E ?? 0;
  let D = "";
  return Q > 0 && a ? D = Q + "\\S" + c + "/" + n + ';"' : a ? D = "\\S" + c + "/" + n + ';"' : Q > 0 && (D = Q + '"'), o === 0 ? g === 0 && !D ? e + '0"' : g === 0 ? e + D : D ? e + g + "'-" + D : e + g + "'" : g === 0 && (o & 4) !== 0 ? e + (D || '0"') : !D && (o & 8) !== 0 ? e + g + "'" : e + g + "'-" + (D || '0"');
}, eM = (A) => {
  let E = A.replace(/\\\\/g, "").replace(/\\\{/g, "").replace(/\\\}/g, "");
  return E = E.replace(/\\[Aa]\d+;/g, ""), E = E.replace(/\\[fF][^;]*;/g, ""), E = E.replace(/\\[cC]\d+;/g, ""), E = E.replace(/\\[Hh][\d.]+;/g, ""), E = E.replace(/\\[WTQA][\d.+-]+;/gi, ""), E = E.replace(/\\[LOKlok]/g, ""), E = E.replace(/\\P/g, " "), E = E.replace(/[{}]/g, ""), E = E.replace(
    /\\U\+([0-9A-Fa-f]{4})/g,
    (B, e) => String.fromCodePoint(parseInt(e, 16))
  ), E = PE(E), E = E.replace(/\x01/g, "\\").replace(/\x02/g, "{").replace(/\x03/g, "}"), E;
}, Hs = (A) => {
  const { entity: E, color: B, font: e, collector: t, layer: g, transform: M, dv: Q = qA, fmt: s } = A, r = A.textColor ?? B, w = A.widthFactor ?? 1, c = E.linearOrAngularPoint1, n = E.linearOrAngularPoint2, a = E.middleOfText;
  if (!c || !n) return null;
  let o = E.text;
  const D = E.actualMeasurement;
  if (o && typeof D == "number" && (o = o.replace(/<>/g, ZA(D, s?.dimdec, s?.dimzin))), !o && typeof D == "number" && (o = ZA(D, s?.dimdec, s?.dimzin)), !o) return null;
  const R = E.textHeight || Q.textHeight, i = [], C = new I.LineBasicMaterial({ color: B });
  let F = 0;
  a && (F = FE(e, o, R, w), OA({
    collector: t,
    layer: g,
    color: r,
    font: e,
    rawText: o,
    height: R,
    posX: a.x,
    posY: a.y,
    posZ: 0.2,
    transform: M,
    widthFactor: w
  }));
  const l = ((E.dimensionType ?? 0) & 1) !== 0, T = new I.Vector3(c.x, c.y, 0), u = new I.Vector3(n.x, n.y, 0);
  if (l) {
    const h = n.x - c.x;
    if (Math.abs(h) < q) {
      const x = a ? a.y + F / 2 : n.y, U = [T, new I.Vector3(n.x, Math.max(n.y, x), 0)], z = new I.BufferGeometry().setFromPoints(U);
      i.push(new I.Line(z, C));
    } else {
      const x = Math.abs(h) / 2, U = n.y - c.y !== 0 ? Math.sign(n.y - c.y) : 1;
      let z = n.y - U * x;
      U > 0 ? z = Math.max(z, c.y) : z = Math.min(z, c.y);
      const k = new I.Vector3(c.x, z, 0);
      if (Math.abs(z - c.y) > q) {
        const G = new I.BufferGeometry().setFromPoints([T, k]);
        i.push(new I.Line(G, C));
      }
      const P = new I.BufferGeometry().setFromPoints([k, u]);
      i.push(new I.Line(P, C));
      const y = a ? a.y + F / 2 : n.y;
      if (Math.abs(y - n.y) > q && U * (y - n.y) > 0) {
        const G = new I.BufferGeometry().setFromPoints([
          u,
          new I.Vector3(n.x, y, 0)
        ]);
        i.push(new I.Line(G, C));
      }
    }
  } else {
    const h = n.y - c.y;
    if (Math.abs(h) < q) {
      const x = a ? a.x + F / 2 : n.x, U = [T, new I.Vector3(Math.max(n.x, x), n.y, 0)], z = new I.BufferGeometry().setFromPoints(U);
      i.push(new I.Line(z, C));
    } else {
      const x = Math.abs(h) / 2, U = n.x - c.x !== 0 ? Math.sign(n.x - c.x) : 1;
      let z = n.x - U * x;
      U > 0 ? z = Math.max(z, c.x) : z = Math.min(z, c.x);
      const k = new I.Vector3(z, c.y, 0);
      if (Math.abs(z - c.x) > q) {
        const G = new I.BufferGeometry().setFromPoints([T, k]);
        i.push(new I.Line(G, C));
      }
      const P = new I.BufferGeometry().setFromPoints([k, u]);
      i.push(new I.Line(P, C));
      const y = a ? a.x + F / 2 : n.x;
      if (Math.abs(y - n.x) > q && U * (y - n.x) > 0) {
        const G = new I.BufferGeometry().setFromPoints([
          u,
          new I.Vector3(y, n.y, 0)
        ]);
        i.push(new I.Line(G, C));
      }
    }
  }
  return i.length === 0 ? null : (ME(i), i);
}, ms = (A) => {
  const { entity: E, color: B, font: e, collector: t, layer: g, transform: M, dv: Q = qA, fmt: s } = A, r = A.textColor ?? B, w = A.widthFactor ?? 1, c = E.anchorPoint, n = E.diameterOrRadiusPoint, a = E.middleOfText;
  if (!c || !n) return null;
  let o = E.text;
  const D = E.actualMeasurement ?? Math.sqrt((c.x - n.x) ** 2 + (c.y - n.y) ** 2);
  if (o) {
    const BA = "R" + ZA(D, s?.dimdec, s?.dimzin);
    o = o.replace(/<>/g, BA);
  }
  o || (o = "R" + ZA(D, s?.dimdec, s?.dimzin));
  const R = E.textHeight || Q.textHeight, i = [], C = new I.LineBasicMaterial({ color: B }), F = new I.MeshBasicMaterial({ color: B, side: I.DoubleSide }), l = Q.arrowKind === "tick" ? Q.tickSize : Q.arrowSize, T = (BA, tA) => {
    i.push(...lE({
      from: BA,
      tip: tA,
      size: l,
      kind: Q.arrowKind,
      lineMaterial: C,
      fillMaterial: F
    }));
  }, u = D, h = n.x - c.x, x = n.y - c.y, U = Math.sqrt(h * h + x * x);
  if (U < q) return null;
  const z = h / U, k = x / U, P = -k, y = z, G = A.dimtih ?? 0, d = A.dimtoh ?? 0, S = A.dimtad ?? 1, v = A.dimgap ?? R * 0.4, j = A.dimtmove ?? 0, m = ((E.dimensionType ?? 0) & 32) !== 0;
  if (!a) {
    const BA = new I.BufferGeometry().setFromPoints([
      new I.Vector3(c.x, c.y, 0),
      new I.Vector3(n.x, n.y, 0)
    ]);
    return i.push(new I.Line(BA, C)), T(
      new I.Vector3(c.x, c.y, 0.1),
      new I.Vector3(n.x, n.y, 0.1)
    ), ME(i), i;
  }
  const b = a.x - c.x, N = a.y - c.y, f = b * z + N * k, p = b * P + N * y, W = f <= u;
  if (!(W ? G !== 1 : d !== 1)) {
    const BA = new I.Vector3(n.x, n.y, 0), tA = a.y - R / 2, nA = c.x - n.x, wA = c.y - n.y, iA = Math.sqrt(nA * nA + wA * wA), nE = iA > q ? nA / iA : 1, wB = iA > q ? wA / iA : 0;
    let xE = a.x;
    if (Math.abs(wB) > q) {
      const nQ = (tA - n.y) / wB;
      xE = n.x + nQ * nE;
    }
    const Tt = FE(e, o, R, w);
    OA({
      collector: t,
      layer: g,
      color: r,
      font: e,
      rawText: o,
      height: R,
      posX: a.x,
      posY: a.y,
      posZ: 0.2,
      transform: M,
      widthFactor: w
    });
    const se = new I.Vector3(xE, tA, 0);
    i.push(new I.Line(
      new I.BufferGeometry().setFromPoints([BA, se]),
      C
    ));
    const MQ = a.x - Tt / 2, QQ = a.x + Tt / 2, sQ = xE <= a.x ? xE : MQ, rQ = xE <= a.x ? QQ : xE;
    return i.push(new I.Line(
      new I.BufferGeometry().setFromPoints([
        new I.Vector3(sQ, tA, 0),
        new I.Vector3(rQ, tA, 0)
      ]),
      C
    )), T(
      new I.Vector3(se.x, se.y, 0.1),
      new I.Vector3(n.x, n.y, 0.1)
    ), ME(i), i;
  }
  let $ = Math.atan2(k, z);
  $ > Math.PI / 2 && ($ -= Math.PI), $ < -Math.PI / 2 && ($ += Math.PI);
  const QA = -Math.sin($), Z = Math.cos($), _ = QA * P + Z * y;
  let MA = a.x, eA = a.y;
  const V = Math.abs(p) < R * 0.1;
  if (m && !V && (p >= 0 ? 1 : -1) * _ < 0) {
    const tA = -p, nA = c.x + z * f, wA = c.y + k * f;
    MA = nA + P * tA, eA = wA + y * tA;
  }
  const AA = FE(e, o, R) / 2, rA = S === 0;
  if (W) {
    const BA = Math.max(0, u - Q.arrowSize);
    if (rA && f > q) {
      const tA = Math.max(0, f - AA - v), nA = f + AA + v;
      tA > q && i.push(new I.Line(
        new I.BufferGeometry().setFromPoints([
          new I.Vector3(c.x, c.y, 0),
          new I.Vector3(c.x + z * tA, c.y + k * tA, 0)
        ]),
        C
      )), nA < BA && i.push(new I.Line(
        new I.BufferGeometry().setFromPoints([
          new I.Vector3(c.x + z * nA, c.y + k * nA, 0),
          new I.Vector3(c.x + z * BA, c.y + k * BA, 0)
        ]),
        C
      ));
    } else BA > q && i.push(new I.Line(
      new I.BufferGeometry().setFromPoints([
        new I.Vector3(c.x, c.y, 0),
        new I.Vector3(c.x + z * BA, c.y + k * BA, 0)
      ]),
      C
    ));
    T(
      new I.Vector3(c.x, c.y, 0.1),
      new I.Vector3(n.x, n.y, 0.1)
    );
  } else {
    const BA = Q.arrowSize, tA = u + BA, nA = BA * ZB, wA = rA ? f - AA - v : f + AA, iA = Math.max(wA, tA + nA);
    iA > tA && i.push(new I.Line(
      new I.BufferGeometry().setFromPoints([
        new I.Vector3(c.x + z * tA, c.y + k * tA, 0),
        new I.Vector3(c.x + z * iA, c.y + k * iA, 0)
      ]),
      C
    )), T(
      new I.Vector3(c.x + z * tA, c.y + k * tA, 0.1),
      new I.Vector3(n.x, n.y, 0.1)
    );
  }
  if (!m && j === 1) {
    const BA = S >= 1 ? v + R / 2 : 0;
    if (Math.abs(p) > BA + R) {
      const tA = c.x + z * f, nA = c.y + k * f;
      i.push(new I.Line(
        new I.BufferGeometry().setFromPoints([
          new I.Vector3(tA, nA, 0),
          new I.Vector3(MA, eA, 0)
        ]),
        C
      ));
    }
  }
  return OA({
    collector: t,
    layer: g,
    color: r,
    font: e,
    rawText: o,
    height: R,
    posX: MA,
    posY: eA,
    posZ: 0.2,
    rotation: $,
    hAlign: "center",
    transform: M,
    widthFactor: w
  }), ME(i), i;
}, Vs = (A) => {
  const { entity: E, color: B, font: e, collector: t, layer: g, transform: M, dv: Q = qA, fmt: s } = A, r = A.widthFactor ?? 1, w = A.textColor ?? B, c = E.anchorPoint, n = E.diameterOrRadiusPoint, a = E.middleOfText;
  if (!c || !n) return null;
  let o = E.text;
  const D = E.actualMeasurement ?? Math.sqrt((c.x - n.x) ** 2 + (c.y - n.y) ** 2);
  o && (o = o.replace(/<>/g, ZA(D, s?.dimdec, s?.dimzin))), o || (o = ZA(D, s?.dimdec, s?.dimzin));
  const R = E.textHeight || Q.textHeight, i = [], C = new I.LineBasicMaterial({ color: B }), F = new I.MeshBasicMaterial({ color: B, side: I.DoubleSide }), l = Q.arrowKind === "tick" ? Q.tickSize : Q.arrowSize, T = (N, f) => {
    i.push(...lE({
      from: N,
      tip: f,
      size: l,
      kind: Q.arrowKind,
      lineMaterial: C,
      fillMaterial: F
    }));
  }, u = (c.x + n.x) / 2, h = (c.y + n.y) / 2, x = u - c.x, U = h - c.y, z = Math.sqrt(x * x + U * U), k = z > q ? x / z : 1, P = z > q ? U / z : 0;
  let y = !1, G = 0, d = 0, S = 0;
  if (a && (S = z * 2, S > q)) {
    const N = (c.x - n.x) / S, f = (c.y - n.y) / S;
    G = ((a.x - n.x) * N + (a.y - n.y) * f) / S, d = -(a.x - n.x) * f + (a.y - n.y) * N, y = G >= 0 && G <= 1;
  }
  const v = y ? 1 : -1, j = new I.Vector3(
    c.x + v * k * Q.arrowSize,
    c.y + v * P * Q.arrowSize,
    0.1
  );
  T(j, new I.Vector3(c.x, c.y, 0.1));
  const m = new I.Vector3(
    n.x - v * k * Q.arrowSize,
    n.y - v * P * Q.arrowSize,
    0.1
  );
  T(m, new I.Vector3(n.x, n.y, 0.1));
  const b = new I.BufferGeometry().setFromPoints([
    new I.Vector3(n.x, n.y, 0),
    new I.Vector3(c.x, c.y, 0)
  ]);
  if (i.push(new I.Line(b, C)), a && y) {
    const N = A.dimtih !== 1;
    let f = 0, p = a.x, W = a.y;
    if (N) {
      f = Math.atan2(c.y - n.y, c.x - n.x), f > Math.PI / 2 && (f -= Math.PI), f < -Math.PI / 2 && (f += Math.PI);
      const J = ((E.dimensionType ?? 0) & 32) !== 0, $ = Math.abs(d) < R * 0.1;
      if (J && !$ && S > q) {
        const QA = (c.x - n.x) / S, Z = (c.y - n.y) / S, _ = -Z, MA = QA, eA = -Math.sin(f), V = Math.cos(f), H = eA * _ + V * MA;
        if ((d >= 0 ? 1 : -1) * H < 0) {
          const rA = G, BA = n.x + QA * (rA * S), tA = n.y + Z * (rA * S);
          p = BA - _ * d, W = tA - MA * d;
        }
      }
    }
    OA({
      collector: t,
      layer: g,
      color: w,
      font: e,
      rawText: o,
      height: R,
      posX: p,
      posY: W,
      posZ: 0.2,
      rotation: f,
      transform: M,
      widthFactor: r
    });
  } else if (a) {
    const N = (a.x - c.x) ** 2 + (a.y - c.y) ** 2, f = (a.x - n.x) ** 2 + (a.y - n.y) ** 2, p = N <= f ? c : n;
    if (A.dimtoh !== 1 && S > q) {
      const W = (p.x - u) / (S / 2), J = (p.y - h) / (S / 2), $ = (a.x - p.x) * W + (a.y - p.y) * J, Z = FE(e, o, R, r) / 2, _ = A.dimgap ?? R * 0.4, MA = Q.arrowSize * ZB, eA = Math.max($ + Z + _, Q.arrowSize + MA);
      eA > q && i.push(new I.Line(
        new I.BufferGeometry().setFromPoints([
          new I.Vector3(p.x, p.y, 0),
          new I.Vector3(p.x + W * eA, p.y + J * eA, 0)
        ]),
        C
      ));
      const V = p === c ? n : c, H = (V.x - u) / (S / 2), AA = (V.y - h) / (S / 2), rA = Q.arrowSize + MA;
      i.push(new I.Line(
        new I.BufferGeometry().setFromPoints([
          new I.Vector3(V.x, V.y, 0),
          new I.Vector3(V.x + H * rA, V.y + AA * rA, 0)
        ]),
        C
      ));
      let BA = Math.atan2(c.y - n.y, c.x - n.x);
      BA > Math.PI / 2 && (BA -= Math.PI), BA < -Math.PI / 2 && (BA += Math.PI), OA({
        collector: t,
        layer: g,
        color: w,
        font: e,
        rawText: o,
        height: R,
        posX: a.x,
        posY: a.y,
        posZ: 0.2,
        rotation: BA,
        transform: M,
        widthFactor: r
      });
    } else {
      const W = u - p.x, J = h - p.y, $ = Math.sqrt(W * W + J * J), QA = $ > q ? W / $ : 1, Z = $ > q ? J / $ : 0, _ = a.y - R / 2;
      let MA = a.x;
      if (Math.abs(Z) > q) {
        const iA = (_ - p.y) / Z;
        MA = p.x + iA * QA;
      }
      const eA = FE(e, o, R, r);
      OA({
        collector: t,
        layer: g,
        color: w,
        font: e,
        rawText: o,
        height: R,
        posX: a.x,
        posY: a.y,
        posZ: 0.2,
        transform: M,
        widthFactor: r
      });
      const V = a.x - eA / 2, H = a.x + eA / 2, AA = new I.Vector3(p.x, p.y, 0), rA = new I.Vector3(MA, _, 0), BA = new I.BufferGeometry().setFromPoints([AA, rA]);
      i.push(new I.Line(BA, C));
      const tA = MA <= a.x ? MA : V, nA = MA <= a.x ? H : MA, wA = new I.BufferGeometry().setFromPoints([
        new I.Vector3(tA, _, 0),
        new I.Vector3(nA, _, 0)
      ]);
      i.push(new I.Line(wA, C));
    }
  } else {
    const N = new I.BufferGeometry().setFromPoints([
      new I.Vector3(n.x, n.y, 0),
      new I.Vector3(c.x, c.y, 0)
    ]);
    i.push(new I.Line(N, C)), OA({
      collector: t,
      layer: g,
      color: w,
      font: e,
      rawText: o,
      height: R,
      posX: u,
      posY: h,
      posZ: 0.2,
      transform: M,
      widthFactor: r
    });
  }
  return i.length === 0 ? null : (ME(i), i);
}, Js = (A, E) => {
  const B = A.x2 - A.x1, e = A.y2 - A.y1, t = E.x2 - E.x1, g = E.y2 - E.y1, M = B * g - e * t;
  if (Math.abs(M) < q) return null;
  const Q = ((E.x1 - A.x1) * g - (E.y1 - A.y1) * t) / M;
  return { x: A.x1 + Q * B, y: A.y1 + Q * e };
}, IE = (A) => {
  const E = Math.PI * 2;
  return (A % E + E) % E;
}, we = (A, E, B) => {
  const e = IE(A), t = IE(E), g = IE(B);
  return e < t ? g >= e && g <= t : g >= e || g <= t;
}, bs = (A) => {
  const { entity: E, color: B, font: e, collector: t, layer: g, transform: M, dv: Q = qA, fmt: s } = A, r = A.textColor ?? B, w = A.widthFactor ?? 1, c = E.linearOrAngularPoint1, n = E.linearOrAngularPoint2, a = E.diameterOrRadiusPoint, o = E.anchorPoint, D = E.arcPoint, R = E.middleOfText;
  if (!c || !n || !a || !o) return null;
  let i;
  if (Math.sqrt((n.x - a.x) ** 2 + (n.y - a.y) ** 2) < q)
    i = { x: n.x, y: n.y };
  else {
    const H = Js(
      { x1: c.x, y1: c.y, x2: n.x, y2: n.y },
      { x1: a.x, y1: a.y, x2: o.x, y2: o.y }
    );
    if (!H) return null;
    i = H;
  }
  const F = [
    {
      angle: Math.atan2(c.y - i.y, c.x - i.x),
      pt: c,
      line: 1,
      dist: Math.sqrt((c.x - i.x) ** 2 + (c.y - i.y) ** 2)
    },
    {
      angle: Math.atan2(n.y - i.y, n.x - i.x),
      pt: n,
      line: 1,
      dist: Math.sqrt((n.x - i.x) ** 2 + (n.y - i.y) ** 2)
    },
    {
      angle: Math.atan2(a.y - i.y, a.x - i.x),
      pt: a,
      line: 2,
      dist: Math.sqrt((a.x - i.x) ** 2 + (a.y - i.y) ** 2)
    },
    {
      angle: Math.atan2(o.y - i.y, o.x - i.x),
      pt: o,
      line: 2,
      dist: Math.sqrt((o.x - i.x) ** 2 + (o.y - i.y) ** 2)
    }
  ], l = D ? Math.sqrt((D.x - i.x) ** 2 + (D.y - i.y) ** 2) : Math.max(...F.map((H) => H.dist)) * 0.8;
  if (l < q) return null;
  let T = 0, u = 0, h = c, x = o;
  if (D) {
    const H = Math.atan2(D.y - i.y, D.x - i.x), rA = F.filter((nA) => nA.dist > q).map((nA) => ({ ...nA, normAngle: IE(nA.angle) })).sort((nA, wA) => nA.normAngle - wA.normAngle), BA = rA.length;
    let tA = !1;
    for (let nA = 0; nA < BA; nA++) {
      const wA = rA[nA], iA = rA[(nA + 1) % BA];
      if (wA.line !== iA.line && we(wA.angle, iA.angle, H)) {
        T = wA.angle, u = iA.angle, h = wA.pt, x = iA.pt, tA = !0;
        break;
      }
    }
    if (!tA) {
      const nA = F[0].dist >= F[1].dist ? F[0] : F[1], wA = F[2].dist >= F[3].dist ? F[2] : F[3];
      we(nA.angle, wA.angle, H) ? (T = nA.angle, u = wA.angle, h = nA.pt, x = wA.pt) : (T = wA.angle, u = nA.angle, h = wA.pt, x = nA.pt);
    }
  } else {
    const H = F[0].dist >= F[1].dist ? F[0] : F[1], AA = F[2].dist >= F[3].dist ? F[2] : F[3];
    T = H.angle, u = AA.angle, h = H.pt, x = AA.pt;
  }
  let U = IE(u - T);
  U < q && (U = Math.PI * 2);
  const z = [], k = new I.LineBasicMaterial({ color: B }), P = new I.LineDashedMaterial({
    color: B,
    dashSize: Q.extLineDash,
    gapSize: Q.extLineGap
  }), y = new I.MeshBasicMaterial({ color: B, side: I.DoubleSide });
  let G = E.text;
  const d = E.actualMeasurement;
  if (typeof d == "number") {
    const H = d * qB / Math.PI, AA = ZA(H, s?.dimadec, s?.dimzin) + "°";
    G ? G = G.replace(/<>/g, AA) : G = AA;
  }
  const S = E.textHeight || Q.textHeight;
  let v, j, m, b = !1;
  if (G && R) {
    j = R.x, m = R.y, v = Math.atan2(R.y - i.y, R.x - i.x);
    const H = Math.sqrt((R.x - i.x) ** 2 + (R.y - i.y) ** 2);
    b = Math.abs(H - l) < S && we(T, u, v);
  } else {
    const H = T + U / 2, AA = l + S * 0.8;
    j = i.x + AA * Math.cos(H), m = i.y + AA * Math.sin(H), v = H;
  }
  const N = (H, AA) => {
    const rA = IE(AA - H);
    if (rA < q) return;
    const BA = Math.max(gE, Math.floor(rA * WA / (Math.PI * 2))), tA = [];
    for (let nA = 0; nA <= BA; nA++) {
      const wA = H + nA / BA * rA;
      tA.push(new I.Vector3(i.x + l * Math.cos(wA), i.y + l * Math.sin(wA), 0));
    }
    z.push(new I.Line(new I.BufferGeometry().setFromPoints(tA), k));
  };
  if (b && G && e) {
    const AA = (FE(e, G, S) / 2 + Q.textGap / 4) / l;
    N(T, v - AA), N(v + AA, u);
  } else
    N(T, u);
  const f = new I.Vector3(
    i.x + l * Math.cos(T),
    i.y + l * Math.sin(T),
    0
  ), p = new I.Vector3(
    i.x + l * Math.cos(u),
    i.y + l * Math.sin(u),
    0
  ), W = lA(
    new I.Vector3(h.x, h.y, 0),
    f,
    P,
    Q.extLineExtension
  );
  z.push(W);
  const J = lA(
    new I.Vector3(x.x, x.y, 0),
    p,
    P,
    Q.extLineExtension
  );
  z.push(J);
  const $ = Q.arrowKind === "tick" ? Q.tickSize : Q.arrowSize, QA = (H, AA) => {
    z.push(...lE({
      from: H,
      tip: AA,
      size: $,
      kind: Q.arrowKind,
      lineMaterial: k,
      fillMaterial: y
    }));
  }, Z = Q.arrowSize / l, _ = T + Z, MA = new I.Vector3(
    i.x + l * Math.cos(_),
    i.y + l * Math.sin(_),
    0.1
  );
  QA(MA, new I.Vector3(f.x, f.y, 0.1));
  const eA = u - Z, V = new I.Vector3(
    i.x + l * Math.cos(eA),
    i.y + l * Math.sin(eA),
    0.1
  );
  if (QA(V, new I.Vector3(p.x, p.y, 0.1)), G) {
    let H = v + Math.PI / 2;
    const AA = IE(H);
    AA > Math.PI / 2 && AA < Math.PI * 1.5 && (H += Math.PI), OA({
      collector: t,
      layer: g,
      color: r,
      font: e,
      rawText: G,
      height: S,
      posX: j,
      posY: m,
      posZ: 0.2,
      rotation: H,
      transform: M,
      widthFactor: w
    });
  }
  return z.length === 0 ? null : (ME(z, P), z);
}, RE = (A) => A * Math.PI / qB, Mt = (A, E) => {
  let B = E.line.get(A);
  if (!B) {
    const e = KA(A) ? E.resolveColor(A) : A;
    B = new I.LineBasicMaterial({ color: e, depthTest: !1, depthWrite: !1 }), E.line.set(A, B), KA(A) && E.trackThemeMaterial(B, A);
  }
  return B;
}, YB = (A, E) => {
  let B = E.mesh.get(A);
  if (!B) {
    const e = KA(A) ? E.resolveColor(A) : A;
    B = new I.MeshBasicMaterial({ color: e, side: I.DoubleSide, depthTest: !1, depthWrite: !1 }), E.mesh.set(A, B), KA(A) && E.trackThemeMaterial(B, A);
  }
  return B;
}, tM = (A, E) => {
  let B = E.points.get(A);
  if (!B) {
    const e = KA(A) ? E.resolveColor(A) : A;
    B = new I.PointsMaterial({
      color: e,
      size: SQ,
      sizeAttenuation: !1,
      depthTest: !1,
      depthWrite: !1
    }), E.points.set(A, B), KA(A) && E.trackThemeMaterial(B, A);
  }
  return B;
}, _E = (A, E, B) => {
  if (Math.abs(B) < q)
    return [A, E];
  const e = E.x - A.x, t = E.y - A.y, g = Math.sqrt(e * e + t * t);
  if (g < q)
    return [A, E];
  const M = 4 * Math.atan(B), Q = g / (2 * Math.sin(M / 2)), s = Q * Math.cos(M / 2), r = (A.x + E.x) / 2, w = (A.y + E.y) / 2, c = e / g, a = -(t / g), o = c, D = r + a * s, R = w + o * s, i = Math.atan2(A.y - R, A.x - D);
  let F = Math.atan2(E.y - R, E.x - D) - i;
  for (; F > Math.PI; ) F -= 2 * Math.PI;
  for (; F < -Math.PI; ) F += 2 * Math.PI;
  B > 0 && F < 0 ? F += 2 * Math.PI : B < 0 && F > 0 && (F -= 2 * Math.PI);
  const l = Math.max(
    gE,
    Math.floor(Math.abs(F) * WA / (2 * Math.PI))
  ), T = [];
  for (let u = 0; u <= l; u++) {
    const h = u / l, x = i + F * h, U = D + Math.abs(Q) * Math.cos(x), z = R + Math.abs(Q) * Math.sin(x);
    T.push(new I.Vector3(U, z, 0));
  }
  return T;
}, Ye = 0, dE = 1, Vt = 2;
class Jt {
  buffer;
  length = 0;
  constructor(E = 1024) {
    this.buffer = new Float32Array(E);
  }
  grow(E) {
    const B = Math.max(this.buffer.length * 2, this.length + E), e = new Float32Array(B);
    e.set(this.buffer.subarray(0, this.length)), this.buffer = e;
  }
  push(E) {
    this.length >= this.buffer.length && this.grow(1), this.buffer[this.length++] = E;
  }
  push3(E, B, e) {
    this.length + 3 > this.buffer.length && this.grow(3), this.buffer[this.length++] = E, this.buffer[this.length++] = B, this.buffer[this.length++] = e;
  }
  push6(E, B, e, t, g, M) {
    this.length + 6 > this.buffer.length && this.grow(6), this.buffer[this.length++] = E, this.buffer[this.length++] = B, this.buffer[this.length++] = e, this.buffer[this.length++] = t, this.buffer[this.length++] = g, this.buffer[this.length++] = M;
  }
  pushArray(E) {
    const B = E.length;
    this.length + B > this.buffer.length && this.grow(B);
    for (let e = 0; e < B; e++)
      this.buffer[this.length + e] = E[e];
    this.length += B;
  }
  /** Push flat [x,y,z, ...] array with per-vertex offset subtraction */
  pushArrayWithOffset3(E, B, e, t) {
    const g = E.length;
    this.length + g > this.buffer.length && this.grow(g);
    for (let M = 0; M < g; M += 3)
      this.buffer[this.length + M] = E[M] - B, this.buffer[this.length + M + 1] = E[M + 1] - e, this.buffer[this.length + M + 2] = E[M + 2] - t;
    this.length += g;
  }
  at(E) {
    return this.buffer[E];
  }
  /** Return a compact Float32Array copy for use in BufferAttribute */
  toFloat32Array() {
    return this.buffer.slice(0, this.length);
  }
  /** Convert to regular number[] (for block templates and tests) */
  toArray() {
    return Array.from(this.buffer.subarray(0, this.length));
  }
}
class Os {
  buffer;
  length = 0;
  constructor(E = 1024) {
    this.buffer = new Uint32Array(E);
  }
  grow(E) {
    const B = Math.max(this.buffer.length * 2, this.length + E), e = new Uint32Array(B);
    e.set(this.buffer.subarray(0, this.length)), this.buffer = e;
  }
  pushArrayWithOffset(E, B) {
    const e = E.length;
    this.length + e > this.buffer.length && this.grow(e);
    for (let t = 0; t < e; t++)
      this.buffer[this.length + t] = E[t] + B;
    this.length += e;
  }
  at(E) {
    return this.buffer[E];
  }
  /** Return a compact Uint32Array copy for BufferAttribute index */
  toUint32Array() {
    return this.buffer.slice(0, this.length);
  }
  /** Convert to regular number[] (for block templates and tests) */
  toArray() {
    return Array.from(this.buffer.subarray(0, this.length));
  }
}
class bA {
  /** Line segment pairs: flat [x,y,z, x,y,z, ...] per key */
  lineSegments = /* @__PURE__ */ new Map();
  /** Point positions (POINT entities): flat [x,y,z, ...] per key */
  points = /* @__PURE__ */ new Map();
  /** Linetype dot positions (smaller size): flat [x,y,z, ...] per key */
  linetypeDots = /* @__PURE__ */ new Map();
  /** Mesh vertex positions: flat [x,y,z, ...] per key */
  meshVertices = /* @__PURE__ */ new Map();
  /** Mesh triangle indices per key */
  meshIndices = /* @__PURE__ */ new Map();
  /** Overlay mesh vertices (text + arrows) rendered on top of everything */
  overlayVertices = /* @__PURE__ */ new Map();
  /** Overlay mesh triangle indices */
  overlayIndices = /* @__PURE__ */ new Map();
  /** Origin offset subtracted from all coordinates for Float32 precision */
  ox;
  oy;
  oz;
  constructor(E) {
    this.ox = E?.x ?? 0, this.oy = E?.y ?? 0, this.oz = E?.z ?? 0;
  }
  static makeKey(E, B) {
    return `${E}::${B}`;
  }
  getOrCreateFloat32(E, B) {
    let e = E.get(B);
    return e || (e = new Jt(), E.set(B, e)), e;
  }
  /**
   * Add a continuous polyline as segment pairs.
   * [p0,p1,p2,p3] → pairs [p0,p1, p1,p2, p2,p3]
   */
  addLineFromPoints(E, B, e) {
    if (e.length < 2) return;
    const t = bA.makeKey(E, B), g = this.getOrCreateFloat32(this.lineSegments, t), { ox: M, oy: Q, oz: s } = this;
    for (let r = 0; r < e.length - 1; r++) {
      const w = e[r], c = e[r + 1];
      g.push6(w.x - M, w.y - Q, w.z - s, c.x - M, c.y - Q, c.z - s);
    }
  }
  /**
   * Add pre-built line segment data (flat array, already paired).
   * Used for patterned lines (LineSegments from applyLinetypePattern).
   */
  addLineSegments(E, B, e) {
    if (e.length < 6) return;
    const t = bA.makeKey(E, B);
    this.getOrCreateFloat32(this.lineSegments, t).pushArrayWithOffset3(e, this.ox, this.oy, this.oz);
  }
  /** Add point positions (flat [x,y,z, ...]) */
  addPoints(E, B, e) {
    if (e.length < 3) return;
    const t = bA.makeKey(E, B);
    this.getOrCreateFloat32(this.points, t).pushArrayWithOffset3(e, this.ox, this.oy, this.oz);
  }
  /** Add a single point */
  addPoint(E, B, e, t, g) {
    const M = bA.makeKey(E, B);
    this.getOrCreateFloat32(this.points, M).push3(e - this.ox, t - this.oy, g - this.oz);
  }
  /** Add linetype dot positions (rendered with smaller LINETYPE_DOT_SIZE) */
  addLinetypeDots(E, B, e) {
    if (e.length < 3) return;
    const t = bA.makeKey(E, B);
    this.getOrCreateFloat32(this.linetypeDots, t).pushArrayWithOffset3(e, this.ox, this.oy, this.oz);
  }
  /**
   * Add mesh triangles (vertices + indices).
   * Indices are offset by the current vertex count for this key.
   */
  addMesh(E, B, e, t) {
    this.addMeshToBuffers(this.meshVertices, this.meshIndices, E, B, e, t);
  }
  /**
   * Add overlay mesh triangles (text glyphs + dimension/leader arrows).
   * Rendered last in flush() — on top of lines and regular meshes.
   */
  addOverlayMesh(E, B, e, t) {
    this.addMeshToBuffers(this.overlayVertices, this.overlayIndices, E, B, e, t);
  }
  addMeshToBuffers(E, B, e, t, g, M) {
    if (g.length < 9 || M.length < 3) return;
    const Q = bA.makeKey(e, t);
    let s = E.get(Q);
    s || (s = new Jt(), E.set(Q, s));
    let r = B.get(Q);
    r || (r = new Os(), B.set(Q, r));
    const w = s.length / 3;
    r.pushArrayWithOffset(M, w), s.pushArrayWithOffset3(g, this.ox, this.oy, this.oz);
  }
  /**
   * Create merged Three.js objects from accumulated data.
   * Returns array of objects with userData.layerName set.
   * Buffers exceeding MAX_BUFFER_VERTICES are split into multiple objects
   * to stay within WebGL draw call limits.
   */
  flush(E) {
    const B = [];
    for (const [t, g] of this.meshVertices) {
      const M = this.meshIndices.get(t);
      if (!M || g.length < 9 || M.length < 3) continue;
      const [Q, s] = JE(t), r = YB(s, E);
      if (g.length / 3 <= cE) {
        const c = new I.BufferGeometry();
        c.setAttribute("position", new I.BufferAttribute(g.toFloat32Array(), 3)), c.setIndex(new I.BufferAttribute(M.toUint32Array(), 1));
        const n = new I.Mesh(c, r);
        n.frustumCulled = !1, n.renderOrder = Ye, n.userData.layerName = Q, B.push(n);
      } else {
        const c = g.toFloat32Array(), n = M.toUint32Array();
        for (let a = 0; a < n.length; a += cE * 3) {
          const o = Math.min(a + cE * 3, n.length), D = new I.BufferGeometry();
          D.setAttribute("position", new I.BufferAttribute(c, 3)), D.setIndex(new I.BufferAttribute(n.slice(a, o), 1));
          const R = new I.Mesh(D, r);
          R.frustumCulled = !1, R.renderOrder = Ye, R.userData.layerName = Q, B.push(R);
        }
      }
    }
    for (const [t, g] of this.lineSegments) {
      if (g.length < 6) continue;
      const [M, Q] = JE(t), s = Mt(Q, E);
      ce(g, M, 3, B, (r, w) => {
        const c = new I.BufferGeometry();
        c.setAttribute("position", r);
        const n = new I.LineSegments(c, s);
        return n.frustumCulled = !1, n.renderOrder = dE, n.userData.layerName = w, n;
      });
    }
    for (const [t, g] of this.points) {
      if (g.length < 3) continue;
      const [M, Q] = JE(t), s = tM(Q, E);
      ce(g, M, 3, B, (r, w) => {
        const c = new I.BufferGeometry();
        c.setAttribute("position", r);
        const n = new I.Points(c, s);
        return n.frustumCulled = !1, n.renderOrder = dE, n.userData.layerName = w, n;
      });
    }
    const e = /* @__PURE__ */ new Map();
    for (const [t, g] of this.linetypeDots) {
      if (g.length < 3) continue;
      const [M, Q] = JE(t);
      let s = e.get(Q);
      if (!s) {
        const r = E.resolveColor(Q);
        s = new I.PointsMaterial({
          color: r,
          size: Xg,
          sizeAttenuation: !1,
          depthTest: !1,
          depthWrite: !1
        }), e.set(Q, s), KA(Q) && E.trackThemeMaterial(s, Q);
      }
      ce(g, M, 3, B, (r, w) => {
        const c = new I.BufferGeometry();
        c.setAttribute("position", r);
        const n = new I.Points(c, s);
        return n.frustumCulled = !1, n.renderOrder = dE, n.userData.layerName = w, n;
      });
    }
    for (const [t, g] of this.overlayVertices) {
      const M = this.overlayIndices.get(t);
      if (!M || g.length < 9 || M.length < 3) continue;
      const [Q, s] = JE(t), r = YB(s, E);
      if (g.length / 3 <= cE) {
        const c = new I.BufferGeometry();
        c.setAttribute("position", new I.BufferAttribute(g.toFloat32Array(), 3)), c.setIndex(new I.BufferAttribute(M.toUint32Array(), 1));
        const n = new I.Mesh(c, r);
        n.frustumCulled = !1, n.renderOrder = Vt, n.userData.layerName = Q, B.push(n);
      } else {
        const c = g.toFloat32Array(), n = M.toUint32Array();
        for (let a = 0; a < n.length; a += cE * 3) {
          const o = Math.min(a + cE * 3, n.length), D = new I.BufferGeometry();
          D.setAttribute("position", new I.BufferAttribute(c, 3)), D.setIndex(new I.BufferAttribute(n.slice(a, o), 1));
          const R = new I.Mesh(D, r);
          R.frustumCulled = !1, R.renderOrder = Vt, R.userData.layerName = Q, B.push(R);
        }
      }
    }
    return B;
  }
}
const cE = 1e7, bt = cE * 3;
function ce(A, E, B, e, t) {
  const g = A.length;
  if (g <= bt) {
    e.push(t(new I.BufferAttribute(A.toFloat32Array(), 3), E));
    return;
  }
  const M = Math.floor(bt / B) * B;
  for (let Q = 0; Q < g; Q += M) {
    const s = Math.min(Q + M, g), r = A.buffer.slice(Q, s);
    e.push(t(new I.BufferAttribute(r, 3), E));
  }
}
function JE(A) {
  const E = A.indexOf("::");
  return E === -1 ? ["0", A] : [A.substring(0, E), A.substring(E + 2)];
}
const js = 2, Qt = "\0INHERIT", st = "\0BYBLOCK", Ls = /* @__PURE__ */ new Set([
  "LINE",
  "CIRCLE",
  "ARC",
  "ELLIPSE",
  "LWPOLYLINE",
  "POLYLINE",
  "SPLINE",
  "POINT",
  "SOLID",
  "3DFACE",
  "HATCH",
  "MLINE",
  "XLINE",
  "RAY"
]);
function aB(A, E) {
  const B = new Array(A.length);
  for (let e = 0; e < A.length; e += 3) {
    const t = A[e], g = A[e + 1], M = A[e + 2];
    B[e] = E[0] * t + E[4] * g + E[8] * M + E[12], B[e + 1] = E[1] * t + E[5] * g + E[9] * M + E[13], B[e + 2] = E[2] * t + E[6] * g + E[10] * M + E[14];
  }
  return B;
}
function Ws(A, E, B, e) {
  const t = new bA(), g = [];
  for (let s = 0; s < E.length; s++) {
    const r = E[s];
    if (r.visible === !1) continue;
    if (!Ls.has(r.type)) {
      g.push(s);
      continue;
    }
    if (r.type === "INSERT") {
      g.push(s);
      continue;
    }
    const w = r.lineType;
    if (w && w.toUpperCase() === "BYBLOCK") {
      g.push(s);
      continue;
    }
    const c = !r.layer || r.layer === "0" ? Qt : r.layer, n = aA(r, B.layers, st);
    e({
      entity: r,
      colorCtx: B,
      collector: t,
      layer: c,
      overrideColor: n
    }) || g.push(s);
  }
  const M = /* @__PURE__ */ new Map(), Q = /* @__PURE__ */ new Set();
  for (const s of t.lineSegments.keys()) Q.add(s);
  for (const s of t.points.keys()) Q.add(s);
  for (const s of t.linetypeDots.keys()) Q.add(s);
  for (const s of t.meshVertices.keys()) Q.add(s);
  for (const s of Q)
    M.set(s, {
      lineSegments: t.lineSegments.get(s)?.toArray() ?? [],
      points: t.points.get(s)?.toArray() ?? [],
      linetypeDots: t.linetypeDots.get(s)?.toArray() ?? [],
      meshVertices: t.meshVertices.get(s)?.toArray() ?? [],
      meshIndices: t.meshIndices.get(s)?.toArray() ?? []
    });
  return { name: A, buckets: M, fallbackEntityIndices: g };
}
function Xs(A, E, B, e, t) {
  const g = t.elements;
  for (const [M, Q] of A.buckets) {
    const s = M.indexOf("::"), r = s === -1 ? "0" : M.substring(0, s), w = s === -1 ? M : M.substring(s + 2), c = r === Qt ? B : r, n = w === st ? e : w;
    Q.lineSegments.length >= 6 && E.addLineSegments(c, n, aB(Q.lineSegments, g)), Q.points.length >= 3 && E.addPoints(c, n, aB(Q.points, g)), Q.linetypeDots.length >= 3 && E.addLinetypeDots(c, n, aB(Q.linetypeDots, g)), Q.meshVertices.length >= 9 && Q.meshIndices.length >= 3 && E.addMesh(c, n, aB(Q.meshVertices, g), Q.meshIndices);
  }
}
function Ks(A) {
  const E = [];
  for (const [B, e] of A.buckets) {
    const t = B.indexOf("::"), g = t === -1 ? "0" : B.substring(0, t), M = t === -1 ? B : B.substring(t + 2), Q = { rawLayer: g, rawColor: M };
    let s = !1;
    if (e.lineSegments.length >= 6) {
      const r = new I.BufferGeometry();
      r.setAttribute("position", new I.BufferAttribute(new Float32Array(e.lineSegments), 3)), Q.lineGeo = r, s = !0;
    }
    if (e.meshVertices.length >= 9 && e.meshIndices.length >= 3) {
      const r = new I.BufferGeometry();
      r.setAttribute("position", new I.BufferAttribute(new Float32Array(e.meshVertices), 3)), r.setIndex(e.meshIndices), Q.meshGeo = r, s = !0;
    }
    if (e.points.length >= 3) {
      const r = new I.BufferGeometry();
      r.setAttribute("position", new I.BufferAttribute(new Float32Array(e.points), 3)), Q.pointsGeo = r, s = !0;
    }
    if (e.linetypeDots.length >= 3) {
      const r = new I.BufferGeometry();
      r.setAttribute("position", new I.BufferAttribute(new Float32Array(e.linetypeDots), 3)), Q.dotsGeo = r, s = !0;
    }
    s && E.push(Q);
  }
  return { entries: E, fallbackEntityIndices: A.fallbackEntityIndices };
}
function Zs(A, E, B, e, t, g, M) {
  let Q = t;
  M && (M.x !== 0 || M.y !== 0) && (Q = t.clone(), Q.elements[12] -= M.x, Q.elements[13] -= M.y, Q.elements[14] -= M.z);
  for (const s of A.entries) {
    const r = s.rawLayer === Qt ? B : s.rawLayer, w = s.rawColor === st ? e : s.rawColor;
    if (s.lineGeo) {
      const c = Mt(w, g.materials), n = new I.LineSegments(s.lineGeo, c);
      n.matrixAutoUpdate = !1, n.matrix.copy(Q), n.frustumCulled = !1, n.renderOrder = dE, n.userData.layerName = r, E.add(n);
    }
    if (s.meshGeo) {
      const c = YB(w, g.materials), n = new I.Mesh(s.meshGeo, c);
      n.matrixAutoUpdate = !1, n.matrix.copy(Q), n.frustumCulled = !1, n.renderOrder = Ye, n.userData.layerName = r, E.add(n);
    }
    if (s.pointsGeo) {
      const c = tM(w, g.materials), n = new I.Points(s.pointsGeo, c);
      n.matrixAutoUpdate = !1, n.matrix.copy(Q), n.frustumCulled = !1, n.renderOrder = dE, n.userData.layerName = r, E.add(n);
    }
    if (s.dotsGeo) {
      const c = g.materials.resolveColor(w), n = new I.PointsMaterial({
        color: c,
        size: Xg,
        sizeAttenuation: !1,
        depthTest: !1,
        depthWrite: !1
      });
      KA(w) && g.materials.trackThemeMaterial(n, w);
      const a = new I.Points(s.dotsGeo, n);
      a.matrixAutoUpdate = !1, a.matrix.copy(Q), a.frustumCulled = !1, a.renderOrder = dE, a.userData.layerName = r, E.add(a);
    }
  }
}
String.prototype.codePointAt || (function() {
  var A = (function() {
    try {
      var B = {}, e = Object.defineProperty, t = e(B, B, B) && e;
    } catch {
    }
    return t;
  })(), E = function(B) {
    if (this == null)
      throw TypeError();
    var e = String(this), t = e.length, g = B ? Number(B) : 0;
    if (g != g && (g = 0), !(g < 0 || g >= t)) {
      var M = e.charCodeAt(g), Q;
      return (
        // check if it’s the start of a surrogate pair
        M >= 55296 && M <= 56319 && // high surrogate
        t > g + 1 && (Q = e.charCodeAt(g + 1), Q >= 56320 && Q <= 57343) ? (M - 55296) * 1024 + Q - 56320 + 65536 : M
      );
    }
  };
  A ? A(String.prototype, "codePointAt", {
    value: E,
    configurable: !0,
    writable: !0
  }) : String.prototype.codePointAt = E;
})();
var rt = 0, gM = -3;
function $E() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function qs(A, E) {
  this.source = A, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = E, this.destLen = 0, this.ltree = new $E(), this.dtree = new $E();
}
var MM = new $E(), QM = new $E(), nt = new Uint8Array(30), wt = new Uint16Array(30), sM = new Uint8Array(30), rM = new Uint16Array(30), _s = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), Ot = new $E(), pA = new Uint8Array(320);
function nM(A, E, B, e) {
  var t, g;
  for (t = 0; t < B; ++t)
    A[t] = 0;
  for (t = 0; t < 30 - B; ++t)
    A[t + B] = t / B | 0;
  for (g = e, t = 0; t < 30; ++t)
    E[t] = g, g += 1 << A[t];
}
function $s(A, E) {
  var B;
  for (B = 0; B < 7; ++B)
    A.table[B] = 0;
  for (A.table[7] = 24, A.table[8] = 152, A.table[9] = 112, B = 0; B < 24; ++B)
    A.trans[B] = 256 + B;
  for (B = 0; B < 144; ++B)
    A.trans[24 + B] = B;
  for (B = 0; B < 8; ++B)
    A.trans[168 + B] = 280 + B;
  for (B = 0; B < 112; ++B)
    A.trans[176 + B] = 144 + B;
  for (B = 0; B < 5; ++B)
    E.table[B] = 0;
  for (E.table[5] = 32, B = 0; B < 32; ++B)
    E.trans[B] = B;
}
var jt = new Uint16Array(16);
function ae(A, E, B, e) {
  var t, g;
  for (t = 0; t < 16; ++t)
    A.table[t] = 0;
  for (t = 0; t < e; ++t)
    A.table[E[B + t]]++;
  for (A.table[0] = 0, g = 0, t = 0; t < 16; ++t)
    jt[t] = g, g += A.table[t];
  for (t = 0; t < e; ++t)
    E[B + t] && (A.trans[jt[E[B + t]]++] = t);
}
function Ar(A) {
  A.bitcount-- || (A.tag = A.source[A.sourceIndex++], A.bitcount = 7);
  var E = A.tag & 1;
  return A.tag >>>= 1, E;
}
function vA(A, E, B) {
  if (!E)
    return B;
  for (; A.bitcount < 24; )
    A.tag |= A.source[A.sourceIndex++] << A.bitcount, A.bitcount += 8;
  var e = A.tag & 65535 >>> 16 - E;
  return A.tag >>>= E, A.bitcount -= E, e + B;
}
function ke(A, E) {
  for (; A.bitcount < 24; )
    A.tag |= A.source[A.sourceIndex++] << A.bitcount, A.bitcount += 8;
  var B = 0, e = 0, t = 0, g = A.tag;
  do
    e = 2 * e + (g & 1), g >>>= 1, ++t, B += E.table[t], e -= E.table[t];
  while (e >= 0);
  return A.tag = g, A.bitcount -= t, E.trans[B + e];
}
function Er(A, E, B) {
  var e, t, g, M, Q, s;
  for (e = vA(A, 5, 257), t = vA(A, 5, 1), g = vA(A, 4, 4), M = 0; M < 19; ++M)
    pA[M] = 0;
  for (M = 0; M < g; ++M) {
    var r = vA(A, 3, 0);
    pA[_s[M]] = r;
  }
  for (ae(Ot, pA, 0, 19), Q = 0; Q < e + t; ) {
    var w = ke(A, Ot);
    switch (w) {
      case 16:
        var c = pA[Q - 1];
        for (s = vA(A, 2, 3); s; --s)
          pA[Q++] = c;
        break;
      case 17:
        for (s = vA(A, 3, 3); s; --s)
          pA[Q++] = 0;
        break;
      case 18:
        for (s = vA(A, 7, 11); s; --s)
          pA[Q++] = 0;
        break;
      default:
        pA[Q++] = w;
        break;
    }
  }
  ae(E, pA, 0, e), ae(B, pA, e, t);
}
function Lt(A, E, B) {
  for (; ; ) {
    var e = ke(A, E);
    if (e === 256)
      return rt;
    if (e < 256)
      A.dest[A.destLen++] = e;
    else {
      var t, g, M, Q;
      for (e -= 257, t = vA(A, nt[e], wt[e]), g = ke(A, B), M = A.destLen - vA(A, sM[g], rM[g]), Q = M; Q < M + t; ++Q)
        A.dest[A.destLen++] = A.dest[Q];
    }
  }
}
function Br(A) {
  for (var E, B, e; A.bitcount > 8; )
    A.sourceIndex--, A.bitcount -= 8;
  if (E = A.source[A.sourceIndex + 1], E = 256 * E + A.source[A.sourceIndex], B = A.source[A.sourceIndex + 3], B = 256 * B + A.source[A.sourceIndex + 2], E !== (~B & 65535))
    return gM;
  for (A.sourceIndex += 4, e = E; e; --e)
    A.dest[A.destLen++] = A.source[A.sourceIndex++];
  return A.bitcount = 0, rt;
}
function er(A, E) {
  var B = new qs(A, E), e, t, g;
  do {
    switch (e = Ar(B), t = vA(B, 2, 0), t) {
      case 0:
        g = Br(B);
        break;
      case 1:
        g = Lt(B, MM, QM);
        break;
      case 2:
        Er(B, B.ltree, B.dtree), g = Lt(B, B.ltree, B.dtree);
        break;
      default:
        g = gM;
    }
    if (g !== rt)
      throw new Error("Data error");
  } while (!e);
  return B.destLen < B.dest.length ? typeof B.dest.slice == "function" ? B.dest.slice(0, B.destLen) : B.dest.subarray(0, B.destLen) : B.dest;
}
$s(MM, QM);
nM(nt, wt, 4, 3);
nM(sM, rM, 2, 1);
nt[28] = 0;
wt[28] = 258;
var tr = er;
function TE(A, E, B, e, t) {
  return Math.pow(1 - t, 3) * A + 3 * Math.pow(1 - t, 2) * t * E + 3 * (1 - t) * Math.pow(t, 2) * B + Math.pow(t, 3) * e;
}
function _A() {
  this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
}
_A.prototype.isEmpty = function() {
  return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
};
_A.prototype.addPoint = function(A, E) {
  typeof A == "number" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = A, this.x2 = A), A < this.x1 && (this.x1 = A), A > this.x2 && (this.x2 = A)), typeof E == "number" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = E, this.y2 = E), E < this.y1 && (this.y1 = E), E > this.y2 && (this.y2 = E));
};
_A.prototype.addX = function(A) {
  this.addPoint(A, null);
};
_A.prototype.addY = function(A) {
  this.addPoint(null, A);
};
_A.prototype.addBezier = function(A, E, B, e, t, g, M, Q) {
  var s = [A, E], r = [B, e], w = [t, g], c = [M, Q];
  this.addPoint(A, E), this.addPoint(M, Q);
  for (var n = 0; n <= 1; n++) {
    var a = 6 * s[n] - 12 * r[n] + 6 * w[n], o = -3 * s[n] + 9 * r[n] - 9 * w[n] + 3 * c[n], D = 3 * r[n] - 3 * s[n];
    if (o === 0) {
      if (a === 0)
        continue;
      var R = -D / a;
      0 < R && R < 1 && (n === 0 && this.addX(TE(s[n], r[n], w[n], c[n], R)), n === 1 && this.addY(TE(s[n], r[n], w[n], c[n], R)));
      continue;
    }
    var i = Math.pow(a, 2) - 4 * D * o;
    if (!(i < 0)) {
      var C = (-a + Math.sqrt(i)) / (2 * o);
      0 < C && C < 1 && (n === 0 && this.addX(TE(s[n], r[n], w[n], c[n], C)), n === 1 && this.addY(TE(s[n], r[n], w[n], c[n], C)));
      var F = (-a - Math.sqrt(i)) / (2 * o);
      0 < F && F < 1 && (n === 0 && this.addX(TE(s[n], r[n], w[n], c[n], F)), n === 1 && this.addY(TE(s[n], r[n], w[n], c[n], F)));
    }
  }
};
_A.prototype.addQuad = function(A, E, B, e, t, g) {
  var M = A + 0.6666666666666666 * (B - A), Q = E + 2 / 3 * (e - E), s = M + 1 / 3 * (t - A), r = Q + 1 / 3 * (g - E);
  this.addBezier(A, E, M, Q, s, r, t, g);
};
function FA() {
  this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
}
FA.prototype.moveTo = function(A, E) {
  this.commands.push({
    type: "M",
    x: A,
    y: E
  });
};
FA.prototype.lineTo = function(A, E) {
  this.commands.push({
    type: "L",
    x: A,
    y: E
  });
};
FA.prototype.curveTo = FA.prototype.bezierCurveTo = function(A, E, B, e, t, g) {
  this.commands.push({
    type: "C",
    x1: A,
    y1: E,
    x2: B,
    y2: e,
    x: t,
    y: g
  });
};
FA.prototype.quadTo = FA.prototype.quadraticCurveTo = function(A, E, B, e) {
  this.commands.push({
    type: "Q",
    x1: A,
    y1: E,
    x: B,
    y: e
  });
};
FA.prototype.close = FA.prototype.closePath = function() {
  this.commands.push({
    type: "Z"
  });
};
FA.prototype.extend = function(A) {
  if (A.commands)
    A = A.commands;
  else if (A instanceof _A) {
    var E = A;
    this.moveTo(E.x1, E.y1), this.lineTo(E.x2, E.y1), this.lineTo(E.x2, E.y2), this.lineTo(E.x1, E.y2), this.close();
    return;
  }
  Array.prototype.push.apply(this.commands, A);
};
FA.prototype.getBoundingBox = function() {
  for (var A = new _A(), E = 0, B = 0, e = 0, t = 0, g = 0; g < this.commands.length; g++) {
    var M = this.commands[g];
    switch (M.type) {
      case "M":
        A.addPoint(M.x, M.y), E = e = M.x, B = t = M.y;
        break;
      case "L":
        A.addPoint(M.x, M.y), e = M.x, t = M.y;
        break;
      case "Q":
        A.addQuad(e, t, M.x1, M.y1, M.x, M.y), e = M.x, t = M.y;
        break;
      case "C":
        A.addBezier(e, t, M.x1, M.y1, M.x2, M.y2, M.x, M.y), e = M.x, t = M.y;
        break;
      case "Z":
        e = E, t = B;
        break;
      default:
        throw new Error("Unexpected path command " + M.type);
    }
  }
  return A.isEmpty() && A.addPoint(0, 0), A;
};
FA.prototype.draw = function(A) {
  A.beginPath();
  for (var E = 0; E < this.commands.length; E += 1) {
    var B = this.commands[E];
    B.type === "M" ? A.moveTo(B.x, B.y) : B.type === "L" ? A.lineTo(B.x, B.y) : B.type === "C" ? A.bezierCurveTo(B.x1, B.y1, B.x2, B.y2, B.x, B.y) : B.type === "Q" ? A.quadraticCurveTo(B.x1, B.y1, B.x, B.y) : B.type === "Z" && A.closePath();
  }
  this.fill && (A.fillStyle = this.fill, A.fill()), this.stroke && (A.strokeStyle = this.stroke, A.lineWidth = this.strokeWidth, A.stroke());
};
FA.prototype.toPathData = function(A) {
  A = A !== void 0 ? A : 2;
  function E(M) {
    return Math.round(M) === M ? "" + Math.round(M) : M.toFixed(A);
  }
  function B() {
    for (var M = arguments, Q = "", s = 0; s < arguments.length; s += 1) {
      var r = M[s];
      r >= 0 && s > 0 && (Q += " "), Q += E(r);
    }
    return Q;
  }
  for (var e = "", t = 0; t < this.commands.length; t += 1) {
    var g = this.commands[t];
    g.type === "M" ? e += "M" + B(g.x, g.y) : g.type === "L" ? e += "L" + B(g.x, g.y) : g.type === "C" ? e += "C" + B(g.x1, g.y1, g.x2, g.y2, g.x, g.y) : g.type === "Q" ? e += "Q" + B(g.x1, g.y1, g.x, g.y) : g.type === "Z" && (e += "Z");
  }
  return e;
};
FA.prototype.toSVG = function(A) {
  var E = '<path d="';
  return E += this.toPathData(A), E += '"', this.fill && this.fill !== "black" && (this.fill === null ? E += ' fill="none"' : E += ' fill="' + this.fill + '"'), this.stroke && (E += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), E += "/>", E;
};
FA.prototype.toDOMElement = function(A) {
  var E = this.toPathData(A), B = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return B.setAttribute("d", E), B;
};
function wM(A) {
  throw new Error(A);
}
function Wt(A, E) {
  A || wM(E);
}
var gA = { fail: wM, argument: Wt, assert: Wt }, Xt = 32768, Kt = 2147483648, pE = {}, O = {}, sA = {};
function yA(A) {
  return function() {
    return A;
  };
}
O.BYTE = function(A) {
  return gA.argument(A >= 0 && A <= 255, "Byte value should be between 0 and 255."), [A];
};
sA.BYTE = yA(1);
O.CHAR = function(A) {
  return [A.charCodeAt(0)];
};
sA.CHAR = yA(1);
O.CHARARRAY = function(A) {
  typeof A > "u" && (A = "", console.warn("Undefined CHARARRAY encountered and treated as an empty string. This is probably caused by a missing glyph name."));
  for (var E = [], B = 0; B < A.length; B += 1)
    E[B] = A.charCodeAt(B);
  return E;
};
sA.CHARARRAY = function(A) {
  return typeof A > "u" ? 0 : A.length;
};
O.USHORT = function(A) {
  return [A >> 8 & 255, A & 255];
};
sA.USHORT = yA(2);
O.SHORT = function(A) {
  return A >= Xt && (A = -(2 * Xt - A)), [A >> 8 & 255, A & 255];
};
sA.SHORT = yA(2);
O.UINT24 = function(A) {
  return [A >> 16 & 255, A >> 8 & 255, A & 255];
};
sA.UINT24 = yA(3);
O.ULONG = function(A) {
  return [A >> 24 & 255, A >> 16 & 255, A >> 8 & 255, A & 255];
};
sA.ULONG = yA(4);
O.LONG = function(A) {
  return A >= Kt && (A = -(2 * Kt - A)), [A >> 24 & 255, A >> 16 & 255, A >> 8 & 255, A & 255];
};
sA.LONG = yA(4);
O.FIXED = O.ULONG;
sA.FIXED = sA.ULONG;
O.FWORD = O.SHORT;
sA.FWORD = sA.SHORT;
O.UFWORD = O.USHORT;
sA.UFWORD = sA.USHORT;
O.LONGDATETIME = function(A) {
  return [0, 0, 0, 0, A >> 24 & 255, A >> 16 & 255, A >> 8 & 255, A & 255];
};
sA.LONGDATETIME = yA(8);
O.TAG = function(A) {
  return gA.argument(A.length === 4, "Tag should be exactly 4 ASCII characters."), [
    A.charCodeAt(0),
    A.charCodeAt(1),
    A.charCodeAt(2),
    A.charCodeAt(3)
  ];
};
sA.TAG = yA(4);
O.Card8 = O.BYTE;
sA.Card8 = sA.BYTE;
O.Card16 = O.USHORT;
sA.Card16 = sA.USHORT;
O.OffSize = O.BYTE;
sA.OffSize = sA.BYTE;
O.SID = O.USHORT;
sA.SID = sA.USHORT;
O.NUMBER = function(A) {
  return A >= -107 && A <= 107 ? [A + 139] : A >= 108 && A <= 1131 ? (A = A - 108, [(A >> 8) + 247, A & 255]) : A >= -1131 && A <= -108 ? (A = -A - 108, [(A >> 8) + 251, A & 255]) : A >= -32768 && A <= 32767 ? O.NUMBER16(A) : O.NUMBER32(A);
};
sA.NUMBER = function(A) {
  return O.NUMBER(A).length;
};
O.NUMBER16 = function(A) {
  return [28, A >> 8 & 255, A & 255];
};
sA.NUMBER16 = yA(3);
O.NUMBER32 = function(A) {
  return [29, A >> 24 & 255, A >> 16 & 255, A >> 8 & 255, A & 255];
};
sA.NUMBER32 = yA(5);
O.REAL = function(A) {
  var E = A.toString(), B = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(E);
  if (B) {
    var e = parseFloat("1e" + ((B[2] ? +B[2] : 0) + B[1].length));
    E = (Math.round(A * e) / e).toString();
  }
  for (var t = "", g = 0, M = E.length; g < M; g += 1) {
    var Q = E[g];
    Q === "e" ? t += E[++g] === "-" ? "c" : "b" : Q === "." ? t += "a" : Q === "-" ? t += "e" : t += Q;
  }
  t += t.length & 1 ? "f" : "ff";
  for (var s = [30], r = 0, w = t.length; r < w; r += 2)
    s.push(parseInt(t.substr(r, 2), 16));
  return s;
};
sA.REAL = function(A) {
  return O.REAL(A).length;
};
O.NAME = O.CHARARRAY;
sA.NAME = sA.CHARARRAY;
O.STRING = O.CHARARRAY;
sA.STRING = sA.CHARARRAY;
pE.UTF8 = function(A, E, B) {
  for (var e = [], t = B, g = 0; g < t; g++, E += 1)
    e[g] = A.getUint8(E);
  return String.fromCharCode.apply(null, e);
};
pE.UTF16 = function(A, E, B) {
  for (var e = [], t = B / 2, g = 0; g < t; g++, E += 2)
    e[g] = A.getUint16(E);
  return String.fromCharCode.apply(null, e);
};
O.UTF16 = function(A) {
  for (var E = [], B = 0; B < A.length; B += 1) {
    var e = A.charCodeAt(B);
    E[E.length] = e >> 8 & 255, E[E.length] = e & 255;
  }
  return E;
};
sA.UTF16 = function(A) {
  return A.length * 2;
};
var de = {
  "x-mac-croatian": (
    // Python: 'mac_croatian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
  ),
  "x-mac-cyrillic": (
    // Python: 'mac_cyrillic'
    "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю"
  ),
  "x-mac-gaelic": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ"
  ),
  "x-mac-greek": (
    // Python: 'mac_greek'
    "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­"
  ),
  "x-mac-icelandic": (
    // Python: 'mac_iceland'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-inuit": (
    // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
    "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł"
  ),
  "x-mac-ce": (
    // Python: 'mac_latin2'
    "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
  ),
  macintosh: (
    // Python: 'mac_roman'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-romanian": (
    // Python: 'mac_romanian'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  ),
  "x-mac-turkish": (
    // Python: 'mac_turkish'
    "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
  )
};
pE.MACSTRING = function(A, E, B, e) {
  var t = de[e];
  if (t !== void 0) {
    for (var g = "", M = 0; M < B; M++) {
      var Q = A.getUint8(E + M);
      Q <= 127 ? g += String.fromCharCode(Q) : g += t[Q & 127];
    }
    return g;
  }
};
var oB = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap(), iB, gr = function(A) {
  if (!iB) {
    iB = {};
    for (var E in de)
      iB[E] = new String(E);
  }
  var B = iB[A];
  if (B !== void 0) {
    if (oB) {
      var e = oB.get(B);
      if (e !== void 0)
        return e;
    }
    var t = de[A];
    if (t !== void 0) {
      for (var g = {}, M = 0; M < t.length; M++)
        g[t.charCodeAt(M)] = M + 128;
      return oB && oB.set(B, g), g;
    }
  }
};
O.MACSTRING = function(A, E) {
  var B = gr(E);
  if (B !== void 0) {
    for (var e = [], t = 0; t < A.length; t++) {
      var g = A.charCodeAt(t);
      if (g >= 128 && (g = B[g], g === void 0))
        return;
      e[t] = g;
    }
    return e;
  }
};
sA.MACSTRING = function(A, E) {
  var B = O.MACSTRING(A, E);
  return B !== void 0 ? B.length : 0;
};
function Ge(A) {
  return A >= -128 && A <= 127;
}
function Mr(A, E, B) {
  for (var e = 0, t = A.length; E < t && e < 64 && A[E] === 0; )
    ++E, ++e;
  return B.push(128 | e - 1), E;
}
function Qr(A, E, B) {
  for (var e = 0, t = A.length, g = E; g < t && e < 64; ) {
    var M = A[g];
    if (!Ge(M) || M === 0 && g + 1 < t && A[g + 1] === 0)
      break;
    ++g, ++e;
  }
  B.push(e - 1);
  for (var Q = E; Q < g; ++Q)
    B.push(A[Q] + 256 & 255);
  return g;
}
function sr(A, E, B) {
  for (var e = 0, t = A.length, g = E; g < t && e < 64; ) {
    var M = A[g];
    if (M === 0 || Ge(M) && g + 1 < t && Ge(A[g + 1]))
      break;
    ++g, ++e;
  }
  B.push(64 | e - 1);
  for (var Q = E; Q < g; ++Q) {
    var s = A[Q];
    B.push(s + 65536 >> 8 & 255, s + 256 & 255);
  }
  return g;
}
O.VARDELTAS = function(A) {
  for (var E = 0, B = []; E < A.length; ) {
    var e = A[E];
    e === 0 ? E = Mr(A, E, B) : e >= -128 && e <= 127 ? E = Qr(A, E, B) : E = sr(A, E, B);
  }
  return B;
};
O.INDEX = function(A) {
  for (var E = 1, B = [E], e = [], t = 0; t < A.length; t += 1) {
    var g = O.OBJECT(A[t]);
    Array.prototype.push.apply(e, g), E += g.length, B.push(E);
  }
  if (e.length === 0)
    return [0, 0];
  for (var M = [], Q = 1 + Math.floor(Math.log(E) / Math.log(2)) / 8 | 0, s = [void 0, O.BYTE, O.USHORT, O.UINT24, O.ULONG][Q], r = 0; r < B.length; r += 1) {
    var w = s(B[r]);
    Array.prototype.push.apply(M, w);
  }
  return Array.prototype.concat(
    O.Card16(A.length),
    O.OffSize(Q),
    M,
    e
  );
};
sA.INDEX = function(A) {
  return O.INDEX(A).length;
};
O.DICT = function(A) {
  for (var E = [], B = Object.keys(A), e = B.length, t = 0; t < e; t += 1) {
    var g = parseInt(B[t], 0), M = A[g];
    E = E.concat(O.OPERAND(M.value, M.type)), E = E.concat(O.OPERATOR(g));
  }
  return E;
};
sA.DICT = function(A) {
  return O.DICT(A).length;
};
O.OPERATOR = function(A) {
  return A < 1200 ? [A] : [12, A - 1200];
};
O.OPERAND = function(A, E) {
  var B = [];
  if (Array.isArray(E))
    for (var e = 0; e < E.length; e += 1)
      gA.argument(A.length === E.length, "Not enough arguments given for type" + E), B = B.concat(O.OPERAND(A[e], E[e]));
  else if (E === "SID")
    B = B.concat(O.NUMBER(A));
  else if (E === "offset")
    B = B.concat(O.NUMBER32(A));
  else if (E === "number")
    B = B.concat(O.NUMBER(A));
  else if (E === "real")
    B = B.concat(O.REAL(A));
  else
    throw new Error("Unknown operand type " + E);
  return B;
};
O.OP = O.BYTE;
sA.OP = sA.BYTE;
var IB = typeof WeakMap == "function" && /* @__PURE__ */ new WeakMap();
O.CHARSTRING = function(A) {
  if (IB) {
    var E = IB.get(A);
    if (E !== void 0)
      return E;
  }
  for (var B = [], e = A.length, t = 0; t < e; t += 1) {
    var g = A[t];
    B = B.concat(O[g.type](g.value));
  }
  return IB && IB.set(A, B), B;
};
sA.CHARSTRING = function(A) {
  return O.CHARSTRING(A).length;
};
O.OBJECT = function(A) {
  var E = O[A.type];
  return gA.argument(E !== void 0, "No encoding function for type " + A.type), E(A.value);
};
sA.OBJECT = function(A) {
  var E = sA[A.type];
  return gA.argument(E !== void 0, "No sizeOf function for type " + A.type), E(A.value);
};
O.TABLE = function(A) {
  for (var E = [], B = A.fields.length, e = [], t = [], g = 0; g < B; g += 1) {
    var M = A.fields[g], Q = O[M.type];
    gA.argument(Q !== void 0, "No encoding function for field type " + M.type + " (" + M.name + ")");
    var s = A[M.name];
    s === void 0 && (s = M.value);
    var r = Q(s);
    M.type === "TABLE" ? (t.push(E.length), E = E.concat([0, 0]), e.push(r)) : E = E.concat(r);
  }
  for (var w = 0; w < e.length; w += 1) {
    var c = t[w], n = E.length;
    gA.argument(n < 65536, "Table " + A.tableName + " too big."), E[c] = n >> 8, E[c + 1] = n & 255, E = E.concat(e[w]);
  }
  return E;
};
sA.TABLE = function(A) {
  for (var E = 0, B = A.fields.length, e = 0; e < B; e += 1) {
    var t = A.fields[e], g = sA[t.type];
    gA.argument(g !== void 0, "No sizeOf function for field type " + t.type + " (" + t.name + ")");
    var M = A[t.name];
    M === void 0 && (M = t.value), E += g(M), t.type === "TABLE" && (E += 2);
  }
  return E;
};
O.RECORD = O.TABLE;
sA.RECORD = sA.TABLE;
O.LITERAL = function(A) {
  return A;
};
sA.LITERAL = function(A) {
  return A.length;
};
function RA(A, E, B) {
  if (E.length && (E[0].name !== "coverageFormat" || E[0].value === 1))
    for (var e = 0; e < E.length; e += 1) {
      var t = E[e];
      this[t.name] = t.value;
    }
  if (this.tableName = A, this.fields = E, B)
    for (var g = Object.keys(B), M = 0; M < g.length; M += 1) {
      var Q = g[M], s = B[Q];
      this[Q] !== void 0 && (this[Q] = s);
    }
}
RA.prototype.encode = function() {
  return O.TABLE(this);
};
RA.prototype.sizeOf = function() {
  return sA.TABLE(this);
};
function AB(A, E, B) {
  B === void 0 && (B = E.length);
  var e = new Array(E.length + 1);
  e[0] = { name: A + "Count", type: "USHORT", value: B };
  for (var t = 0; t < E.length; t++)
    e[t + 1] = { name: A + t, type: "USHORT", value: E[t] };
  return e;
}
function ye(A, E, B) {
  var e = E.length, t = new Array(e + 1);
  t[0] = { name: A + "Count", type: "USHORT", value: e };
  for (var g = 0; g < e; g++)
    t[g + 1] = { name: A + g, type: "TABLE", value: B(E[g], g) };
  return t;
}
function EB(A, E, B) {
  var e = E.length, t = [];
  t[0] = { name: A + "Count", type: "USHORT", value: e };
  for (var g = 0; g < e; g++)
    t = t.concat(B(E[g], g));
  return t;
}
function kB(A) {
  A.format === 1 ? RA.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 1 }].concat(AB("glyph", A.glyphs))
  ) : A.format === 2 ? RA.call(
    this,
    "coverageTable",
    [{ name: "coverageFormat", type: "USHORT", value: 2 }].concat(EB("rangeRecord", A.ranges, function(E) {
      return [
        { name: "startGlyphID", type: "USHORT", value: E.start },
        { name: "endGlyphID", type: "USHORT", value: E.end },
        { name: "startCoverageIndex", type: "USHORT", value: E.index }
      ];
    }))
  ) : gA.assert(!1, "Coverage format must be 1 or 2.");
}
kB.prototype = Object.create(RA.prototype);
kB.prototype.constructor = kB;
function dB(A) {
  RA.call(
    this,
    "scriptListTable",
    EB("scriptRecord", A, function(E, B) {
      var e = E.script, t = e.defaultLangSys;
      return gA.assert(!!t, "Unable to write GSUB: script " + E.tag + " has no default language system."), [
        { name: "scriptTag" + B, type: "TAG", value: E.tag },
        { name: "script" + B, type: "TABLE", value: new RA("scriptTable", [
          { name: "defaultLangSys", type: "TABLE", value: new RA("defaultLangSys", [
            { name: "lookupOrder", type: "USHORT", value: 0 },
            { name: "reqFeatureIndex", type: "USHORT", value: t.reqFeatureIndex }
          ].concat(AB("featureIndex", t.featureIndexes))) }
        ].concat(EB("langSys", e.langSysRecords, function(g, M) {
          var Q = g.langSys;
          return [
            { name: "langSysTag" + M, type: "TAG", value: g.tag },
            { name: "langSys" + M, type: "TABLE", value: new RA("langSys", [
              { name: "lookupOrder", type: "USHORT", value: 0 },
              { name: "reqFeatureIndex", type: "USHORT", value: Q.reqFeatureIndex }
            ].concat(AB("featureIndex", Q.featureIndexes))) }
          ];
        }))) }
      ];
    })
  );
}
dB.prototype = Object.create(RA.prototype);
dB.prototype.constructor = dB;
function GB(A) {
  RA.call(
    this,
    "featureListTable",
    EB("featureRecord", A, function(E, B) {
      var e = E.feature;
      return [
        { name: "featureTag" + B, type: "TAG", value: E.tag },
        { name: "feature" + B, type: "TABLE", value: new RA("featureTable", [
          { name: "featureParams", type: "USHORT", value: e.featureParams }
        ].concat(AB("lookupListIndex", e.lookupListIndexes))) }
      ];
    })
  );
}
GB.prototype = Object.create(RA.prototype);
GB.prototype.constructor = GB;
function yB(A, E) {
  RA.call(this, "lookupListTable", ye("lookup", A, function(B) {
    var e = E[B.lookupType];
    return gA.assert(!!e, "Unable to write GSUB lookup type " + B.lookupType + " tables."), new RA("lookupTable", [
      { name: "lookupType", type: "USHORT", value: B.lookupType },
      { name: "lookupFlag", type: "USHORT", value: B.lookupFlag }
    ].concat(ye("subtable", B.subtables, e)));
  }));
}
yB.prototype = Object.create(RA.prototype);
yB.prototype.constructor = yB;
var L = {
  Table: RA,
  Record: RA,
  Coverage: kB,
  ScriptList: dB,
  FeatureList: GB,
  LookupList: yB,
  ushortList: AB,
  tableList: ye,
  recordList: EB
};
function Zt(A, E) {
  return A.getUint8(E);
}
function SB(A, E) {
  return A.getUint16(E, !1);
}
function rr(A, E) {
  return A.getInt16(E, !1);
}
function ct(A, E) {
  return A.getUint32(E, !1);
}
function cM(A, E) {
  var B = A.getInt16(E, !1), e = A.getUint16(E + 2, !1);
  return B + e / 65535;
}
function nr(A, E) {
  for (var B = "", e = E; e < E + 4; e += 1)
    B += String.fromCharCode(A.getInt8(e));
  return B;
}
function wr(A, E, B) {
  for (var e = 0, t = 0; t < B; t += 1)
    e <<= 8, e += A.getUint8(E + t);
  return e;
}
function cr(A, E, B) {
  for (var e = [], t = E; t < B; t += 1)
    e.push(A.getUint8(t));
  return e;
}
function ar(A) {
  for (var E = "", B = 0; B < A.length; B += 1)
    E += String.fromCharCode(A[B]);
  return E;
}
var or = {
  byte: 1,
  uShort: 2,
  short: 2,
  uLong: 4,
  fixed: 4,
  longDateTime: 8,
  tag: 4
};
function Y(A, E) {
  this.data = A, this.offset = E, this.relativeOffset = 0;
}
Y.prototype.parseByte = function() {
  var A = this.data.getUint8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, A;
};
Y.prototype.parseChar = function() {
  var A = this.data.getInt8(this.offset + this.relativeOffset);
  return this.relativeOffset += 1, A;
};
Y.prototype.parseCard8 = Y.prototype.parseByte;
Y.prototype.parseUShort = function() {
  var A = this.data.getUint16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, A;
};
Y.prototype.parseCard16 = Y.prototype.parseUShort;
Y.prototype.parseSID = Y.prototype.parseUShort;
Y.prototype.parseOffset16 = Y.prototype.parseUShort;
Y.prototype.parseShort = function() {
  var A = this.data.getInt16(this.offset + this.relativeOffset);
  return this.relativeOffset += 2, A;
};
Y.prototype.parseF2Dot14 = function() {
  var A = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
  return this.relativeOffset += 2, A;
};
Y.prototype.parseULong = function() {
  var A = ct(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, A;
};
Y.prototype.parseOffset32 = Y.prototype.parseULong;
Y.prototype.parseFixed = function() {
  var A = cM(this.data, this.offset + this.relativeOffset);
  return this.relativeOffset += 4, A;
};
Y.prototype.parseString = function(A) {
  var E = this.data, B = this.offset + this.relativeOffset, e = "";
  this.relativeOffset += A;
  for (var t = 0; t < A; t++)
    e += String.fromCharCode(E.getUint8(B + t));
  return e;
};
Y.prototype.parseTag = function() {
  return this.parseString(4);
};
Y.prototype.parseLongDateTime = function() {
  var A = ct(this.data, this.offset + this.relativeOffset + 4);
  return A -= 2082844800, this.relativeOffset += 8, A;
};
Y.prototype.parseVersion = function(A) {
  var E = SB(this.data, this.offset + this.relativeOffset), B = SB(this.data, this.offset + this.relativeOffset + 2);
  return this.relativeOffset += 4, A === void 0 && (A = 4096), E + B / A / 10;
};
Y.prototype.skip = function(A, E) {
  E === void 0 && (E = 1), this.relativeOffset += or[A] * E;
};
Y.prototype.parseULongList = function(A) {
  A === void 0 && (A = this.parseULong());
  for (var E = new Array(A), B = this.data, e = this.offset + this.relativeOffset, t = 0; t < A; t++)
    E[t] = B.getUint32(e), e += 4;
  return this.relativeOffset += A * 4, E;
};
Y.prototype.parseOffset16List = Y.prototype.parseUShortList = function(A) {
  A === void 0 && (A = this.parseUShort());
  for (var E = new Array(A), B = this.data, e = this.offset + this.relativeOffset, t = 0; t < A; t++)
    E[t] = B.getUint16(e), e += 2;
  return this.relativeOffset += A * 2, E;
};
Y.prototype.parseShortList = function(A) {
  for (var E = new Array(A), B = this.data, e = this.offset + this.relativeOffset, t = 0; t < A; t++)
    E[t] = B.getInt16(e), e += 2;
  return this.relativeOffset += A * 2, E;
};
Y.prototype.parseByteList = function(A) {
  for (var E = new Array(A), B = this.data, e = this.offset + this.relativeOffset, t = 0; t < A; t++)
    E[t] = B.getUint8(e++);
  return this.relativeOffset += A, E;
};
Y.prototype.parseList = function(A, E) {
  E || (E = A, A = this.parseUShort());
  for (var B = new Array(A), e = 0; e < A; e++)
    B[e] = E.call(this);
  return B;
};
Y.prototype.parseList32 = function(A, E) {
  E || (E = A, A = this.parseULong());
  for (var B = new Array(A), e = 0; e < A; e++)
    B[e] = E.call(this);
  return B;
};
Y.prototype.parseRecordList = function(A, E) {
  E || (E = A, A = this.parseUShort());
  for (var B = new Array(A), e = Object.keys(E), t = 0; t < A; t++) {
    for (var g = {}, M = 0; M < e.length; M++) {
      var Q = e[M], s = E[Q];
      g[Q] = s.call(this);
    }
    B[t] = g;
  }
  return B;
};
Y.prototype.parseRecordList32 = function(A, E) {
  E || (E = A, A = this.parseULong());
  for (var B = new Array(A), e = Object.keys(E), t = 0; t < A; t++) {
    for (var g = {}, M = 0; M < e.length; M++) {
      var Q = e[M], s = E[Q];
      g[Q] = s.call(this);
    }
    B[t] = g;
  }
  return B;
};
Y.prototype.parseStruct = function(A) {
  if (typeof A == "function")
    return A.call(this);
  for (var E = Object.keys(A), B = {}, e = 0; e < E.length; e++) {
    var t = E[e], g = A[t];
    B[t] = g.call(this);
  }
  return B;
};
Y.prototype.parseValueRecord = function(A) {
  if (A === void 0 && (A = this.parseUShort()), A !== 0) {
    var E = {};
    return A & 1 && (E.xPlacement = this.parseShort()), A & 2 && (E.yPlacement = this.parseShort()), A & 4 && (E.xAdvance = this.parseShort()), A & 8 && (E.yAdvance = this.parseShort()), A & 16 && (E.xPlaDevice = void 0, this.parseShort()), A & 32 && (E.yPlaDevice = void 0, this.parseShort()), A & 64 && (E.xAdvDevice = void 0, this.parseShort()), A & 128 && (E.yAdvDevice = void 0, this.parseShort()), E;
  }
};
Y.prototype.parseValueRecordList = function() {
  for (var A = this.parseUShort(), E = this.parseUShort(), B = new Array(E), e = 0; e < E; e++)
    B[e] = this.parseValueRecord(A);
  return B;
};
Y.prototype.parsePointer = function(A) {
  var E = this.parseOffset16();
  if (E > 0)
    return new Y(this.data, this.offset + E).parseStruct(A);
};
Y.prototype.parsePointer32 = function(A) {
  var E = this.parseOffset32();
  if (E > 0)
    return new Y(this.data, this.offset + E).parseStruct(A);
};
Y.prototype.parseListOfLists = function(A) {
  for (var E = this.parseOffset16List(), B = E.length, e = this.relativeOffset, t = new Array(B), g = 0; g < B; g++) {
    var M = E[g];
    if (M === 0) {
      t[g] = void 0;
      continue;
    }
    if (this.relativeOffset = M, A) {
      for (var Q = this.parseOffset16List(), s = new Array(Q.length), r = 0; r < Q.length; r++)
        this.relativeOffset = M + Q[r], s[r] = A.call(this);
      t[g] = s;
    } else
      t[g] = this.parseUShortList();
  }
  return this.relativeOffset = e, t;
};
Y.prototype.parseCoverage = function() {
  var A = this.offset + this.relativeOffset, E = this.parseUShort(), B = this.parseUShort();
  if (E === 1)
    return {
      format: 1,
      glyphs: this.parseUShortList(B)
    };
  if (E === 2) {
    for (var e = new Array(B), t = 0; t < B; t++)
      e[t] = {
        start: this.parseUShort(),
        end: this.parseUShort(),
        index: this.parseUShort()
      };
    return {
      format: 2,
      ranges: e
    };
  }
  throw new Error("0x" + A.toString(16) + ": Coverage format must be 1 or 2.");
};
Y.prototype.parseClassDef = function() {
  var A = this.offset + this.relativeOffset, E = this.parseUShort();
  if (E === 1)
    return {
      format: 1,
      startGlyph: this.parseUShort(),
      classes: this.parseUShortList()
    };
  if (E === 2)
    return {
      format: 2,
      ranges: this.parseRecordList({
        start: Y.uShort,
        end: Y.uShort,
        classId: Y.uShort
      })
    };
  throw new Error("0x" + A.toString(16) + ": ClassDef format must be 1 or 2.");
};
Y.list = function(A, E) {
  return function() {
    return this.parseList(A, E);
  };
};
Y.list32 = function(A, E) {
  return function() {
    return this.parseList32(A, E);
  };
};
Y.recordList = function(A, E) {
  return function() {
    return this.parseRecordList(A, E);
  };
};
Y.recordList32 = function(A, E) {
  return function() {
    return this.parseRecordList32(A, E);
  };
};
Y.pointer = function(A) {
  return function() {
    return this.parsePointer(A);
  };
};
Y.pointer32 = function(A) {
  return function() {
    return this.parsePointer32(A);
  };
};
Y.tag = Y.prototype.parseTag;
Y.byte = Y.prototype.parseByte;
Y.uShort = Y.offset16 = Y.prototype.parseUShort;
Y.uShortList = Y.prototype.parseUShortList;
Y.uLong = Y.offset32 = Y.prototype.parseULong;
Y.uLongList = Y.prototype.parseULongList;
Y.struct = Y.prototype.parseStruct;
Y.coverage = Y.prototype.parseCoverage;
Y.classDef = Y.prototype.parseClassDef;
var qt = {
  reserved: Y.uShort,
  reqFeatureIndex: Y.uShort,
  featureIndexes: Y.uShortList
};
Y.prototype.parseScriptList = function() {
  return this.parsePointer(Y.recordList({
    tag: Y.tag,
    script: Y.pointer({
      defaultLangSys: Y.pointer(qt),
      langSysRecords: Y.recordList({
        tag: Y.tag,
        langSys: Y.pointer(qt)
      })
    })
  })) || [];
};
Y.prototype.parseFeatureList = function() {
  return this.parsePointer(Y.recordList({
    tag: Y.tag,
    feature: Y.pointer({
      featureParams: Y.offset16,
      lookupListIndexes: Y.uShortList
    })
  })) || [];
};
Y.prototype.parseLookupList = function(A) {
  return this.parsePointer(Y.list(Y.pointer(function() {
    var E = this.parseUShort();
    gA.argument(1 <= E && E <= 9, "GPOS/GSUB lookup type " + E + " unknown.");
    var B = this.parseUShort(), e = B & 16;
    return {
      lookupType: E,
      lookupFlag: B,
      subtables: this.parseList(Y.pointer(A[E])),
      markFilteringSet: e ? this.parseUShort() : void 0
    };
  }))) || [];
};
Y.prototype.parseFeatureVariationsList = function() {
  return this.parsePointer32(function() {
    var A = this.parseUShort(), E = this.parseUShort();
    gA.argument(A === 1 && E < 1, "GPOS/GSUB feature variations table unknown.");
    var B = this.parseRecordList32({
      conditionSetOffset: Y.offset32,
      featureTableSubstitutionOffset: Y.offset32
    });
    return B;
  }) || [];
};
var K = {
  getByte: Zt,
  getCard8: Zt,
  getUShort: SB,
  getCard16: SB,
  getShort: rr,
  getULong: ct,
  getFixed: cM,
  getTag: nr,
  getOffset: wr,
  getBytes: cr,
  bytesToString: ar,
  Parser: Y
};
function ir(A, E) {
  E.parseUShort(), A.length = E.parseULong(), A.language = E.parseULong();
  var B;
  A.groupCount = B = E.parseULong(), A.glyphIndexMap = {};
  for (var e = 0; e < B; e += 1)
    for (var t = E.parseULong(), g = E.parseULong(), M = E.parseULong(), Q = t; Q <= g; Q += 1)
      A.glyphIndexMap[Q] = M, M++;
}
function Ir(A, E, B, e, t) {
  A.length = E.parseUShort(), A.language = E.parseUShort();
  var g;
  A.segCount = g = E.parseUShort() >> 1, E.skip("uShort", 3), A.glyphIndexMap = {};
  for (var M = new K.Parser(B, e + t + 14), Q = new K.Parser(B, e + t + 16 + g * 2), s = new K.Parser(B, e + t + 16 + g * 4), r = new K.Parser(B, e + t + 16 + g * 6), w = e + t + 16 + g * 8, c = 0; c < g - 1; c += 1)
    for (var n = void 0, a = M.parseUShort(), o = Q.parseUShort(), D = s.parseShort(), R = r.parseUShort(), i = o; i <= a; i += 1)
      R !== 0 ? (w = r.offset + r.relativeOffset - 2, w += R, w += (i - o) * 2, n = K.getUShort(B, w), n !== 0 && (n = n + D & 65535)) : n = i + D & 65535, A.glyphIndexMap[i] = n;
}
function Fr(A, E) {
  var B = {};
  B.version = K.getUShort(A, E), gA.argument(B.version === 0, "cmap table version should be 0."), B.numTables = K.getUShort(A, E + 2);
  for (var e = -1, t = B.numTables - 1; t >= 0; t -= 1) {
    var g = K.getUShort(A, E + 4 + t * 8), M = K.getUShort(A, E + 4 + t * 8 + 2);
    if (g === 3 && (M === 0 || M === 1 || M === 10) || g === 0 && (M === 0 || M === 1 || M === 2 || M === 3 || M === 4)) {
      e = K.getULong(A, E + 4 + t * 8 + 4);
      break;
    }
  }
  if (e === -1)
    throw new Error("No valid cmap sub-tables found.");
  var Q = new K.Parser(A, E + e);
  if (B.format = Q.parseUShort(), B.format === 12)
    ir(B, Q);
  else if (B.format === 4)
    Ir(B, Q, A, E, e);
  else
    throw new Error("Only format 4 and 12 cmap tables are supported (found format " + B.format + ").");
  return B;
}
function Rr(A, E, B) {
  A.segments.push({
    end: E,
    start: E,
    delta: -(E - B),
    offset: 0,
    glyphIndex: B
  });
}
function Cr(A) {
  A.segments.push({
    end: 65535,
    start: 65535,
    delta: 1,
    offset: 0
  });
}
function Dr(A) {
  var E = !0, B;
  for (B = A.length - 1; B > 0; B -= 1) {
    var e = A.get(B);
    if (e.unicode > 65535) {
      console.log("Adding CMAP format 12 (needed!)"), E = !1;
      break;
    }
  }
  var t = [
    { name: "version", type: "USHORT", value: 0 },
    { name: "numTables", type: "USHORT", value: E ? 1 : 2 },
    // CMAP 4 header
    { name: "platformID", type: "USHORT", value: 3 },
    { name: "encodingID", type: "USHORT", value: 1 },
    { name: "offset", type: "ULONG", value: E ? 12 : 20 }
  ];
  E || (t = t.concat([
    // CMAP 12 header
    { name: "cmap12PlatformID", type: "USHORT", value: 3 },
    // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
    { name: "cmap12EncodingID", type: "USHORT", value: 10 },
    { name: "cmap12Offset", type: "ULONG", value: 0 }
  ])), t = t.concat([
    // CMAP 4 Subtable
    { name: "format", type: "USHORT", value: 4 },
    { name: "cmap4Length", type: "USHORT", value: 0 },
    { name: "language", type: "USHORT", value: 0 },
    { name: "segCountX2", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  var g = new L.Table("cmap", t);
  for (g.segments = [], B = 0; B < A.length; B += 1) {
    for (var M = A.get(B), Q = 0; Q < M.unicodes.length; Q += 1)
      Rr(g, M.unicodes[Q], B);
    g.segments = g.segments.sort(function(C, F) {
      return C.start - F.start;
    });
  }
  Cr(g);
  var s = g.segments.length, r = 0, w = [], c = [], n = [], a = [], o = [], D = [];
  for (B = 0; B < s; B += 1) {
    var R = g.segments[B];
    R.end <= 65535 && R.start <= 65535 ? (w = w.concat({ name: "end_" + B, type: "USHORT", value: R.end }), c = c.concat({ name: "start_" + B, type: "USHORT", value: R.start }), n = n.concat({ name: "idDelta_" + B, type: "SHORT", value: R.delta }), a = a.concat({ name: "idRangeOffset_" + B, type: "USHORT", value: R.offset }), R.glyphId !== void 0 && (o = o.concat({ name: "glyph_" + B, type: "USHORT", value: R.glyphId }))) : r += 1, !E && R.glyphIndex !== void 0 && (D = D.concat({ name: "cmap12Start_" + B, type: "ULONG", value: R.start }), D = D.concat({ name: "cmap12End_" + B, type: "ULONG", value: R.end }), D = D.concat({ name: "cmap12Glyph_" + B, type: "ULONG", value: R.glyphIndex }));
  }
  if (g.segCountX2 = (s - r) * 2, g.searchRange = Math.pow(2, Math.floor(Math.log(s - r) / Math.log(2))) * 2, g.entrySelector = Math.log(g.searchRange / 2) / Math.log(2), g.rangeShift = g.segCountX2 - g.searchRange, g.fields = g.fields.concat(w), g.fields.push({ name: "reservedPad", type: "USHORT", value: 0 }), g.fields = g.fields.concat(c), g.fields = g.fields.concat(n), g.fields = g.fields.concat(a), g.fields = g.fields.concat(o), g.cmap4Length = 14 + // Subtable header
  w.length * 2 + 2 + // reservedPad
  c.length * 2 + n.length * 2 + a.length * 2 + o.length * 2, !E) {
    var i = 16 + // Subtable header
    D.length * 4;
    g.cmap12Offset = 20 + g.cmap4Length, g.fields = g.fields.concat([
      { name: "cmap12Format", type: "USHORT", value: 12 },
      { name: "cmap12Reserved", type: "USHORT", value: 0 },
      { name: "cmap12Length", type: "ULONG", value: i },
      { name: "cmap12Language", type: "ULONG", value: 0 },
      { name: "cmap12nGroups", type: "ULONG", value: D.length / 3 }
    ]), g.fields = g.fields.concat(D);
  }
  return g;
}
var aM = { parse: Fr, make: Dr }, TB = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "266 ff",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
], lr = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], xr = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], aE = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
function oM(A) {
  this.font = A;
}
oM.prototype.charToGlyphIndex = function(A) {
  var E = A.codePointAt(0), B = this.font.glyphs;
  if (B) {
    for (var e = 0; e < B.length; e += 1)
      for (var t = B.get(e), g = 0; g < t.unicodes.length; g += 1)
        if (t.unicodes[g] === E)
          return e;
  }
  return null;
};
function iM(A) {
  this.cmap = A;
}
iM.prototype.charToGlyphIndex = function(A) {
  return this.cmap.glyphIndexMap[A.codePointAt(0)] || 0;
};
function pB(A, E) {
  this.encoding = A, this.charset = E;
}
pB.prototype.charToGlyphIndex = function(A) {
  var E = A.codePointAt(0), B = this.encoding[E];
  return this.charset.indexOf(B);
};
function at(A) {
  switch (A.version) {
    case 1:
      this.names = aE.slice();
      break;
    case 2:
      this.names = new Array(A.numberOfGlyphs);
      for (var E = 0; E < A.numberOfGlyphs; E++)
        A.glyphNameIndex[E] < aE.length ? this.names[E] = aE[A.glyphNameIndex[E]] : this.names[E] = A.names[A.glyphNameIndex[E] - aE.length];
      break;
    case 2.5:
      this.names = new Array(A.numberOfGlyphs);
      for (var B = 0; B < A.numberOfGlyphs; B++)
        this.names[B] = aE[B + A.glyphNameIndex[B]];
      break;
    case 3:
      this.names = [];
      break;
    default:
      this.names = [];
      break;
  }
}
at.prototype.nameToGlyphIndex = function(A) {
  return this.names.indexOf(A);
};
at.prototype.glyphIndexToName = function(A) {
  return this.names[A];
};
function Tr(A) {
  for (var E, B = A.tables.cmap.glyphIndexMap, e = Object.keys(B), t = 0; t < e.length; t += 1) {
    var g = e[t], M = B[g];
    E = A.glyphs.get(M), E.addUnicode(parseInt(g));
  }
  for (var Q = 0; Q < A.glyphs.length; Q += 1)
    E = A.glyphs.get(Q), A.cffEncoding ? A.isCIDFont ? E.name = "gid" + Q : E.name = A.cffEncoding.charset[Q] : A.glyphNames.names && (E.name = A.glyphNames.glyphIndexToName(Q));
}
function hr(A) {
  A._IndexToUnicodeMap = {};
  for (var E = A.tables.cmap.glyphIndexMap, B = Object.keys(E), e = 0; e < B.length; e += 1) {
    var t = B[e], g = E[t];
    A._IndexToUnicodeMap[g] === void 0 ? A._IndexToUnicodeMap[g] = {
      unicodes: [parseInt(t)]
    } : A._IndexToUnicodeMap[g].unicodes.push(parseInt(t));
  }
}
function ur(A, E) {
  E.lowMemory ? hr(A) : Tr(A);
}
function fr(A, E, B, e, t) {
  A.beginPath(), A.moveTo(E, B), A.lineTo(e, t), A.stroke();
}
var wE = { line: fr };
function Ur(A, E) {
  var B = E || new FA();
  return {
    configurable: !0,
    get: function() {
      return typeof B == "function" && (B = B()), B;
    },
    set: function(e) {
      B = e;
    }
  };
}
function hA(A) {
  this.bindConstructorValues(A);
}
hA.prototype.bindConstructorValues = function(A) {
  this.index = A.index || 0, this.name = A.name || null, this.unicode = A.unicode || void 0, this.unicodes = A.unicodes || A.unicode !== void 0 ? [A.unicode] : [], "xMin" in A && (this.xMin = A.xMin), "yMin" in A && (this.yMin = A.yMin), "xMax" in A && (this.xMax = A.xMax), "yMax" in A && (this.yMax = A.yMax), "advanceWidth" in A && (this.advanceWidth = A.advanceWidth), Object.defineProperty(this, "path", Ur(this, A.path));
};
hA.prototype.addUnicode = function(A) {
  this.unicodes.length === 0 && (this.unicode = A), this.unicodes.push(A);
};
hA.prototype.getBoundingBox = function() {
  return this.path.getBoundingBox();
};
hA.prototype.getPath = function(A, E, B, e, t) {
  A = A !== void 0 ? A : 0, E = E !== void 0 ? E : 0, B = B !== void 0 ? B : 72;
  var g, M;
  e || (e = {});
  var Q = e.xScale, s = e.yScale;
  if (e.hinting && t && t.hinting && (M = this.path && t.hinting.exec(this, B)), M)
    g = t.hinting.getCommands(M), A = Math.round(A), E = Math.round(E), Q = s = 1;
  else {
    g = this.path.commands;
    var r = 1 / (this.path.unitsPerEm || 1e3) * B;
    Q === void 0 && (Q = r), s === void 0 && (s = r);
  }
  for (var w = new FA(), c = 0; c < g.length; c += 1) {
    var n = g[c];
    n.type === "M" ? w.moveTo(A + n.x * Q, E + -n.y * s) : n.type === "L" ? w.lineTo(A + n.x * Q, E + -n.y * s) : n.type === "Q" ? w.quadraticCurveTo(
      A + n.x1 * Q,
      E + -n.y1 * s,
      A + n.x * Q,
      E + -n.y * s
    ) : n.type === "C" ? w.curveTo(
      A + n.x1 * Q,
      E + -n.y1 * s,
      A + n.x2 * Q,
      E + -n.y2 * s,
      A + n.x * Q,
      E + -n.y * s
    ) : n.type === "Z" && w.closePath();
  }
  return w;
};
hA.prototype.getContours = function() {
  if (this.points === void 0)
    return [];
  for (var A = [], E = [], B = 0; B < this.points.length; B += 1) {
    var e = this.points[B];
    E.push(e), e.lastPointOfContour && (A.push(E), E = []);
  }
  return gA.argument(E.length === 0, "There are still points left in the current contour."), A;
};
hA.prototype.getMetrics = function() {
  for (var A = this.path.commands, E = [], B = [], e = 0; e < A.length; e += 1) {
    var t = A[e];
    t.type !== "Z" && (E.push(t.x), B.push(t.y)), (t.type === "Q" || t.type === "C") && (E.push(t.x1), B.push(t.y1)), t.type === "C" && (E.push(t.x2), B.push(t.y2));
  }
  var g = {
    xMin: Math.min.apply(null, E),
    yMin: Math.min.apply(null, B),
    xMax: Math.max.apply(null, E),
    yMax: Math.max.apply(null, B),
    leftSideBearing: this.leftSideBearing
  };
  return isFinite(g.xMin) || (g.xMin = 0), isFinite(g.xMax) || (g.xMax = this.advanceWidth), isFinite(g.yMin) || (g.yMin = 0), isFinite(g.yMax) || (g.yMax = 0), g.rightSideBearing = this.advanceWidth - g.leftSideBearing - (g.xMax - g.xMin), g;
};
hA.prototype.draw = function(A, E, B, e, t) {
  this.getPath(E, B, e, t).draw(A);
};
hA.prototype.drawPoints = function(A, E, B, e) {
  function t(c, n, a, o) {
    A.beginPath();
    for (var D = 0; D < c.length; D += 1)
      A.moveTo(n + c[D].x * o, a + c[D].y * o), A.arc(n + c[D].x * o, a + c[D].y * o, 2, 0, Math.PI * 2, !1);
    A.closePath(), A.fill();
  }
  E = E !== void 0 ? E : 0, B = B !== void 0 ? B : 0, e = e !== void 0 ? e : 24;
  for (var g = 1 / this.path.unitsPerEm * e, M = [], Q = [], s = this.path, r = 0; r < s.commands.length; r += 1) {
    var w = s.commands[r];
    w.x !== void 0 && M.push({ x: w.x, y: -w.y }), w.x1 !== void 0 && Q.push({ x: w.x1, y: -w.y1 }), w.x2 !== void 0 && Q.push({ x: w.x2, y: -w.y2 });
  }
  A.fillStyle = "blue", t(M, E, B, g), A.fillStyle = "red", t(Q, E, B, g);
};
hA.prototype.drawMetrics = function(A, E, B, e) {
  var t;
  E = E !== void 0 ? E : 0, B = B !== void 0 ? B : 0, e = e !== void 0 ? e : 24, t = 1 / this.path.unitsPerEm * e, A.lineWidth = 1, A.strokeStyle = "black", wE.line(A, E, -1e4, E, 1e4), wE.line(A, -1e4, B, 1e4, B);
  var g = this.xMin || 0, M = this.yMin || 0, Q = this.xMax || 0, s = this.yMax || 0, r = this.advanceWidth || 0;
  A.strokeStyle = "blue", wE.line(A, E + g * t, -1e4, E + g * t, 1e4), wE.line(A, E + Q * t, -1e4, E + Q * t, 1e4), wE.line(A, -1e4, B + -M * t, 1e4, B + -M * t), wE.line(A, -1e4, B + -s * t, 1e4, B + -s * t), A.strokeStyle = "green", wE.line(A, E + r * t, -1e4, E + r * t, 1e4);
};
function FB(A, E, B) {
  Object.defineProperty(A, E, {
    get: function() {
      return A.path, A[B];
    },
    set: function(e) {
      A[B] = e;
    },
    enumerable: !0,
    configurable: !0
  });
}
function ot(A, E) {
  if (this.font = A, this.glyphs = {}, Array.isArray(E))
    for (var B = 0; B < E.length; B++) {
      var e = E[B];
      e.path.unitsPerEm = A.unitsPerEm, this.glyphs[B] = e;
    }
  this.length = E && E.length || 0;
}
ot.prototype.get = function(A) {
  if (this.glyphs[A] === void 0) {
    this.font._push(A), typeof this.glyphs[A] == "function" && (this.glyphs[A] = this.glyphs[A]());
    var E = this.glyphs[A], B = this.font._IndexToUnicodeMap[A];
    if (B)
      for (var e = 0; e < B.unicodes.length; e++)
        E.addUnicode(B.unicodes[e]);
    this.font.cffEncoding ? this.font.isCIDFont ? E.name = "gid" + A : E.name = this.font.cffEncoding.charset[A] : this.font.glyphNames.names && (E.name = this.font.glyphNames.glyphIndexToName(A)), this.glyphs[A].advanceWidth = this.font._hmtxTableData[A].advanceWidth, this.glyphs[A].leftSideBearing = this.font._hmtxTableData[A].leftSideBearing;
  } else
    typeof this.glyphs[A] == "function" && (this.glyphs[A] = this.glyphs[A]());
  return this.glyphs[A];
};
ot.prototype.push = function(A, E) {
  this.glyphs[A] = E, this.length++;
};
function zr(A, E) {
  return new hA({ index: E, font: A });
}
function Yr(A, E, B, e, t, g) {
  return function() {
    var M = new hA({ index: E, font: A });
    return M.path = function() {
      B(M, e, t);
      var Q = g(A.glyphs, M);
      return Q.unitsPerEm = A.unitsPerEm, Q;
    }, FB(M, "xMin", "_xMin"), FB(M, "xMax", "_xMax"), FB(M, "yMin", "_yMin"), FB(M, "yMax", "_yMax"), M;
  };
}
function kr(A, E, B, e) {
  return function() {
    var t = new hA({ index: E, font: A });
    return t.path = function() {
      var g = B(A, t, e);
      return g.unitsPerEm = A.unitsPerEm, g;
    }, t;
  };
}
var HA = { GlyphSet: ot, glyphLoader: zr, ttfGlyphLoader: Yr, cffGlyphLoader: kr };
function IM(A, E) {
  if (A === E)
    return !0;
  if (Array.isArray(A) && Array.isArray(E)) {
    if (A.length !== E.length)
      return !1;
    for (var B = 0; B < A.length; B += 1)
      if (!IM(A[B], E[B]))
        return !1;
    return !0;
  } else
    return !1;
}
function Se(A) {
  var E;
  return A.length < 1240 ? E = 107 : A.length < 33900 ? E = 1131 : E = 32768, E;
}
function EE(A, E, B) {
  var e = [], t = [], g = K.getCard16(A, E), M, Q;
  if (g !== 0) {
    var s = K.getByte(A, E + 2);
    M = E + (g + 1) * s + 2;
    for (var r = E + 3, w = 0; w < g + 1; w += 1)
      e.push(K.getOffset(A, r, s)), r += s;
    Q = M + e[g];
  } else
    Q = E + 2;
  for (var c = 0; c < e.length - 1; c += 1) {
    var n = K.getBytes(A, M + e[c], M + e[c + 1]);
    B && (n = B(n)), t.push(n);
  }
  return { objects: t, startOffset: E, endOffset: Q };
}
function dr(A, E) {
  var B = [], e = K.getCard16(A, E), t, g;
  if (e !== 0) {
    var M = K.getByte(A, E + 2);
    t = E + (e + 1) * M + 2;
    for (var Q = E + 3, s = 0; s < e + 1; s += 1)
      B.push(K.getOffset(A, Q, M)), Q += M;
    g = t + B[e];
  } else
    g = E + 2;
  return { offsets: B, startOffset: E, endOffset: g };
}
function Gr(A, E, B, e, t) {
  var g = K.getCard16(B, e), M = 0;
  if (g !== 0) {
    var Q = K.getByte(B, e + 2);
    M = e + (g + 1) * Q + 2;
  }
  var s = K.getBytes(B, M + E[A], M + E[A + 1]);
  return s;
}
function yr(A) {
  for (var E = "", B = 15, e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"]; ; ) {
    var t = A.parseByte(), g = t >> 4, M = t & 15;
    if (g === B || (E += e[g], M === B))
      break;
    E += e[M];
  }
  return parseFloat(E);
}
function Sr(A, E) {
  var B, e, t, g;
  if (E === 28)
    return B = A.parseByte(), e = A.parseByte(), B << 8 | e;
  if (E === 29)
    return B = A.parseByte(), e = A.parseByte(), t = A.parseByte(), g = A.parseByte(), B << 24 | e << 16 | t << 8 | g;
  if (E === 30)
    return yr(A);
  if (E >= 32 && E <= 246)
    return E - 139;
  if (E >= 247 && E <= 250)
    return B = A.parseByte(), (E - 247) * 256 + B + 108;
  if (E >= 251 && E <= 254)
    return B = A.parseByte(), -(E - 251) * 256 - B - 108;
  throw new Error("Invalid b0 " + E);
}
function pr(A) {
  for (var E = {}, B = 0; B < A.length; B += 1) {
    var e = A[B][0], t = A[B][1], g = void 0;
    if (t.length === 1 ? g = t[0] : g = t, E.hasOwnProperty(e) && !isNaN(E[e]))
      throw new Error("Object " + E + " already has key " + e);
    E[e] = g;
  }
  return E;
}
function FM(A, E, B) {
  E = E !== void 0 ? E : 0;
  var e = new K.Parser(A, E), t = [], g = [];
  for (B = B !== void 0 ? B : A.length; e.relativeOffset < B; ) {
    var M = e.parseByte();
    M <= 21 ? (M === 12 && (M = 1200 + e.parseByte()), t.push([M, g]), g = []) : g.push(Sr(e, M));
  }
  return pr(t);
}
function XE(A, E) {
  return E <= 390 ? E = TB[E] : E = A[E - 391], E;
}
function RM(A, E, B) {
  for (var e = {}, t, g = 0; g < E.length; g += 1) {
    var M = E[g];
    if (Array.isArray(M.type)) {
      var Q = [];
      Q.length = M.type.length;
      for (var s = 0; s < M.type.length; s++)
        t = A[M.op] !== void 0 ? A[M.op][s] : void 0, t === void 0 && (t = M.value !== void 0 && M.value[s] !== void 0 ? M.value[s] : null), M.type[s] === "SID" && (t = XE(B, t)), Q[s] = t;
      e[M.name] = Q;
    } else
      t = A[M.op], t === void 0 && (t = M.value !== void 0 ? M.value : null), M.type === "SID" && (t = XE(B, t)), e[M.name] = t;
  }
  return e;
}
function Pr(A, E) {
  var B = {};
  return B.formatMajor = K.getCard8(A, E), B.formatMinor = K.getCard8(A, E + 1), B.size = K.getCard8(A, E + 2), B.offsetSize = K.getCard8(A, E + 3), B.startOffset = E, B.endOffset = E + 4, B;
}
var CM = [
  { name: "version", op: 0, type: "SID" },
  { name: "notice", op: 1, type: "SID" },
  { name: "copyright", op: 1200, type: "SID" },
  { name: "fullName", op: 2, type: "SID" },
  { name: "familyName", op: 3, type: "SID" },
  { name: "weight", op: 4, type: "SID" },
  { name: "isFixedPitch", op: 1201, type: "number", value: 0 },
  { name: "italicAngle", op: 1202, type: "number", value: 0 },
  { name: "underlinePosition", op: 1203, type: "number", value: -100 },
  { name: "underlineThickness", op: 1204, type: "number", value: 50 },
  { name: "paintType", op: 1205, type: "number", value: 0 },
  { name: "charstringType", op: 1206, type: "number", value: 2 },
  {
    name: "fontMatrix",
    op: 1207,
    type: ["real", "real", "real", "real", "real", "real"],
    value: [1e-3, 0, 0, 1e-3, 0, 0]
  },
  { name: "uniqueId", op: 13, type: "number" },
  { name: "fontBBox", op: 5, type: ["number", "number", "number", "number"], value: [0, 0, 0, 0] },
  { name: "strokeWidth", op: 1208, type: "number", value: 0 },
  { name: "xuid", op: 14, type: [], value: null },
  { name: "charset", op: 15, type: "offset", value: 0 },
  { name: "encoding", op: 16, type: "offset", value: 0 },
  { name: "charStrings", op: 17, type: "offset", value: 0 },
  { name: "private", op: 18, type: ["number", "offset"], value: [0, 0] },
  { name: "ros", op: 1230, type: ["SID", "SID", "number"] },
  { name: "cidFontVersion", op: 1231, type: "number", value: 0 },
  { name: "cidFontRevision", op: 1232, type: "number", value: 0 },
  { name: "cidFontType", op: 1233, type: "number", value: 0 },
  { name: "cidCount", op: 1234, type: "number", value: 8720 },
  { name: "uidBase", op: 1235, type: "number" },
  { name: "fdArray", op: 1236, type: "offset" },
  { name: "fdSelect", op: 1237, type: "offset" },
  { name: "fontName", op: 1238, type: "SID" }
], DM = [
  { name: "subrs", op: 19, type: "offset", value: 0 },
  { name: "defaultWidthX", op: 20, type: "number", value: 0 },
  { name: "nominalWidthX", op: 21, type: "number", value: 0 }
];
function vr(A, E) {
  var B = FM(A, 0, A.byteLength);
  return RM(B, CM, E);
}
function lM(A, E, B, e) {
  var t = FM(A, E, B);
  return RM(t, DM, e);
}
function _t(A, E, B, e) {
  for (var t = [], g = 0; g < B.length; g += 1) {
    var M = new DataView(new Uint8Array(B[g]).buffer), Q = vr(M, e);
    Q._subrs = [], Q._subrsBias = 0, Q._defaultWidthX = 0, Q._nominalWidthX = 0;
    var s = Q.private[0], r = Q.private[1];
    if (s !== 0 && r !== 0) {
      var w = lM(A, r + E, s, e);
      if (Q._defaultWidthX = w.defaultWidthX, Q._nominalWidthX = w.nominalWidthX, w.subrs !== 0) {
        var c = r + w.subrs, n = EE(A, c + E);
        Q._subrs = n.objects, Q._subrsBias = Se(Q._subrs);
      }
      Q._privateDict = w;
    }
    t.push(Q);
  }
  return t;
}
function Nr(A, E, B, e) {
  var t, g, M = new K.Parser(A, E);
  B -= 1;
  var Q = [".notdef"], s = M.parseCard8();
  if (s === 0)
    for (var r = 0; r < B; r += 1)
      t = M.parseSID(), Q.push(XE(e, t));
  else if (s === 1)
    for (; Q.length <= B; ) {
      t = M.parseSID(), g = M.parseCard8();
      for (var w = 0; w <= g; w += 1)
        Q.push(XE(e, t)), t += 1;
    }
  else if (s === 2)
    for (; Q.length <= B; ) {
      t = M.parseSID(), g = M.parseCard16();
      for (var c = 0; c <= g; c += 1)
        Q.push(XE(e, t)), t += 1;
    }
  else
    throw new Error("Unknown charset format " + s);
  return Q;
}
function Hr(A, E, B) {
  var e, t = {}, g = new K.Parser(A, E), M = g.parseCard8();
  if (M === 0)
    for (var Q = g.parseCard8(), s = 0; s < Q; s += 1)
      e = g.parseCard8(), t[e] = s;
  else if (M === 1) {
    var r = g.parseCard8();
    e = 1;
    for (var w = 0; w < r; w += 1)
      for (var c = g.parseCard8(), n = g.parseCard8(), a = c; a <= c + n; a += 1)
        t[a] = e, e += 1;
  } else
    throw new Error("Unknown encoding format " + M);
  return new pB(t, B);
}
function $t(A, E, B) {
  var e, t, g, M, Q = new FA(), s = [], r = 0, w = !1, c = !1, n = 0, a = 0, o, D, R, i;
  if (A.isCIDFont) {
    var C = A.tables.cff.topDict._fdSelect[E.index], F = A.tables.cff.topDict._fdArray[C];
    o = F._subrs, D = F._subrsBias, R = F._defaultWidthX, i = F._nominalWidthX;
  } else
    o = A.tables.cff.topDict._subrs, D = A.tables.cff.topDict._subrsBias, R = A.tables.cff.topDict._defaultWidthX, i = A.tables.cff.topDict._nominalWidthX;
  var l = R;
  function T(x, U) {
    c && Q.closePath(), Q.moveTo(x, U), c = !0;
  }
  function u() {
    var x;
    x = s.length % 2 !== 0, x && !w && (l = s.shift() + i), r += s.length >> 1, s.length = 0, w = !0;
  }
  function h(x) {
    for (var U, z, k, P, y, G, d, S, v, j, m, b, N = 0; N < x.length; ) {
      var f = x[N];
      switch (N += 1, f) {
        case 1:
          u();
          break;
        case 3:
          u();
          break;
        case 4:
          s.length > 1 && !w && (l = s.shift() + i, w = !0), a += s.pop(), T(n, a);
          break;
        case 5:
          for (; s.length > 0; )
            n += s.shift(), a += s.shift(), Q.lineTo(n, a);
          break;
        case 6:
          for (; s.length > 0 && (n += s.shift(), Q.lineTo(n, a), s.length !== 0); )
            a += s.shift(), Q.lineTo(n, a);
          break;
        case 7:
          for (; s.length > 0 && (a += s.shift(), Q.lineTo(n, a), s.length !== 0); )
            n += s.shift(), Q.lineTo(n, a);
          break;
        case 8:
          for (; s.length > 0; )
            e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M + s.shift(), Q.curveTo(e, t, g, M, n, a);
          break;
        case 10:
          y = s.pop() + D, G = o[y], G && h(G);
          break;
        case 11:
          return;
        case 12:
          switch (f = x[N], N += 1, f) {
            case 35:
              e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), d = g + s.shift(), S = M + s.shift(), v = d + s.shift(), j = S + s.shift(), m = v + s.shift(), b = j + s.shift(), n = m + s.shift(), a = b + s.shift(), s.shift(), Q.curveTo(e, t, g, M, d, S), Q.curveTo(v, j, m, b, n, a);
              break;
            case 34:
              e = n + s.shift(), t = a, g = e + s.shift(), M = t + s.shift(), d = g + s.shift(), S = M, v = d + s.shift(), j = M, m = v + s.shift(), b = a, n = m + s.shift(), Q.curveTo(e, t, g, M, d, S), Q.curveTo(v, j, m, b, n, a);
              break;
            case 36:
              e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), d = g + s.shift(), S = M, v = d + s.shift(), j = M, m = v + s.shift(), b = j + s.shift(), n = m + s.shift(), Q.curveTo(e, t, g, M, d, S), Q.curveTo(v, j, m, b, n, a);
              break;
            case 37:
              e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), d = g + s.shift(), S = M + s.shift(), v = d + s.shift(), j = S + s.shift(), m = v + s.shift(), b = j + s.shift(), Math.abs(m - n) > Math.abs(b - a) ? n = m + s.shift() : a = b + s.shift(), Q.curveTo(e, t, g, M, d, S), Q.curveTo(v, j, m, b, n, a);
              break;
            default:
              console.log("Glyph " + E.index + ": unknown operator 1200" + f), s.length = 0;
          }
          break;
        case 14:
          s.length > 0 && !w && (l = s.shift() + i, w = !0), c && (Q.closePath(), c = !1);
          break;
        case 18:
          u();
          break;
        case 19:
        // hintmask
        case 20:
          u(), N += r + 7 >> 3;
          break;
        case 21:
          s.length > 2 && !w && (l = s.shift() + i, w = !0), a += s.pop(), n += s.pop(), T(n, a);
          break;
        case 22:
          s.length > 1 && !w && (l = s.shift() + i, w = !0), n += s.pop(), T(n, a);
          break;
        case 23:
          u();
          break;
        case 24:
          for (; s.length > 2; )
            e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M + s.shift(), Q.curveTo(e, t, g, M, n, a);
          n += s.shift(), a += s.shift(), Q.lineTo(n, a);
          break;
        case 25:
          for (; s.length > 6; )
            n += s.shift(), a += s.shift(), Q.lineTo(n, a);
          e = n + s.shift(), t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M + s.shift(), Q.curveTo(e, t, g, M, n, a);
          break;
        case 26:
          for (s.length % 2 && (n += s.shift()); s.length > 0; )
            e = n, t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g, a = M + s.shift(), Q.curveTo(e, t, g, M, n, a);
          break;
        case 27:
          for (s.length % 2 && (a += s.shift()); s.length > 0; )
            e = n + s.shift(), t = a, g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M, Q.curveTo(e, t, g, M, n, a);
          break;
        case 28:
          U = x[N], z = x[N + 1], s.push((U << 24 | z << 16) >> 16), N += 2;
          break;
        case 29:
          y = s.pop() + A.gsubrsBias, G = A.gsubrs[y], G && h(G);
          break;
        case 30:
          for (; s.length > 0 && (e = n, t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M + (s.length === 1 ? s.shift() : 0), Q.curveTo(e, t, g, M, n, a), s.length !== 0); )
            e = n + s.shift(), t = a, g = e + s.shift(), M = t + s.shift(), a = M + s.shift(), n = g + (s.length === 1 ? s.shift() : 0), Q.curveTo(e, t, g, M, n, a);
          break;
        case 31:
          for (; s.length > 0 && (e = n + s.shift(), t = a, g = e + s.shift(), M = t + s.shift(), a = M + s.shift(), n = g + (s.length === 1 ? s.shift() : 0), Q.curveTo(e, t, g, M, n, a), s.length !== 0); )
            e = n, t = a + s.shift(), g = e + s.shift(), M = t + s.shift(), n = g + s.shift(), a = M + (s.length === 1 ? s.shift() : 0), Q.curveTo(e, t, g, M, n, a);
          break;
        default:
          f < 32 ? console.log("Glyph " + E.index + ": unknown operator " + f) : f < 247 ? s.push(f - 139) : f < 251 ? (U = x[N], N += 1, s.push((f - 247) * 256 + U + 108)) : f < 255 ? (U = x[N], N += 1, s.push(-(f - 251) * 256 - U - 108)) : (U = x[N], z = x[N + 1], k = x[N + 2], P = x[N + 3], N += 4, s.push((U << 24 | z << 16 | k << 8 | P) / 65536));
      }
    }
  }
  return h(B), E.advanceWidth = l, Q;
}
function mr(A, E, B, e) {
  var t = [], g, M = new K.Parser(A, E), Q = M.parseCard8();
  if (Q === 0)
    for (var s = 0; s < B; s++) {
      if (g = M.parseCard8(), g >= e)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + g + " (FD count " + e + ")");
      t.push(g);
    }
  else if (Q === 3) {
    var r = M.parseCard16(), w = M.parseCard16();
    if (w !== 0)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + w);
    for (var c, n = 0; n < r; n++) {
      if (g = M.parseCard8(), c = M.parseCard16(), g >= e)
        throw new Error("CFF table CID Font FDSelect has bad FD index value " + g + " (FD count " + e + ")");
      if (c > B)
        throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + c);
      for (; w < c; w++)
        t.push(g);
      w = c;
    }
    if (c !== B)
      throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + c);
  } else
    throw new Error("CFF Table CID Font FDSelect table has unsupported format " + Q);
  return t;
}
function Vr(A, E, B, e) {
  B.tables.cff = {};
  var t = Pr(A, E), g = EE(A, t.endOffset, K.bytesToString), M = EE(A, g.endOffset), Q = EE(A, M.endOffset, K.bytesToString), s = EE(A, Q.endOffset);
  B.gsubrs = s.objects, B.gsubrsBias = Se(B.gsubrs);
  var r = _t(A, E, M.objects, Q.objects);
  if (r.length !== 1)
    throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + r.length);
  var w = r[0];
  if (B.tables.cff.topDict = w, w._privateDict && (B.defaultWidthX = w._privateDict.defaultWidthX, B.nominalWidthX = w._privateDict.nominalWidthX), w.ros[0] !== void 0 && w.ros[1] !== void 0 && (B.isCIDFont = !0), B.isCIDFont) {
    var c = w.fdArray, n = w.fdSelect;
    if (c === 0 || n === 0)
      throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
    c += E;
    var a = EE(A, c), o = _t(A, E, a.objects, Q.objects);
    w._fdArray = o, n += E, w._fdSelect = mr(A, n, B.numGlyphs, o.length);
  }
  var D = E + w.private[1], R = lM(A, D, w.private[0], Q.objects);
  if (B.defaultWidthX = R.defaultWidthX, B.nominalWidthX = R.nominalWidthX, R.subrs !== 0) {
    var i = D + R.subrs, C = EE(A, i);
    B.subrs = C.objects, B.subrsBias = Se(B.subrs);
  } else
    B.subrs = [], B.subrsBias = 0;
  var F;
  e.lowMemory ? (F = dr(A, E + w.charStrings), B.nGlyphs = F.offsets.length) : (F = EE(A, E + w.charStrings), B.nGlyphs = F.objects.length);
  var l = Nr(A, E + w.charset, B.nGlyphs, Q.objects);
  if (w.encoding === 0 ? B.cffEncoding = new pB(lr, l) : w.encoding === 1 ? B.cffEncoding = new pB(xr, l) : B.cffEncoding = Hr(A, E + w.encoding, l), B.encoding = B.encoding || B.cffEncoding, B.glyphs = new HA.GlyphSet(B), e.lowMemory)
    B._push = function(h) {
      var x = Gr(h, F.offsets, A, E + w.charStrings);
      B.glyphs.push(h, HA.cffGlyphLoader(B, h, $t, x));
    };
  else
    for (var T = 0; T < B.nGlyphs; T += 1) {
      var u = F.objects[T];
      B.glyphs.push(T, HA.cffGlyphLoader(B, T, $t, u));
    }
}
function xM(A, E) {
  var B, e = TB.indexOf(A);
  return e >= 0 && (B = e), e = E.indexOf(A), e >= 0 ? B = e + TB.length : (B = TB.length + E.length, E.push(A)), B;
}
function Jr() {
  return new L.Record("Header", [
    { name: "major", type: "Card8", value: 1 },
    { name: "minor", type: "Card8", value: 0 },
    { name: "hdrSize", type: "Card8", value: 4 },
    { name: "major", type: "Card8", value: 1 }
  ]);
}
function br(A) {
  var E = new L.Record("Name INDEX", [
    { name: "names", type: "INDEX", value: [] }
  ]);
  E.names = [];
  for (var B = 0; B < A.length; B += 1)
    E.names.push({ name: "name_" + B, type: "NAME", value: A[B] });
  return E;
}
function TM(A, E, B) {
  for (var e = {}, t = 0; t < A.length; t += 1) {
    var g = A[t], M = E[g.name];
    M !== void 0 && !IM(M, g.value) && (g.type === "SID" && (M = xM(M, B)), e[g.op] = { name: g.name, type: g.type, value: M });
  }
  return e;
}
function Ag(A, E) {
  var B = new L.Record("Top DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return B.dict = TM(CM, A, E), B;
}
function Eg(A) {
  var E = new L.Record("Top DICT INDEX", [
    { name: "topDicts", type: "INDEX", value: [] }
  ]);
  return E.topDicts = [{ name: "topDict_0", type: "TABLE", value: A }], E;
}
function Or(A) {
  var E = new L.Record("String INDEX", [
    { name: "strings", type: "INDEX", value: [] }
  ]);
  E.strings = [];
  for (var B = 0; B < A.length; B += 1)
    E.strings.push({ name: "string_" + B, type: "STRING", value: A[B] });
  return E;
}
function jr() {
  return new L.Record("Global Subr INDEX", [
    { name: "subrs", type: "INDEX", value: [] }
  ]);
}
function Lr(A, E) {
  for (var B = new L.Record("Charsets", [
    { name: "format", type: "Card8", value: 0 }
  ]), e = 0; e < A.length; e += 1) {
    var t = A[e], g = xM(t, E);
    B.fields.push({ name: "glyph_" + e, type: "SID", value: g });
  }
  return B;
}
function Wr(A) {
  var E = [], B = A.path;
  E.push({ name: "width", type: "NUMBER", value: A.advanceWidth });
  for (var e = 0, t = 0, g = 0; g < B.commands.length; g += 1) {
    var M = void 0, Q = void 0, s = B.commands[g];
    if (s.type === "Q") {
      var r = 0.3333333333333333, w = 2 / 3;
      s = {
        type: "C",
        x: s.x,
        y: s.y,
        x1: Math.round(r * e + w * s.x1),
        y1: Math.round(r * t + w * s.y1),
        x2: Math.round(r * s.x + w * s.x1),
        y2: Math.round(r * s.y + w * s.y1)
      };
    }
    if (s.type === "M")
      M = Math.round(s.x - e), Q = Math.round(s.y - t), E.push({ name: "dx", type: "NUMBER", value: M }), E.push({ name: "dy", type: "NUMBER", value: Q }), E.push({ name: "rmoveto", type: "OP", value: 21 }), e = Math.round(s.x), t = Math.round(s.y);
    else if (s.type === "L")
      M = Math.round(s.x - e), Q = Math.round(s.y - t), E.push({ name: "dx", type: "NUMBER", value: M }), E.push({ name: "dy", type: "NUMBER", value: Q }), E.push({ name: "rlineto", type: "OP", value: 5 }), e = Math.round(s.x), t = Math.round(s.y);
    else if (s.type === "C") {
      var c = Math.round(s.x1 - e), n = Math.round(s.y1 - t), a = Math.round(s.x2 - s.x1), o = Math.round(s.y2 - s.y1);
      M = Math.round(s.x - s.x2), Q = Math.round(s.y - s.y2), E.push({ name: "dx1", type: "NUMBER", value: c }), E.push({ name: "dy1", type: "NUMBER", value: n }), E.push({ name: "dx2", type: "NUMBER", value: a }), E.push({ name: "dy2", type: "NUMBER", value: o }), E.push({ name: "dx", type: "NUMBER", value: M }), E.push({ name: "dy", type: "NUMBER", value: Q }), E.push({ name: "rrcurveto", type: "OP", value: 8 }), e = Math.round(s.x), t = Math.round(s.y);
    }
  }
  return E.push({ name: "endchar", type: "OP", value: 14 }), E;
}
function Xr(A) {
  for (var E = new L.Record("CharStrings INDEX", [
    { name: "charStrings", type: "INDEX", value: [] }
  ]), B = 0; B < A.length; B += 1) {
    var e = A.get(B), t = Wr(e);
    E.charStrings.push({ name: e.name, type: "CHARSTRING", value: t });
  }
  return E;
}
function Kr(A, E) {
  var B = new L.Record("Private DICT", [
    { name: "dict", type: "DICT", value: {} }
  ]);
  return B.dict = TM(DM, A, E), B;
}
function Zr(A, E) {
  for (var B = new L.Table("CFF ", [
    { name: "header", type: "RECORD" },
    { name: "nameIndex", type: "RECORD" },
    { name: "topDictIndex", type: "RECORD" },
    { name: "stringIndex", type: "RECORD" },
    { name: "globalSubrIndex", type: "RECORD" },
    { name: "charsets", type: "RECORD" },
    { name: "charStringsIndex", type: "RECORD" },
    { name: "privateDict", type: "RECORD" }
  ]), e = 1 / E.unitsPerEm, t = {
    version: E.version,
    fullName: E.fullName,
    familyName: E.familyName,
    weight: E.weightName,
    fontBBox: E.fontBBox || [0, 0, 0, 0],
    fontMatrix: [e, 0, 0, e, 0, 0],
    charset: 999,
    encoding: 0,
    charStrings: 999,
    private: [0, 999]
  }, g = {}, M = [], Q, s = 1; s < A.length; s += 1)
    Q = A.get(s), M.push(Q.name);
  var r = [];
  B.header = Jr(), B.nameIndex = br([E.postScriptName]);
  var w = Ag(t, r);
  B.topDictIndex = Eg(w), B.globalSubrIndex = jr(), B.charsets = Lr(M, r), B.charStringsIndex = Xr(A), B.privateDict = Kr(g, r), B.stringIndex = Or(r);
  var c = B.header.sizeOf() + B.nameIndex.sizeOf() + B.topDictIndex.sizeOf() + B.stringIndex.sizeOf() + B.globalSubrIndex.sizeOf();
  return t.charset = c, t.encoding = 0, t.charStrings = t.charset + B.charsets.sizeOf(), t.private[1] = t.charStrings + B.charStringsIndex.sizeOf(), w = Ag(t, r), B.topDictIndex = Eg(w), B;
}
var hM = { parse: Vr, make: Zr };
function qr(A, E) {
  var B = {}, e = new K.Parser(A, E);
  return B.version = e.parseVersion(), B.fontRevision = Math.round(e.parseFixed() * 1e3) / 1e3, B.checkSumAdjustment = e.parseULong(), B.magicNumber = e.parseULong(), gA.argument(B.magicNumber === 1594834165, "Font header has wrong magic number."), B.flags = e.parseUShort(), B.unitsPerEm = e.parseUShort(), B.created = e.parseLongDateTime(), B.modified = e.parseLongDateTime(), B.xMin = e.parseShort(), B.yMin = e.parseShort(), B.xMax = e.parseShort(), B.yMax = e.parseShort(), B.macStyle = e.parseUShort(), B.lowestRecPPEM = e.parseUShort(), B.fontDirectionHint = e.parseShort(), B.indexToLocFormat = e.parseShort(), B.glyphDataFormat = e.parseShort(), B;
}
function _r(A) {
  var E = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3) + 2082844800, B = E;
  return A.createdTimestamp && (B = A.createdTimestamp + 2082844800), new L.Table("head", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "fontRevision", type: "FIXED", value: 65536 },
    { name: "checkSumAdjustment", type: "ULONG", value: 0 },
    { name: "magicNumber", type: "ULONG", value: 1594834165 },
    { name: "flags", type: "USHORT", value: 0 },
    { name: "unitsPerEm", type: "USHORT", value: 1e3 },
    { name: "created", type: "LONGDATETIME", value: B },
    { name: "modified", type: "LONGDATETIME", value: E },
    { name: "xMin", type: "SHORT", value: 0 },
    { name: "yMin", type: "SHORT", value: 0 },
    { name: "xMax", type: "SHORT", value: 0 },
    { name: "yMax", type: "SHORT", value: 0 },
    { name: "macStyle", type: "USHORT", value: 0 },
    { name: "lowestRecPPEM", type: "USHORT", value: 0 },
    { name: "fontDirectionHint", type: "SHORT", value: 2 },
    { name: "indexToLocFormat", type: "SHORT", value: 0 },
    { name: "glyphDataFormat", type: "SHORT", value: 0 }
  ], A);
}
var uM = { parse: qr, make: _r };
function $r(A, E) {
  var B = {}, e = new K.Parser(A, E);
  return B.version = e.parseVersion(), B.ascender = e.parseShort(), B.descender = e.parseShort(), B.lineGap = e.parseShort(), B.advanceWidthMax = e.parseUShort(), B.minLeftSideBearing = e.parseShort(), B.minRightSideBearing = e.parseShort(), B.xMaxExtent = e.parseShort(), B.caretSlopeRise = e.parseShort(), B.caretSlopeRun = e.parseShort(), B.caretOffset = e.parseShort(), e.relativeOffset += 8, B.metricDataFormat = e.parseShort(), B.numberOfHMetrics = e.parseUShort(), B;
}
function An(A) {
  return new L.Table("hhea", [
    { name: "version", type: "FIXED", value: 65536 },
    { name: "ascender", type: "FWORD", value: 0 },
    { name: "descender", type: "FWORD", value: 0 },
    { name: "lineGap", type: "FWORD", value: 0 },
    { name: "advanceWidthMax", type: "UFWORD", value: 0 },
    { name: "minLeftSideBearing", type: "FWORD", value: 0 },
    { name: "minRightSideBearing", type: "FWORD", value: 0 },
    { name: "xMaxExtent", type: "FWORD", value: 0 },
    { name: "caretSlopeRise", type: "SHORT", value: 1 },
    { name: "caretSlopeRun", type: "SHORT", value: 0 },
    { name: "caretOffset", type: "SHORT", value: 0 },
    { name: "reserved1", type: "SHORT", value: 0 },
    { name: "reserved2", type: "SHORT", value: 0 },
    { name: "reserved3", type: "SHORT", value: 0 },
    { name: "reserved4", type: "SHORT", value: 0 },
    { name: "metricDataFormat", type: "SHORT", value: 0 },
    { name: "numberOfHMetrics", type: "USHORT", value: 0 }
  ], A);
}
var fM = { parse: $r, make: An };
function En(A, E, B, e, t) {
  for (var g, M, Q = new K.Parser(A, E), s = 0; s < e; s += 1) {
    s < B && (g = Q.parseUShort(), M = Q.parseShort());
    var r = t.get(s);
    r.advanceWidth = g, r.leftSideBearing = M;
  }
}
function Bn(A, E, B, e, t) {
  A._hmtxTableData = {};
  for (var g, M, Q = new K.Parser(E, B), s = 0; s < t; s += 1)
    s < e && (g = Q.parseUShort(), M = Q.parseShort()), A._hmtxTableData[s] = {
      advanceWidth: g,
      leftSideBearing: M
    };
}
function en(A, E, B, e, t, g, M) {
  M.lowMemory ? Bn(A, E, B, e, t) : En(E, B, e, t, g);
}
function tn(A) {
  for (var E = new L.Table("hmtx", []), B = 0; B < A.length; B += 1) {
    var e = A.get(B), t = e.advanceWidth || 0, g = e.leftSideBearing || 0;
    E.fields.push({ name: "advanceWidth_" + B, type: "USHORT", value: t }), E.fields.push({ name: "leftSideBearing_" + B, type: "SHORT", value: g });
  }
  return E;
}
var UM = { parse: en, make: tn };
function gn(A) {
  for (var E = new L.Table("ltag", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "numTags", type: "ULONG", value: A.length }
  ]), B = "", e = 12 + A.length * 4, t = 0; t < A.length; ++t) {
    var g = B.indexOf(A[t]);
    g < 0 && (g = B.length, B += A[t]), E.fields.push({ name: "offset " + t, type: "USHORT", value: e + g }), E.fields.push({ name: "length " + t, type: "USHORT", value: A[t].length });
  }
  return E.fields.push({ name: "stringPool", type: "CHARARRAY", value: B }), E;
}
function Mn(A, E) {
  var B = new K.Parser(A, E), e = B.parseULong();
  gA.argument(e === 1, "Unsupported ltag table version."), B.skip("uLong", 1);
  for (var t = B.parseULong(), g = [], M = 0; M < t; M++) {
    for (var Q = "", s = E + B.parseUShort(), r = B.parseUShort(), w = s; w < s + r; ++w)
      Q += String.fromCharCode(A.getInt8(w));
    g.push(Q);
  }
  return g;
}
var zM = { make: gn, parse: Mn };
function Qn(A, E) {
  var B = {}, e = new K.Parser(A, E);
  return B.version = e.parseVersion(), B.numGlyphs = e.parseUShort(), B.version === 1 && (B.maxPoints = e.parseUShort(), B.maxContours = e.parseUShort(), B.maxCompositePoints = e.parseUShort(), B.maxCompositeContours = e.parseUShort(), B.maxZones = e.parseUShort(), B.maxTwilightPoints = e.parseUShort(), B.maxStorage = e.parseUShort(), B.maxFunctionDefs = e.parseUShort(), B.maxInstructionDefs = e.parseUShort(), B.maxStackElements = e.parseUShort(), B.maxSizeOfInstructions = e.parseUShort(), B.maxComponentElements = e.parseUShort(), B.maxComponentDepth = e.parseUShort()), B;
}
function sn(A) {
  return new L.Table("maxp", [
    { name: "version", type: "FIXED", value: 20480 },
    { name: "numGlyphs", type: "USHORT", value: A }
  ]);
}
var YM = { parse: Qn, make: sn }, kM = [
  "copyright",
  // 0
  "fontFamily",
  // 1
  "fontSubfamily",
  // 2
  "uniqueID",
  // 3
  "fullName",
  // 4
  "version",
  // 5
  "postScriptName",
  // 6
  "trademark",
  // 7
  "manufacturer",
  // 8
  "designer",
  // 9
  "description",
  // 10
  "manufacturerURL",
  // 11
  "designerURL",
  // 12
  "license",
  // 13
  "licenseURL",
  // 14
  "reserved",
  // 15
  "preferredFamily",
  // 16
  "preferredSubfamily",
  // 17
  "compatibleFullName",
  // 18
  "sampleText",
  // 19
  "postScriptFindFontName",
  // 20
  "wwsFamily",
  // 21
  "wwsSubfamily"
  // 22
], dM = {
  0: "en",
  1: "fr",
  2: "de",
  3: "it",
  4: "nl",
  5: "sv",
  6: "es",
  7: "da",
  8: "pt",
  9: "no",
  10: "he",
  11: "ja",
  12: "ar",
  13: "fi",
  14: "el",
  15: "is",
  16: "mt",
  17: "tr",
  18: "hr",
  19: "zh-Hant",
  20: "ur",
  21: "hi",
  22: "th",
  23: "ko",
  24: "lt",
  25: "pl",
  26: "hu",
  27: "es",
  28: "lv",
  29: "se",
  30: "fo",
  31: "fa",
  32: "ru",
  33: "zh",
  34: "nl-BE",
  35: "ga",
  36: "sq",
  37: "ro",
  38: "cz",
  39: "sk",
  40: "si",
  41: "yi",
  42: "sr",
  43: "mk",
  44: "bg",
  45: "uk",
  46: "be",
  47: "uz",
  48: "kk",
  49: "az-Cyrl",
  50: "az-Arab",
  51: "hy",
  52: "ka",
  53: "mo",
  54: "ky",
  55: "tg",
  56: "tk",
  57: "mn-CN",
  58: "mn",
  59: "ps",
  60: "ks",
  61: "ku",
  62: "sd",
  63: "bo",
  64: "ne",
  65: "sa",
  66: "mr",
  67: "bn",
  68: "as",
  69: "gu",
  70: "pa",
  71: "or",
  72: "ml",
  73: "kn",
  74: "ta",
  75: "te",
  76: "si",
  77: "my",
  78: "km",
  79: "lo",
  80: "vi",
  81: "id",
  82: "tl",
  83: "ms",
  84: "ms-Arab",
  85: "am",
  86: "ti",
  87: "om",
  88: "so",
  89: "sw",
  90: "rw",
  91: "rn",
  92: "ny",
  93: "mg",
  94: "eo",
  128: "cy",
  129: "eu",
  130: "ca",
  131: "la",
  132: "qu",
  133: "gn",
  134: "ay",
  135: "tt",
  136: "ug",
  137: "dz",
  138: "jv",
  139: "su",
  140: "gl",
  141: "af",
  142: "br",
  143: "iu",
  144: "gd",
  145: "gv",
  146: "ga",
  147: "to",
  148: "el-polyton",
  149: "kl",
  150: "az",
  151: "nn"
}, rn = {
  0: 0,
  // langEnglish → smRoman
  1: 0,
  // langFrench → smRoman
  2: 0,
  // langGerman → smRoman
  3: 0,
  // langItalian → smRoman
  4: 0,
  // langDutch → smRoman
  5: 0,
  // langSwedish → smRoman
  6: 0,
  // langSpanish → smRoman
  7: 0,
  // langDanish → smRoman
  8: 0,
  // langPortuguese → smRoman
  9: 0,
  // langNorwegian → smRoman
  10: 5,
  // langHebrew → smHebrew
  11: 1,
  // langJapanese → smJapanese
  12: 4,
  // langArabic → smArabic
  13: 0,
  // langFinnish → smRoman
  14: 6,
  // langGreek → smGreek
  15: 0,
  // langIcelandic → smRoman (modified)
  16: 0,
  // langMaltese → smRoman
  17: 0,
  // langTurkish → smRoman (modified)
  18: 0,
  // langCroatian → smRoman (modified)
  19: 2,
  // langTradChinese → smTradChinese
  20: 4,
  // langUrdu → smArabic
  21: 9,
  // langHindi → smDevanagari
  22: 21,
  // langThai → smThai
  23: 3,
  // langKorean → smKorean
  24: 29,
  // langLithuanian → smCentralEuroRoman
  25: 29,
  // langPolish → smCentralEuroRoman
  26: 29,
  // langHungarian → smCentralEuroRoman
  27: 29,
  // langEstonian → smCentralEuroRoman
  28: 29,
  // langLatvian → smCentralEuroRoman
  29: 0,
  // langSami → smRoman
  30: 0,
  // langFaroese → smRoman (modified)
  31: 4,
  // langFarsi → smArabic (modified)
  32: 7,
  // langRussian → smCyrillic
  33: 25,
  // langSimpChinese → smSimpChinese
  34: 0,
  // langFlemish → smRoman
  35: 0,
  // langIrishGaelic → smRoman (modified)
  36: 0,
  // langAlbanian → smRoman
  37: 0,
  // langRomanian → smRoman (modified)
  38: 29,
  // langCzech → smCentralEuroRoman
  39: 29,
  // langSlovak → smCentralEuroRoman
  40: 0,
  // langSlovenian → smRoman (modified)
  41: 5,
  // langYiddish → smHebrew
  42: 7,
  // langSerbian → smCyrillic
  43: 7,
  // langMacedonian → smCyrillic
  44: 7,
  // langBulgarian → smCyrillic
  45: 7,
  // langUkrainian → smCyrillic (modified)
  46: 7,
  // langByelorussian → smCyrillic
  47: 7,
  // langUzbek → smCyrillic
  48: 7,
  // langKazakh → smCyrillic
  49: 7,
  // langAzerbaijani → smCyrillic
  50: 4,
  // langAzerbaijanAr → smArabic
  51: 24,
  // langArmenian → smArmenian
  52: 23,
  // langGeorgian → smGeorgian
  53: 7,
  // langMoldavian → smCyrillic
  54: 7,
  // langKirghiz → smCyrillic
  55: 7,
  // langTajiki → smCyrillic
  56: 7,
  // langTurkmen → smCyrillic
  57: 27,
  // langMongolian → smMongolian
  58: 7,
  // langMongolianCyr → smCyrillic
  59: 4,
  // langPashto → smArabic
  60: 4,
  // langKurdish → smArabic
  61: 4,
  // langKashmiri → smArabic
  62: 4,
  // langSindhi → smArabic
  63: 26,
  // langTibetan → smTibetan
  64: 9,
  // langNepali → smDevanagari
  65: 9,
  // langSanskrit → smDevanagari
  66: 9,
  // langMarathi → smDevanagari
  67: 13,
  // langBengali → smBengali
  68: 13,
  // langAssamese → smBengali
  69: 11,
  // langGujarati → smGujarati
  70: 10,
  // langPunjabi → smGurmukhi
  71: 12,
  // langOriya → smOriya
  72: 17,
  // langMalayalam → smMalayalam
  73: 16,
  // langKannada → smKannada
  74: 14,
  // langTamil → smTamil
  75: 15,
  // langTelugu → smTelugu
  76: 18,
  // langSinhalese → smSinhalese
  77: 19,
  // langBurmese → smBurmese
  78: 20,
  // langKhmer → smKhmer
  79: 22,
  // langLao → smLao
  80: 30,
  // langVietnamese → smVietnamese
  81: 0,
  // langIndonesian → smRoman
  82: 0,
  // langTagalog → smRoman
  83: 0,
  // langMalayRoman → smRoman
  84: 4,
  // langMalayArabic → smArabic
  85: 28,
  // langAmharic → smEthiopic
  86: 28,
  // langTigrinya → smEthiopic
  87: 28,
  // langOromo → smEthiopic
  88: 0,
  // langSomali → smRoman
  89: 0,
  // langSwahili → smRoman
  90: 0,
  // langKinyarwanda → smRoman
  91: 0,
  // langRundi → smRoman
  92: 0,
  // langNyanja → smRoman
  93: 0,
  // langMalagasy → smRoman
  94: 0,
  // langEsperanto → smRoman
  128: 0,
  // langWelsh → smRoman (modified)
  129: 0,
  // langBasque → smRoman
  130: 0,
  // langCatalan → smRoman
  131: 0,
  // langLatin → smRoman
  132: 0,
  // langQuechua → smRoman
  133: 0,
  // langGuarani → smRoman
  134: 0,
  // langAymara → smRoman
  135: 7,
  // langTatar → smCyrillic
  136: 4,
  // langUighur → smArabic
  137: 26,
  // langDzongkha → smTibetan
  138: 0,
  // langJavaneseRom → smRoman
  139: 0,
  // langSundaneseRom → smRoman
  140: 0,
  // langGalician → smRoman
  141: 0,
  // langAfrikaans → smRoman
  142: 0,
  // langBreton → smRoman (modified)
  143: 28,
  // langInuktitut → smEthiopic (modified)
  144: 0,
  // langScottishGaelic → smRoman (modified)
  145: 0,
  // langManxGaelic → smRoman (modified)
  146: 0,
  // langIrishGaelicScript → smRoman (modified)
  147: 0,
  // langTongan → smRoman
  148: 6,
  // langGreekAncient → smRoman
  149: 0,
  // langGreenlandic → smRoman
  150: 0,
  // langAzerbaijanRoman → smRoman
  151: 0
  // langNynorsk → smRoman
}, GM = {
  1078: "af",
  1052: "sq",
  1156: "gsw",
  1118: "am",
  5121: "ar-DZ",
  15361: "ar-BH",
  3073: "ar",
  2049: "ar-IQ",
  11265: "ar-JO",
  13313: "ar-KW",
  12289: "ar-LB",
  4097: "ar-LY",
  6145: "ary",
  8193: "ar-OM",
  16385: "ar-QA",
  1025: "ar-SA",
  10241: "ar-SY",
  7169: "aeb",
  14337: "ar-AE",
  9217: "ar-YE",
  1067: "hy",
  1101: "as",
  2092: "az-Cyrl",
  1068: "az",
  1133: "ba",
  1069: "eu",
  1059: "be",
  2117: "bn",
  1093: "bn-IN",
  8218: "bs-Cyrl",
  5146: "bs",
  1150: "br",
  1026: "bg",
  1027: "ca",
  3076: "zh-HK",
  5124: "zh-MO",
  2052: "zh",
  4100: "zh-SG",
  1028: "zh-TW",
  1155: "co",
  1050: "hr",
  4122: "hr-BA",
  1029: "cs",
  1030: "da",
  1164: "prs",
  1125: "dv",
  2067: "nl-BE",
  1043: "nl",
  3081: "en-AU",
  10249: "en-BZ",
  4105: "en-CA",
  9225: "en-029",
  16393: "en-IN",
  6153: "en-IE",
  8201: "en-JM",
  17417: "en-MY",
  5129: "en-NZ",
  13321: "en-PH",
  18441: "en-SG",
  7177: "en-ZA",
  11273: "en-TT",
  2057: "en-GB",
  1033: "en",
  12297: "en-ZW",
  1061: "et",
  1080: "fo",
  1124: "fil",
  1035: "fi",
  2060: "fr-BE",
  3084: "fr-CA",
  1036: "fr",
  5132: "fr-LU",
  6156: "fr-MC",
  4108: "fr-CH",
  1122: "fy",
  1110: "gl",
  1079: "ka",
  3079: "de-AT",
  1031: "de",
  5127: "de-LI",
  4103: "de-LU",
  2055: "de-CH",
  1032: "el",
  1135: "kl",
  1095: "gu",
  1128: "ha",
  1037: "he",
  1081: "hi",
  1038: "hu",
  1039: "is",
  1136: "ig",
  1057: "id",
  1117: "iu",
  2141: "iu-Latn",
  2108: "ga",
  1076: "xh",
  1077: "zu",
  1040: "it",
  2064: "it-CH",
  1041: "ja",
  1099: "kn",
  1087: "kk",
  1107: "km",
  1158: "quc",
  1159: "rw",
  1089: "sw",
  1111: "kok",
  1042: "ko",
  1088: "ky",
  1108: "lo",
  1062: "lv",
  1063: "lt",
  2094: "dsb",
  1134: "lb",
  1071: "mk",
  2110: "ms-BN",
  1086: "ms",
  1100: "ml",
  1082: "mt",
  1153: "mi",
  1146: "arn",
  1102: "mr",
  1148: "moh",
  1104: "mn",
  2128: "mn-CN",
  1121: "ne",
  1044: "nb",
  2068: "nn",
  1154: "oc",
  1096: "or",
  1123: "ps",
  1045: "pl",
  1046: "pt",
  2070: "pt-PT",
  1094: "pa",
  1131: "qu-BO",
  2155: "qu-EC",
  3179: "qu",
  1048: "ro",
  1047: "rm",
  1049: "ru",
  9275: "smn",
  4155: "smj-NO",
  5179: "smj",
  3131: "se-FI",
  1083: "se",
  2107: "se-SE",
  8251: "sms",
  6203: "sma-NO",
  7227: "sms",
  1103: "sa",
  7194: "sr-Cyrl-BA",
  3098: "sr",
  6170: "sr-Latn-BA",
  2074: "sr-Latn",
  1132: "nso",
  1074: "tn",
  1115: "si",
  1051: "sk",
  1060: "sl",
  11274: "es-AR",
  16394: "es-BO",
  13322: "es-CL",
  9226: "es-CO",
  5130: "es-CR",
  7178: "es-DO",
  12298: "es-EC",
  17418: "es-SV",
  4106: "es-GT",
  18442: "es-HN",
  2058: "es-MX",
  19466: "es-NI",
  6154: "es-PA",
  15370: "es-PY",
  10250: "es-PE",
  20490: "es-PR",
  // Microsoft has defined two different language codes for
  // “Spanish with modern sorting” and “Spanish with traditional
  // sorting”. This makes sense for collation APIs, and it would be
  // possible to express this in BCP 47 language tags via Unicode
  // extensions (eg., es-u-co-trad is Spanish with traditional
  // sorting). However, for storing names in fonts, the distinction
  // does not make sense, so we give “es” in both cases.
  3082: "es",
  1034: "es",
  21514: "es-US",
  14346: "es-UY",
  8202: "es-VE",
  2077: "sv-FI",
  1053: "sv",
  1114: "syr",
  1064: "tg",
  2143: "tzm",
  1097: "ta",
  1092: "tt",
  1098: "te",
  1054: "th",
  1105: "bo",
  1055: "tr",
  1090: "tk",
  1152: "ug",
  1058: "uk",
  1070: "hsb",
  1056: "ur",
  2115: "uz-Cyrl",
  1091: "uz",
  1066: "vi",
  1106: "cy",
  1160: "wo",
  1157: "sah",
  1144: "ii",
  1130: "yo"
};
function nn(A, E, B) {
  switch (A) {
    case 0:
      if (E === 65535)
        return "und";
      if (B)
        return B[E];
      break;
    case 1:
      return dM[E];
    case 3:
      return GM[E];
  }
}
var pe = "utf-16", wn = {
  0: "macintosh",
  // smRoman
  1: "x-mac-japanese",
  // smJapanese
  2: "x-mac-chinesetrad",
  // smTradChinese
  3: "x-mac-korean",
  // smKorean
  6: "x-mac-greek",
  // smGreek
  7: "x-mac-cyrillic",
  // smCyrillic
  9: "x-mac-devanagai",
  // smDevanagari
  10: "x-mac-gurmukhi",
  // smGurmukhi
  11: "x-mac-gujarati",
  // smGujarati
  12: "x-mac-oriya",
  // smOriya
  13: "x-mac-bengali",
  // smBengali
  14: "x-mac-tamil",
  // smTamil
  15: "x-mac-telugu",
  // smTelugu
  16: "x-mac-kannada",
  // smKannada
  17: "x-mac-malayalam",
  // smMalayalam
  18: "x-mac-sinhalese",
  // smSinhalese
  19: "x-mac-burmese",
  // smBurmese
  20: "x-mac-khmer",
  // smKhmer
  21: "x-mac-thai",
  // smThai
  22: "x-mac-lao",
  // smLao
  23: "x-mac-georgian",
  // smGeorgian
  24: "x-mac-armenian",
  // smArmenian
  25: "x-mac-chinesesimp",
  // smSimpChinese
  26: "x-mac-tibetan",
  // smTibetan
  27: "x-mac-mongolian",
  // smMongolian
  28: "x-mac-ethiopic",
  // smEthiopic
  29: "x-mac-ce",
  // smCentralEuroRoman
  30: "x-mac-vietnamese",
  // smVietnamese
  31: "x-mac-extarabic"
  // smExtArabic
}, cn = {
  15: "x-mac-icelandic",
  // langIcelandic
  17: "x-mac-turkish",
  // langTurkish
  18: "x-mac-croatian",
  // langCroatian
  24: "x-mac-ce",
  // langLithuanian
  25: "x-mac-ce",
  // langPolish
  26: "x-mac-ce",
  // langHungarian
  27: "x-mac-ce",
  // langEstonian
  28: "x-mac-ce",
  // langLatvian
  30: "x-mac-icelandic",
  // langFaroese
  37: "x-mac-romanian",
  // langRomanian
  38: "x-mac-ce",
  // langCzech
  39: "x-mac-ce",
  // langSlovak
  40: "x-mac-ce",
  // langSlovenian
  143: "x-mac-inuit",
  // langInuktitut
  146: "x-mac-gaelic"
  // langIrishGaelicScript
};
function yM(A, E, B) {
  switch (A) {
    case 0:
      return pe;
    case 1:
      return cn[B] || wn[E];
    case 3:
      if (E === 1 || E === 10)
        return pe;
      break;
  }
}
function an(A, E, B) {
  for (var e = {}, t = new K.Parser(A, E), g = t.parseUShort(), M = t.parseUShort(), Q = t.offset + t.parseUShort(), s = 0; s < M; s++) {
    var r = t.parseUShort(), w = t.parseUShort(), c = t.parseUShort(), n = t.parseUShort(), a = kM[n] || n, o = t.parseUShort(), D = t.parseUShort(), R = nn(r, c, B), i = yM(r, w, c);
    if (i !== void 0 && R !== void 0) {
      var C = void 0;
      if (i === pe ? C = pE.UTF16(A, Q + D, o) : C = pE.MACSTRING(A, Q + D, o, i), C) {
        var F = e[a];
        F === void 0 && (F = e[a] = {}), F[R] = C;
      }
    }
  }
  return g === 1 && t.parseUShort(), e;
}
function oe(A) {
  var E = {};
  for (var B in A)
    E[A[B]] = parseInt(B);
  return E;
}
function Bg(A, E, B, e, t, g) {
  return new L.Record("NameRecord", [
    { name: "platformID", type: "USHORT", value: A },
    { name: "encodingID", type: "USHORT", value: E },
    { name: "languageID", type: "USHORT", value: B },
    { name: "nameID", type: "USHORT", value: e },
    { name: "length", type: "USHORT", value: t },
    { name: "offset", type: "USHORT", value: g }
  ]);
}
function on(A, E) {
  var B = A.length, e = E.length - B + 1;
  A:
    for (var t = 0; t < e; t++)
      for (; t < e; t++) {
        for (var g = 0; g < B; g++)
          if (E[t + g] !== A[g])
            continue A;
        return t;
      }
  return -1;
}
function eg(A, E) {
  var B = on(A, E);
  if (B < 0) {
    B = E.length;
    for (var e = 0, t = A.length; e < t; ++e)
      E.push(A[e]);
  }
  return B;
}
function In(A, E) {
  var B, e = [], t = {}, g = oe(kM);
  for (var M in A) {
    var Q = g[M];
    if (Q === void 0 && (Q = M), B = parseInt(Q), isNaN(B))
      throw new Error('Name table entry "' + M + '" does not exist, see nameTableNames for complete list.');
    t[B] = A[M], e.push(B);
  }
  for (var s = oe(dM), r = oe(GM), w = [], c = [], n = 0; n < e.length; n++) {
    B = e[n];
    var a = t[B];
    for (var o in a) {
      var D = a[o], R = 1, i = s[o], C = rn[i], F = yM(R, C, i), l = O.MACSTRING(D, F);
      l === void 0 && (R = 0, i = E.indexOf(o), i < 0 && (i = E.length, E.push(o)), C = 4, l = O.UTF16(D));
      var T = eg(l, c);
      w.push(Bg(
        R,
        C,
        i,
        B,
        l.length,
        T
      ));
      var u = r[o];
      if (u !== void 0) {
        var h = O.UTF16(D), x = eg(h, c);
        w.push(Bg(
          3,
          1,
          u,
          B,
          h.length,
          x
        ));
      }
    }
  }
  w.sort(function(k, P) {
    return k.platformID - P.platformID || k.encodingID - P.encodingID || k.languageID - P.languageID || k.nameID - P.nameID;
  });
  for (var U = new L.Table("name", [
    { name: "format", type: "USHORT", value: 0 },
    { name: "count", type: "USHORT", value: w.length },
    { name: "stringOffset", type: "USHORT", value: 6 + w.length * 12 }
  ]), z = 0; z < w.length; z++)
    U.fields.push({ name: "record_" + z, type: "RECORD", value: w[z] });
  return U.fields.push({ name: "strings", type: "LITERAL", value: c }), U;
}
var SM = { parse: an, make: In }, Pe = [
  { begin: 0, end: 127 },
  // Basic Latin
  { begin: 128, end: 255 },
  // Latin-1 Supplement
  { begin: 256, end: 383 },
  // Latin Extended-A
  { begin: 384, end: 591 },
  // Latin Extended-B
  { begin: 592, end: 687 },
  // IPA Extensions
  { begin: 688, end: 767 },
  // Spacing Modifier Letters
  { begin: 768, end: 879 },
  // Combining Diacritical Marks
  { begin: 880, end: 1023 },
  // Greek and Coptic
  { begin: 11392, end: 11519 },
  // Coptic
  { begin: 1024, end: 1279 },
  // Cyrillic
  { begin: 1328, end: 1423 },
  // Armenian
  { begin: 1424, end: 1535 },
  // Hebrew
  { begin: 42240, end: 42559 },
  // Vai
  { begin: 1536, end: 1791 },
  // Arabic
  { begin: 1984, end: 2047 },
  // NKo
  { begin: 2304, end: 2431 },
  // Devanagari
  { begin: 2432, end: 2559 },
  // Bengali
  { begin: 2560, end: 2687 },
  // Gurmukhi
  { begin: 2688, end: 2815 },
  // Gujarati
  { begin: 2816, end: 2943 },
  // Oriya
  { begin: 2944, end: 3071 },
  // Tamil
  { begin: 3072, end: 3199 },
  // Telugu
  { begin: 3200, end: 3327 },
  // Kannada
  { begin: 3328, end: 3455 },
  // Malayalam
  { begin: 3584, end: 3711 },
  // Thai
  { begin: 3712, end: 3839 },
  // Lao
  { begin: 4256, end: 4351 },
  // Georgian
  { begin: 6912, end: 7039 },
  // Balinese
  { begin: 4352, end: 4607 },
  // Hangul Jamo
  { begin: 7680, end: 7935 },
  // Latin Extended Additional
  { begin: 7936, end: 8191 },
  // Greek Extended
  { begin: 8192, end: 8303 },
  // General Punctuation
  { begin: 8304, end: 8351 },
  // Superscripts And Subscripts
  { begin: 8352, end: 8399 },
  // Currency Symbol
  { begin: 8400, end: 8447 },
  // Combining Diacritical Marks For Symbols
  { begin: 8448, end: 8527 },
  // Letterlike Symbols
  { begin: 8528, end: 8591 },
  // Number Forms
  { begin: 8592, end: 8703 },
  // Arrows
  { begin: 8704, end: 8959 },
  // Mathematical Operators
  { begin: 8960, end: 9215 },
  // Miscellaneous Technical
  { begin: 9216, end: 9279 },
  // Control Pictures
  { begin: 9280, end: 9311 },
  // Optical Character Recognition
  { begin: 9312, end: 9471 },
  // Enclosed Alphanumerics
  { begin: 9472, end: 9599 },
  // Box Drawing
  { begin: 9600, end: 9631 },
  // Block Elements
  { begin: 9632, end: 9727 },
  // Geometric Shapes
  { begin: 9728, end: 9983 },
  // Miscellaneous Symbols
  { begin: 9984, end: 10175 },
  // Dingbats
  { begin: 12288, end: 12351 },
  // CJK Symbols And Punctuation
  { begin: 12352, end: 12447 },
  // Hiragana
  { begin: 12448, end: 12543 },
  // Katakana
  { begin: 12544, end: 12591 },
  // Bopomofo
  { begin: 12592, end: 12687 },
  // Hangul Compatibility Jamo
  { begin: 43072, end: 43135 },
  // Phags-pa
  { begin: 12800, end: 13055 },
  // Enclosed CJK Letters And Months
  { begin: 13056, end: 13311 },
  // CJK Compatibility
  { begin: 44032, end: 55215 },
  // Hangul Syllables
  { begin: 55296, end: 57343 },
  // Non-Plane 0 *
  { begin: 67840, end: 67871 },
  // Phoenicia
  { begin: 19968, end: 40959 },
  // CJK Unified Ideographs
  { begin: 57344, end: 63743 },
  // Private Use Area (plane 0)
  { begin: 12736, end: 12783 },
  // CJK Strokes
  { begin: 64256, end: 64335 },
  // Alphabetic Presentation Forms
  { begin: 64336, end: 65023 },
  // Arabic Presentation Forms-A
  { begin: 65056, end: 65071 },
  // Combining Half Marks
  { begin: 65040, end: 65055 },
  // Vertical Forms
  { begin: 65104, end: 65135 },
  // Small Form Variants
  { begin: 65136, end: 65279 },
  // Arabic Presentation Forms-B
  { begin: 65280, end: 65519 },
  // Halfwidth And Fullwidth Forms
  { begin: 65520, end: 65535 },
  // Specials
  { begin: 3840, end: 4095 },
  // Tibetan
  { begin: 1792, end: 1871 },
  // Syriac
  { begin: 1920, end: 1983 },
  // Thaana
  { begin: 3456, end: 3583 },
  // Sinhala
  { begin: 4096, end: 4255 },
  // Myanmar
  { begin: 4608, end: 4991 },
  // Ethiopic
  { begin: 5024, end: 5119 },
  // Cherokee
  { begin: 5120, end: 5759 },
  // Unified Canadian Aboriginal Syllabics
  { begin: 5760, end: 5791 },
  // Ogham
  { begin: 5792, end: 5887 },
  // Runic
  { begin: 6016, end: 6143 },
  // Khmer
  { begin: 6144, end: 6319 },
  // Mongolian
  { begin: 10240, end: 10495 },
  // Braille Patterns
  { begin: 40960, end: 42127 },
  // Yi Syllables
  { begin: 5888, end: 5919 },
  // Tagalog
  { begin: 66304, end: 66351 },
  // Old Italic
  { begin: 66352, end: 66383 },
  // Gothic
  { begin: 66560, end: 66639 },
  // Deseret
  { begin: 118784, end: 119039 },
  // Byzantine Musical Symbols
  { begin: 119808, end: 120831 },
  // Mathematical Alphanumeric Symbols
  { begin: 1044480, end: 1048573 },
  // Private Use (plane 15)
  { begin: 65024, end: 65039 },
  // Variation Selectors
  { begin: 917504, end: 917631 },
  // Tags
  { begin: 6400, end: 6479 },
  // Limbu
  { begin: 6480, end: 6527 },
  // Tai Le
  { begin: 6528, end: 6623 },
  // New Tai Lue
  { begin: 6656, end: 6687 },
  // Buginese
  { begin: 11264, end: 11359 },
  // Glagolitic
  { begin: 11568, end: 11647 },
  // Tifinagh
  { begin: 19904, end: 19967 },
  // Yijing Hexagram Symbols
  { begin: 43008, end: 43055 },
  // Syloti Nagri
  { begin: 65536, end: 65663 },
  // Linear B Syllabary
  { begin: 65856, end: 65935 },
  // Ancient Greek Numbers
  { begin: 66432, end: 66463 },
  // Ugaritic
  { begin: 66464, end: 66527 },
  // Old Persian
  { begin: 66640, end: 66687 },
  // Shavian
  { begin: 66688, end: 66735 },
  // Osmanya
  { begin: 67584, end: 67647 },
  // Cypriot Syllabary
  { begin: 68096, end: 68191 },
  // Kharoshthi
  { begin: 119552, end: 119647 },
  // Tai Xuan Jing Symbols
  { begin: 73728, end: 74751 },
  // Cuneiform
  { begin: 119648, end: 119679 },
  // Counting Rod Numerals
  { begin: 7040, end: 7103 },
  // Sundanese
  { begin: 7168, end: 7247 },
  // Lepcha
  { begin: 7248, end: 7295 },
  // Ol Chiki
  { begin: 43136, end: 43231 },
  // Saurashtra
  { begin: 43264, end: 43311 },
  // Kayah Li
  { begin: 43312, end: 43359 },
  // Rejang
  { begin: 43520, end: 43615 },
  // Cham
  { begin: 65936, end: 65999 },
  // Ancient Symbols
  { begin: 66e3, end: 66047 },
  // Phaistos Disc
  { begin: 66208, end: 66271 },
  // Carian
  { begin: 127024, end: 127135 }
  // Domino Tiles
];
function Fn(A) {
  for (var E = 0; E < Pe.length; E += 1) {
    var B = Pe[E];
    if (A >= B.begin && A < B.end)
      return E;
  }
  return -1;
}
function Rn(A, E) {
  var B = {}, e = new K.Parser(A, E);
  B.version = e.parseUShort(), B.xAvgCharWidth = e.parseShort(), B.usWeightClass = e.parseUShort(), B.usWidthClass = e.parseUShort(), B.fsType = e.parseUShort(), B.ySubscriptXSize = e.parseShort(), B.ySubscriptYSize = e.parseShort(), B.ySubscriptXOffset = e.parseShort(), B.ySubscriptYOffset = e.parseShort(), B.ySuperscriptXSize = e.parseShort(), B.ySuperscriptYSize = e.parseShort(), B.ySuperscriptXOffset = e.parseShort(), B.ySuperscriptYOffset = e.parseShort(), B.yStrikeoutSize = e.parseShort(), B.yStrikeoutPosition = e.parseShort(), B.sFamilyClass = e.parseShort(), B.panose = [];
  for (var t = 0; t < 10; t++)
    B.panose[t] = e.parseByte();
  return B.ulUnicodeRange1 = e.parseULong(), B.ulUnicodeRange2 = e.parseULong(), B.ulUnicodeRange3 = e.parseULong(), B.ulUnicodeRange4 = e.parseULong(), B.achVendID = String.fromCharCode(e.parseByte(), e.parseByte(), e.parseByte(), e.parseByte()), B.fsSelection = e.parseUShort(), B.usFirstCharIndex = e.parseUShort(), B.usLastCharIndex = e.parseUShort(), B.sTypoAscender = e.parseShort(), B.sTypoDescender = e.parseShort(), B.sTypoLineGap = e.parseShort(), B.usWinAscent = e.parseUShort(), B.usWinDescent = e.parseUShort(), B.version >= 1 && (B.ulCodePageRange1 = e.parseULong(), B.ulCodePageRange2 = e.parseULong()), B.version >= 2 && (B.sxHeight = e.parseShort(), B.sCapHeight = e.parseShort(), B.usDefaultChar = e.parseUShort(), B.usBreakChar = e.parseUShort(), B.usMaxContent = e.parseUShort()), B;
}
function Cn(A) {
  return new L.Table("OS/2", [
    { name: "version", type: "USHORT", value: 3 },
    { name: "xAvgCharWidth", type: "SHORT", value: 0 },
    { name: "usWeightClass", type: "USHORT", value: 0 },
    { name: "usWidthClass", type: "USHORT", value: 0 },
    { name: "fsType", type: "USHORT", value: 0 },
    { name: "ySubscriptXSize", type: "SHORT", value: 650 },
    { name: "ySubscriptYSize", type: "SHORT", value: 699 },
    { name: "ySubscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySubscriptYOffset", type: "SHORT", value: 140 },
    { name: "ySuperscriptXSize", type: "SHORT", value: 650 },
    { name: "ySuperscriptYSize", type: "SHORT", value: 699 },
    { name: "ySuperscriptXOffset", type: "SHORT", value: 0 },
    { name: "ySuperscriptYOffset", type: "SHORT", value: 479 },
    { name: "yStrikeoutSize", type: "SHORT", value: 49 },
    { name: "yStrikeoutPosition", type: "SHORT", value: 258 },
    { name: "sFamilyClass", type: "SHORT", value: 0 },
    { name: "bFamilyType", type: "BYTE", value: 0 },
    { name: "bSerifStyle", type: "BYTE", value: 0 },
    { name: "bWeight", type: "BYTE", value: 0 },
    { name: "bProportion", type: "BYTE", value: 0 },
    { name: "bContrast", type: "BYTE", value: 0 },
    { name: "bStrokeVariation", type: "BYTE", value: 0 },
    { name: "bArmStyle", type: "BYTE", value: 0 },
    { name: "bLetterform", type: "BYTE", value: 0 },
    { name: "bMidline", type: "BYTE", value: 0 },
    { name: "bXHeight", type: "BYTE", value: 0 },
    { name: "ulUnicodeRange1", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange2", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange3", type: "ULONG", value: 0 },
    { name: "ulUnicodeRange4", type: "ULONG", value: 0 },
    { name: "achVendID", type: "CHARARRAY", value: "XXXX" },
    { name: "fsSelection", type: "USHORT", value: 0 },
    { name: "usFirstCharIndex", type: "USHORT", value: 0 },
    { name: "usLastCharIndex", type: "USHORT", value: 0 },
    { name: "sTypoAscender", type: "SHORT", value: 0 },
    { name: "sTypoDescender", type: "SHORT", value: 0 },
    { name: "sTypoLineGap", type: "SHORT", value: 0 },
    { name: "usWinAscent", type: "USHORT", value: 0 },
    { name: "usWinDescent", type: "USHORT", value: 0 },
    { name: "ulCodePageRange1", type: "ULONG", value: 0 },
    { name: "ulCodePageRange2", type: "ULONG", value: 0 },
    { name: "sxHeight", type: "SHORT", value: 0 },
    { name: "sCapHeight", type: "SHORT", value: 0 },
    { name: "usDefaultChar", type: "USHORT", value: 0 },
    { name: "usBreakChar", type: "USHORT", value: 0 },
    { name: "usMaxContext", type: "USHORT", value: 0 }
  ], A);
}
var ve = { parse: Rn, make: Cn, unicodeRanges: Pe, getUnicodeRange: Fn };
function Dn(A, E) {
  var B = {}, e = new K.Parser(A, E);
  switch (B.version = e.parseVersion(), B.italicAngle = e.parseFixed(), B.underlinePosition = e.parseShort(), B.underlineThickness = e.parseShort(), B.isFixedPitch = e.parseULong(), B.minMemType42 = e.parseULong(), B.maxMemType42 = e.parseULong(), B.minMemType1 = e.parseULong(), B.maxMemType1 = e.parseULong(), B.version) {
    case 1:
      B.names = aE.slice();
      break;
    case 2:
      B.numberOfGlyphs = e.parseUShort(), B.glyphNameIndex = new Array(B.numberOfGlyphs);
      for (var t = 0; t < B.numberOfGlyphs; t++)
        B.glyphNameIndex[t] = e.parseUShort();
      B.names = [];
      for (var g = 0; g < B.numberOfGlyphs; g++)
        if (B.glyphNameIndex[g] >= aE.length) {
          var M = e.parseChar();
          B.names.push(e.parseString(M));
        }
      break;
    case 2.5:
      B.numberOfGlyphs = e.parseUShort(), B.offset = new Array(B.numberOfGlyphs);
      for (var Q = 0; Q < B.numberOfGlyphs; Q++)
        B.offset[Q] = e.parseChar();
      break;
  }
  return B;
}
function ln() {
  return new L.Table("post", [
    { name: "version", type: "FIXED", value: 196608 },
    { name: "italicAngle", type: "FIXED", value: 0 },
    { name: "underlinePosition", type: "FWORD", value: 0 },
    { name: "underlineThickness", type: "FWORD", value: 0 },
    { name: "isFixedPitch", type: "ULONG", value: 0 },
    { name: "minMemType42", type: "ULONG", value: 0 },
    { name: "maxMemType42", type: "ULONG", value: 0 },
    { name: "minMemType1", type: "ULONG", value: 0 },
    { name: "maxMemType1", type: "ULONG", value: 0 }
  ]);
}
var pM = { parse: Dn, make: ln }, kA = new Array(9);
kA[1] = function() {
  var E = this.offset + this.relativeOffset, B = this.parseUShort();
  if (B === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(Y.coverage),
      deltaGlyphId: this.parseUShort()
    };
  if (B === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(Y.coverage),
      substitute: this.parseOffset16List()
    };
  gA.assert(!1, "0x" + E.toString(16) + ": lookup type 1 format must be 1 or 2.");
};
kA[2] = function() {
  var E = this.parseUShort();
  return gA.argument(E === 1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
    substFormat: E,
    coverage: this.parsePointer(Y.coverage),
    sequences: this.parseListOfLists()
  };
};
kA[3] = function() {
  var E = this.parseUShort();
  return gA.argument(E === 1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
    substFormat: E,
    coverage: this.parsePointer(Y.coverage),
    alternateSets: this.parseListOfLists()
  };
};
kA[4] = function() {
  var E = this.parseUShort();
  return gA.argument(E === 1, "GSUB ligature table identifier-format must be 1"), {
    substFormat: E,
    coverage: this.parsePointer(Y.coverage),
    ligatureSets: this.parseListOfLists(function() {
      return {
        ligGlyph: this.parseUShort(),
        components: this.parseUShortList(this.parseUShort() - 1)
      };
    })
  };
};
var GE = {
  sequenceIndex: Y.uShort,
  lookupListIndex: Y.uShort
};
kA[5] = function() {
  var E = this.offset + this.relativeOffset, B = this.parseUShort();
  if (B === 1)
    return {
      substFormat: B,
      coverage: this.parsePointer(Y.coverage),
      ruleSets: this.parseListOfLists(function() {
        var g = this.parseUShort(), M = this.parseUShort();
        return {
          input: this.parseUShortList(g - 1),
          lookupRecords: this.parseRecordList(M, GE)
        };
      })
    };
  if (B === 2)
    return {
      substFormat: B,
      coverage: this.parsePointer(Y.coverage),
      classDef: this.parsePointer(Y.classDef),
      classSets: this.parseListOfLists(function() {
        var g = this.parseUShort(), M = this.parseUShort();
        return {
          classes: this.parseUShortList(g - 1),
          lookupRecords: this.parseRecordList(M, GE)
        };
      })
    };
  if (B === 3) {
    var e = this.parseUShort(), t = this.parseUShort();
    return {
      substFormat: B,
      coverages: this.parseList(e, Y.pointer(Y.coverage)),
      lookupRecords: this.parseRecordList(t, GE)
    };
  }
  gA.assert(!1, "0x" + E.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
};
kA[6] = function() {
  var E = this.offset + this.relativeOffset, B = this.parseUShort();
  if (B === 1)
    return {
      substFormat: 1,
      coverage: this.parsePointer(Y.coverage),
      chainRuleSets: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(GE)
        };
      })
    };
  if (B === 2)
    return {
      substFormat: 2,
      coverage: this.parsePointer(Y.coverage),
      backtrackClassDef: this.parsePointer(Y.classDef),
      inputClassDef: this.parsePointer(Y.classDef),
      lookaheadClassDef: this.parsePointer(Y.classDef),
      chainClassSet: this.parseListOfLists(function() {
        return {
          backtrack: this.parseUShortList(),
          input: this.parseUShortList(this.parseShort() - 1),
          lookahead: this.parseUShortList(),
          lookupRecords: this.parseRecordList(GE)
        };
      })
    };
  if (B === 3)
    return {
      substFormat: 3,
      backtrackCoverage: this.parseList(Y.pointer(Y.coverage)),
      inputCoverage: this.parseList(Y.pointer(Y.coverage)),
      lookaheadCoverage: this.parseList(Y.pointer(Y.coverage)),
      lookupRecords: this.parseRecordList(GE)
    };
  gA.assert(!1, "0x" + E.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
};
kA[7] = function() {
  var E = this.parseUShort();
  gA.argument(E === 1, "GSUB Extension Substitution subtable identifier-format must be 1");
  var B = this.parseUShort(), e = new Y(this.data, this.offset + this.parseULong());
  return {
    substFormat: 1,
    lookupType: B,
    extension: kA[B].call(e)
  };
};
kA[8] = function() {
  var E = this.parseUShort();
  return gA.argument(E === 1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
    substFormat: E,
    coverage: this.parsePointer(Y.coverage),
    backtrackCoverage: this.parseList(Y.pointer(Y.coverage)),
    lookaheadCoverage: this.parseList(Y.pointer(Y.coverage)),
    substitutes: this.parseUShortList()
  };
};
function xn(A, E) {
  E = E || 0;
  var B = new Y(A, E), e = B.parseVersion(1);
  return gA.argument(e === 1 || e === 1.1, "Unsupported GSUB table version."), e === 1 ? {
    version: e,
    scripts: B.parseScriptList(),
    features: B.parseFeatureList(),
    lookups: B.parseLookupList(kA)
  } : {
    version: e,
    scripts: B.parseScriptList(),
    features: B.parseFeatureList(),
    lookups: B.parseLookupList(kA),
    variations: B.parseFeatureVariationsList()
  };
}
var NE = new Array(9);
NE[1] = function(E) {
  return E.substFormat === 1 ? new L.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) },
    { name: "deltaGlyphID", type: "USHORT", value: E.deltaGlyphId }
  ]) : new L.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 2 },
    { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) }
  ].concat(L.ushortList("substitute", E.substitute)));
};
NE[2] = function(E) {
  return gA.assert(E.substFormat === 1, "Lookup type 2 substFormat must be 1."), new L.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) }
  ].concat(L.tableList("seqSet", E.sequences, function(B) {
    return new L.Table("sequenceSetTable", L.ushortList("sequence", B));
  })));
};
NE[3] = function(E) {
  return gA.assert(E.substFormat === 1, "Lookup type 3 substFormat must be 1."), new L.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) }
  ].concat(L.tableList("altSet", E.alternateSets, function(B) {
    return new L.Table("alternateSetTable", L.ushortList("alternate", B));
  })));
};
NE[4] = function(E) {
  return gA.assert(E.substFormat === 1, "Lookup type 4 substFormat must be 1."), new L.Table("substitutionTable", [
    { name: "substFormat", type: "USHORT", value: 1 },
    { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) }
  ].concat(L.tableList("ligSet", E.ligatureSets, function(B) {
    return new L.Table("ligatureSetTable", L.tableList("ligature", B, function(e) {
      return new L.Table(
        "ligatureTable",
        [{ name: "ligGlyph", type: "USHORT", value: e.ligGlyph }].concat(L.ushortList("component", e.components, e.components.length + 1))
      );
    }));
  })));
};
NE[6] = function(E) {
  if (E.substFormat === 1) {
    var B = new L.Table("chainContextTable", [
      { name: "substFormat", type: "USHORT", value: E.substFormat },
      { name: "coverage", type: "TABLE", value: new L.Coverage(E.coverage) }
    ].concat(L.tableList("chainRuleSet", E.chainRuleSets, function(g) {
      return new L.Table("chainRuleSetTable", L.tableList("chainRule", g, function(M) {
        var Q = L.ushortList("backtrackGlyph", M.backtrack, M.backtrack.length).concat(L.ushortList("inputGlyph", M.input, M.input.length + 1)).concat(L.ushortList("lookaheadGlyph", M.lookahead, M.lookahead.length)).concat(L.ushortList("substitution", [], M.lookupRecords.length));
        return M.lookupRecords.forEach(function(s, r) {
          Q = Q.concat({ name: "sequenceIndex" + r, type: "USHORT", value: s.sequenceIndex }).concat({ name: "lookupListIndex" + r, type: "USHORT", value: s.lookupListIndex });
        }), new L.Table("chainRuleTable", Q);
      }));
    })));
    return B;
  } else if (E.substFormat === 2)
    gA.assert(!1, "lookup type 6 format 2 is not yet supported.");
  else if (E.substFormat === 3) {
    var e = [
      { name: "substFormat", type: "USHORT", value: E.substFormat }
    ];
    e.push({ name: "backtrackGlyphCount", type: "USHORT", value: E.backtrackCoverage.length }), E.backtrackCoverage.forEach(function(g, M) {
      e.push({ name: "backtrackCoverage" + M, type: "TABLE", value: new L.Coverage(g) });
    }), e.push({ name: "inputGlyphCount", type: "USHORT", value: E.inputCoverage.length }), E.inputCoverage.forEach(function(g, M) {
      e.push({ name: "inputCoverage" + M, type: "TABLE", value: new L.Coverage(g) });
    }), e.push({ name: "lookaheadGlyphCount", type: "USHORT", value: E.lookaheadCoverage.length }), E.lookaheadCoverage.forEach(function(g, M) {
      e.push({ name: "lookaheadCoverage" + M, type: "TABLE", value: new L.Coverage(g) });
    }), e.push({ name: "substitutionCount", type: "USHORT", value: E.lookupRecords.length }), E.lookupRecords.forEach(function(g, M) {
      e = e.concat({ name: "sequenceIndex" + M, type: "USHORT", value: g.sequenceIndex }).concat({ name: "lookupListIndex" + M, type: "USHORT", value: g.lookupListIndex });
    });
    var t = new L.Table("chainContextTable", e);
    return t;
  }
  gA.assert(!1, "lookup type 6 format must be 1, 2 or 3.");
};
function Tn(A) {
  return new L.Table("GSUB", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new L.ScriptList(A.scripts) },
    { name: "features", type: "TABLE", value: new L.FeatureList(A.features) },
    { name: "lookups", type: "TABLE", value: new L.LookupList(A.lookups, NE) }
  ]);
}
var PM = { parse: xn, make: Tn };
function hn(A, E) {
  var B = new K.Parser(A, E), e = B.parseULong();
  gA.argument(e === 1, "Unsupported META table version."), B.parseULong(), B.parseULong();
  for (var t = B.parseULong(), g = {}, M = 0; M < t; M++) {
    var Q = B.parseTag(), s = B.parseULong(), r = B.parseULong(), w = pE.UTF8(A, E + s, r);
    g[Q] = w;
  }
  return g;
}
function un(A) {
  var E = Object.keys(A).length, B = "", e = 16 + E * 12, t = new L.Table("meta", [
    { name: "version", type: "ULONG", value: 1 },
    { name: "flags", type: "ULONG", value: 0 },
    { name: "offset", type: "ULONG", value: e },
    { name: "numTags", type: "ULONG", value: E }
  ]);
  for (var g in A) {
    var M = B.length;
    B += A[g], t.fields.push({ name: "tag " + g, type: "TAG", value: g }), t.fields.push({ name: "offset " + g, type: "ULONG", value: e + M }), t.fields.push({ name: "length " + g, type: "ULONG", value: A[g].length });
  }
  return t.fields.push({ name: "stringPool", type: "CHARARRAY", value: B }), t;
}
var vM = { parse: hn, make: un };
function tg(A) {
  return Math.log(A) / Math.log(2) | 0;
}
function it(A) {
  for (; A.length % 4 !== 0; )
    A.push(0);
  for (var E = 0, B = 0; B < A.length; B += 4)
    E += (A[B] << 24) + (A[B + 1] << 16) + (A[B + 2] << 8) + A[B + 3];
  return E %= Math.pow(2, 32), E;
}
function gg(A, E, B, e) {
  return new L.Record("Table Record", [
    { name: "tag", type: "TAG", value: A !== void 0 ? A : "" },
    { name: "checkSum", type: "ULONG", value: E !== void 0 ? E : 0 },
    { name: "offset", type: "ULONG", value: B !== void 0 ? B : 0 },
    { name: "length", type: "ULONG", value: e !== void 0 ? e : 0 }
  ]);
}
function NM(A) {
  var E = new L.Table("sfnt", [
    { name: "version", type: "TAG", value: "OTTO" },
    { name: "numTables", type: "USHORT", value: 0 },
    { name: "searchRange", type: "USHORT", value: 0 },
    { name: "entrySelector", type: "USHORT", value: 0 },
    { name: "rangeShift", type: "USHORT", value: 0 }
  ]);
  E.tables = A, E.numTables = A.length;
  var B = Math.pow(2, tg(E.numTables));
  E.searchRange = 16 * B, E.entrySelector = tg(B), E.rangeShift = E.numTables * 16 - E.searchRange;
  for (var e = [], t = [], g = E.sizeOf() + gg().sizeOf() * E.numTables; g % 4 !== 0; )
    g += 1, t.push({ name: "padding", type: "BYTE", value: 0 });
  for (var M = 0; M < A.length; M += 1) {
    var Q = A[M];
    gA.argument(Q.tableName.length === 4, "Table name" + Q.tableName + " is invalid.");
    var s = Q.sizeOf(), r = gg(Q.tableName, it(Q.encode()), g, s);
    for (e.push({ name: r.tag + " Table Record", type: "RECORD", value: r }), t.push({ name: Q.tableName + " table", type: "RECORD", value: Q }), g += s, gA.argument(!isNaN(g), "Something went wrong calculating the offset."); g % 4 !== 0; )
      g += 1, t.push({ name: "padding", type: "BYTE", value: 0 });
  }
  return e.sort(function(w, c) {
    return w.value.tag > c.value.tag ? 1 : -1;
  }), E.fields = E.fields.concat(e), E.fields = E.fields.concat(t), E;
}
function Mg(A, E, B) {
  for (var e = 0; e < E.length; e += 1) {
    var t = A.charToGlyphIndex(E[e]);
    if (t > 0) {
      var g = A.glyphs.get(t);
      return g.getMetrics();
    }
  }
  return B;
}
function fn(A) {
  for (var E = 0, B = 0; B < A.length; B += 1)
    E += A[B];
  return E / A.length;
}
function Un(A) {
  for (var E = [], B = [], e = [], t = [], g = [], M = [], Q = [], s, r = 0, w = 0, c = 0, n = 0, a = 0, o = 0; o < A.glyphs.length; o += 1) {
    var D = A.glyphs.get(o), R = D.unicode | 0;
    if (isNaN(D.advanceWidth))
      throw new Error("Glyph " + D.name + " (" + o + "): advanceWidth is not a number.");
    (s > R || s === void 0) && R > 0 && (s = R), r < R && (r = R);
    var i = ve.getUnicodeRange(R);
    if (i < 32)
      w |= 1 << i;
    else if (i < 64)
      c |= 1 << i - 32;
    else if (i < 96)
      n |= 1 << i - 64;
    else if (i < 123)
      a |= 1 << i - 96;
    else
      throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
    if (D.name !== ".notdef") {
      var C = D.getMetrics();
      E.push(C.xMin), B.push(C.yMin), e.push(C.xMax), t.push(C.yMax), M.push(C.leftSideBearing), Q.push(C.rightSideBearing), g.push(D.advanceWidth);
    }
  }
  var F = {
    xMin: Math.min.apply(null, E),
    yMin: Math.min.apply(null, B),
    xMax: Math.max.apply(null, e),
    yMax: Math.max.apply(null, t),
    advanceWidthMax: Math.max.apply(null, g),
    advanceWidthAvg: fn(g),
    minLeftSideBearing: Math.min.apply(null, M),
    maxLeftSideBearing: Math.max.apply(null, M),
    minRightSideBearing: Math.min.apply(null, Q)
  };
  F.ascender = A.ascender, F.descender = A.descender;
  var l = uM.make({
    flags: 3,
    // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
    unitsPerEm: A.unitsPerEm,
    xMin: F.xMin,
    yMin: F.yMin,
    xMax: F.xMax,
    yMax: F.yMax,
    lowestRecPPEM: 3,
    createdTimestamp: A.createdTimestamp
  }), T = fM.make({
    ascender: F.ascender,
    descender: F.descender,
    advanceWidthMax: F.advanceWidthMax,
    minLeftSideBearing: F.minLeftSideBearing,
    minRightSideBearing: F.minRightSideBearing,
    xMaxExtent: F.maxLeftSideBearing + (F.xMax - F.xMin),
    numberOfHMetrics: A.glyphs.length
  }), u = YM.make(A.glyphs.length), h = ve.make(Object.assign({
    xAvgCharWidth: Math.round(F.advanceWidthAvg),
    usFirstCharIndex: s,
    usLastCharIndex: r,
    ulUnicodeRange1: w,
    ulUnicodeRange2: c,
    ulUnicodeRange3: n,
    ulUnicodeRange4: a,
    // See http://typophile.com/node/13081 for more info on vertical metrics.
    // We get metrics for typical characters (such as "x" for xHeight).
    // We provide some fallback characters if characters are unavailable: their
    // ordering was chosen experimentally.
    sTypoAscender: F.ascender,
    sTypoDescender: F.descender,
    sTypoLineGap: 0,
    usWinAscent: F.yMax,
    usWinDescent: Math.abs(F.yMin),
    ulCodePageRange1: 1,
    // FIXME: hard-code Latin 1 support for now
    sxHeight: Mg(A, "xyvw", { yMax: Math.round(F.ascender / 2) }).yMax,
    sCapHeight: Mg(A, "HIKLEFJMNTZBDPRAGOQSUVWXY", F).yMax,
    usDefaultChar: A.hasChar(" ") ? 32 : 0,
    // Use space as the default character, if available.
    usBreakChar: A.hasChar(" ") ? 32 : 0
    // Use space as the break character, if available.
  }, A.tables.os2)), x = UM.make(A.glyphs), U = aM.make(A.glyphs), z = A.getEnglishName("fontFamily"), k = A.getEnglishName("fontSubfamily"), P = z + " " + k, y = A.getEnglishName("postScriptName");
  y || (y = z.replace(/\s/g, "") + "-" + k);
  var G = {};
  for (var d in A.names)
    G[d] = A.names[d];
  G.uniqueID || (G.uniqueID = { en: A.getEnglishName("manufacturer") + ":" + P }), G.postScriptName || (G.postScriptName = { en: y }), G.preferredFamily || (G.preferredFamily = A.names.fontFamily), G.preferredSubfamily || (G.preferredSubfamily = A.names.fontSubfamily);
  var S = [], v = SM.make(G, S), j = S.length > 0 ? zM.make(S) : void 0, m = pM.make(), b = hM.make(A.glyphs, {
    version: A.getEnglishName("version"),
    fullName: P,
    familyName: z,
    weightName: k,
    postScriptName: y,
    unitsPerEm: A.unitsPerEm,
    fontBBox: [0, F.yMin, F.ascender, F.advanceWidthMax]
  }), N = A.metas && Object.keys(A.metas).length > 0 ? vM.make(A.metas) : void 0, f = [l, T, u, h, v, U, m, b, x];
  j && f.push(j), A.tables.gsub && f.push(PM.make(A.tables.gsub)), N && f.push(N);
  for (var p = NM(f), W = p.encode(), J = it(W), $ = p.fields, QA = !1, Z = 0; Z < $.length; Z += 1)
    if ($[Z].name === "head table") {
      $[Z].value.checkSumAdjustment = 2981146554 - J, QA = !0;
      break;
    }
  if (!QA)
    throw new Error("Could not find head table with checkSum to adjust.");
  return p;
}
var zn = { make: NM, fontToTable: Un, computeCheckSum: it };
function ie(A, E) {
  for (var B = 0, e = A.length - 1; B <= e; ) {
    var t = B + e >>> 1, g = A[t].tag;
    if (g === E)
      return t;
    g < E ? B = t + 1 : e = t - 1;
  }
  return -B - 1;
}
function Qg(A, E) {
  for (var B = 0, e = A.length - 1; B <= e; ) {
    var t = B + e >>> 1, g = A[t];
    if (g === E)
      return t;
    g < E ? B = t + 1 : e = t - 1;
  }
  return -B - 1;
}
function sg(A, E) {
  for (var B, e = 0, t = A.length - 1; e <= t; ) {
    var g = e + t >>> 1;
    B = A[g];
    var M = B.start;
    if (M === E)
      return B;
    M < E ? e = g + 1 : t = g - 1;
  }
  if (e > 0)
    return B = A[e - 1], E > B.end ? 0 : B;
}
function gB(A, E) {
  this.font = A, this.tableName = E;
}
gB.prototype = {
  /**
   * Binary search an object by "tag" property
   * @instance
   * @function searchTag
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {string} tag
   * @return {number}
   */
  searchTag: ie,
  /**
   * Binary search in a list of numbers
   * @instance
   * @function binSearch
   * @memberof opentype.Layout
   * @param  {Array} arr
   * @param  {number} value
   * @return {number}
   */
  binSearch: Qg,
  /**
   * Get or create the Layout table (GSUB, GPOS etc).
   * @param  {boolean} create - Whether to create a new one.
   * @return {Object} The GSUB or GPOS table.
   */
  getTable: function(A) {
    var E = this.font.tables[this.tableName];
    return !E && A && (E = this.font.tables[this.tableName] = this.createDefaultTable()), E;
  },
  /**
   * Returns all scripts in the substitution table.
   * @instance
   * @return {Array}
   */
  getScriptNames: function() {
    var A = this.getTable();
    return A ? A.scripts.map(function(E) {
      return E.tag;
    }) : [];
  },
  /**
   * Returns the best bet for a script name.
   * Returns 'DFLT' if it exists.
   * If not, returns 'latn' if it exists.
   * If neither exist, returns undefined.
   */
  getDefaultScriptName: function() {
    var A = this.getTable();
    if (A) {
      for (var E = !1, B = 0; B < A.scripts.length; B++) {
        var e = A.scripts[B].tag;
        if (e === "DFLT")
          return e;
        e === "latn" && (E = !0);
      }
      if (E)
        return "latn";
    }
  },
  /**
   * Returns all LangSysRecords in the given script.
   * @instance
   * @param {string} [script='DFLT']
   * @param {boolean} create - forces the creation of this script table if it doesn't exist.
   * @return {Object} An object with tag and script properties.
   */
  getScriptTable: function(A, E) {
    var B = this.getTable(E);
    if (B) {
      A = A || "DFLT";
      var e = B.scripts, t = ie(B.scripts, A);
      if (t >= 0)
        return e[t].script;
      if (E) {
        var g = {
          tag: A,
          script: {
            defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
            langSysRecords: []
          }
        };
        return e.splice(-1 - t, 0, g), g.script;
      }
    }
  },
  /**
   * Returns a language system table
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
   * @return {Object}
   */
  getLangSysTable: function(A, E, B) {
    var e = this.getScriptTable(A, B);
    if (e) {
      if (!E || E === "dflt" || E === "DFLT")
        return e.defaultLangSys;
      var t = ie(e.langSysRecords, E);
      if (t >= 0)
        return e.langSysRecords[t].langSys;
      if (B) {
        var g = {
          tag: E,
          langSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] }
        };
        return e.langSysRecords.splice(-1 - t, 0, g), g.langSys;
      }
    }
  },
  /**
   * Get a specific feature table.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
   * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
   * @return {Object}
   */
  getFeatureTable: function(A, E, B, e) {
    var t = this.getLangSysTable(A, E, e);
    if (t) {
      for (var g, M = t.featureIndexes, Q = this.font.tables[this.tableName].features, s = 0; s < M.length; s++)
        if (g = Q[M[s]], g.tag === B)
          return g.feature;
      if (e) {
        var r = Q.length;
        return gA.assert(r === 0 || B >= Q[r - 1].tag, "Features must be added in alphabetical order."), g = {
          tag: B,
          feature: { params: 0, lookupListIndexes: [] }
        }, Q.push(g), M.push(r), g.feature;
      }
    }
  },
  /**
   * Get the lookup tables of a given type for a script/language/feature.
   * @instance
   * @param {string} [script='DFLT']
   * @param {string} [language='dlft']
   * @param {string} feature - 4-letter feature code
   * @param {number} lookupType - 1 to 9
   * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
   * @return {Object[]}
   */
  getLookupTables: function(A, E, B, e, t) {
    var g = this.getFeatureTable(A, E, B, t), M = [];
    if (g) {
      for (var Q, s = g.lookupListIndexes, r = this.font.tables[this.tableName].lookups, w = 0; w < s.length; w++)
        Q = r[s[w]], Q.lookupType === e && M.push(Q);
      if (M.length === 0 && t) {
        Q = {
          lookupType: e,
          lookupFlag: 0,
          subtables: [],
          markFilteringSet: void 0
        };
        var c = r.length;
        return r.push(Q), s.push(c), [Q];
      }
    }
    return M;
  },
  /**
   * Find a glyph in a class definition table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
   * @param {object} classDefTable - an OpenType Layout class definition table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getGlyphClass: function(A, E) {
    switch (A.format) {
      case 1:
        return A.startGlyph <= E && E < A.startGlyph + A.classes.length ? A.classes[E - A.startGlyph] : 0;
      case 2:
        var B = sg(A.ranges, E);
        return B ? B.classId : 0;
    }
  },
  /**
   * Find a glyph in a coverage table
   * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
   * @param {object} coverageTable - an OpenType Layout coverage table
   * @param {number} glyphIndex - the index of the glyph to find
   * @returns {number} -1 if not found
   */
  getCoverageIndex: function(A, E) {
    switch (A.format) {
      case 1:
        var B = Qg(A.glyphs, E);
        return B >= 0 ? B : -1;
      case 2:
        var e = sg(A.ranges, E);
        return e ? e.index + E - e.start : -1;
    }
  },
  /**
   * Returns the list of glyph indexes of a coverage table.
   * Format 1: the list is stored raw
   * Format 2: compact list as range records.
   * @instance
   * @param  {Object} coverageTable
   * @return {Array}
   */
  expandCoverage: function(A) {
    if (A.format === 1)
      return A.glyphs;
    for (var E = [], B = A.ranges, e = 0; e < B.length; e++)
      for (var t = B[e], g = t.start, M = t.end, Q = g; Q <= M; Q++)
        E.push(Q);
    return E;
  }
};
function MB(A) {
  gB.call(this, A, "gpos");
}
MB.prototype = gB.prototype;
MB.prototype.init = function() {
  var A = this.getDefaultScriptName();
  this.defaultKerningTables = this.getKerningTables(A);
};
MB.prototype.getKerningValue = function(A, E, B) {
  for (var e = 0; e < A.length; e++)
    for (var t = A[e].subtables, g = 0; g < t.length; g++) {
      var M = t[g], Q = this.getCoverageIndex(M.coverage, E);
      if (!(Q < 0))
        switch (M.posFormat) {
          case 1:
            for (var s = M.pairSets[Q], r = 0; r < s.length; r++) {
              var w = s[r];
              if (w.secondGlyph === B)
                return w.value1 && w.value1.xAdvance || 0;
            }
            break;
          // left glyph found, not right glyph - try next subtable
          case 2:
            var c = this.getGlyphClass(M.classDef1, E), n = this.getGlyphClass(M.classDef2, B), a = M.classRecords[c][n];
            return a.value1 && a.value1.xAdvance || 0;
        }
    }
  return 0;
};
MB.prototype.getKerningTables = function(A, E) {
  if (this.font.tables.gpos)
    return this.getLookupTables(A, E, "kern", 2);
};
function uA(A) {
  gB.call(this, A, "gsub");
}
function Yn(A, E) {
  var B = A.length;
  if (B !== E.length)
    return !1;
  for (var e = 0; e < B; e++)
    if (A[e] !== E[e])
      return !1;
  return !0;
}
function It(A, E, B) {
  for (var e = A.subtables, t = 0; t < e.length; t++) {
    var g = e[t];
    if (g.substFormat === E)
      return g;
  }
  if (B)
    return e.push(B), B;
}
uA.prototype = gB.prototype;
uA.prototype.createDefaultTable = function() {
  return {
    version: 1,
    scripts: [{
      tag: "DFLT",
      script: {
        defaultLangSys: { reserved: 0, reqFeatureIndex: 65535, featureIndexes: [] },
        langSysRecords: []
      }
    }],
    features: [],
    lookups: []
  };
};
uA.prototype.getSingle = function(A, E, B) {
  for (var e = [], t = this.getLookupTables(E, B, A, 1), g = 0; g < t.length; g++)
    for (var M = t[g].subtables, Q = 0; Q < M.length; Q++) {
      var s = M[Q], r = this.expandCoverage(s.coverage), w = void 0;
      if (s.substFormat === 1) {
        var c = s.deltaGlyphId;
        for (w = 0; w < r.length; w++) {
          var n = r[w];
          e.push({ sub: n, by: n + c });
        }
      } else {
        var a = s.substitute;
        for (w = 0; w < r.length; w++)
          e.push({ sub: r[w], by: a[w] });
      }
    }
  return e;
};
uA.prototype.getMultiple = function(A, E, B) {
  for (var e = [], t = this.getLookupTables(E, B, A, 2), g = 0; g < t.length; g++)
    for (var M = t[g].subtables, Q = 0; Q < M.length; Q++) {
      var s = M[Q], r = this.expandCoverage(s.coverage), w = void 0;
      for (w = 0; w < r.length; w++) {
        var c = r[w], n = s.sequences[w];
        e.push({ sub: c, by: n });
      }
    }
  return e;
};
uA.prototype.getAlternates = function(A, E, B) {
  for (var e = [], t = this.getLookupTables(E, B, A, 3), g = 0; g < t.length; g++)
    for (var M = t[g].subtables, Q = 0; Q < M.length; Q++)
      for (var s = M[Q], r = this.expandCoverage(s.coverage), w = s.alternateSets, c = 0; c < r.length; c++)
        e.push({ sub: r[c], by: w[c] });
  return e;
};
uA.prototype.getLigatures = function(A, E, B) {
  for (var e = [], t = this.getLookupTables(E, B, A, 4), g = 0; g < t.length; g++)
    for (var M = t[g].subtables, Q = 0; Q < M.length; Q++)
      for (var s = M[Q], r = this.expandCoverage(s.coverage), w = s.ligatureSets, c = 0; c < r.length; c++)
        for (var n = r[c], a = w[c], o = 0; o < a.length; o++) {
          var D = a[o];
          e.push({
            sub: [n].concat(D.components),
            by: D.ligGlyph
          });
        }
  return e;
};
uA.prototype.addSingle = function(A, E, B, e) {
  var t = this.getLookupTables(B, e, A, 1, !0)[0], g = It(t, 2, {
    // lookup type 1 subtable, format 2, coverage format 1
    substFormat: 2,
    coverage: { format: 1, glyphs: [] },
    substitute: []
  });
  gA.assert(g.coverage.format === 1, "Single: unable to modify coverage table format " + g.coverage.format);
  var M = E.sub, Q = this.binSearch(g.coverage.glyphs, M);
  Q < 0 && (Q = -1 - Q, g.coverage.glyphs.splice(Q, 0, M), g.substitute.splice(Q, 0, 0)), g.substitute[Q] = E.by;
};
uA.prototype.addMultiple = function(A, E, B, e) {
  gA.assert(E.by instanceof Array && E.by.length > 1, 'Multiple: "by" must be an array of two or more ids');
  var t = this.getLookupTables(B, e, A, 2, !0)[0], g = It(t, 1, {
    // lookup type 2 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    sequences: []
  });
  gA.assert(g.coverage.format === 1, "Multiple: unable to modify coverage table format " + g.coverage.format);
  var M = E.sub, Q = this.binSearch(g.coverage.glyphs, M);
  Q < 0 && (Q = -1 - Q, g.coverage.glyphs.splice(Q, 0, M), g.sequences.splice(Q, 0, 0)), g.sequences[Q] = E.by;
};
uA.prototype.addAlternate = function(A, E, B, e) {
  var t = this.getLookupTables(B, e, A, 3, !0)[0], g = It(t, 1, {
    // lookup type 3 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    alternateSets: []
  });
  gA.assert(g.coverage.format === 1, "Alternate: unable to modify coverage table format " + g.coverage.format);
  var M = E.sub, Q = this.binSearch(g.coverage.glyphs, M);
  Q < 0 && (Q = -1 - Q, g.coverage.glyphs.splice(Q, 0, M), g.alternateSets.splice(Q, 0, 0)), g.alternateSets[Q] = E.by;
};
uA.prototype.addLigature = function(A, E, B, e) {
  var t = this.getLookupTables(B, e, A, 4, !0)[0], g = t.subtables[0];
  g || (g = {
    // lookup type 4 subtable, format 1, coverage format 1
    substFormat: 1,
    coverage: { format: 1, glyphs: [] },
    ligatureSets: []
  }, t.subtables[0] = g), gA.assert(g.coverage.format === 1, "Ligature: unable to modify coverage table format " + g.coverage.format);
  var M = E.sub[0], Q = E.sub.slice(1), s = {
    ligGlyph: E.by,
    components: Q
  }, r = this.binSearch(g.coverage.glyphs, M);
  if (r >= 0) {
    for (var w = g.ligatureSets[r], c = 0; c < w.length; c++)
      if (Yn(w[c].components, Q))
        return;
    w.push(s);
  } else
    r = -1 - r, g.coverage.glyphs.splice(r, 0, M), g.ligatureSets.splice(r, 0, [s]);
};
uA.prototype.getFeature = function(A, E, B) {
  if (/ss\d\d/.test(A))
    return this.getSingle(A, E, B);
  switch (A) {
    case "aalt":
    case "salt":
      return this.getSingle(A, E, B).concat(this.getAlternates(A, E, B));
    case "dlig":
    case "liga":
    case "rlig":
      return this.getLigatures(A, E, B);
    case "ccmp":
      return this.getMultiple(A, E, B).concat(this.getLigatures(A, E, B));
    case "stch":
      return this.getMultiple(A, E, B);
  }
};
uA.prototype.add = function(A, E, B, e) {
  if (/ss\d\d/.test(A))
    return this.addSingle(A, E, B, e);
  switch (A) {
    case "aalt":
    case "salt":
      return typeof E.by == "number" ? this.addSingle(A, E, B, e) : this.addAlternate(A, E, B, e);
    case "dlig":
    case "liga":
    case "rlig":
      return this.addLigature(A, E, B, e);
    case "ccmp":
      return E.by instanceof Array ? this.addMultiple(A, E, B, e) : this.addLigature(A, E, B, e);
  }
};
function kn() {
  return typeof window < "u";
}
function HM(A) {
  for (var E = new ArrayBuffer(A.length), B = new Uint8Array(E), e = 0; e < A.length; ++e)
    B[e] = A[e];
  return E;
}
function dn(A) {
  for (var E = new Buffer(A.byteLength), B = new Uint8Array(A), e = 0; e < E.length; ++e)
    E[e] = B[e];
  return E;
}
function bE(A, E) {
  if (!A)
    throw E;
}
function rg(A, E, B, e, t) {
  var g;
  return (E & e) > 0 ? (g = A.parseByte(), (E & t) === 0 && (g = -g), g = B + g) : (E & t) > 0 ? g = B : g = B + A.parseShort(), g;
}
function mM(A, E, B) {
  var e = new K.Parser(E, B);
  A.numberOfContours = e.parseShort(), A._xMin = e.parseShort(), A._yMin = e.parseShort(), A._xMax = e.parseShort(), A._yMax = e.parseShort();
  var t, g;
  if (A.numberOfContours > 0) {
    for (var M = A.endPointIndices = [], Q = 0; Q < A.numberOfContours; Q += 1)
      M.push(e.parseUShort());
    A.instructionLength = e.parseUShort(), A.instructions = [];
    for (var s = 0; s < A.instructionLength; s += 1)
      A.instructions.push(e.parseByte());
    var r = M[M.length - 1] + 1;
    t = [];
    for (var w = 0; w < r; w += 1)
      if (g = e.parseByte(), t.push(g), (g & 8) > 0)
        for (var c = e.parseByte(), n = 0; n < c; n += 1)
          t.push(g), w += 1;
    if (gA.argument(t.length === r, "Bad flags."), M.length > 0) {
      var a = [], o;
      if (r > 0) {
        for (var D = 0; D < r; D += 1)
          g = t[D], o = {}, o.onCurve = !!(g & 1), o.lastPointOfContour = M.indexOf(D) >= 0, a.push(o);
        for (var R = 0, i = 0; i < r; i += 1)
          g = t[i], o = a[i], o.x = rg(e, g, R, 2, 16), R = o.x;
        for (var C = 0, F = 0; F < r; F += 1)
          g = t[F], o = a[F], o.y = rg(e, g, C, 4, 32), C = o.y;
      }
      A.points = a;
    } else
      A.points = [];
  } else if (A.numberOfContours === 0)
    A.points = [];
  else {
    A.isComposite = !0, A.points = [], A.components = [];
    for (var l = !0; l; ) {
      t = e.parseUShort();
      var T = {
        glyphIndex: e.parseUShort(),
        xScale: 1,
        scale01: 0,
        scale10: 0,
        yScale: 1,
        dx: 0,
        dy: 0
      };
      (t & 1) > 0 ? (t & 2) > 0 ? (T.dx = e.parseShort(), T.dy = e.parseShort()) : T.matchedPoints = [e.parseUShort(), e.parseUShort()] : (t & 2) > 0 ? (T.dx = e.parseChar(), T.dy = e.parseChar()) : T.matchedPoints = [e.parseByte(), e.parseByte()], (t & 8) > 0 ? T.xScale = T.yScale = e.parseF2Dot14() : (t & 64) > 0 ? (T.xScale = e.parseF2Dot14(), T.yScale = e.parseF2Dot14()) : (t & 128) > 0 && (T.xScale = e.parseF2Dot14(), T.scale01 = e.parseF2Dot14(), T.scale10 = e.parseF2Dot14(), T.yScale = e.parseF2Dot14()), A.components.push(T), l = !!(t & 32);
    }
    if (t & 256) {
      A.instructionLength = e.parseUShort(), A.instructions = [];
      for (var u = 0; u < A.instructionLength; u += 1)
        A.instructions.push(e.parseByte());
    }
  }
}
function Ie(A, E) {
  for (var B = [], e = 0; e < A.length; e += 1) {
    var t = A[e], g = {
      x: E.xScale * t.x + E.scale01 * t.y + E.dx,
      y: E.scale10 * t.x + E.yScale * t.y + E.dy,
      onCurve: t.onCurve,
      lastPointOfContour: t.lastPointOfContour
    };
    B.push(g);
  }
  return B;
}
function Gn(A) {
  for (var E = [], B = [], e = 0; e < A.length; e += 1) {
    var t = A[e];
    B.push(t), t.lastPointOfContour && (E.push(B), B = []);
  }
  return gA.argument(B.length === 0, "There are still points left in the current contour."), E;
}
function VM(A) {
  var E = new FA();
  if (!A)
    return E;
  for (var B = Gn(A), e = 0; e < B.length; ++e) {
    var t = B[e], g = null, M = t[t.length - 1], Q = t[0];
    if (M.onCurve)
      E.moveTo(M.x, M.y);
    else if (Q.onCurve)
      E.moveTo(Q.x, Q.y);
    else {
      var s = { x: (M.x + Q.x) * 0.5, y: (M.y + Q.y) * 0.5 };
      E.moveTo(s.x, s.y);
    }
    for (var r = 0; r < t.length; ++r)
      if (g = M, M = Q, Q = t[(r + 1) % t.length], M.onCurve)
        E.lineTo(M.x, M.y);
      else {
        var w = Q;
        g.onCurve || ((M.x + g.x) * 0.5, (M.y + g.y) * 0.5), Q.onCurve || (w = { x: (M.x + Q.x) * 0.5, y: (M.y + Q.y) * 0.5 }), E.quadraticCurveTo(M.x, M.y, w.x, w.y);
      }
    E.closePath();
  }
  return E;
}
function JM(A, E) {
  if (E.isComposite)
    for (var B = 0; B < E.components.length; B += 1) {
      var e = E.components[B], t = A.get(e.glyphIndex);
      if (t.getPath(), t.points) {
        var g = void 0;
        if (e.matchedPoints === void 0)
          g = Ie(t.points, e);
        else {
          if (e.matchedPoints[0] > E.points.length - 1 || e.matchedPoints[1] > t.points.length - 1)
            throw Error("Matched points out of range in " + E.name);
          var M = E.points[e.matchedPoints[0]], Q = t.points[e.matchedPoints[1]], s = {
            xScale: e.xScale,
            scale01: e.scale01,
            scale10: e.scale10,
            yScale: e.yScale,
            dx: 0,
            dy: 0
          };
          Q = Ie([Q], s)[0], s.dx = M.x - Q.x, s.dy = M.y - Q.y, g = Ie(t.points, s);
        }
        E.points = E.points.concat(g);
      }
    }
  return VM(E.points);
}
function yn(A, E, B, e) {
  for (var t = new HA.GlyphSet(e), g = 0; g < B.length - 1; g += 1) {
    var M = B[g], Q = B[g + 1];
    M !== Q ? t.push(g, HA.ttfGlyphLoader(e, g, mM, A, E + M, JM)) : t.push(g, HA.glyphLoader(e, g));
  }
  return t;
}
function Sn(A, E, B, e) {
  var t = new HA.GlyphSet(e);
  return e._push = function(g) {
    var M = B[g], Q = B[g + 1];
    M !== Q ? t.push(g, HA.ttfGlyphLoader(e, g, mM, A, E + M, JM)) : t.push(g, HA.glyphLoader(e, g));
  }, t;
}
function pn(A, E, B, e, t) {
  return t.lowMemory ? Sn(A, E, B, e) : yn(A, E, B, e);
}
var bM = { getPath: VM, parse: pn }, OM, CE, jM, Ne;
function LM(A) {
  this.font = A, this.getCommands = function(E) {
    return bM.getPath(E).commands;
  }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
}
function Pn(A) {
  return A;
}
function WM(A) {
  return Math.sign(A) * Math.round(Math.abs(A));
}
function vn(A) {
  return Math.sign(A) * Math.round(Math.abs(A * 2)) / 2;
}
function Nn(A) {
  return Math.sign(A) * (Math.round(Math.abs(A) + 0.5) - 0.5);
}
function Hn(A) {
  return Math.sign(A) * Math.ceil(Math.abs(A));
}
function mn(A) {
  return Math.sign(A) * Math.floor(Math.abs(A));
}
var XM = function(A) {
  var E = this.srPeriod, B = this.srPhase, e = this.srThreshold, t = 1;
  return A < 0 && (A = -A, t = -1), A += e - B, A = Math.trunc(A / E) * E, A += B, A < 0 ? B * t : A * t;
}, NA = {
  x: 1,
  y: 0,
  axis: "x",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(A, E, B, e) {
    return (B ? A.xo : A.x) - (e ? E.xo : E.x);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(A, E, B, e) {
    var t, g, M, Q, s, r, w;
    if (!e || e === this) {
      if (t = A.xo - E.xo, g = A.xo - B.xo, s = E.x - E.xo, r = B.x - B.xo, M = Math.abs(t), Q = Math.abs(g), w = M + Q, w === 0) {
        A.x = A.xo + (s + r) / 2;
        return;
      }
      A.x = A.xo + (s * Q + r * M) / w;
      return;
    }
    if (t = e.distance(A, E, !0, !0), g = e.distance(A, B, !0, !0), s = e.distance(E, E, !1, !0), r = e.distance(B, B, !1, !0), M = Math.abs(t), Q = Math.abs(g), w = M + Q, w === 0) {
      NA.setRelative(A, A, (s + r) / 2, e, !0);
      return;
    }
    NA.setRelative(A, A, (s * Q + r * M) / w, e, !0);
  },
  // Slope of line normal to this
  normalSlope: Number.NEGATIVE_INFINITY,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'.
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(A, E, B, e, t) {
    if (!e || e === this) {
      A.x = (t ? E.xo : E.x) + B;
      return;
    }
    var g = t ? E.xo : E.x, M = t ? E.yo : E.y, Q = g + B * e.x, s = M + B * e.y;
    A.x = Q + (A.y - s) / e.normalSlope;
  },
  // Slope of vector line.
  slope: 0,
  // Touches the point p.
  touch: function(A) {
    A.xTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(A) {
    return A.xTouched;
  },
  // Untouches the point p.
  untouch: function(A) {
    A.xTouched = !1;
  }
}, jA = {
  x: 0,
  y: 1,
  axis: "y",
  // Gets the projected distance between two points.
  // o1/o2 ... if true, respective original position is used.
  distance: function(A, E, B, e) {
    return (B ? A.yo : A.y) - (e ? E.yo : E.y);
  },
  // Moves point p so the moved position has the same relative
  // position to the moved positions of rp1 and rp2 than the
  // original positions had.
  //
  // See APPENDIX on INTERPOLATE at the bottom of this file.
  interpolate: function(A, E, B, e) {
    var t, g, M, Q, s, r, w;
    if (!e || e === this) {
      if (t = A.yo - E.yo, g = A.yo - B.yo, s = E.y - E.yo, r = B.y - B.yo, M = Math.abs(t), Q = Math.abs(g), w = M + Q, w === 0) {
        A.y = A.yo + (s + r) / 2;
        return;
      }
      A.y = A.yo + (s * Q + r * M) / w;
      return;
    }
    if (t = e.distance(A, E, !0, !0), g = e.distance(A, B, !0, !0), s = e.distance(E, E, !1, !0), r = e.distance(B, B, !1, !0), M = Math.abs(t), Q = Math.abs(g), w = M + Q, w === 0) {
      jA.setRelative(A, A, (s + r) / 2, e, !0);
      return;
    }
    jA.setRelative(A, A, (s * Q + r * M) / w, e, !0);
  },
  // Slope of line normal to this.
  normalSlope: 0,
  // Sets the point 'p' relative to point 'rp'
  // by the distance 'd'
  //
  // See APPENDIX on SETRELATIVE at the bottom of this file.
  //
  // p   ... point to set
  // rp  ... reference point
  // d   ... distance on projection vector
  // pv  ... projection vector (undefined = this)
  // org ... if true, uses the original position of rp as reference.
  setRelative: function(A, E, B, e, t) {
    if (!e || e === this) {
      A.y = (t ? E.yo : E.y) + B;
      return;
    }
    var g = t ? E.xo : E.x, M = t ? E.yo : E.y, Q = g + B * e.x, s = M + B * e.y;
    A.y = s + e.normalSlope * (A.x - Q);
  },
  // Slope of vector line.
  slope: Number.POSITIVE_INFINITY,
  // Touches the point p.
  touch: function(A) {
    A.yTouched = !0;
  },
  // Tests if a point p is touched.
  touched: function(A) {
    return A.yTouched;
  },
  // Untouches the point p.
  untouch: function(A) {
    A.yTouched = !1;
  }
};
Object.freeze(NA);
Object.freeze(jA);
function QB(A, E) {
  this.x = A, this.y = E, this.axis = void 0, this.slope = E / A, this.normalSlope = -A / E, Object.freeze(this);
}
QB.prototype.distance = function(A, E, B, e) {
  return this.x * NA.distance(A, E, B, e) + this.y * jA.distance(A, E, B, e);
};
QB.prototype.interpolate = function(A, E, B, e) {
  var t, g, M, Q, s, r, w;
  if (M = e.distance(A, E, !0, !0), Q = e.distance(A, B, !0, !0), t = e.distance(E, E, !1, !0), g = e.distance(B, B, !1, !0), s = Math.abs(M), r = Math.abs(Q), w = s + r, w === 0) {
    this.setRelative(A, A, (t + g) / 2, e, !0);
    return;
  }
  this.setRelative(A, A, (t * r + g * s) / w, e, !0);
};
QB.prototype.setRelative = function(A, E, B, e, t) {
  e = e || this;
  var g = t ? E.xo : E.x, M = t ? E.yo : E.y, Q = g + B * e.x, s = M + B * e.y, r = e.normalSlope, w = this.slope, c = A.x, n = A.y;
  A.x = (w * c - r * Q + s - n) / (w - r), A.y = w * (A.x - c) + n;
};
QB.prototype.touch = function(A) {
  A.xTouched = !0, A.yTouched = !0;
};
function sB(A, E) {
  var B = Math.sqrt(A * A + E * E);
  return A /= B, E /= B, A === 1 && E === 0 ? NA : A === 0 && E === 1 ? jA : new QB(A, E);
}
function XA(A, E, B, e) {
  this.x = this.xo = Math.round(A * 64) / 64, this.y = this.yo = Math.round(E * 64) / 64, this.lastPointOfContour = B, this.onCurve = e, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
}
XA.prototype.nextTouched = function(A) {
  for (var E = this.nextPointOnContour; !A.touched(E) && E !== this; )
    E = E.nextPointOnContour;
  return E;
};
XA.prototype.prevTouched = function(A) {
  for (var E = this.prevPointOnContour; !A.touched(E) && E !== this; )
    E = E.prevPointOnContour;
  return E;
};
var BB = Object.freeze(new XA(0, 0)), Vn = {
  cvCutIn: 17 / 16,
  // control value cut in
  deltaBase: 9,
  deltaShift: 0.125,
  loop: 1,
  // loops some instructions
  minDis: 1,
  // minimum distance
  autoFlip: !0
};
function BE(A, E) {
  switch (this.env = A, this.stack = [], this.prog = E, A) {
    case "glyf":
      this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
    /* fall through */
    case "prep":
      this.fv = this.pv = this.dpv = NA, this.round = WM;
  }
}
LM.prototype.exec = function(A, E) {
  if (typeof E != "number")
    throw new Error("Point size is not a number!");
  if (!(this._errorState > 2)) {
    var B = this.font, e = this._prepState;
    if (!e || e.ppem !== E) {
      var t = this._fpgmState;
      if (!t) {
        BE.prototype = Vn, t = this._fpgmState = new BE("fpgm", B.tables.fpgm), t.funcs = [], t.font = B, exports.DEBUG && (console.log("---EXEC FPGM---"), t.step = -1);
        try {
          CE(t);
        } catch (r) {
          console.log("Hinting error in FPGM:" + r), this._errorState = 3;
          return;
        }
      }
      BE.prototype = t, e = this._prepState = new BE("prep", B.tables.prep), e.ppem = E;
      var g = B.tables.cvt;
      if (g)
        for (var M = e.cvt = new Array(g.length), Q = E / B.unitsPerEm, s = 0; s < g.length; s++)
          M[s] = g[s] * Q;
      else
        e.cvt = [];
      exports.DEBUG && (console.log("---EXEC PREP---"), e.step = -1);
      try {
        CE(e);
      } catch (r) {
        this._errorState < 2 && console.log("Hinting error in PREP:" + r), this._errorState = 2;
      }
    }
    if (!(this._errorState > 1))
      try {
        return jM(A, e);
      } catch (r) {
        this._errorState < 1 && (console.log("Hinting error:" + r), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
        return;
      }
  }
};
jM = function(A, E) {
  var B = E.ppem / E.font.unitsPerEm, e = B, t = A.components, g, M, Q;
  if (BE.prototype = E, !t)
    Q = new BE("glyf", A.instructions), exports.DEBUG && (console.log("---EXEC GLYPH---"), Q.step = -1), Ne(A, Q, B, e), M = Q.gZone;
  else {
    var s = E.font;
    M = [], g = [];
    for (var r = 0; r < t.length; r++) {
      var w = t[r], c = s.glyphs.get(w.glyphIndex);
      Q = new BE("glyf", c.instructions), exports.DEBUG && (console.log("---EXEC COMP " + r + "---"), Q.step = -1), Ne(c, Q, B, e);
      for (var n = Math.round(w.dx * B), a = Math.round(w.dy * e), o = Q.gZone, D = Q.contours, R = 0; R < o.length; R++) {
        var i = o[R];
        i.xTouched = i.yTouched = !1, i.xo = i.x = i.x + n, i.yo = i.y = i.y + a;
      }
      var C = M.length;
      M.push.apply(M, o);
      for (var F = 0; F < D.length; F++)
        g.push(D[F] + C);
    }
    A.instructions && !Q.inhibitGridFit && (Q = new BE("glyf", A.instructions), Q.gZone = Q.z0 = Q.z1 = Q.z2 = M, Q.contours = g, M.push(
      new XA(0, 0),
      new XA(Math.round(A.advanceWidth * B), 0)
    ), exports.DEBUG && (console.log("---EXEC COMPOSITE---"), Q.step = -1), CE(Q), M.length -= 2);
  }
  return M;
};
Ne = function(A, E, B, e) {
  for (var t = A.points || [], g = t.length, M = E.gZone = E.z0 = E.z1 = E.z2 = [], Q = E.contours = [], s, r = 0; r < g; r++)
    s = t[r], M[r] = new XA(
      s.x * B,
      s.y * e,
      s.lastPointOfContour,
      s.onCurve
    );
  for (var w, c, n = 0; n < g; n++)
    s = M[n], w || (w = s, Q.push(n)), s.lastPointOfContour ? (s.nextPointOnContour = w, w.prevPointOnContour = s, w = void 0) : (c = M[n + 1], s.nextPointOnContour = c, c.prevPointOnContour = s);
  if (!E.inhibitGridFit) {
    if (exports.DEBUG) {
      console.log("PROCESSING GLYPH", E.stack);
      for (var a = 0; a < g; a++)
        console.log(a, M[a].x, M[a].y);
    }
    if (M.push(
      new XA(0, 0),
      new XA(Math.round(A.advanceWidth * B), 0)
    ), CE(E), M.length -= 2, exports.DEBUG) {
      console.log("FINISHED GLYPH", E.stack);
      for (var o = 0; o < g; o++)
        console.log(o, M[o].x, M[o].y);
    }
  }
};
CE = function(A) {
  var E = A.prog;
  if (E) {
    var B = E.length, e;
    for (A.ip = 0; A.ip < B; A.ip++) {
      if (exports.DEBUG && A.step++, e = OM[E[A.ip]], !e)
        throw new Error(
          "unknown instruction: 0x" + Number(E[A.ip]).toString(16)
        );
      e(A);
    }
  }
};
function Be(A) {
  for (var E = A.tZone = new Array(A.gZone.length), B = 0; B < E.length; B++)
    E[B] = new XA(0, 0);
}
function KM(A, E) {
  var B = A.prog, e = A.ip, t = 1, g;
  do
    if (g = B[++e], g === 88)
      t++;
    else if (g === 89)
      t--;
    else if (g === 64)
      e += B[e + 1] + 1;
    else if (g === 65)
      e += 2 * B[e + 1] + 1;
    else if (g >= 176 && g <= 183)
      e += g - 176 + 1;
    else if (g >= 184 && g <= 191)
      e += (g - 184 + 1) * 2;
    else if (E && t === 1 && g === 27)
      break;
  while (t > 0);
  A.ip = e;
}
function ng(A, E) {
  exports.DEBUG && console.log(E.step, "SVTCA[" + A.axis + "]"), E.fv = E.pv = E.dpv = A;
}
function wg(A, E) {
  exports.DEBUG && console.log(E.step, "SPVTCA[" + A.axis + "]"), E.pv = E.dpv = A;
}
function cg(A, E) {
  exports.DEBUG && console.log(E.step, "SFVTCA[" + A.axis + "]"), E.fv = A;
}
function ag(A, E) {
  var B = E.stack, e = B.pop(), t = B.pop(), g = E.z2[e], M = E.z1[t];
  exports.DEBUG && console.log("SPVTL[" + A + "]", e, t);
  var Q, s;
  A ? (Q = g.y - M.y, s = M.x - g.x) : (Q = M.x - g.x, s = M.y - g.y), E.pv = E.dpv = sB(Q, s);
}
function og(A, E) {
  var B = E.stack, e = B.pop(), t = B.pop(), g = E.z2[e], M = E.z1[t];
  exports.DEBUG && console.log("SFVTL[" + A + "]", e, t);
  var Q, s;
  A ? (Q = g.y - M.y, s = M.x - g.x) : (Q = M.x - g.x, s = M.y - g.y), E.fv = sB(Q, s);
}
function Jn(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "SPVFS[]", B, e), A.pv = A.dpv = sB(e, B);
}
function bn(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "SPVFS[]", B, e), A.fv = sB(e, B);
}
function On(A) {
  var E = A.stack, B = A.pv;
  exports.DEBUG && console.log(A.step, "GPV[]"), E.push(B.x * 16384), E.push(B.y * 16384);
}
function jn(A) {
  var E = A.stack, B = A.fv;
  exports.DEBUG && console.log(A.step, "GFV[]"), E.push(B.x * 16384), E.push(B.y * 16384);
}
function Ln(A) {
  A.fv = A.pv, exports.DEBUG && console.log(A.step, "SFVTPV[]");
}
function Wn(A) {
  var E = A.stack, B = E.pop(), e = E.pop(), t = E.pop(), g = E.pop(), M = E.pop(), Q = A.z0, s = A.z1, r = Q[B], w = Q[e], c = s[t], n = s[g], a = A.z2[M];
  exports.DEBUG && console.log("ISECT[], ", B, e, t, g, M);
  var o = r.x, D = r.y, R = w.x, i = w.y, C = c.x, F = c.y, l = n.x, T = n.y, u = (o - R) * (F - T) - (D - i) * (C - l), h = o * i - D * R, x = C * T - F * l;
  a.x = (h * (C - l) - x * (o - R)) / u, a.y = (h * (F - T) - x * (D - i)) / u;
}
function Xn(A) {
  A.rp0 = A.stack.pop(), exports.DEBUG && console.log(A.step, "SRP0[]", A.rp0);
}
function Kn(A) {
  A.rp1 = A.stack.pop(), exports.DEBUG && console.log(A.step, "SRP1[]", A.rp1);
}
function Zn(A) {
  A.rp2 = A.stack.pop(), exports.DEBUG && console.log(A.step, "SRP2[]", A.rp2);
}
function qn(A) {
  var E = A.stack.pop();
  switch (exports.DEBUG && console.log(A.step, "SZP0[]", E), A.zp0 = E, E) {
    case 0:
      A.tZone || Be(A), A.z0 = A.tZone;
      break;
    case 1:
      A.z0 = A.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function _n(A) {
  var E = A.stack.pop();
  switch (exports.DEBUG && console.log(A.step, "SZP1[]", E), A.zp1 = E, E) {
    case 0:
      A.tZone || Be(A), A.z1 = A.tZone;
      break;
    case 1:
      A.z1 = A.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function $n(A) {
  var E = A.stack.pop();
  switch (exports.DEBUG && console.log(A.step, "SZP2[]", E), A.zp2 = E, E) {
    case 0:
      A.tZone || Be(A), A.z2 = A.tZone;
      break;
    case 1:
      A.z2 = A.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function Aw(A) {
  var E = A.stack.pop();
  switch (exports.DEBUG && console.log(A.step, "SZPS[]", E), A.zp0 = A.zp1 = A.zp2 = E, E) {
    case 0:
      A.tZone || Be(A), A.z0 = A.z1 = A.z2 = A.tZone;
      break;
    case 1:
      A.z0 = A.z1 = A.z2 = A.gZone;
      break;
    default:
      throw new Error("Invalid zone pointer");
  }
}
function Ew(A) {
  A.loop = A.stack.pop(), exports.DEBUG && console.log(A.step, "SLOOP[]", A.loop);
}
function Bw(A) {
  exports.DEBUG && console.log(A.step, "RTG[]"), A.round = WM;
}
function ew(A) {
  exports.DEBUG && console.log(A.step, "RTHG[]"), A.round = Nn;
}
function tw(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "SMD[]", E), A.minDis = E / 64;
}
function gw(A) {
  exports.DEBUG && console.log(A.step, "ELSE[]"), KM(A, !1);
}
function Mw(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "JMPR[]", E), A.ip += E - 1;
}
function Qw(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "SCVTCI[]", E), A.cvCutIn = E / 64;
}
function sw(A) {
  var E = A.stack;
  exports.DEBUG && console.log(A.step, "DUP[]"), E.push(E[E.length - 1]);
}
function Fe(A) {
  exports.DEBUG && console.log(A.step, "POP[]"), A.stack.pop();
}
function rw(A) {
  exports.DEBUG && console.log(A.step, "CLEAR[]"), A.stack.length = 0;
}
function nw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "SWAP[]"), E.push(B), E.push(e);
}
function ww(A) {
  var E = A.stack;
  exports.DEBUG && console.log(A.step, "DEPTH[]"), E.push(E.length);
}
function cw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "LOOPCALL[]", B, e);
  var t = A.ip, g = A.prog;
  A.prog = A.funcs[B];
  for (var M = 0; M < e; M++)
    CE(A), exports.DEBUG && console.log(
      ++A.step,
      M + 1 < e ? "next loopcall" : "done loopcall",
      M
    );
  A.ip = t, A.prog = g;
}
function aw(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "CALL[]", E);
  var B = A.ip, e = A.prog;
  A.prog = A.funcs[E], CE(A), A.ip = B, A.prog = e, exports.DEBUG && console.log(++A.step, "returning from", E);
}
function ow(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "CINDEX[]", B), E.push(E[E.length - B]);
}
function iw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "MINDEX[]", B), E.push(E.splice(E.length - B, 1)[0]);
}
function Iw(A) {
  if (A.env !== "fpgm")
    throw new Error("FDEF not allowed here");
  var E = A.stack, B = A.prog, e = A.ip, t = E.pop(), g = e;
  for (exports.DEBUG && console.log(A.step, "FDEF[]", t); B[++e] !== 45; )
    ;
  A.ip = e, A.funcs[t] = B.slice(g + 1, e);
}
function ig(A, E) {
  var B = E.stack.pop(), e = E.z0[B], t = E.fv, g = E.pv;
  exports.DEBUG && console.log(E.step, "MDAP[" + A + "]", B);
  var M = g.distance(e, BB);
  A && (M = E.round(M)), t.setRelative(e, BB, M, g), t.touch(e), E.rp0 = E.rp1 = B;
}
function Ig(A, E) {
  var B = E.z2, e = B.length - 2, t, g, M;
  exports.DEBUG && console.log(E.step, "IUP[" + A.axis + "]");
  for (var Q = 0; Q < e; Q++)
    t = B[Q], !A.touched(t) && (g = t.prevTouched(A), g !== t && (M = t.nextTouched(A), g === M && A.setRelative(t, t, A.distance(g, g, !1, !0), A, !0), A.interpolate(t, g, M, A)));
}
function Fg(A, E) {
  for (var B = E.stack, e = A ? E.rp1 : E.rp2, t = (A ? E.z0 : E.z1)[e], g = E.fv, M = E.pv, Q = E.loop, s = E.z2; Q--; ) {
    var r = B.pop(), w = s[r], c = M.distance(t, t, !1, !0);
    g.setRelative(w, w, c, M), g.touch(w), exports.DEBUG && console.log(
      E.step,
      (E.loop > 1 ? "loop " + (E.loop - Q) + ": " : "") + "SHP[" + (A ? "rp1" : "rp2") + "]",
      r
    );
  }
  E.loop = 1;
}
function Rg(A, E) {
  var B = E.stack, e = A ? E.rp1 : E.rp2, t = (A ? E.z0 : E.z1)[e], g = E.fv, M = E.pv, Q = B.pop(), s = E.z2[E.contours[Q]], r = s;
  exports.DEBUG && console.log(E.step, "SHC[" + A + "]", Q);
  var w = M.distance(t, t, !1, !0);
  do
    r !== t && g.setRelative(r, r, w, M), r = r.nextPointOnContour;
  while (r !== s);
}
function Cg(A, E) {
  var B = E.stack, e = A ? E.rp1 : E.rp2, t = (A ? E.z0 : E.z1)[e], g = E.fv, M = E.pv, Q = B.pop();
  exports.DEBUG && console.log(E.step, "SHZ[" + A + "]", Q);
  var s;
  switch (Q) {
    case 0:
      s = E.tZone;
      break;
    case 1:
      s = E.gZone;
      break;
    default:
      throw new Error("Invalid zone");
  }
  for (var r, w = M.distance(t, t, !1, !0), c = s.length - 2, n = 0; n < c; n++)
    r = s[n], g.setRelative(r, r, w, M);
}
function Fw(A) {
  for (var E = A.stack, B = A.loop, e = A.fv, t = E.pop() / 64, g = A.z2; B--; ) {
    var M = E.pop(), Q = g[M];
    exports.DEBUG && console.log(
      A.step,
      (A.loop > 1 ? "loop " + (A.loop - B) + ": " : "") + "SHPIX[]",
      M,
      t
    ), e.setRelative(Q, Q, t), e.touch(Q);
  }
  A.loop = 1;
}
function Rw(A) {
  for (var E = A.stack, B = A.rp1, e = A.rp2, t = A.loop, g = A.z0[B], M = A.z1[e], Q = A.fv, s = A.dpv, r = A.z2; t--; ) {
    var w = E.pop(), c = r[w];
    exports.DEBUG && console.log(
      A.step,
      (A.loop > 1 ? "loop " + (A.loop - t) + ": " : "") + "IP[]",
      w,
      B,
      "<->",
      e
    ), Q.interpolate(c, g, M, s), Q.touch(c);
  }
  A.loop = 1;
}
function Dg(A, E) {
  var B = E.stack, e = B.pop() / 64, t = B.pop(), g = E.z1[t], M = E.z0[E.rp0], Q = E.fv, s = E.pv;
  Q.setRelative(g, M, e, s), Q.touch(g), exports.DEBUG && console.log(E.step, "MSIRP[" + A + "]", e, t), E.rp1 = E.rp0, E.rp2 = t, A && (E.rp0 = t);
}
function Cw(A) {
  for (var E = A.stack, B = A.rp0, e = A.z0[B], t = A.loop, g = A.fv, M = A.pv, Q = A.z1; t--; ) {
    var s = E.pop(), r = Q[s];
    exports.DEBUG && console.log(
      A.step,
      (A.loop > 1 ? "loop " + (A.loop - t) + ": " : "") + "ALIGNRP[]",
      s
    ), g.setRelative(r, e, 0, M), g.touch(r);
  }
  A.loop = 1;
}
function Dw(A) {
  exports.DEBUG && console.log(A.step, "RTDG[]"), A.round = vn;
}
function lg(A, E) {
  var B = E.stack, e = B.pop(), t = B.pop(), g = E.z0[t], M = E.fv, Q = E.pv, s = E.cvt[e];
  exports.DEBUG && console.log(
    E.step,
    "MIAP[" + A + "]",
    e,
    "(",
    s,
    ")",
    t
  );
  var r = Q.distance(g, BB);
  A && (Math.abs(r - s) < E.cvCutIn && (r = s), r = E.round(r)), M.setRelative(g, BB, r, Q), E.zp0 === 0 && (g.xo = g.x, g.yo = g.y), M.touch(g), E.rp0 = E.rp1 = t;
}
function lw(A) {
  var E = A.prog, B = A.ip, e = A.stack, t = E[++B];
  exports.DEBUG && console.log(A.step, "NPUSHB[]", t);
  for (var g = 0; g < t; g++)
    e.push(E[++B]);
  A.ip = B;
}
function xw(A) {
  var E = A.ip, B = A.prog, e = A.stack, t = B[++E];
  exports.DEBUG && console.log(A.step, "NPUSHW[]", t);
  for (var g = 0; g < t; g++) {
    var M = B[++E] << 8 | B[++E];
    M & 32768 && (M = -((M ^ 65535) + 1)), e.push(M);
  }
  A.ip = E;
}
function Tw(A) {
  var E = A.stack, B = A.store;
  B || (B = A.store = []);
  var e = E.pop(), t = E.pop();
  exports.DEBUG && console.log(A.step, "WS", e, t), B[t] = e;
}
function hw(A) {
  var E = A.stack, B = A.store, e = E.pop();
  exports.DEBUG && console.log(A.step, "RS", e);
  var t = B && B[e] || 0;
  E.push(t);
}
function uw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "WCVTP", B, e), A.cvt[e] = B / 64;
}
function fw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "RCVT", B), E.push(A.cvt[B] * 64);
}
function xg(A, E) {
  var B = E.stack, e = B.pop(), t = E.z2[e];
  exports.DEBUG && console.log(E.step, "GC[" + A + "]", e), B.push(E.dpv.distance(t, BB, A, !1) * 64);
}
function Tg(A, E) {
  var B = E.stack, e = B.pop(), t = B.pop(), g = E.z1[e], M = E.z0[t], Q = E.dpv.distance(M, g, A, A);
  exports.DEBUG && console.log(E.step, "MD[" + A + "]", e, t, "->", Q), E.stack.push(Math.round(Q * 64));
}
function Uw(A) {
  exports.DEBUG && console.log(A.step, "MPPEM[]"), A.stack.push(A.ppem);
}
function zw(A) {
  exports.DEBUG && console.log(A.step, "FLIPON[]"), A.autoFlip = !0;
}
function Yw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "LT[]", B, e), E.push(e < B ? 1 : 0);
}
function kw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "LTEQ[]", B, e), E.push(e <= B ? 1 : 0);
}
function dw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "GT[]", B, e), E.push(e > B ? 1 : 0);
}
function Gw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "GTEQ[]", B, e), E.push(e >= B ? 1 : 0);
}
function yw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "EQ[]", B, e), E.push(B === e ? 1 : 0);
}
function Sw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "NEQ[]", B, e), E.push(B !== e ? 1 : 0);
}
function pw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "ODD[]", B), E.push(Math.trunc(B) % 2 ? 1 : 0);
}
function Pw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "EVEN[]", B), E.push(Math.trunc(B) % 2 ? 0 : 1);
}
function vw(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "IF[]", E), E || (KM(A, !0), exports.DEBUG && console.log(A.step, "EIF[]"));
}
function Nw(A) {
  exports.DEBUG && console.log(A.step, "EIF[]");
}
function Hw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "AND[]", B, e), E.push(B && e ? 1 : 0);
}
function mw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "OR[]", B, e), E.push(B || e ? 1 : 0);
}
function Vw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "NOT[]", B), E.push(B ? 0 : 1);
}
function Re(A, E) {
  var B = E.stack, e = B.pop(), t = E.fv, g = E.pv, M = E.ppem, Q = E.deltaBase + (A - 1) * 16, s = E.deltaShift, r = E.z0;
  exports.DEBUG && console.log(E.step, "DELTAP[" + A + "]", e, B);
  for (var w = 0; w < e; w++) {
    var c = B.pop(), n = B.pop(), a = Q + ((n & 240) >> 4);
    if (a === M) {
      var o = (n & 15) - 8;
      o >= 0 && o++, exports.DEBUG && console.log(E.step, "DELTAPFIX", c, "by", o * s);
      var D = r[c];
      t.setRelative(D, D, o * s, g);
    }
  }
}
function Jw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "SDB[]", B), A.deltaBase = B;
}
function bw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "SDS[]", B), A.deltaShift = Math.pow(0.5, B);
}
function Ow(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "ADD[]", B, e), E.push(e + B);
}
function jw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "SUB[]", B, e), E.push(e - B);
}
function Lw(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "DIV[]", B, e), E.push(e * 64 / B);
}
function Ww(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "MUL[]", B, e), E.push(e * B / 64);
}
function Xw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "ABS[]", B), E.push(Math.abs(B));
}
function Kw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "NEG[]", B), E.push(-B);
}
function Zw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "FLOOR[]", B), E.push(Math.floor(B / 64) * 64);
}
function qw(A) {
  var E = A.stack, B = E.pop();
  exports.DEBUG && console.log(A.step, "CEILING[]", B), E.push(Math.ceil(B / 64) * 64);
}
function RB(A, E) {
  var B = E.stack, e = B.pop();
  exports.DEBUG && console.log(E.step, "ROUND[]"), B.push(E.round(e / 64) * 64);
}
function _w(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "WCVTF[]", B, e), A.cvt[e] = B * A.ppem / A.font.unitsPerEm;
}
function Ce(A, E) {
  var B = E.stack, e = B.pop(), t = E.ppem, g = E.deltaBase + (A - 1) * 16, M = E.deltaShift;
  exports.DEBUG && console.log(E.step, "DELTAC[" + A + "]", e, B);
  for (var Q = 0; Q < e; Q++) {
    var s = B.pop(), r = B.pop(), w = g + ((r & 240) >> 4);
    if (w === t) {
      var c = (r & 15) - 8;
      c >= 0 && c++;
      var n = c * M;
      exports.DEBUG && console.log(E.step, "DELTACFIX", s, "by", n), E.cvt[s] += n;
    }
  }
}
function $w(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "SROUND[]", E), A.round = XM;
  var B;
  switch (E & 192) {
    case 0:
      B = 0.5;
      break;
    case 64:
      B = 1;
      break;
    case 128:
      B = 2;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  switch (A.srPeriod = B, E & 48) {
    case 0:
      A.srPhase = 0;
      break;
    case 16:
      A.srPhase = 0.25 * B;
      break;
    case 32:
      A.srPhase = 0.5 * B;
      break;
    case 48:
      A.srPhase = 0.75 * B;
      break;
    default:
      throw new Error("invalid SROUND value");
  }
  E &= 15, E === 0 ? A.srThreshold = 0 : A.srThreshold = (E / 8 - 0.5) * B;
}
function Ac(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "S45ROUND[]", E), A.round = XM;
  var B;
  switch (E & 192) {
    case 0:
      B = Math.sqrt(2) / 2;
      break;
    case 64:
      B = Math.sqrt(2);
      break;
    case 128:
      B = 2 * Math.sqrt(2);
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  switch (A.srPeriod = B, E & 48) {
    case 0:
      A.srPhase = 0;
      break;
    case 16:
      A.srPhase = 0.25 * B;
      break;
    case 32:
      A.srPhase = 0.5 * B;
      break;
    case 48:
      A.srPhase = 0.75 * B;
      break;
    default:
      throw new Error("invalid S45ROUND value");
  }
  E &= 15, E === 0 ? A.srThreshold = 0 : A.srThreshold = (E / 8 - 0.5) * B;
}
function Ec(A) {
  exports.DEBUG && console.log(A.step, "ROFF[]"), A.round = Pn;
}
function Bc(A) {
  exports.DEBUG && console.log(A.step, "RUTG[]"), A.round = Hn;
}
function ec(A) {
  exports.DEBUG && console.log(A.step, "RDTG[]"), A.round = mn;
}
function tc(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "SCANCTRL[]", E);
}
function hg(A, E) {
  var B = E.stack, e = B.pop(), t = B.pop(), g = E.z2[e], M = E.z1[t];
  exports.DEBUG && console.log(E.step, "SDPVTL[" + A + "]", e, t);
  var Q, s;
  A ? (Q = g.y - M.y, s = M.x - g.x) : (Q = M.x - g.x, s = M.y - g.y), E.dpv = sB(Q, s);
}
function gc(A) {
  var E = A.stack, B = E.pop(), e = 0;
  exports.DEBUG && console.log(A.step, "GETINFO[]", B), B & 1 && (e = 35), B & 32 && (e |= 4096), E.push(e);
}
function Mc(A) {
  var E = A.stack, B = E.pop(), e = E.pop(), t = E.pop();
  exports.DEBUG && console.log(A.step, "ROLL[]"), E.push(e), E.push(B), E.push(t);
}
function Qc(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "MAX[]", B, e), E.push(Math.max(e, B));
}
function sc(A) {
  var E = A.stack, B = E.pop(), e = E.pop();
  exports.DEBUG && console.log(A.step, "MIN[]", B, e), E.push(Math.min(e, B));
}
function rc(A) {
  var E = A.stack.pop();
  exports.DEBUG && console.log(A.step, "SCANTYPE[]", E);
}
function nc(A) {
  var E = A.stack.pop(), B = A.stack.pop();
  switch (exports.DEBUG && console.log(A.step, "INSTCTRL[]", E, B), E) {
    case 1:
      A.inhibitGridFit = !!B;
      return;
    case 2:
      A.ignoreCvt = !!B;
      return;
    default:
      throw new Error("invalid INSTCTRL[] selector");
  }
}
function $A(A, E) {
  var B = E.stack, e = E.prog, t = E.ip;
  exports.DEBUG && console.log(E.step, "PUSHB[" + A + "]");
  for (var g = 0; g < A; g++)
    B.push(e[++t]);
  E.ip = t;
}
function AE(A, E) {
  var B = E.ip, e = E.prog, t = E.stack;
  exports.DEBUG && console.log(E.ip, "PUSHW[" + A + "]");
  for (var g = 0; g < A; g++) {
    var M = e[++B] << 8 | e[++B];
    M & 32768 && (M = -((M ^ 65535) + 1)), t.push(M);
  }
  E.ip = B;
}
function X(A, E, B, e, t, g) {
  var M = g.stack, Q = A && M.pop(), s = M.pop(), r = g.rp0, w = g.z0[r], c = g.z1[s], n = g.minDis, a = g.fv, o = g.dpv, D, R, i, C;
  R = D = o.distance(c, w, !0, !0), i = R >= 0 ? 1 : -1, R = Math.abs(R), A && (C = g.cvt[Q], e && Math.abs(R - C) < g.cvCutIn && (R = C)), B && R < n && (R = n), e && (R = g.round(R)), a.setRelative(c, w, i * R, o), a.touch(c), exports.DEBUG && console.log(
    g.step,
    (A ? "MIRP[" : "MDRP[") + (E ? "M" : "m") + (B ? ">" : "_") + (e ? "R" : "_") + (t === 0 ? "Gr" : t === 1 ? "Bl" : t === 2 ? "Wh" : "") + "]",
    A ? Q + "(" + g.cvt[Q] + "," + C + ")" : "",
    s,
    "(d =",
    D,
    "->",
    i * R,
    ")"
  ), g.rp1 = g.rp0, g.rp2 = s, E && (g.rp0 = s);
}
OM = [
  /* 0x00 */
  ng.bind(void 0, jA),
  /* 0x01 */
  ng.bind(void 0, NA),
  /* 0x02 */
  wg.bind(void 0, jA),
  /* 0x03 */
  wg.bind(void 0, NA),
  /* 0x04 */
  cg.bind(void 0, jA),
  /* 0x05 */
  cg.bind(void 0, NA),
  /* 0x06 */
  ag.bind(void 0, 0),
  /* 0x07 */
  ag.bind(void 0, 1),
  /* 0x08 */
  og.bind(void 0, 0),
  /* 0x09 */
  og.bind(void 0, 1),
  /* 0x0A */
  Jn,
  /* 0x0B */
  bn,
  /* 0x0C */
  On,
  /* 0x0D */
  jn,
  /* 0x0E */
  Ln,
  /* 0x0F */
  Wn,
  /* 0x10 */
  Xn,
  /* 0x11 */
  Kn,
  /* 0x12 */
  Zn,
  /* 0x13 */
  qn,
  /* 0x14 */
  _n,
  /* 0x15 */
  $n,
  /* 0x16 */
  Aw,
  /* 0x17 */
  Ew,
  /* 0x18 */
  Bw,
  /* 0x19 */
  ew,
  /* 0x1A */
  tw,
  /* 0x1B */
  gw,
  /* 0x1C */
  Mw,
  /* 0x1D */
  Qw,
  /* 0x1E */
  void 0,
  // TODO SSWCI
  /* 0x1F */
  void 0,
  // TODO SSW
  /* 0x20 */
  sw,
  /* 0x21 */
  Fe,
  /* 0x22 */
  rw,
  /* 0x23 */
  nw,
  /* 0x24 */
  ww,
  /* 0x25 */
  ow,
  /* 0x26 */
  iw,
  /* 0x27 */
  void 0,
  // TODO ALIGNPTS
  /* 0x28 */
  void 0,
  /* 0x29 */
  void 0,
  // TODO UTP
  /* 0x2A */
  cw,
  /* 0x2B */
  aw,
  /* 0x2C */
  Iw,
  /* 0x2D */
  void 0,
  // ENDF (eaten by FDEF)
  /* 0x2E */
  ig.bind(void 0, 0),
  /* 0x2F */
  ig.bind(void 0, 1),
  /* 0x30 */
  Ig.bind(void 0, jA),
  /* 0x31 */
  Ig.bind(void 0, NA),
  /* 0x32 */
  Fg.bind(void 0, 0),
  /* 0x33 */
  Fg.bind(void 0, 1),
  /* 0x34 */
  Rg.bind(void 0, 0),
  /* 0x35 */
  Rg.bind(void 0, 1),
  /* 0x36 */
  Cg.bind(void 0, 0),
  /* 0x37 */
  Cg.bind(void 0, 1),
  /* 0x38 */
  Fw,
  /* 0x39 */
  Rw,
  /* 0x3A */
  Dg.bind(void 0, 0),
  /* 0x3B */
  Dg.bind(void 0, 1),
  /* 0x3C */
  Cw,
  /* 0x3D */
  Dw,
  /* 0x3E */
  lg.bind(void 0, 0),
  /* 0x3F */
  lg.bind(void 0, 1),
  /* 0x40 */
  lw,
  /* 0x41 */
  xw,
  /* 0x42 */
  Tw,
  /* 0x43 */
  hw,
  /* 0x44 */
  uw,
  /* 0x45 */
  fw,
  /* 0x46 */
  xg.bind(void 0, 0),
  /* 0x47 */
  xg.bind(void 0, 1),
  /* 0x48 */
  void 0,
  // TODO SCFS
  /* 0x49 */
  Tg.bind(void 0, 0),
  /* 0x4A */
  Tg.bind(void 0, 1),
  /* 0x4B */
  Uw,
  /* 0x4C */
  void 0,
  // TODO MPS
  /* 0x4D */
  zw,
  /* 0x4E */
  void 0,
  // TODO FLIPOFF
  /* 0x4F */
  void 0,
  // TODO DEBUG
  /* 0x50 */
  Yw,
  /* 0x51 */
  kw,
  /* 0x52 */
  dw,
  /* 0x53 */
  Gw,
  /* 0x54 */
  yw,
  /* 0x55 */
  Sw,
  /* 0x56 */
  pw,
  /* 0x57 */
  Pw,
  /* 0x58 */
  vw,
  /* 0x59 */
  Nw,
  /* 0x5A */
  Hw,
  /* 0x5B */
  mw,
  /* 0x5C */
  Vw,
  /* 0x5D */
  Re.bind(void 0, 1),
  /* 0x5E */
  Jw,
  /* 0x5F */
  bw,
  /* 0x60 */
  Ow,
  /* 0x61 */
  jw,
  /* 0x62 */
  Lw,
  /* 0x63 */
  Ww,
  /* 0x64 */
  Xw,
  /* 0x65 */
  Kw,
  /* 0x66 */
  Zw,
  /* 0x67 */
  qw,
  /* 0x68 */
  RB.bind(void 0, 0),
  /* 0x69 */
  RB.bind(void 0, 1),
  /* 0x6A */
  RB.bind(void 0, 2),
  /* 0x6B */
  RB.bind(void 0, 3),
  /* 0x6C */
  void 0,
  // TODO NROUND[ab]
  /* 0x6D */
  void 0,
  // TODO NROUND[ab]
  /* 0x6E */
  void 0,
  // TODO NROUND[ab]
  /* 0x6F */
  void 0,
  // TODO NROUND[ab]
  /* 0x70 */
  _w,
  /* 0x71 */
  Re.bind(void 0, 2),
  /* 0x72 */
  Re.bind(void 0, 3),
  /* 0x73 */
  Ce.bind(void 0, 1),
  /* 0x74 */
  Ce.bind(void 0, 2),
  /* 0x75 */
  Ce.bind(void 0, 3),
  /* 0x76 */
  $w,
  /* 0x77 */
  Ac,
  /* 0x78 */
  void 0,
  // TODO JROT[]
  /* 0x79 */
  void 0,
  // TODO JROF[]
  /* 0x7A */
  Ec,
  /* 0x7B */
  void 0,
  /* 0x7C */
  Bc,
  /* 0x7D */
  ec,
  /* 0x7E */
  Fe,
  // actually SANGW, supposed to do only a pop though
  /* 0x7F */
  Fe,
  // actually AA, supposed to do only a pop though
  /* 0x80 */
  void 0,
  // TODO FLIPPT
  /* 0x81 */
  void 0,
  // TODO FLIPRGON
  /* 0x82 */
  void 0,
  // TODO FLIPRGOFF
  /* 0x83 */
  void 0,
  /* 0x84 */
  void 0,
  /* 0x85 */
  tc,
  /* 0x86 */
  hg.bind(void 0, 0),
  /* 0x87 */
  hg.bind(void 0, 1),
  /* 0x88 */
  gc,
  /* 0x89 */
  void 0,
  // TODO IDEF
  /* 0x8A */
  Mc,
  /* 0x8B */
  Qc,
  /* 0x8C */
  sc,
  /* 0x8D */
  rc,
  /* 0x8E */
  nc,
  /* 0x8F */
  void 0,
  /* 0x90 */
  void 0,
  /* 0x91 */
  void 0,
  /* 0x92 */
  void 0,
  /* 0x93 */
  void 0,
  /* 0x94 */
  void 0,
  /* 0x95 */
  void 0,
  /* 0x96 */
  void 0,
  /* 0x97 */
  void 0,
  /* 0x98 */
  void 0,
  /* 0x99 */
  void 0,
  /* 0x9A */
  void 0,
  /* 0x9B */
  void 0,
  /* 0x9C */
  void 0,
  /* 0x9D */
  void 0,
  /* 0x9E */
  void 0,
  /* 0x9F */
  void 0,
  /* 0xA0 */
  void 0,
  /* 0xA1 */
  void 0,
  /* 0xA2 */
  void 0,
  /* 0xA3 */
  void 0,
  /* 0xA4 */
  void 0,
  /* 0xA5 */
  void 0,
  /* 0xA6 */
  void 0,
  /* 0xA7 */
  void 0,
  /* 0xA8 */
  void 0,
  /* 0xA9 */
  void 0,
  /* 0xAA */
  void 0,
  /* 0xAB */
  void 0,
  /* 0xAC */
  void 0,
  /* 0xAD */
  void 0,
  /* 0xAE */
  void 0,
  /* 0xAF */
  void 0,
  /* 0xB0 */
  $A.bind(void 0, 1),
  /* 0xB1 */
  $A.bind(void 0, 2),
  /* 0xB2 */
  $A.bind(void 0, 3),
  /* 0xB3 */
  $A.bind(void 0, 4),
  /* 0xB4 */
  $A.bind(void 0, 5),
  /* 0xB5 */
  $A.bind(void 0, 6),
  /* 0xB6 */
  $A.bind(void 0, 7),
  /* 0xB7 */
  $A.bind(void 0, 8),
  /* 0xB8 */
  AE.bind(void 0, 1),
  /* 0xB9 */
  AE.bind(void 0, 2),
  /* 0xBA */
  AE.bind(void 0, 3),
  /* 0xBB */
  AE.bind(void 0, 4),
  /* 0xBC */
  AE.bind(void 0, 5),
  /* 0xBD */
  AE.bind(void 0, 6),
  /* 0xBE */
  AE.bind(void 0, 7),
  /* 0xBF */
  AE.bind(void 0, 8),
  /* 0xC0 */
  X.bind(void 0, 0, 0, 0, 0, 0),
  /* 0xC1 */
  X.bind(void 0, 0, 0, 0, 0, 1),
  /* 0xC2 */
  X.bind(void 0, 0, 0, 0, 0, 2),
  /* 0xC3 */
  X.bind(void 0, 0, 0, 0, 0, 3),
  /* 0xC4 */
  X.bind(void 0, 0, 0, 0, 1, 0),
  /* 0xC5 */
  X.bind(void 0, 0, 0, 0, 1, 1),
  /* 0xC6 */
  X.bind(void 0, 0, 0, 0, 1, 2),
  /* 0xC7 */
  X.bind(void 0, 0, 0, 0, 1, 3),
  /* 0xC8 */
  X.bind(void 0, 0, 0, 1, 0, 0),
  /* 0xC9 */
  X.bind(void 0, 0, 0, 1, 0, 1),
  /* 0xCA */
  X.bind(void 0, 0, 0, 1, 0, 2),
  /* 0xCB */
  X.bind(void 0, 0, 0, 1, 0, 3),
  /* 0xCC */
  X.bind(void 0, 0, 0, 1, 1, 0),
  /* 0xCD */
  X.bind(void 0, 0, 0, 1, 1, 1),
  /* 0xCE */
  X.bind(void 0, 0, 0, 1, 1, 2),
  /* 0xCF */
  X.bind(void 0, 0, 0, 1, 1, 3),
  /* 0xD0 */
  X.bind(void 0, 0, 1, 0, 0, 0),
  /* 0xD1 */
  X.bind(void 0, 0, 1, 0, 0, 1),
  /* 0xD2 */
  X.bind(void 0, 0, 1, 0, 0, 2),
  /* 0xD3 */
  X.bind(void 0, 0, 1, 0, 0, 3),
  /* 0xD4 */
  X.bind(void 0, 0, 1, 0, 1, 0),
  /* 0xD5 */
  X.bind(void 0, 0, 1, 0, 1, 1),
  /* 0xD6 */
  X.bind(void 0, 0, 1, 0, 1, 2),
  /* 0xD7 */
  X.bind(void 0, 0, 1, 0, 1, 3),
  /* 0xD8 */
  X.bind(void 0, 0, 1, 1, 0, 0),
  /* 0xD9 */
  X.bind(void 0, 0, 1, 1, 0, 1),
  /* 0xDA */
  X.bind(void 0, 0, 1, 1, 0, 2),
  /* 0xDB */
  X.bind(void 0, 0, 1, 1, 0, 3),
  /* 0xDC */
  X.bind(void 0, 0, 1, 1, 1, 0),
  /* 0xDD */
  X.bind(void 0, 0, 1, 1, 1, 1),
  /* 0xDE */
  X.bind(void 0, 0, 1, 1, 1, 2),
  /* 0xDF */
  X.bind(void 0, 0, 1, 1, 1, 3),
  /* 0xE0 */
  X.bind(void 0, 1, 0, 0, 0, 0),
  /* 0xE1 */
  X.bind(void 0, 1, 0, 0, 0, 1),
  /* 0xE2 */
  X.bind(void 0, 1, 0, 0, 0, 2),
  /* 0xE3 */
  X.bind(void 0, 1, 0, 0, 0, 3),
  /* 0xE4 */
  X.bind(void 0, 1, 0, 0, 1, 0),
  /* 0xE5 */
  X.bind(void 0, 1, 0, 0, 1, 1),
  /* 0xE6 */
  X.bind(void 0, 1, 0, 0, 1, 2),
  /* 0xE7 */
  X.bind(void 0, 1, 0, 0, 1, 3),
  /* 0xE8 */
  X.bind(void 0, 1, 0, 1, 0, 0),
  /* 0xE9 */
  X.bind(void 0, 1, 0, 1, 0, 1),
  /* 0xEA */
  X.bind(void 0, 1, 0, 1, 0, 2),
  /* 0xEB */
  X.bind(void 0, 1, 0, 1, 0, 3),
  /* 0xEC */
  X.bind(void 0, 1, 0, 1, 1, 0),
  /* 0xED */
  X.bind(void 0, 1, 0, 1, 1, 1),
  /* 0xEE */
  X.bind(void 0, 1, 0, 1, 1, 2),
  /* 0xEF */
  X.bind(void 0, 1, 0, 1, 1, 3),
  /* 0xF0 */
  X.bind(void 0, 1, 1, 0, 0, 0),
  /* 0xF1 */
  X.bind(void 0, 1, 1, 0, 0, 1),
  /* 0xF2 */
  X.bind(void 0, 1, 1, 0, 0, 2),
  /* 0xF3 */
  X.bind(void 0, 1, 1, 0, 0, 3),
  /* 0xF4 */
  X.bind(void 0, 1, 1, 0, 1, 0),
  /* 0xF5 */
  X.bind(void 0, 1, 1, 0, 1, 1),
  /* 0xF6 */
  X.bind(void 0, 1, 1, 0, 1, 2),
  /* 0xF7 */
  X.bind(void 0, 1, 1, 0, 1, 3),
  /* 0xF8 */
  X.bind(void 0, 1, 1, 1, 0, 0),
  /* 0xF9 */
  X.bind(void 0, 1, 1, 1, 0, 1),
  /* 0xFA */
  X.bind(void 0, 1, 1, 1, 0, 2),
  /* 0xFB */
  X.bind(void 0, 1, 1, 1, 0, 3),
  /* 0xFC */
  X.bind(void 0, 1, 1, 1, 1, 0),
  /* 0xFD */
  X.bind(void 0, 1, 1, 1, 1, 1),
  /* 0xFE */
  X.bind(void 0, 1, 1, 1, 1, 2),
  /* 0xFF */
  X.bind(void 0, 1, 1, 1, 1, 3)
];
function HE(A) {
  this.char = A, this.state = {}, this.activeState = null;
}
function Ft(A, E, B) {
  this.contextName = B, this.startIndex = A, this.endOffset = E;
}
function wc(A, E, B) {
  this.contextName = A, this.openRange = null, this.ranges = [], this.checkStart = E, this.checkEnd = B;
}
function dA(A, E) {
  this.context = A, this.index = E, this.length = A.length, this.current = A[E], this.backtrack = A.slice(0, E), this.lookahead = A.slice(E + 1);
}
function ee(A) {
  this.eventId = A, this.subscribers = [];
}
function cc(A) {
  var E = this, B = [
    "start",
    "end",
    "next",
    "newToken",
    "contextStart",
    "contextEnd",
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD",
    "updateContextsRanges"
  ];
  B.forEach(function(t) {
    Object.defineProperty(E.events, t, {
      value: new ee(t)
    });
  }), A && B.forEach(function(t) {
    var g = A[t];
    typeof g == "function" && E.events[t].subscribe(g);
  });
  var e = [
    "insertToken",
    "removeToken",
    "removeRange",
    "replaceToken",
    "replaceRange",
    "composeRUD"
  ];
  e.forEach(function(t) {
    E.events[t].subscribe(
      E.updateContextsRanges
    );
  });
}
function oA(A) {
  this.tokens = [], this.registeredContexts = {}, this.contextCheckers = [], this.events = {}, this.registeredModifiers = [], cc.call(this, A);
}
HE.prototype.setState = function(A, E) {
  return this.state[A] = E, this.activeState = { key: A, value: this.state[A] }, this.activeState;
};
HE.prototype.getState = function(A) {
  return this.state[A] || null;
};
oA.prototype.inboundIndex = function(A) {
  return A >= 0 && A < this.tokens.length;
};
oA.prototype.composeRUD = function(A) {
  var E = this, B = !0, e = A.map(function(g) {
    return E[g[0]].apply(E, g.slice(1).concat(B));
  }), t = function(g) {
    return typeof g == "object" && g.hasOwnProperty("FAIL");
  };
  if (e.every(t))
    return {
      FAIL: "composeRUD: one or more operations hasn't completed successfully",
      report: e.filter(t)
    };
  this.dispatch("composeRUD", [e.filter(function(g) {
    return !t(g);
  })]);
};
oA.prototype.replaceRange = function(A, E, B, e) {
  E = E !== null ? E : this.tokens.length;
  var t = B.every(function(M) {
    return M instanceof HE;
  });
  if (!isNaN(A) && this.inboundIndex(A) && t) {
    var g = this.tokens.splice.apply(
      this.tokens,
      [A, E].concat(B)
    );
    return e || this.dispatch("replaceToken", [A, E, B]), [g, B];
  } else
    return { FAIL: "replaceRange: invalid tokens or startIndex." };
};
oA.prototype.replaceToken = function(A, E, B) {
  if (!isNaN(A) && this.inboundIndex(A) && E instanceof HE) {
    var e = this.tokens.splice(A, 1, E);
    return B || this.dispatch("replaceToken", [A, E]), [e[0], E];
  } else
    return { FAIL: "replaceToken: invalid token or index." };
};
oA.prototype.removeRange = function(A, E, B) {
  E = isNaN(E) ? this.tokens.length : E;
  var e = this.tokens.splice(A, E);
  return B || this.dispatch("removeRange", [e, A, E]), e;
};
oA.prototype.removeToken = function(A, E) {
  if (!isNaN(A) && this.inboundIndex(A)) {
    var B = this.tokens.splice(A, 1);
    return E || this.dispatch("removeToken", [B, A]), B;
  } else
    return { FAIL: "removeToken: invalid token index." };
};
oA.prototype.insertToken = function(A, E, B) {
  var e = A.every(
    function(t) {
      return t instanceof HE;
    }
  );
  return e ? (this.tokens.splice.apply(
    this.tokens,
    [E, 0].concat(A)
  ), B || this.dispatch("insertToken", [A, E]), A) : { FAIL: "insertToken: invalid token(s)." };
};
oA.prototype.registerModifier = function(A, E, B) {
  this.events.newToken.subscribe(function(e, t) {
    var g = [e, t], M = E === null || E.apply(this, g) === !0, Q = [e, t];
    if (M) {
      var s = B.apply(this, Q);
      e.setState(A, s);
    }
  }), this.registeredModifiers.push(A);
};
ee.prototype.subscribe = function(A) {
  return typeof A == "function" ? this.subscribers.push(A) - 1 : { FAIL: "invalid '" + this.eventId + "' event handler" };
};
ee.prototype.unsubscribe = function(A) {
  this.subscribers.splice(A, 1);
};
dA.prototype.setCurrentIndex = function(A) {
  this.index = A, this.current = this.context[A], this.backtrack = this.context.slice(0, A), this.lookahead = this.context.slice(A + 1);
};
dA.prototype.get = function(A) {
  switch (!0) {
    case A === 0:
      return this.current;
    case (A < 0 && Math.abs(A) <= this.backtrack.length):
      return this.backtrack.slice(A)[0];
    case (A > 0 && A <= this.lookahead.length):
      return this.lookahead[A - 1];
    default:
      return null;
  }
};
oA.prototype.rangeToText = function(A) {
  if (A instanceof Ft)
    return this.getRangeTokens(A).map(function(E) {
      return E.char;
    }).join("");
};
oA.prototype.getText = function() {
  return this.tokens.map(function(A) {
    return A.char;
  }).join("");
};
oA.prototype.getContext = function(A) {
  var E = this.registeredContexts[A];
  return E || null;
};
oA.prototype.on = function(A, E) {
  var B = this.events[A];
  return B ? B.subscribe(E) : null;
};
oA.prototype.dispatch = function(A, E) {
  var B = this, e = this.events[A];
  e instanceof ee && e.subscribers.forEach(function(t) {
    t.apply(B, E || []);
  });
};
oA.prototype.registerContextChecker = function(A, E, B) {
  if (this.getContext(A))
    return {
      FAIL: "context name '" + A + "' is already registered."
    };
  if (typeof E != "function")
    return {
      FAIL: "missing context start check."
    };
  if (typeof B != "function")
    return {
      FAIL: "missing context end check."
    };
  var e = new wc(
    A,
    E,
    B
  );
  return this.registeredContexts[A] = e, this.contextCheckers.push(e), e;
};
oA.prototype.getRangeTokens = function(A) {
  var E = A.startIndex + A.endOffset;
  return [].concat(
    this.tokens.slice(A.startIndex, E)
  );
};
oA.prototype.getContextRanges = function(A) {
  var E = this.getContext(A);
  return E ? E.ranges : { FAIL: "context checker '" + A + "' is not registered." };
};
oA.prototype.resetContextsRanges = function() {
  var A = this.registeredContexts;
  for (var E in A)
    if (A.hasOwnProperty(E)) {
      var B = A[E];
      B.ranges = [];
    }
};
oA.prototype.updateContextsRanges = function() {
  this.resetContextsRanges();
  for (var A = this.tokens.map(function(e) {
    return e.char;
  }), E = 0; E < A.length; E++) {
    var B = new dA(A, E);
    this.runContextCheck(B);
  }
  this.dispatch("updateContextsRanges", [this.registeredContexts]);
};
oA.prototype.setEndOffset = function(A, E) {
  var B = this.getContext(E).openRange.startIndex, e = new Ft(B, A, E), t = this.getContext(E).ranges;
  return e.rangeId = E + "." + t.length, t.push(e), this.getContext(E).openRange = null, e;
};
oA.prototype.runContextCheck = function(A) {
  var E = this, B = A.index;
  this.contextCheckers.forEach(function(e) {
    var t = e.contextName, g = E.getContext(t).openRange;
    if (!g && e.checkStart(A) && (g = new Ft(B, null, t), E.getContext(t).openRange = g, E.dispatch("contextStart", [t, B])), g && e.checkEnd(A)) {
      var M = B - g.startIndex + 1, Q = E.setEndOffset(M, t);
      E.dispatch("contextEnd", [t, Q]);
    }
  });
};
oA.prototype.tokenize = function(A) {
  this.tokens = [], this.resetContextsRanges();
  var E = Array.from(A);
  this.dispatch("start");
  for (var B = 0; B < E.length; B++) {
    var e = E[B], t = new dA(E, B);
    this.dispatch("next", [t]), this.runContextCheck(t);
    var g = new HE(e);
    this.tokens.push(g), this.dispatch("newToken", [g, t]);
  }
  return this.dispatch("end", [this.tokens]), this.tokens;
};
function QE(A) {
  return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(A);
}
function ZM(A) {
  return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(A);
}
function rE(A) {
  return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(A);
}
function hB(A) {
  return /[A-z]/.test(A);
}
function ac(A) {
  return /\s/.test(A);
}
function fA(A) {
  this.font = A, this.features = {};
}
function oE(A) {
  this.id = A.id, this.tag = A.tag, this.substitution = A.substitution;
}
function rB(A, E) {
  if (!A)
    return -1;
  switch (E.format) {
    case 1:
      return E.glyphs.indexOf(A);
    case 2:
      for (var B = E.ranges, e = 0; e < B.length; e++) {
        var t = B[e];
        if (A >= t.start && A <= t.end) {
          var g = A - t.start;
          return t.index + g;
        }
      }
      break;
    default:
      return -1;
  }
  return -1;
}
function oc(A, E) {
  var B = rB(A, E.coverage);
  return B === -1 ? null : A + E.deltaGlyphId;
}
function ic(A, E) {
  var B = rB(A, E.coverage);
  return B === -1 ? null : E.substitute[B];
}
function De(A, E) {
  for (var B = [], e = 0; e < A.length; e++) {
    var t = A[e], g = E.current;
    g = Array.isArray(g) ? g[0] : g;
    var M = rB(g, t);
    M !== -1 && B.push(M);
  }
  return B.length !== A.length ? -1 : B;
}
function Ic(A, E) {
  var B = E.inputCoverage.length + E.lookaheadCoverage.length + E.backtrackCoverage.length;
  if (A.context.length < B)
    return [];
  var e = De(
    E.inputCoverage,
    A
  );
  if (e === -1)
    return [];
  var t = E.inputCoverage.length - 1;
  if (A.lookahead.length < E.lookaheadCoverage.length)
    return [];
  for (var g = A.lookahead.slice(t); g.length && rE(g[0].char); )
    g.shift();
  var M = new dA(g, 0), Q = De(
    E.lookaheadCoverage,
    M
  ), s = [].concat(A.backtrack);
  for (s.reverse(); s.length && rE(s[0].char); )
    s.shift();
  if (s.length < E.backtrackCoverage.length)
    return [];
  var r = new dA(s, 0), w = De(
    E.backtrackCoverage,
    r
  ), c = e.length === E.inputCoverage.length && Q.length === E.lookaheadCoverage.length && w.length === E.backtrackCoverage.length, n = [];
  if (c)
    for (var a = 0; a < E.lookupRecords.length; a++)
      for (var o = E.lookupRecords[a], D = o.lookupListIndex, R = this.getLookupByIndex(D), i = 0; i < R.subtables.length; i++) {
        var C = R.subtables[i], F = this.getLookupMethod(R, C), l = this.getSubstitutionType(R, C);
        if (l === "12")
          for (var T = 0; T < e.length; T++) {
            var u = A.get(T), h = F(u);
            h && n.push(h);
          }
      }
  return n;
}
function Fc(A, E) {
  var B = A.current, e = rB(B, E.coverage);
  if (e === -1)
    return null;
  for (var t, g = E.ligatureSets[e], M = 0; M < g.length; M++) {
    t = g[M];
    for (var Q = 0; Q < t.components.length; Q++) {
      var s = A.lookahead[Q], r = t.components[Q];
      if (s !== r)
        break;
      if (Q === t.components.length - 1)
        return t;
    }
  }
  return null;
}
function Rc(A, E) {
  var B = rB(A, E.coverage);
  return B === -1 ? null : E.sequences[B];
}
fA.prototype.getDefaultScriptFeaturesIndexes = function() {
  for (var A = this.font.tables.gsub.scripts, E = 0; E < A.length; E++) {
    var B = A[E];
    if (B.tag === "DFLT")
      return B.script.defaultLangSys.featureIndexes;
  }
  return [];
};
fA.prototype.getScriptFeaturesIndexes = function(A) {
  var E = this.font.tables;
  if (!E.gsub)
    return [];
  if (!A)
    return this.getDefaultScriptFeaturesIndexes();
  for (var B = this.font.tables.gsub.scripts, e = 0; e < B.length; e++) {
    var t = B[e];
    if (t.tag === A && t.script.defaultLangSys)
      return t.script.defaultLangSys.featureIndexes;
    var g = t.langSysRecords;
    if (g)
      for (var M = 0; M < g.length; M++) {
        var Q = g[M];
        if (Q.tag === A) {
          var s = Q.langSys;
          return s.featureIndexes;
        }
      }
  }
  return this.getDefaultScriptFeaturesIndexes();
};
fA.prototype.mapTagsToFeatures = function(A, E) {
  for (var B = {}, e = 0; e < A.length; e++) {
    var t = A[e].tag, g = A[e].feature;
    B[t] = g;
  }
  this.features[E].tags = B;
};
fA.prototype.getScriptFeatures = function(A) {
  var E = this.features[A];
  if (this.features.hasOwnProperty(A))
    return E;
  var B = this.getScriptFeaturesIndexes(A);
  if (!B)
    return null;
  var e = this.font.tables.gsub;
  return E = B.map(function(t) {
    return e.features[t];
  }), this.features[A] = E, this.mapTagsToFeatures(E, A), E;
};
fA.prototype.getSubstitutionType = function(A, E) {
  var B = A.lookupType.toString(), e = E.substFormat.toString();
  return B + e;
};
fA.prototype.getLookupMethod = function(A, E) {
  var B = this, e = this.getSubstitutionType(A, E);
  switch (e) {
    case "11":
      return function(t) {
        return oc.apply(
          B,
          [t, E]
        );
      };
    case "12":
      return function(t) {
        return ic.apply(
          B,
          [t, E]
        );
      };
    case "63":
      return function(t) {
        return Ic.apply(
          B,
          [t, E]
        );
      };
    case "41":
      return function(t) {
        return Fc.apply(
          B,
          [t, E]
        );
      };
    case "21":
      return function(t) {
        return Rc.apply(
          B,
          [t, E]
        );
      };
    default:
      throw new Error(
        "lookupType: " + A.lookupType + " - substFormat: " + E.substFormat + " is not yet supported"
      );
  }
};
fA.prototype.lookupFeature = function(A) {
  var E = A.contextParams, B = E.index, e = this.getFeature({
    tag: A.tag,
    script: A.script
  });
  if (!e)
    return new Error(
      "font '" + this.font.names.fullName.en + "' doesn't support feature '" + A.tag + "' for script '" + A.script + "'."
    );
  for (var t = this.getFeatureLookups(e), g = [].concat(E.context), M = 0; M < t.length; M++)
    for (var Q = t[M], s = this.getLookupSubtables(Q), r = 0; r < s.length; r++) {
      var w = s[r], c = this.getSubstitutionType(Q, w), n = this.getLookupMethod(Q, w), a = void 0;
      switch (c) {
        case "11":
          a = n(E.current), a && g.splice(B, 1, new oE({
            id: 11,
            tag: A.tag,
            substitution: a
          }));
          break;
        case "12":
          a = n(E.current), a && g.splice(B, 1, new oE({
            id: 12,
            tag: A.tag,
            substitution: a
          }));
          break;
        case "63":
          a = n(E), Array.isArray(a) && a.length && g.splice(B, 1, new oE({
            id: 63,
            tag: A.tag,
            substitution: a
          }));
          break;
        case "41":
          a = n(E), a && g.splice(B, 1, new oE({
            id: 41,
            tag: A.tag,
            substitution: a
          }));
          break;
        case "21":
          a = n(E.current), a && g.splice(B, 1, new oE({
            id: 21,
            tag: A.tag,
            substitution: a
          }));
          break;
      }
      E = new dA(g, B), !(Array.isArray(a) && !a.length) && (a = null);
    }
  return g.length ? g : null;
};
fA.prototype.supports = function(A) {
  if (!A.script)
    return !1;
  this.getScriptFeatures(A.script);
  var E = this.features.hasOwnProperty(A.script);
  if (!A.tag)
    return E;
  var B = this.features[A.script].some(function(e) {
    return e.tag === A.tag;
  });
  return E && B;
};
fA.prototype.getLookupSubtables = function(A) {
  return A.subtables || null;
};
fA.prototype.getLookupByIndex = function(A) {
  var E = this.font.tables.gsub.lookups;
  return E[A] || null;
};
fA.prototype.getFeatureLookups = function(A) {
  return A.lookupListIndexes.map(this.getLookupByIndex.bind(this));
};
fA.prototype.getFeature = function(E) {
  if (!this.font)
    return { FAIL: "No font was found" };
  this.features.hasOwnProperty(E.script) || this.getScriptFeatures(E.script);
  var B = this.features[E.script];
  return B ? B.tags[E.tag] ? this.features[E.script].tags[E.tag] : null : { FAIL: "No feature for script " + E.script };
};
function Cc(A) {
  var E = A.current, B = A.get(-1);
  return (
    // ? arabic first char
    B === null && QE(E) || // ? arabic char preceded with a non arabic char
    !QE(B) && QE(E)
  );
}
function Dc(A) {
  var E = A.get(1);
  return (
    // ? last arabic char
    E === null || // ? next char is not arabic
    !QE(E)
  );
}
var lc = {
  startCheck: Cc,
  endCheck: Dc
};
function xc(A) {
  var E = A.current, B = A.get(-1);
  return (
    // ? an arabic char preceded with a non arabic char
    (QE(E) || rE(E)) && !QE(B)
  );
}
function Tc(A) {
  var E = A.get(1);
  switch (!0) {
    case E === null:
      return !0;
    case (!QE(E) && !rE(E)):
      var B = ac(E);
      if (!B)
        return !0;
      if (B) {
        var e = !1;
        if (e = A.lookahead.some(
          function(t) {
            return QE(t) || rE(t);
          }
        ), !e)
          return !0;
      }
      break;
    default:
      return !1;
  }
}
var hc = {
  startCheck: xc,
  endCheck: Tc
};
function uc(A, E, B) {
  E[B].setState(A.tag, A.substitution);
}
function fc(A, E, B) {
  E[B].setState(A.tag, A.substitution);
}
function Uc(A, E, B) {
  A.substitution.forEach(function(e, t) {
    var g = E[B + t];
    g.setState(A.tag, e);
  });
}
function zc(A, E, B) {
  var e = E[B];
  e.setState(A.tag, A.substitution.ligGlyph);
  for (var t = A.substitution.components.length, g = 0; g < t; g++)
    e = E[B + g + 1], e.setState("deleted", !0);
}
var ug = {
  11: uc,
  12: fc,
  63: Uc,
  41: zc
};
function Rt(A, E, B) {
  A instanceof oE && ug[A.id] && ug[A.id](A, E, B);
}
function Yc(A) {
  for (var E = [].concat(A.backtrack), B = E.length - 1; B >= 0; B--) {
    var e = E[B], t = ZM(e), g = rE(e);
    if (!t && !g)
      return !0;
    if (t)
      return !1;
  }
  return !1;
}
function kc(A) {
  if (ZM(A.current))
    return !1;
  for (var E = 0; E < A.lookahead.length; E++) {
    var B = A.lookahead[E], e = rE(B);
    if (!e)
      return !0;
  }
  return !1;
}
function dc(A) {
  var E = this, B = "arab", e = this.featuresTags[B], t = this.tokenizer.getRangeTokens(A);
  if (t.length !== 1) {
    var g = new dA(
      t.map(
        function(Q) {
          return Q.getState("glyphIndex");
        }
      ),
      0
    ), M = new dA(
      t.map(
        function(Q) {
          return Q.char;
        }
      ),
      0
    );
    t.forEach(function(Q, s) {
      if (!rE(Q.char)) {
        g.setCurrentIndex(s), M.setCurrentIndex(s);
        var r = 0;
        Yc(M) && (r |= 1), kc(M) && (r |= 2);
        var w;
        switch (r) {
          case 1:
            w = "fina";
            break;
          case 2:
            w = "init";
            break;
          case 3:
            w = "medi";
            break;
        }
        if (e.indexOf(w) !== -1) {
          var c = E.query.lookupFeature({
            tag: w,
            script: B,
            contextParams: g
          });
          if (c instanceof Error)
            return console.info(c.message);
          c.forEach(function(n, a) {
            n instanceof oE && (Rt(n, t, a), g.context[a] = n.substitution);
          });
        }
      }
    });
  }
}
function fg(A, E) {
  var B = A.map(function(e) {
    return e.activeState.value;
  });
  return new dA(B, 0);
}
function Gc(A) {
  var E = this, B = "arab", e = this.tokenizer.getRangeTokens(A), t = fg(e);
  t.context.forEach(function(g, M) {
    t.setCurrentIndex(M);
    var Q = E.query.lookupFeature({
      tag: "rlig",
      script: B,
      contextParams: t
    });
    Q.length && (Q.forEach(
      function(s) {
        return Rt(s, e, M);
      }
    ), t = fg(e));
  });
}
function yc(A) {
  var E = A.current, B = A.get(-1);
  return (
    // ? latin first char
    B === null && hB(E) || // ? latin char preceded with a non latin char
    !hB(B) && hB(E)
  );
}
function Sc(A) {
  var E = A.get(1);
  return (
    // ? last latin char
    E === null || // ? next char is not latin
    !hB(E)
  );
}
var pc = {
  startCheck: yc,
  endCheck: Sc
};
function Ug(A, E) {
  var B = A.map(function(e) {
    return e.activeState.value;
  });
  return new dA(B, 0);
}
function Pc(A) {
  var E = this, B = "latn", e = this.tokenizer.getRangeTokens(A), t = Ug(e);
  t.context.forEach(function(g, M) {
    t.setCurrentIndex(M);
    var Q = E.query.lookupFeature({
      tag: "liga",
      script: B,
      contextParams: t
    });
    Q.length && (Q.forEach(
      function(s) {
        return Rt(s, e, M);
      }
    ), t = Ug(e));
  });
}
function SA(A) {
  this.baseDir = A || "ltr", this.tokenizer = new oA(), this.featuresTags = {};
}
SA.prototype.setText = function(A) {
  this.text = A;
};
SA.prototype.contextChecks = {
  latinWordCheck: pc,
  arabicWordCheck: lc,
  arabicSentenceCheck: hc
};
function le(A) {
  var E = this.contextChecks[A + "Check"];
  return this.tokenizer.registerContextChecker(
    A,
    E.startCheck,
    E.endCheck
  );
}
function vc() {
  return le.call(this, "latinWord"), le.call(this, "arabicWord"), le.call(this, "arabicSentence"), this.tokenizer.tokenize(this.text);
}
function Nc() {
  var A = this, E = this.tokenizer.getContextRanges("arabicSentence");
  E.forEach(function(B) {
    var e = A.tokenizer.getRangeTokens(B);
    A.tokenizer.replaceRange(
      B.startIndex,
      B.endOffset,
      e.reverse()
    );
  });
}
SA.prototype.registerFeatures = function(A, E) {
  var B = this, e = E.filter(
    function(t) {
      return B.query.supports({ script: A, tag: t });
    }
  );
  this.featuresTags.hasOwnProperty(A) ? this.featuresTags[A] = this.featuresTags[A].concat(e) : this.featuresTags[A] = e;
};
SA.prototype.applyFeatures = function(A, E) {
  if (!A)
    throw new Error(
      "No valid font was provided to apply features"
    );
  this.query || (this.query = new fA(A));
  for (var B = 0; B < E.length; B++) {
    var e = E[B];
    this.query.supports({ script: e.script }) && this.registerFeatures(e.script, e.tags);
  }
};
SA.prototype.registerModifier = function(A, E, B) {
  this.tokenizer.registerModifier(A, E, B);
};
function Ct() {
  if (this.tokenizer.registeredModifiers.indexOf("glyphIndex") === -1)
    throw new Error(
      "glyphIndex modifier is required to apply arabic presentation features."
    );
}
function Hc() {
  var A = this, E = "arab";
  if (this.featuresTags.hasOwnProperty(E)) {
    Ct.call(this);
    var B = this.tokenizer.getContextRanges("arabicWord");
    B.forEach(function(e) {
      dc.call(A, e);
    });
  }
}
function mc() {
  var A = this, E = "arab";
  if (this.featuresTags.hasOwnProperty(E)) {
    var B = this.featuresTags[E];
    if (B.indexOf("rlig") !== -1) {
      Ct.call(this);
      var e = this.tokenizer.getContextRanges("arabicWord");
      e.forEach(function(t) {
        Gc.call(A, t);
      });
    }
  }
}
function Vc() {
  var A = this, E = "latn";
  if (this.featuresTags.hasOwnProperty(E)) {
    var B = this.featuresTags[E];
    if (B.indexOf("liga") !== -1) {
      Ct.call(this);
      var e = this.tokenizer.getContextRanges("latinWord");
      e.forEach(function(t) {
        Pc.call(A, t);
      });
    }
  }
}
SA.prototype.checkContextReady = function(A) {
  return !!this.tokenizer.getContext(A);
};
SA.prototype.applyFeaturesToContexts = function() {
  this.checkContextReady("arabicWord") && (Hc.call(this), mc.call(this)), this.checkContextReady("latinWord") && Vc.call(this), this.checkContextReady("arabicSentence") && Nc.call(this);
};
SA.prototype.processText = function(A) {
  (!this.text || this.text !== A) && (this.setText(A), vc.call(this), this.applyFeaturesToContexts());
};
SA.prototype.getBidiText = function(A) {
  return this.processText(A), this.tokenizer.getText();
};
SA.prototype.getTextGlyphs = function(A) {
  this.processText(A);
  for (var E = [], B = 0; B < this.tokenizer.tokens.length; B++) {
    var e = this.tokenizer.tokens[B];
    if (!e.state.deleted) {
      var t = e.activeState.value;
      E.push(Array.isArray(t) ? t[0] : t);
    }
  }
  return E;
};
function cA(A) {
  A = A || {}, A.tables = A.tables || {}, A.empty || (bE(A.familyName, "When creating a new Font object, familyName is required."), bE(A.styleName, "When creating a new Font object, styleName is required."), bE(A.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), bE(A.ascender, "When creating a new Font object, ascender is required."), bE(A.descender <= 0, "When creating a new Font object, negative descender value is required."), this.names = {
    fontFamily: { en: A.familyName || " " },
    fontSubfamily: { en: A.styleName || " " },
    fullName: { en: A.fullName || A.familyName + " " + A.styleName },
    // postScriptName may not contain any whitespace
    postScriptName: { en: A.postScriptName || (A.familyName + A.styleName).replace(/\s/g, "") },
    designer: { en: A.designer || " " },
    designerURL: { en: A.designerURL || " " },
    manufacturer: { en: A.manufacturer || " " },
    manufacturerURL: { en: A.manufacturerURL || " " },
    license: { en: A.license || " " },
    licenseURL: { en: A.licenseURL || " " },
    version: { en: A.version || "Version 0.1" },
    description: { en: A.description || " " },
    copyright: { en: A.copyright || " " },
    trademark: { en: A.trademark || " " }
  }, this.unitsPerEm = A.unitsPerEm || 1e3, this.ascender = A.ascender, this.descender = A.descender, this.createdTimestamp = A.createdTimestamp, this.tables = Object.assign(A.tables, {
    os2: Object.assign({
      usWeightClass: A.weightClass || this.usWeightClasses.MEDIUM,
      usWidthClass: A.widthClass || this.usWidthClasses.MEDIUM,
      fsSelection: A.fsSelection || this.fsSelectionValues.REGULAR
    }, A.tables.os2)
  })), this.supported = !0, this.glyphs = new HA.GlyphSet(this, A.glyphs || []), this.encoding = new oM(this), this.position = new MB(this), this.substitution = new uA(this), this.tables = this.tables || {}, this._push = null, this._hmtxTableData = {}, Object.defineProperty(this, "hinting", {
    get: function() {
      if (this._hinting)
        return this._hinting;
      if (this.outlinesFormat === "truetype")
        return this._hinting = new LM(this);
    }
  });
}
cA.prototype.hasChar = function(A) {
  return this.encoding.charToGlyphIndex(A) !== null;
};
cA.prototype.charToGlyphIndex = function(A) {
  return this.encoding.charToGlyphIndex(A);
};
cA.prototype.charToGlyph = function(A) {
  var E = this.charToGlyphIndex(A), B = this.glyphs.get(E);
  return B || (B = this.glyphs.get(0)), B;
};
cA.prototype.updateFeatures = function(A) {
  return this.defaultRenderOptions.features.map(function(E) {
    return E.script === "latn" ? {
      script: "latn",
      tags: E.tags.filter(function(B) {
        return A[B];
      })
    } : E;
  });
};
cA.prototype.stringToGlyphs = function(A, E) {
  var B = this, e = new SA(), t = function(c) {
    return B.charToGlyphIndex(c.char);
  };
  e.registerModifier("glyphIndex", null, t);
  var g = E ? this.updateFeatures(E.features) : this.defaultRenderOptions.features;
  e.applyFeatures(this, g);
  for (var M = e.getTextGlyphs(A), Q = M.length, s = new Array(Q), r = this.glyphs.get(0), w = 0; w < Q; w += 1)
    s[w] = this.glyphs.get(M[w]) || r;
  return s;
};
cA.prototype.nameToGlyphIndex = function(A) {
  return this.glyphNames.nameToGlyphIndex(A);
};
cA.prototype.nameToGlyph = function(A) {
  var E = this.nameToGlyphIndex(A), B = this.glyphs.get(E);
  return B || (B = this.glyphs.get(0)), B;
};
cA.prototype.glyphIndexToName = function(A) {
  return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(A) : "";
};
cA.prototype.getKerningValue = function(A, E) {
  A = A.index || A, E = E.index || E;
  var B = this.position.defaultKerningTables;
  return B ? this.position.getKerningValue(B, A, E) : this.kerningPairs[A + "," + E] || 0;
};
cA.prototype.defaultRenderOptions = {
  kerning: !0,
  features: [
    /**
     * these 4 features are required to render Arabic text properly
     * and shouldn't be turned off when rendering arabic text.
     */
    { script: "arab", tags: ["init", "medi", "fina", "rlig"] },
    { script: "latn", tags: ["liga", "rlig"] }
  ]
};
cA.prototype.forEachGlyph = function(A, E, B, e, t, g) {
  E = E !== void 0 ? E : 0, B = B !== void 0 ? B : 0, e = e !== void 0 ? e : 72, t = Object.assign({}, this.defaultRenderOptions, t);
  var M = 1 / this.unitsPerEm * e, Q = this.stringToGlyphs(A, t), s;
  if (t.kerning) {
    var r = t.script || this.position.getDefaultScriptName();
    s = this.position.getKerningTables(r, t.language);
  }
  for (var w = 0; w < Q.length; w += 1) {
    var c = Q[w];
    if (g.call(this, c, E, B, e, t), c.advanceWidth && (E += c.advanceWidth * M), t.kerning && w < Q.length - 1) {
      var n = s ? this.position.getKerningValue(s, c.index, Q[w + 1].index) : this.getKerningValue(c, Q[w + 1]);
      E += n * M;
    }
    t.letterSpacing ? E += t.letterSpacing * e : t.tracking && (E += t.tracking / 1e3 * e);
  }
  return E;
};
cA.prototype.getPath = function(A, E, B, e, t) {
  var g = new FA();
  return this.forEachGlyph(A, E, B, e, t, function(M, Q, s, r) {
    var w = M.getPath(Q, s, r, t, this);
    g.extend(w);
  }), g;
};
cA.prototype.getPaths = function(A, E, B, e, t) {
  var g = [];
  return this.forEachGlyph(A, E, B, e, t, function(M, Q, s, r) {
    var w = M.getPath(Q, s, r, t, this);
    g.push(w);
  }), g;
};
cA.prototype.getAdvanceWidth = function(A, E, B) {
  return this.forEachGlyph(A, 0, 0, E, B, function() {
  });
};
cA.prototype.draw = function(A, E, B, e, t, g) {
  this.getPath(E, B, e, t, g).draw(A);
};
cA.prototype.drawPoints = function(A, E, B, e, t, g) {
  this.forEachGlyph(E, B, e, t, g, function(M, Q, s, r) {
    M.drawPoints(A, Q, s, r);
  });
};
cA.prototype.drawMetrics = function(A, E, B, e, t, g) {
  this.forEachGlyph(E, B, e, t, g, function(M, Q, s, r) {
    M.drawMetrics(A, Q, s, r);
  });
};
cA.prototype.getEnglishName = function(A) {
  var E = this.names[A];
  if (E)
    return E.en;
};
cA.prototype.validate = function() {
  var A = this;
  function E(e, t) {
  }
  function B(e) {
    var t = A.getEnglishName(e);
    t && t.trim().length > 0;
  }
  B("fontFamily"), B("weightName"), B("manufacturer"), B("copyright"), B("version"), this.unitsPerEm > 0;
};
cA.prototype.toTables = function() {
  return zn.fontToTable(this);
};
cA.prototype.toBuffer = function() {
  return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
};
cA.prototype.toArrayBuffer = function() {
  for (var A = this.toTables(), E = A.encode(), B = new ArrayBuffer(E.length), e = new Uint8Array(B), t = 0; t < E.length; t++)
    e[t] = E[t];
  return B;
};
cA.prototype.download = function(A) {
  var E = this.getEnglishName("fontFamily"), B = this.getEnglishName("fontSubfamily");
  A = A || E.replace(/\s/g, "") + "-" + B + ".otf";
  var e = this.toArrayBuffer();
  if (kn())
    if (window.URL = window.URL || window.webkitURL, window.URL) {
      var t = new DataView(e), g = new Blob([t], { type: "font/opentype" }), M = document.createElement("a");
      M.href = window.URL.createObjectURL(g), M.download = A;
      var Q = document.createEvent("MouseEvents");
      Q.initEvent("click", !0, !1), M.dispatchEvent(Q);
    } else
      console.warn("Font file could not be downloaded. Try using a different browser.");
  else {
    var s = require("fs"), r = dn(e);
    s.writeFileSync(A, r);
  }
};
cA.prototype.fsSelectionValues = {
  ITALIC: 1,
  //1
  UNDERSCORE: 2,
  //2
  NEGATIVE: 4,
  //4
  OUTLINED: 8,
  //8
  STRIKEOUT: 16,
  //16
  BOLD: 32,
  //32
  REGULAR: 64,
  //64
  USER_TYPO_METRICS: 128,
  //128
  WWS: 256,
  //256
  OBLIQUE: 512
  //512
};
cA.prototype.usWidthClasses = {
  ULTRA_CONDENSED: 1,
  EXTRA_CONDENSED: 2,
  CONDENSED: 3,
  SEMI_CONDENSED: 4,
  MEDIUM: 5,
  SEMI_EXPANDED: 6,
  EXPANDED: 7,
  EXTRA_EXPANDED: 8,
  ULTRA_EXPANDED: 9
};
cA.prototype.usWeightClasses = {
  THIN: 100,
  EXTRA_LIGHT: 200,
  LIGHT: 300,
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
  BLACK: 900
};
function qM(A, E) {
  var B = JSON.stringify(A), e = 256;
  for (var t in E) {
    var g = parseInt(t);
    if (!(!g || g < 256)) {
      if (JSON.stringify(E[t]) === B)
        return g;
      e <= g && (e = g + 1);
    }
  }
  return E[e] = A, e;
}
function Jc(A, E, B) {
  var e = qM(E.name, B);
  return [
    { name: "tag_" + A, type: "TAG", value: E.tag },
    { name: "minValue_" + A, type: "FIXED", value: E.minValue << 16 },
    { name: "defaultValue_" + A, type: "FIXED", value: E.defaultValue << 16 },
    { name: "maxValue_" + A, type: "FIXED", value: E.maxValue << 16 },
    { name: "flags_" + A, type: "USHORT", value: 0 },
    { name: "nameID_" + A, type: "USHORT", value: e }
  ];
}
function bc(A, E, B) {
  var e = {}, t = new K.Parser(A, E);
  return e.tag = t.parseTag(), e.minValue = t.parseFixed(), e.defaultValue = t.parseFixed(), e.maxValue = t.parseFixed(), t.skip("uShort", 1), e.name = B[t.parseUShort()] || {}, e;
}
function Oc(A, E, B, e) {
  for (var t = qM(E.name, e), g = [
    { name: "nameID_" + A, type: "USHORT", value: t },
    { name: "flags_" + A, type: "USHORT", value: 0 }
  ], M = 0; M < B.length; ++M) {
    var Q = B[M].tag;
    g.push({
      name: "axis_" + A + " " + Q,
      type: "FIXED",
      value: E.coordinates[Q] << 16
    });
  }
  return g;
}
function jc(A, E, B, e) {
  var t = {}, g = new K.Parser(A, E);
  t.name = e[g.parseUShort()] || {}, g.skip("uShort", 1), t.coordinates = {};
  for (var M = 0; M < B.length; ++M)
    t.coordinates[B[M].tag] = g.parseFixed();
  return t;
}
function Lc(A, E) {
  var B = new L.Table("fvar", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "offsetToData", type: "USHORT", value: 0 },
    { name: "countSizePairs", type: "USHORT", value: 2 },
    { name: "axisCount", type: "USHORT", value: A.axes.length },
    { name: "axisSize", type: "USHORT", value: 20 },
    { name: "instanceCount", type: "USHORT", value: A.instances.length },
    { name: "instanceSize", type: "USHORT", value: 4 + A.axes.length * 4 }
  ]);
  B.offsetToData = B.sizeOf();
  for (var e = 0; e < A.axes.length; e++)
    B.fields = B.fields.concat(Jc(e, A.axes[e], E));
  for (var t = 0; t < A.instances.length; t++)
    B.fields = B.fields.concat(Oc(t, A.instances[t], A.axes, E));
  return B;
}
function Wc(A, E, B) {
  var e = new K.Parser(A, E), t = e.parseULong();
  gA.argument(t === 65536, "Unsupported fvar table version.");
  var g = e.parseOffset16();
  e.skip("uShort", 1);
  for (var M = e.parseUShort(), Q = e.parseUShort(), s = e.parseUShort(), r = e.parseUShort(), w = [], c = 0; c < M; c++)
    w.push(bc(A, E + g + c * Q, B));
  for (var n = [], a = E + g + M * Q, o = 0; o < s; o++)
    n.push(jc(A, a + o * r, w, B));
  return { axes: w, instances: n };
}
var Xc = { make: Lc, parse: Wc }, Kc = function() {
  return {
    coverage: this.parsePointer(Y.coverage),
    attachPoints: this.parseList(Y.pointer(Y.uShortList))
  };
}, Zc = function() {
  var A = this.parseUShort();
  if (gA.argument(
    A === 1 || A === 2 || A === 3,
    "Unsupported CaretValue table version."
  ), A === 1)
    return { coordinate: this.parseShort() };
  if (A === 2)
    return { pointindex: this.parseShort() };
  if (A === 3)
    return { coordinate: this.parseShort() };
}, qc = function() {
  return this.parseList(Y.pointer(Zc));
}, _c = function() {
  return {
    coverage: this.parsePointer(Y.coverage),
    ligGlyphs: this.parseList(Y.pointer(qc))
  };
}, $c = function() {
  return this.parseUShort(), this.parseList(Y.pointer(Y.coverage));
};
function Aa(A, E) {
  E = E || 0;
  var B = new Y(A, E), e = B.parseVersion(1);
  gA.argument(
    e === 1 || e === 1.2 || e === 1.3,
    "Unsupported GDEF table version."
  );
  var t = {
    version: e,
    classDef: B.parsePointer(Y.classDef),
    attachList: B.parsePointer(Kc),
    ligCaretList: B.parsePointer(_c),
    markAttachClassDef: B.parsePointer(Y.classDef)
  };
  return e >= 1.2 && (t.markGlyphSets = B.parsePointer($c)), t;
}
var Ea = { parse: Aa }, GA = new Array(10);
GA[1] = function() {
  var E = this.offset + this.relativeOffset, B = this.parseUShort();
  if (B === 1)
    return {
      posFormat: 1,
      coverage: this.parsePointer(Y.coverage),
      value: this.parseValueRecord()
    };
  if (B === 2)
    return {
      posFormat: 2,
      coverage: this.parsePointer(Y.coverage),
      values: this.parseValueRecordList()
    };
  gA.assert(!1, "0x" + E.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
};
GA[2] = function() {
  var E = this.offset + this.relativeOffset, B = this.parseUShort();
  gA.assert(B === 1 || B === 2, "0x" + E.toString(16) + ": GPOS lookup type 2 format must be 1 or 2.");
  var e = this.parsePointer(Y.coverage), t = this.parseUShort(), g = this.parseUShort();
  if (B === 1)
    return {
      posFormat: B,
      coverage: e,
      valueFormat1: t,
      valueFormat2: g,
      pairSets: this.parseList(Y.pointer(Y.list(function() {
        return {
          // pairValueRecord
          secondGlyph: this.parseUShort(),
          value1: this.parseValueRecord(t),
          value2: this.parseValueRecord(g)
        };
      })))
    };
  if (B === 2) {
    var M = this.parsePointer(Y.classDef), Q = this.parsePointer(Y.classDef), s = this.parseUShort(), r = this.parseUShort();
    return {
      // Class Pair Adjustment
      posFormat: B,
      coverage: e,
      valueFormat1: t,
      valueFormat2: g,
      classDef1: M,
      classDef2: Q,
      class1Count: s,
      class2Count: r,
      classRecords: this.parseList(s, Y.list(r, function() {
        return {
          value1: this.parseValueRecord(t),
          value2: this.parseValueRecord(g)
        };
      }))
    };
  }
};
GA[3] = function() {
  return { error: "GPOS Lookup 3 not supported" };
};
GA[4] = function() {
  return { error: "GPOS Lookup 4 not supported" };
};
GA[5] = function() {
  return { error: "GPOS Lookup 5 not supported" };
};
GA[6] = function() {
  return { error: "GPOS Lookup 6 not supported" };
};
GA[7] = function() {
  return { error: "GPOS Lookup 7 not supported" };
};
GA[8] = function() {
  return { error: "GPOS Lookup 8 not supported" };
};
GA[9] = function() {
  return { error: "GPOS Lookup 9 not supported" };
};
function Ba(A, E) {
  E = E || 0;
  var B = new Y(A, E), e = B.parseVersion(1);
  return gA.argument(e === 1 || e === 1.1, "Unsupported GPOS table version " + e), e === 1 ? {
    version: e,
    scripts: B.parseScriptList(),
    features: B.parseFeatureList(),
    lookups: B.parseLookupList(GA)
  } : {
    version: e,
    scripts: B.parseScriptList(),
    features: B.parseFeatureList(),
    lookups: B.parseLookupList(GA),
    variations: B.parseFeatureVariationsList()
  };
}
var ea = new Array(10);
function ta(A) {
  return new L.Table("GPOS", [
    { name: "version", type: "ULONG", value: 65536 },
    { name: "scripts", type: "TABLE", value: new L.ScriptList(A.scripts) },
    { name: "features", type: "TABLE", value: new L.FeatureList(A.features) },
    { name: "lookups", type: "TABLE", value: new L.LookupList(A.lookups, ea) }
  ]);
}
var ga = { parse: Ba, make: ta };
function Ma(A) {
  var E = {};
  A.skip("uShort");
  var B = A.parseUShort();
  gA.argument(B === 0, "Unsupported kern sub-table version."), A.skip("uShort", 2);
  var e = A.parseUShort();
  A.skip("uShort", 3);
  for (var t = 0; t < e; t += 1) {
    var g = A.parseUShort(), M = A.parseUShort(), Q = A.parseShort();
    E[g + "," + M] = Q;
  }
  return E;
}
function Qa(A) {
  var E = {};
  A.skip("uShort");
  var B = A.parseULong();
  B > 1 && console.warn("Only the first kern subtable is supported."), A.skip("uLong");
  var e = A.parseUShort(), t = e & 255;
  if (A.skip("uShort"), t === 0) {
    var g = A.parseUShort();
    A.skip("uShort", 3);
    for (var M = 0; M < g; M += 1) {
      var Q = A.parseUShort(), s = A.parseUShort(), r = A.parseShort();
      E[Q + "," + s] = r;
    }
  }
  return E;
}
function sa(A, E) {
  var B = new K.Parser(A, E), e = B.parseUShort();
  if (e === 0)
    return Ma(B);
  if (e === 1)
    return Qa(B);
  throw new Error("Unsupported kern table version (" + e + ").");
}
var ra = { parse: sa };
function na(A, E, B, e) {
  for (var t = new K.Parser(A, E), g = e ? t.parseUShort : t.parseULong, M = [], Q = 0; Q < B + 1; Q += 1) {
    var s = g.call(t);
    e && (s *= 2), M.push(s);
  }
  return M;
}
var wa = { parse: na };
function ca(A, E) {
  var B = require("fs");
  B.readFile(A, function(e, t) {
    if (e)
      return E(e.message);
    E(null, HM(t));
  });
}
function aa(A, E) {
  var B = new XMLHttpRequest();
  B.open("get", A, !0), B.responseType = "arraybuffer", B.onload = function() {
    return B.response ? E(null, B.response) : E("Font could not be loaded: " + B.statusText);
  }, B.onerror = function() {
    E("Font could not be loaded");
  }, B.send();
}
function zg(A, E) {
  for (var B = [], e = 12, t = 0; t < E; t += 1) {
    var g = K.getTag(A, e), M = K.getULong(A, e + 4), Q = K.getULong(A, e + 8), s = K.getULong(A, e + 12);
    B.push({ tag: g, checksum: M, offset: Q, length: s, compression: !1 }), e += 16;
  }
  return B;
}
function oa(A, E) {
  for (var B = [], e = 44, t = 0; t < E; t += 1) {
    var g = K.getTag(A, e), M = K.getULong(A, e + 4), Q = K.getULong(A, e + 8), s = K.getULong(A, e + 12), r = void 0;
    Q < s ? r = "WOFF" : r = !1, B.push({
      tag: g,
      offset: M,
      compression: r,
      compressedLength: Q,
      length: s
    }), e += 20;
  }
  return B;
}
function IA(A, E) {
  if (E.compression === "WOFF") {
    var B = new Uint8Array(A.buffer, E.offset + 2, E.compressedLength - 2), e = new Uint8Array(E.length);
    if (tr(B, e), e.byteLength !== E.length)
      throw new Error("Decompression error: " + E.tag + " decompressed length doesn't match recorded length");
    var t = new DataView(e.buffer, 0);
    return { data: t, offset: 0 };
  } else
    return { data: A, offset: E.offset };
}
function Dt(A, E) {
  E = E ?? {};
  var B, e, t = new cA({ empty: !0 }), g = new DataView(A, 0), M, Q = [], s = K.getTag(g, 0);
  if (s === "\0\0\0" || s === "true" || s === "typ1")
    t.outlinesFormat = "truetype", M = K.getUShort(g, 4), Q = zg(g, M);
  else if (s === "OTTO")
    t.outlinesFormat = "cff", M = K.getUShort(g, 4), Q = zg(g, M);
  else if (s === "wOFF") {
    var r = K.getTag(g, 4);
    if (r === "\0\0\0")
      t.outlinesFormat = "truetype";
    else if (r === "OTTO")
      t.outlinesFormat = "cff";
    else
      throw new Error("Unsupported OpenType flavor " + s);
    M = K.getUShort(g, 12), Q = oa(g, M);
  } else
    throw new Error("Unsupported OpenType signature " + s);
  for (var w, c, n, a, o, D, R, i, C, F, l, T, u = 0; u < M; u += 1) {
    var h = Q[u], x = void 0;
    switch (h.tag) {
      case "cmap":
        x = IA(g, h), t.tables.cmap = aM.parse(x.data, x.offset), t.encoding = new iM(t.tables.cmap);
        break;
      case "cvt ":
        x = IA(g, h), T = new K.Parser(x.data, x.offset), t.tables.cvt = T.parseShortList(h.length / 2);
        break;
      case "fvar":
        c = h;
        break;
      case "fpgm":
        x = IA(g, h), T = new K.Parser(x.data, x.offset), t.tables.fpgm = T.parseByteList(h.length);
        break;
      case "head":
        x = IA(g, h), t.tables.head = uM.parse(x.data, x.offset), t.unitsPerEm = t.tables.head.unitsPerEm, B = t.tables.head.indexToLocFormat;
        break;
      case "hhea":
        x = IA(g, h), t.tables.hhea = fM.parse(x.data, x.offset), t.ascender = t.tables.hhea.ascender, t.descender = t.tables.hhea.descender, t.numberOfHMetrics = t.tables.hhea.numberOfHMetrics;
        break;
      case "hmtx":
        R = h;
        break;
      case "ltag":
        x = IA(g, h), e = zM.parse(x.data, x.offset);
        break;
      case "maxp":
        x = IA(g, h), t.tables.maxp = YM.parse(x.data, x.offset), t.numGlyphs = t.tables.maxp.numGlyphs;
        break;
      case "name":
        F = h;
        break;
      case "OS/2":
        x = IA(g, h), t.tables.os2 = ve.parse(x.data, x.offset);
        break;
      case "post":
        x = IA(g, h), t.tables.post = pM.parse(x.data, x.offset), t.glyphNames = new at(t.tables.post);
        break;
      case "prep":
        x = IA(g, h), T = new K.Parser(x.data, x.offset), t.tables.prep = T.parseByteList(h.length);
        break;
      case "glyf":
        n = h;
        break;
      case "loca":
        C = h;
        break;
      case "CFF ":
        w = h;
        break;
      case "kern":
        i = h;
        break;
      case "GDEF":
        a = h;
        break;
      case "GPOS":
        o = h;
        break;
      case "GSUB":
        D = h;
        break;
      case "meta":
        l = h;
        break;
    }
  }
  var U = IA(g, F);
  if (t.tables.name = SM.parse(U.data, U.offset, e), t.names = t.tables.name, n && C) {
    var z = B === 0, k = IA(g, C), P = wa.parse(k.data, k.offset, t.numGlyphs, z), y = IA(g, n);
    t.glyphs = bM.parse(y.data, y.offset, P, t, E);
  } else if (w) {
    var G = IA(g, w);
    hM.parse(G.data, G.offset, t, E);
  } else
    throw new Error("Font doesn't contain TrueType or CFF outlines.");
  var d = IA(g, R);
  if (UM.parse(t, d.data, d.offset, t.numberOfHMetrics, t.numGlyphs, t.glyphs, E), ur(t, E), i) {
    var S = IA(g, i);
    t.kerningPairs = ra.parse(S.data, S.offset);
  } else
    t.kerningPairs = {};
  if (a) {
    var v = IA(g, a);
    t.tables.gdef = Ea.parse(v.data, v.offset);
  }
  if (o) {
    var j = IA(g, o);
    t.tables.gpos = ga.parse(j.data, j.offset), t.position.init();
  }
  if (D) {
    var m = IA(g, D);
    t.tables.gsub = PM.parse(m.data, m.offset);
  }
  if (c) {
    var b = IA(g, c);
    t.tables.fvar = Xc.parse(b.data, b.offset, t.names);
  }
  if (l) {
    var N = IA(g, l);
    t.tables.meta = vM.parse(N.data, N.offset), t.metas = t.tables.meta;
  }
  return t;
}
function ia(A, E, B) {
  B = B ?? {};
  var e = typeof window > "u", t = e && !B.isUrl ? ca : aa;
  return new Promise(function(g, M) {
    t(A, function(Q, s) {
      if (Q) {
        if (E)
          return E(Q);
        M(Q);
      }
      var r;
      try {
        r = Dt(s, B);
      } catch (w) {
        if (E)
          return E(w, null);
        M(w);
      }
      if (E)
        return E(null, r);
      g(r);
    });
  });
}
function Ia(A, E) {
  var B = require("fs"), e = B.readFileSync(A);
  return Dt(HM(e), E);
}
var lt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Font: cA,
  Glyph: hA,
  Path: FA,
  BoundingBox: _A,
  _parse: K,
  parse: Dt,
  load: ia,
  loadSync: Ia
});
const He = atob("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"), _M = new Uint8Array(He.length);
for (let A = 0; A < He.length; A++) _M[A] = He.charCodeAt(A);
const Fa = _M.buffer;
let jE = null, uE = null, CB = null;
const Yg = /* @__PURE__ */ new Map();
function Ra() {
  if (!jE) {
    jE = lt.parse(Fa);
    const A = jE.tables?.os2;
    A && (A.sCapHeight = 1467);
  }
  return jE;
}
async function Ti(A) {
  const E = Yg.get(A);
  if (E) return E;
  const e = await (await fetch(A)).arrayBuffer(), t = lt.parse(e);
  return Yg.set(A, t), t;
}
async function Ca() {
  return uE || CB || (CB = (async () => {
    const { default: A } = await import("./LiberationSerif-Regular-BmDFkyOw.js");
    uE = lt.parse(A);
    const E = uE.tables?.os2;
    return E && (E.sCapHeight = 1356), uE;
  })(), CB);
}
function hi() {
  return uE;
}
function ui() {
  return jE;
}
const VA = (A, E, B, e, t) => {
  if (!(e.length < 2))
    if (t && t.length > 0) {
      let g = 0;
      for (const r of t) g += Math.abs(r);
      if (g > 0) {
        let r = 0;
        for (let w = 0; w < e.length - 1; w++) {
          const c = e[w + 1].x - e[w].x, n = e[w + 1].y - e[w].y;
          r += Math.sqrt(c * c + n * n);
        }
        if (r / g > NQ) {
          A.addLineFromPoints(E, B, e);
          return;
        }
      }
      const M = VQ(e, t), Q = M.segments.length >= 6, s = M.dots.length >= 3;
      Q && A.addLineSegments(E, B, M.segments), s && A.addLinetypeDots(E, B, M.dots), !Q && !s && A.addLineFromPoints(E, B, e);
    } else
      A.addLineFromPoints(E, B, e);
}, Da = (A) => {
  if (!A || A.length < 3) return null;
  const E = [], B = [];
  for (const e of A)
    E.push(e.x, e.y, e.z || 0);
  return B.push(0, 1, 2), A.length >= 4 && B.push(0, 2, 3), { vertices: E, indices: B };
}, JA = (A, E) => {
  if (E) for (const B of A) B.applyMatrix4(E);
  return A;
};
function la(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!HB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = E.vertices[0], c = E.vertices[1], n = [
    new I.Vector3(w.x, w.y, 0),
    new I.Vector3(c.x, c.y, 0)
  ];
  return VA(e, t, Q, JA(n, g), r), !0;
}
const kg = 1 / 64;
function CA(A) {
  if (!A) return null;
  const E = A.x ?? 0, B = A.y ?? 0, e = A.z ?? 1;
  if (Math.abs(E) < 1e-10 && Math.abs(B) < 1e-10 && e > 0) return null;
  const t = new I.Vector3(E, B, e).normalize();
  let g;
  Math.abs(t.x) < kg && Math.abs(t.y) < kg ? g = new I.Vector3(0, 1, 0).cross(t).normalize() : g = new I.Vector3(0, 0, 1).cross(t).normalize();
  const M = t.clone().cross(g).normalize();
  return new I.Matrix4().makeBasis(g, M, t);
}
function mE(A, E) {
  if (!E) return A;
  for (const B of A) B.applyMatrix4(E);
  return A;
}
function LA(A, E) {
  return E ? A.applyMatrix4(E) : A;
}
function $M(A, E, B, e, t) {
  const g = WA, M = [];
  for (let Q = 0; Q <= g; Q++) {
    const s = Q / g * Math.PI * 2;
    M.push(
      new I.Vector3(
        A + e * Math.cos(s),
        E + e * Math.sin(s),
        B
      )
    );
  }
  return M;
}
function AQ(A, E, B, e, t, g) {
  let M = g;
  M <= t && (M += Math.PI * 2);
  const Q = M - t, s = Math.max(
    gE,
    Math.floor(Q * WA / (2 * Math.PI))
  ), r = [];
  for (let w = 0; w <= s; w++) {
    const c = t + w / s * Q;
    r.push(
      new I.Vector3(
        A + e * Math.cos(c),
        E + e * Math.sin(c),
        B
      )
    );
  }
  return r;
}
function nB(A, E, B, e, t, g, M, Q, s = !0, r = 0) {
  const w = Math.sqrt(e * e + t * t);
  if (w < q) return [];
  const c = w * g, n = Math.atan2(t, e), a = Math.abs(Q - M - 2 * Math.PI) < q || Math.abs(Q - M) < q;
  let o = M, D = Q;
  a && (o = 0, D = 2 * Math.PI);
  let R = D - o;
  s ? R < 0 && (R += 2 * Math.PI) : R > 0 && (R -= 2 * Math.PI);
  const i = r > 0 ? r : Math.max(
    gE,
    Math.floor(Math.abs(R) * WA / (2 * Math.PI))
  ), C = Math.cos(n), F = Math.sin(n), l = [];
  for (let T = 0; T <= i; T++) {
    const u = o + T / i * R, h = w * Math.cos(u), x = c * Math.sin(u), U = A + h * C - x * F, z = E + h * F + x * C;
    l.push(new I.Vector3(U, z, B));
  }
  return l;
}
function xa(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!VB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = CA(E.extrusionDirection), c = $M(
    E.center.x,
    E.center.y,
    E.center.z || 0,
    E.radius
  );
  return VA(e, t, Q, JA(mE(c, w), g), r), !0;
}
function Ta(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!mB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = CA(E.extrusionDirection), c = AQ(
    E.center.x,
    E.center.y,
    E.center.z || 0,
    E.radius,
    E.startAngle,
    E.endAngle
  );
  return VA(e, t, Q, JA(mE(c, w), g), r), !0;
}
function ha(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!JB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern;
  let w = E.majorAxisEndPoint.x, c = E.majorAxisEndPoint.y;
  const n = CA(E.extrusionDirection);
  if (n) {
    const o = new I.Vector3(w, c, 0).applyMatrix4(n);
    w = o.x, c = o.y;
  }
  const a = nB(
    E.center.x,
    E.center.y,
    E.center.z || 0,
    w,
    c,
    E.axisRatio,
    E.startAngle,
    E.endAngle
  );
  return VA(e, t, Q, JA(a, g), r), !0;
}
const EQ = (A) => {
  if (A.controlPoints && A.controlPoints.length > 1 && A.degreeOfSplineCurve !== void 0 && A.knotValues && A.knotValues.length > 0) {
    const B = A.degreeOfSplineCurve, e = A.knotValues, t = A.controlPoints.map((g, M) => {
      const Q = A.weights?.[M] ?? 1;
      return new I.Vector4(g.x, g.y, 0, Q);
    });
    try {
      const g = B, M = t.length, Q = new IQ(B, e, t, g, M), s = Math.max(
        t.length * kQ,
        dQ
      ), r = Q.getPoints(s);
      return A.closed && r.length > 1 && r.push(r[0].clone()), r;
    } catch (g) {
      console.warn("NURBS creation error, using fallback:", g);
    }
  }
  const E = A.fitPoints || A.vertices || A.controlPoints;
  if (E && E.length > 1) {
    const B = E.map(
      (g) => new I.Vector3(g.x, g.y, 0)
    ), e = new I.CatmullRomCurve3(B, A.closed === !0, "centripetal"), t = Math.max(
      B.length * GQ,
      yQ
    );
    return e.getPoints(t);
  }
  return null;
};
function ua(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!bB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = EQ(E);
  return w ? (VA(e, t, Q, JA(w, g), r), !0) : !1;
}
const BQ = (A) => {
  const E = [];
  for (let B = 0; B < A.vertices.length - 1; B++) {
    const e = A.vertices[B], t = A.vertices[B + 1];
    if (!e || !t) continue;
    const g = new I.Vector3(e.x, e.y, 0), M = new I.Vector3(t.x, t.y, 0);
    if (B === 0 && E.push(g), e.bulge && Math.abs(e.bulge) > q) {
      const Q = _E(g, M, e.bulge);
      E.push(...Q.slice(1));
    } else
      E.push(M);
  }
  if (A.shape && A.vertices.length > 1) {
    const B = A.vertices[A.vertices.length - 1], e = A.vertices[0], t = new I.Vector3(B.x, B.y, 0), g = new I.Vector3(e.x, e.y, 0);
    if (B.bulge && Math.abs(B.bulge) > q) {
      const M = _E(t, g, B.bulge);
      E.push(...M.slice(1));
    } else
      E.push(g);
  }
  return E;
};
function xe(A, E) {
  const B = A.startWidth !== void 0 ? A.startWidth : E.width ?? E.defaultStartWidth ?? 0, e = A.endWidth !== void 0 ? A.endWidth : A.startWidth !== void 0 ? A.startWidth : E.width ?? E.defaultEndWidth ?? E.defaultStartWidth ?? 0;
  return { startW: B, endW: e };
}
function fa(A) {
  return A.width || A.defaultStartWidth || A.defaultEndWidth ? !0 : A.vertices.some((E) => !!(E.startWidth || E.endWidth));
}
const Ua = (A, E, B, e, t, g) => {
  const M = e.vertices;
  if (M.length < 2) return;
  const Q = !!e.shape, s = Q ? M.length : M.length - 1, r = [], w = [];
  for (let i = 0; i < s; i++) {
    const C = M[i], F = M[(i + 1) % M.length], { startW: l, endW: T } = xe(C, e), u = l / 2, h = T / 2, x = new I.Vector3(C.x, C.y, 0), U = new I.Vector3(F.x, F.y, 0);
    let z;
    C.bulge && Math.abs(C.bulge) > q ? z = _E(x, U, C.bulge) : z = [x, U];
    let k = i > 0;
    if (k) {
      const G = xe(M[i - 1], e).endW;
      Math.abs(G - l) > q && (k = !1);
    }
    const P = k ? 1 : 0, y = Q && i === s - 1 ? z.length - 1 : z.length;
    for (let G = P; G < y; G++) {
      const d = z.length > 1 ? G / (z.length - 1) : 0;
      r.push(z[G]), w.push(u + (h - u) * d);
    }
  }
  const c = r.length;
  if (c < 2) return;
  const n = 2, a = [];
  for (let i = 0; i < c; i++) {
    let C, F;
    if (Q || i > 0 && i < c - 1) {
      const h = (i - 1 + c) % c, x = (i + 1) % c, U = r[i].x - r[h].x, z = r[i].y - r[h].y, k = Math.sqrt(U * U + z * z), P = r[x].x - r[i].x, y = r[x].y - r[i].y, G = Math.sqrt(P * P + y * y);
      if (k < q && G < q) {
        if (a.length >= 6) {
          const d = a.length - 6;
          a.push(
            a[d],
            a[d + 1],
            a[d + 2],
            a[d + 3],
            a[d + 4],
            a[d + 5]
          );
        } else {
          const d = r[i];
          a.push(d.x, d.y, d.z, d.x, d.y, d.z);
        }
        continue;
      }
      if (k < q)
        C = -y / G, F = P / G;
      else if (G < q)
        C = -z / k, F = U / k;
      else {
        const d = -z / k, S = U / k, v = -y / G, j = P / G;
        let m = d + v, b = S + j;
        const N = Math.sqrt(m * m + b * b);
        if (N < q)
          C = d, F = S;
        else {
          m /= N, b /= N;
          const f = m * d + b * S, p = Math.min(1 / Math.max(f, q), n);
          C = m * p, F = b * p;
        }
      }
    } else if (i === 0) {
      const h = r[1].x - r[0].x, x = r[1].y - r[0].y, U = Math.sqrt(h * h + x * x);
      U < q ? (C = 0, F = 1) : (C = -x / U, F = h / U);
    } else {
      const h = r[i].x - r[i - 1].x, x = r[i].y - r[i - 1].y, U = Math.sqrt(h * h + x * x);
      U < q ? (C = 0, F = 1) : (C = -x / U, F = h / U);
    }
    const T = w[i], u = r[i];
    a.push(
      u.x + C * T,
      u.y + F * T,
      u.z,
      u.x - C * T,
      u.y - F * T,
      u.z
    );
  }
  if (t || g) {
    const i = new I.Vector3();
    for (let C = 0; C < a.length; C += 3)
      i.set(a[C], a[C + 1], a[C + 2]), t && i.applyMatrix4(t), g && i.applyMatrix4(g), a[C] = i.x, a[C + 1] = i.y, a[C + 2] = i.z;
  }
  const o = a.length / 6;
  if (o < 2) return;
  const D = [], R = Q ? o : o - 1;
  for (let i = 0; i < R; i++) {
    const C = (i + 1) % o, F = i * 2, l = i * 2 + 1, T = C * 2, u = C * 2 + 1;
    D.push(F, l, T), D.push(l, u, T);
  }
  A.addMesh(E, B, a, D);
  for (let i = 0; i < s; i++) {
    const C = M[i], F = M[(i + 1) % M.length], { startW: l, endW: T } = xe(C, e);
    if (Math.abs(l) > q || Math.abs(T) > q) continue;
    const u = new I.Vector3(C.x, C.y, 0), h = new I.Vector3(F.x, F.y, 0), x = C.bulge && Math.abs(C.bulge) > q ? _E(u, h, C.bulge) : [u, h];
    if (t) for (const U of x) U.applyMatrix4(t);
    if (g) for (const U of x) U.applyMatrix4(g);
    A.addLineFromPoints(E, B, x);
  }
}, za = (A, E, B, e, t) => {
  const g = [], M = [];
  for (const Q of e)
    Q.faceA !== void 0 ? M.push(Q) : g.push(new I.Vector3(Q.x, Q.y, Q.z || 0));
  if (t)
    for (const Q of g) Q.applyMatrix4(t);
  if (!(g.length === 0 || M.length === 0))
    for (const Q of M) {
      const s = [Q.faceA, Q.faceB, Q.faceC, Q.faceD], r = [], w = [];
      for (const c of s)
        c === void 0 || c === 0 || (r.push(Math.abs(c)), w.push(c > 0));
      for (let c = 0; c < r.length; c++) {
        if (!w[c]) continue;
        const n = r[c] - 1, a = r[(c + 1) % r.length] - 1;
        n < 0 || n >= g.length || a < 0 || a >= g.length || A.addLineFromPoints(E, B, [g[n], g[a]]);
      }
    }
}, Ya = (A, E, B, e, t) => {
  const g = e.meshMVertexCount, M = e.meshNVertexCount, Q = e.vertices;
  if (Q.length < g * M) return;
  const s = [];
  for (let n = 0; n < g * M; n++) {
    const a = Q[n];
    s.push(new I.Vector3(a.x, a.y, a.z || 0));
  }
  if (t)
    for (const n of s) n.applyMatrix4(t);
  const r = e.shape === !0, w = e.is3dPolygonMeshClosed === !0, c = (n, a) => n * M + a;
  for (let n = 0; n < g; n++) {
    const a = w ? M : M - 1;
    for (let o = 0; o < a; o++)
      A.addLineFromPoints(E, B, [s[c(n, o)], s[c(n, (o + 1) % M)]]);
  }
  for (let n = 0; n < M; n++) {
    const a = r ? g : g - 1;
    for (let o = 0; o < a; o++)
      A.addLineFromPoints(E, B, [s[c(o, n)], s[c((o + 1) % g, n)]]);
  }
};
function dg(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!OB(E)) return !1;
  if (E.vertices.length === 0) return !0;
  if (E.vertices.length === 1) {
    const n = M ?? aA(E, B.layers, B.blockColor), a = E.vertices[0], o = new I.Vector3(a.x, a.y, a.z ?? 0), D = CA(E.extrusionDirection);
    return D && o.applyMatrix4(D), g && o.applyMatrix4(g), e.addPoint(t, n, o.x, o.y, o.z), !0;
  }
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern;
  if (E.isPolyfaceMesh)
    return za(e, t, Q, E.vertices, g), !0;
  if (E.is3dPolygonMesh && E.meshMVertexCount && E.meshNVertexCount)
    return Ya(e, t, Q, E, g), !0;
  if (fa(E)) {
    const n = CA(E.extrusionDirection);
    return Ua(e, t, Q, E, n, g), !0;
  }
  const w = CA(E.extrusionDirection), c = BQ(E);
  return VA(e, t, Q, JA(mE(c, w), g), r), !0;
}
const ka = (A) => {
  const { collector: E, layer: B, color: e, x: t, y: g, z: M, pdMode: Q, halfSize: s } = A, r = Q & 15, w = (Q & 32) !== 0, c = (Q & 64) !== 0, n = w || c ? s * 2 : s;
  switch (r) {
    case 0:
      E.addPoint(B, e, t, g, M);
      break;
    case 1:
      break;
    case 2:
      E.addLineSegments(B, e, [
        t - n,
        g,
        M,
        t + n,
        g,
        M,
        t,
        g - n,
        M,
        t,
        g + n,
        M
      ]);
      break;
    case 3:
      E.addLineSegments(B, e, [
        t - n,
        g - n,
        M,
        t + n,
        g + n,
        M,
        t - n,
        g + n,
        M,
        t + n,
        g - n,
        M
      ]);
      break;
    case 4:
      E.addLineSegments(B, e, [
        t,
        g,
        M,
        t,
        g + n,
        M
      ]);
      break;
  }
  if (w) {
    const a = [];
    for (let o = 0; o < re; o++) {
      const D = o / re * Math.PI * 2, R = (o + 1) / re * Math.PI * 2;
      a.push(
        t + s * Math.cos(D),
        g + s * Math.sin(D),
        M,
        t + s * Math.cos(R),
        g + s * Math.sin(R),
        M
      );
    }
    E.addLineSegments(B, e, a);
  }
  c && E.addLineSegments(B, e, [
    t - s,
    g - s,
    M,
    t + s,
    g - s,
    M,
    t + s,
    g - s,
    M,
    t + s,
    g + s,
    M,
    t + s,
    g + s,
    M,
    t - s,
    g + s,
    M,
    t - s,
    g + s,
    M,
    t - s,
    g - s,
    M
  ]);
}, da = (A) => {
  if (!A) return fe;
  const E = A.$PDSIZE ?? 0;
  if (E > 0) return E;
  if (E < 0) return Math.abs(E);
  const B = A.$EXTMIN, e = A.$EXTMAX;
  return B && e && e.x > B.x && e.y > B.y ? (e.y - B.y) * 0.05 : fe;
};
function Ga(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!je(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), s = CA(E.extrusionDirection), r = LA(
    new I.Vector3(E.position.x, E.position.y, E.position.z || 0),
    s
  );
  g && r.applyMatrix4(g);
  const w = B.pdMode ?? 0;
  if (w === 0)
    e.addPoint(t, Q, r.x, r.y, r.z);
  else {
    const c = (B.pointDisplaySize ?? fe) / 2;
    ka({ collector: e, layer: t, color: Q, x: r.x, y: r.y, z: r.z, pdMode: w, halfSize: c });
  }
  return !0;
}
function ya(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!jB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), s = CA(E.extrusionDirection);
  let r = E.points;
  s && (r = E.points.map((c) => {
    const n = new I.Vector3(c.x, c.y, c.z || 0).applyMatrix4(s);
    return { x: n.x, y: n.y, z: n.z };
  })), g && (r = r.map((c) => {
    const n = new I.Vector3(c.x, c.y, c.z || 0).applyMatrix4(g);
    return { x: n.x, y: n.y, z: n.z };
  }));
  const w = Da(r);
  return w ? (e.addMesh(t, Q, w.vertices, w.indices), !0) : !1;
}
const Sa = (A, E, B, e, t) => {
  if (!e || e.length < 3) return;
  const g = t ?? 0, Q = e.length >= 4 ? [[0, 1], [1, 2], [2, 3], [3, 0]] : [[0, 1], [1, 2], [2, 0]];
  for (let s = 0; s < Q.length; s++) {
    if (g & 1 << s) continue;
    const [r, w] = Q[s], c = [
      new I.Vector3(e[r].x, e[r].y, e[r].z || 0),
      new I.Vector3(e[w].x, e[w].y, e[w].z || 0)
    ];
    A.addLineFromPoints(E, B, c);
  }
};
function pa(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!LB(E)) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor);
  let s = E.vertices;
  return g && (s = s.map((r) => {
    const w = new I.Vector3(r.x, r.y, r.z || 0).applyMatrix4(g);
    return { x: w.x, y: w.y, z: w.z };
  })), Sa(e, t, Q, s, E.edgeFlags), !0;
}
const EA = (A, E, B, e, t, g = []) => ({
  angle: A,
  basePoint: { x: E, y: B },
  offset: { x: e, y: t },
  dashes: g
}), Pa = {
  // ANSI patterns (inch-based from acad.pat)
  ANSI31: [EA(45, 0, 0, 0, 3.175)],
  ANSI32: [EA(45, 0, 0, 0, 9.525)],
  ANSI33: [EA(45, 0, 0, 0, 6.35, [6.35, -3.175])],
  ANSI34: [EA(45, 0, 0, 0, 6.35), EA(45, 4.49, 0, 0, 6.35)],
  ANSI35: [EA(45, 0, 0, 0, 6.35, [6.35, -3.175]), EA(45, 4.49, 0, 0, 6.35, [6.35, -3.175])],
  ANSI36: [EA(45, 0, 0, 0, 6.35, [6.35, -3.175]), EA(45, 4.49, 0, 0, 6.35)],
  ANSI37: [
    EA(45, 0, 0, 0, 3.175),
    EA(135, 0, 0, 0, 3.175)
  ],
  ANSI38: [
    EA(45, 0, 0, 0, 3.175),
    EA(135, 0, 0, 6.35, 6.35, [16.51, -3.175])
  ],
  // Simple line/cross patterns
  LINE: [EA(0, 0, 0, 0, 3.175)],
  ANGLE: [EA(0, 0, 0, 0, 6.35, [6.35, -3.175]), EA(90, 0, 0, 0, 6.35, [6.35, -3.175])],
  CROSS: [EA(0, 0, 0, 0, 6.35, [6.35, -6.35]), EA(90, 3.175, -3.175, 0, 6.35, [6.35, -6.35])],
  NET: [EA(0, 0, 0, 0, 3.175), EA(90, 0, 0, 0, 3.175)],
  NET3: [EA(0, 0, 0, 0, 3.175), EA(60, 0, 0, 0, 3.175), EA(120, 0, 0, 0, 3.175)],
  SQUARE: [EA(0, 0, 0, 0, 3.175, [3.175, -3.175]), EA(90, 0, 0, 0, 3.175, [3.175, -3.175])],
  // Brick pattern
  BRICK: [
    EA(0, 0, 0, 0, 6.35),
    EA(90, 0, 0, 6.35, 6.35, [6.35, -6.35])
  ],
  // Dot pattern
  DOTS: [EA(0, 0, 0, 0, 3.175, [0, -3.175])],
  // Hexagonal pattern
  HEX: [
    EA(0, 0, 0, 0, 5.4914, [3.175, -3.175]),
    EA(60, 0, 0, 0, 5.4914, [3.175, -3.175]),
    EA(120, 1.5875, 2.7457, 0, 5.4914, [3.175, -3.175])
  ],
  // Honeycomb pattern
  HONEY: [
    EA(0, 0, 0, 5.4914, 9.5104, [3.175, -3.175]),
    EA(60, 0, 0, 5.4914, 9.5104, [3.175, -3.175]),
    EA(120, 1.5875, 2.7457, 5.4914, 9.5104, [3.175, -3.175])
  ],
  // Star-shaped pattern
  STARS: [
    EA(0, 0, 0, 0, 5.4914, [3.175, -3.175]),
    EA(60, 0, 0, 0, 5.4914, [3.175, -3.175]),
    EA(120, 0, 0, 0, 5.4914, [3.175, -3.175])
  ],
  // Steel plate pattern
  STEEL: [
    EA(45, 0, 0, 0, 3.175),
    EA(45, 0, 1.5875, 0, 3.175)
  ],
  // Grass / ground pattern
  GRASS: [
    EA(90, 0, 0, 11.049, 5.5245, [3.175, -41.275]),
    EA(45, 0, 0, 11.049, 5.5245, [4.49, -39.96]),
    EA(135, 0, 0, 11.049, 5.5245, [4.49, -39.96])
  ],
  // Earth pattern
  EARTH: [
    EA(0, 0, 0, 6.35, 3.175, [6.35, -6.35]),
    EA(0, 0, 1.5875, 6.35, 3.175, [6.35, -6.35]),
    EA(90, 1.5875, 1.5875, 6.35, 3.175, [3.175, -9.525])
  ],
  // Insulation pattern (zigzag)
  INSUL: [
    EA(0, 0, 0, 0, 9.525),
    EA(0, 0, 4.7625, 0, 9.525, [4.7625, -4.7625])
  ],
  // Mudst (simple diagonal)
  MUDST: [
    EA(0, 0, 0, 12.7, 6.35, [6.35, -19.05]),
    EA(90, 3.175, 0, 12.7, 6.35, [6.35, -19.05])
  ],
  // Dash pattern
  DASH: [EA(0, 0, 0, 0, 3.175, [3.175, -1.5875])],
  // GOST standard hatches (common fallback for Russian DXF files)
  GOST_GLASS: [EA(45, 0, 0, 0, 4)],
  GOST_WOOD: [
    EA(45, 0, 0, 0, 4),
    EA(135, 0, 0, 0, 4, [2, -6])
  ],
  GOST_METAL: [EA(45, 0, 0, 0, 3)],
  "GOST_NON-METAL": [
    EA(45, 0, 0, 0, 6),
    EA(135, 0, 0, 0, 6)
  ],
  GOST_GROUND: [
    EA(45, 0, 0, 0, 3, [3, -3]),
    EA(45, 1.5, 0, 0, 3, [3, -3])
  ]
}, te = (A, E, B) => {
  const e = Math.PI / 180;
  return B ? [A * e, E * e] : [-A * e, -E * e];
}, ge = (A, E, B) => {
  const e = Math.PI / 180;
  return B ? [A * e, E * e] : [-A * e, -E * e];
}, me = (A, E, B) => {
  let e = E - A;
  if (Math.abs(e) < q || Math.abs(Math.abs(e) - 2 * Math.PI) < q)
    return B ? 2 * Math.PI : -2 * Math.PI;
  B ? e < 0 && (e += 2 * Math.PI) : e > 0 && (e -= 2 * Math.PI);
  const t = 2 * Math.PI - 10 * Math.PI / 180;
  return Math.abs(e) > t && (e = e > 0 ? e - 2 * Math.PI : e + 2 * Math.PI), e;
}, va = (A) => {
  if (A.type === "line")
    return { x: A.start.x, y: A.start.y };
  if (A.type === "arc") {
    const [E] = te(A.startAngle, A.endAngle, A.ccw);
    return {
      x: A.center.x + A.radius * Math.cos(E),
      y: A.center.y + A.radius * Math.sin(E)
    };
  } else if (A.type === "ellipse") {
    const [E, B] = ge(A.startAngle, A.endAngle, A.ccw), e = nB(
      A.center.x,
      A.center.y,
      0,
      A.majorAxisEndPoint.x,
      A.majorAxisEndPoint.y,
      A.axisRatio,
      E,
      B,
      A.ccw,
      1
    );
    return e.length > 0 ? { x: e[0].x, y: e[0].y } : { x: 0, y: 0 };
  } else if (A.type === "spline") {
    const E = Me(A);
    return E.length > 0 ? { x: E[0].x, y: E[0].y } : { x: 0, y: 0 };
  }
  return { x: 0, y: 0 };
}, Me = (A) => {
  const E = A.fitPoints && A.fitPoints.length > 1 ? A.fitPoints : A.controlPoints;
  if (!E || E.length < 2) return [];
  const B = E.map((g) => new I.Vector3(g.x, g.y, 0));
  if (B.length === 2) return B;
  const e = new I.CatmullRomCurve3(B, !1, "centripetal"), t = Math.max(B.length * 4, 20);
  return e.getPoints(t);
}, Na = (A, E) => {
  if (E.edges && E.edges.length > 0) {
    const B = E.edges[0], e = va(B);
    A.moveTo(e.x, e.y);
    for (const t of E.edges)
      Ja(A, t);
    return !0;
  } else if (E.polylineVertices && E.polylineVertices.length > 1) {
    const B = E.polylineVertices;
    A.moveTo(B[0].x, B[0].y);
    for (let e = 0; e < B.length - 1; e++) {
      const t = B[e], g = B[e + 1];
      if (!A.currentPath) break;
      t.bulge && Math.abs(t.bulge) > q ? ba(A, t, g, t.bulge) : A.currentPath.lineTo(g.x, g.y);
    }
    return !0;
  }
  return !1;
}, eQ = (A) => {
  let E = 0, B = 0;
  for (const t of A)
    E += t.x, B += t.y;
  const e = A.length;
  return { x: E / e, y: B / e };
}, Ha = (A) => {
  let E = 0;
  const B = A.length;
  for (let e = 0, t = B - 1; e < B; t = e++)
    E += (A[t].x - A[e].x) * (A[t].y + A[e].y);
  return E / 2;
}, ma = (A, E) => {
  if (E === 0 || A.length <= 1) return A;
  const B = A.map((g) => ({
    pts: g,
    area: Math.abs(Ha(g))
  }));
  B.sort((g, M) => M.area - g.area);
  const e = E === 1 ? 1 : 0, t = [];
  for (let g = 0; g < B.length; g++) {
    const M = eQ(B[g].pts);
    let Q = 0;
    for (let s = 0; s < g; s++)
      eE(M.x, M.y, B[s].pts) && Q++;
    Q <= e && t.push(B[g].pts);
  }
  return t;
}, Va = (A, E = 0) => {
  const B = [];
  for (const g of A) {
    const M = new I.ShapePath();
    if (Na(M, g))
      for (const Q of M.toShapes(!1)) {
        const s = Q.getPoints(12);
        B.push({ shape: Q, area: Math.abs(I.ShapeUtils.area(s)), pts: s });
      }
  }
  if (B.length <= 1) return B.map((g) => g.shape);
  B.sort((g, M) => M.area - g.area);
  const e = [], t = [];
  for (let g = 0; g < B.length; g++) {
    const M = eQ(B[g].pts);
    let Q = 0;
    for (let s = 0; s < g; s++)
      eE(M.x, M.y, B[s].pts) && Q++;
    if (E === 1 && Q >= 2 || E === 2 && Q >= 1) {
      t[g] = !0;
      continue;
    }
    if (Q % 2 === 0)
      e.push(B[g].shape), t[g] = !1;
    else {
      t[g] = !0;
      for (let s = g - 1; s >= 0; s--)
        if (!t[s] && eE(M.x, M.y, B[s].pts)) {
          B[s].shape.holes.push(new I.Path(B[g].pts));
          break;
        }
    }
  }
  return e;
}, Ja = (A, E) => {
  if (A.currentPath) {
    if (E.type === "line")
      A.currentPath.lineTo(E.end.x, E.end.y);
    else if (E.type === "arc") {
      const [B, e] = te(E.startAngle, E.endAngle, E.ccw);
      A.currentPath.absarc(
        E.center.x,
        E.center.y,
        E.radius,
        B,
        e,
        !E.ccw
        // THREE.js: aClockwise=true means CW, DXF ccw=true means CCW
      );
    } else if (E.type === "ellipse") {
      const [B, e] = ge(E.startAngle, E.endAngle, E.ccw), t = nB(
        E.center.x,
        E.center.y,
        0,
        E.majorAxisEndPoint.x,
        E.majorAxisEndPoint.y,
        E.axisRatio,
        B,
        e,
        E.ccw
      );
      for (let g = 1; g < t.length; g++)
        A.currentPath.lineTo(t[g].x, t[g].y);
    } else if (E.type === "spline") {
      const B = Me(E);
      for (let e = 1; e < B.length; e++)
        A.currentPath.lineTo(B[e].x, B[e].y);
    }
  }
}, ba = (A, E, B, e) => {
  if (!A.currentPath) return;
  const t = B.x - E.x, g = B.y - E.y, M = Math.sqrt(t * t + g * g);
  if (M < q) {
    A.currentPath.lineTo(B.x, B.y);
    return;
  }
  const Q = 4 * Math.atan(e), s = M / (2 * Math.sin(Q / 2)), r = s * Math.cos(Q / 2), w = (E.x + B.x) / 2, c = (E.y + B.y) / 2, n = -g / M, a = t / M, o = w + n * r, D = c + a * r, R = Math.atan2(E.y - D, E.x - o), i = Math.atan2(B.y - D, B.x - o), C = e < 0;
  A.currentPath.absarc(o, D, Math.abs(s), R, i, C);
}, PB = (A) => {
  const E = [];
  if (A.edges && A.edges.length > 0) {
    for (const B of A.edges)
      if (B.type === "line")
        E.length === 0 && E.push(new I.Vector3(B.start.x, B.start.y, 0)), E.push(new I.Vector3(B.end.x, B.end.y, 0));
      else if (B.type === "arc") {
        const [e, t] = te(B.startAngle, B.endAngle, B.ccw), g = me(e, t, B.ccw), M = Math.max(
          gE,
          Math.floor(Math.abs(g) * WA / (2 * Math.PI))
        );
        for (let Q = 0; Q <= M; Q++) {
          const s = e + Q / M * g;
          E.push(
            new I.Vector3(
              B.center.x + B.radius * Math.cos(s),
              B.center.y + B.radius * Math.sin(s),
              0
            )
          );
        }
      } else if (B.type === "ellipse") {
        const [e, t] = ge(B.startAngle, B.endAngle, B.ccw), g = nB(
          B.center.x,
          B.center.y,
          0,
          B.majorAxisEndPoint.x,
          B.majorAxisEndPoint.y,
          B.axisRatio,
          e,
          t,
          B.ccw
        ), M = E.length > 0 ? 1 : 0;
        for (let Q = M; Q < g.length; Q++)
          E.push(g[Q]);
      } else if (B.type === "spline") {
        const e = Me(B), t = E.length > 0 ? 1 : 0;
        for (let g = t; g < e.length; g++)
          E.push(e[g]);
      }
  } else if (A.polylineVertices && A.polylineVertices.length > 1) {
    const B = A.polylineVertices;
    E.push(new I.Vector3(B[0].x, B[0].y, 0));
    for (let e = 0; e < B.length - 1; e++) {
      const t = B[e], g = B[e + 1];
      if (t.bulge && Math.abs(t.bulge) > q) {
        const M = new I.Vector3(t.x, t.y, 0), Q = new I.Vector3(g.x, g.y, 0), s = _E(M, Q, t.bulge);
        E.push(...s.slice(1));
      } else
        E.push(new I.Vector3(g.x, g.y, 0));
    }
  }
  return E;
}, Oa = (A) => {
  const E = [];
  if (A.edges && A.edges.length > 0) {
    for (const B of A.edges)
      if (B.type === "line")
        E.length === 0 && E.push({ x: B.start.x, y: B.start.y }), E.push({ x: B.end.x, y: B.end.y });
      else if (B.type === "arc") {
        const [e, t] = te(B.startAngle, B.endAngle, B.ccw), g = me(e, t, B.ccw), M = Math.max(
          gE,
          Math.floor(Math.abs(g) * WA / (2 * Math.PI))
        );
        for (let Q = 0; Q <= M; Q++) {
          const s = e + Q / M * g;
          E.push({
            x: B.center.x + B.radius * Math.cos(s),
            y: B.center.y + B.radius * Math.sin(s)
          });
        }
      } else if (B.type === "ellipse") {
        const e = B.majorAxisEndPoint.x, t = B.majorAxisEndPoint.y, g = Math.sqrt(e * e + t * t);
        if (g < q) continue;
        const M = g * B.axisRatio, Q = Math.atan2(t, e), s = Math.cos(Q), r = Math.sin(Q);
        let [w, c] = ge(B.startAngle, B.endAngle, B.ccw);
        (Math.abs(c - w - 2 * Math.PI) < q || Math.abs(c - w) < q) && (w = 0, c = 2 * Math.PI);
        const a = me(w, c, B.ccw), o = Math.max(
          gE,
          Math.floor(Math.abs(a) * WA / (2 * Math.PI))
        ), D = E.length > 0 ? 1 : 0;
        for (let R = D; R <= o; R++) {
          const i = w + R / o * a, C = g * Math.cos(i), F = M * Math.sin(i);
          E.push({
            x: B.center.x + C * s - F * r,
            y: B.center.y + C * r + F * s
          });
        }
      } else if (B.type === "spline") {
        const e = Me(B), t = E.length > 0 ? 1 : 0;
        for (let g = t; g < e.length; g++)
          E.push({ x: e[g].x, y: e[g].y });
      }
  } else if (A.polylineVertices && A.polylineVertices.length > 1) {
    const B = A.polylineVertices;
    E.push({ x: B[0].x, y: B[0].y });
    for (let e = 0; e < B.length - 1; e++) {
      const t = B[e], g = B[e + 1];
      if (t.bulge && Math.abs(t.bulge) > q) {
        const M = g.x - t.x, Q = g.y - t.y, s = Math.sqrt(M * M + Q * Q);
        if (s < q) {
          E.push({ x: g.x, y: g.y });
          continue;
        }
        const r = 4 * Math.atan(t.bulge), w = s / (2 * Math.sin(r / 2)), c = w * Math.cos(r / 2), n = (t.x + g.x) / 2, a = (t.y + g.y) / 2, o = -Q / s, D = M / s, R = n + o * c, i = a + D * c, C = Math.atan2(t.y - i, t.x - R);
        let l = Math.atan2(g.y - i, g.x - R) - C;
        for (; l > Math.PI; ) l -= 2 * Math.PI;
        for (; l < -Math.PI; ) l += 2 * Math.PI;
        t.bulge > 0 && l < 0 ? l += 2 * Math.PI : t.bulge < 0 && l > 0 && (l -= 2 * Math.PI);
        const T = Math.max(
          gE,
          Math.floor(Math.abs(l) * WA / (2 * Math.PI))
        ), u = Math.abs(w);
        for (let h = 1; h <= T; h++) {
          const x = C + l * (h / T);
          E.push({ x: R + u * Math.cos(x), y: i + u * Math.sin(x) });
        }
      } else
        E.push({ x: g.x, y: g.y });
    }
  }
  return E;
}, eE = (A, E, B) => {
  let e = !1;
  const t = B.length;
  for (let g = 0, M = t - 1; g < t; M = g++) {
    const Q = B[g].y, s = B[M].y;
    Q > E != s > E && A < (B[M].x - B[g].x) * (E - Q) / (s - Q) + B[g].x && (e = !e);
  }
  return e;
}, Gg = (A, E, B) => {
  let e = 0;
  for (const t of B)
    eE(A, E, t) && e++;
  return e % 2 === 1;
}, ja = (A, E, B, e, t) => {
  const g = B - A, M = e - E, Q = [], s = t.length;
  for (let C = 0; C < s; C++) {
    const F = (C + 1) % s, l = t[F].x - t[C].x, T = t[F].y - t[C].y, u = g * T - M * l;
    if (Math.abs(u) < 1e-10) continue;
    const h = ((t[C].x - A) * T - (t[C].y - E) * l) / u, x = ((t[C].x - A) * M - (t[C].y - E) * g) / u;
    h > 1e-9 && h < 1 - 1e-9 && x > -1e-9 && x < 1 + 1e-9 && Q.push(h);
  }
  Q.sort((C, F) => C - F);
  const r = [];
  for (let C = 0; C < Q.length; C++)
    C > 0 && Q[C] - Q[C - 1] < 1e-7 || r.push(Q[C]);
  const w = [0, ...r, 1], c = [];
  if (r.length === 0)
    return eE(A + 0.5 * g, E + 0.5 * M, t) && c.push([A, E, B, e]), c;
  const n = w[1] / 2, a = eE(A + n * g, E + n * M, t), o = (w[w.length - 2] + 1) / 2, D = eE(A + o * g, E + o * M, t), R = r.length % 2 === 0 ? a : !a;
  if (D !== R) {
    for (let C = 0; C < w.length - 1; C++) {
      const F = w[C], l = w[C + 1];
      if (l - F < 1e-9) continue;
      const T = (F + l) / 2;
      eE(A + T * g, E + T * M, t) && c.push([
        A + F * g,
        E + F * M,
        A + l * g,
        E + l * M
      ]);
    }
    return c;
  }
  let i = a;
  for (let C = 0; C < w.length - 1; C++) {
    const F = w[C], l = w[C + 1];
    i && l - F > 1e-9 && c.push([
      A + F * g,
      E + F * M,
      A + l * g,
      E + l * M
    ]), i = !i;
  }
  return c;
}, yg = (A, E, B, e, t) => {
  if (t.length === 1)
    return ja(A, E, B, e, t[0]);
  const g = B - A, M = e - E, Q = /* @__PURE__ */ new Set();
  for (const n of t) {
    const a = n.length;
    for (let o = 0; o < a; o++) {
      const D = (o + 1) % a, R = n[D].x - n[o].x, i = n[D].y - n[o].y, C = g * i - M * R;
      if (Math.abs(C) < 1e-10) continue;
      const F = ((n[o].x - A) * i - (n[o].y - E) * R) / C, l = ((n[o].x - A) * M - (n[o].y - E) * g) / C;
      F > 1e-9 && F < 1 - 1e-9 && l > -1e-9 && l < 1 + 1e-9 && Q.add(F);
    }
  }
  const s = Array.from(Q).sort((n, a) => n - a), r = [];
  let w = 0, c = Gg(A, E, t);
  for (let n = 0; n < s.length; n++) {
    const a = s[n];
    c && r.push([A + w * g, E + w * M, A + a * g, E + a * M]);
    const o = (a + (s[n + 1] ?? 1)) / 2;
    c = Gg(A + o * g, E + o * M, t), w = a;
  }
  return c && r.push([A + w * g, E + w * M, B, e]), r;
}, La = (A, E, B = 1, e = 0, t = !1) => {
  let g = 1 / 0, M = 1 / 0, Q = -1 / 0, s = -1 / 0;
  for (const o of E)
    for (const D of o)
      D.x < g && (g = D.x), D.y < M && (M = D.y), D.x > Q && (Q = D.x), D.y > s && (s = D.y);
  const r = Math.sqrt((Q - g) ** 2 + (s - M) ** 2), w = [], c = [], n = B || 1, a = e || 0;
  for (const o of A) {
    const D = (o.angle + a) * Math.PI / 180, R = Math.cos(D), i = Math.sin(D), C = -i, F = R;
    let l, T, u, h;
    if (t) {
      u = o.offset.x * n, h = o.offset.y * n;
      const N = u * C + h * F;
      N < 0 && (u = -u, h = -h), l = Math.abs(N), T = u * R + h * i;
    } else
      l = Math.abs(o.offset.x * C + o.offset.y * F) * n, T = o.offset.x * n, u = l * C + T * R, h = l * F + T * i;
    if (l < q) continue;
    const x = o.basePoint.x * n, U = o.basePoint.y * n, z = [
      { x: g, y: M },
      { x: Q, y: M },
      { x: Q, y: s },
      { x: g, y: s }
    ];
    let k = 1 / 0, P = -1 / 0, y = 1 / 0, G = -1 / 0;
    for (const N of z) {
      const f = N.x - x, p = N.y - U, W = f * C + p * F, J = f * R + p * i;
      W < k && (k = W), W > P && (P = W), J < y && (y = J), J > G && (G = J);
    }
    const d = Math.floor(k / l), S = Math.ceil(P / l);
    if (S - d > pQ) continue;
    const v = Math.max(Math.abs(y), Math.abs(G)) + r, j = o.dashes.map((N) => N * n), m = j.reduce((N, f) => N + Math.abs(f), 0), b = j.length === 0 || m < q;
    for (let N = d; N <= S && !(w.length / 6 >= Yt); N++) {
      const f = x + N * u, p = U + N * h;
      if (b) {
        const W = f - v * R, J = p - v * i, $ = f + v * R, QA = p + v * i, Z = yg(W, J, $, QA, E);
        for (const _ of Z)
          w.push(_[0], _[1], 0, _[2], _[3], 0);
      } else {
        const W = y - N * T - r, J = G - N * T + r, $ = f + W * R, QA = p + W * i, Z = f + J * R, _ = p + J * i, MA = yg($, QA, Z, _, E);
        for (const [eA, V, H, AA] of MA) {
          const rA = (eA - f) * R + (V - p) * i, BA = (H - f) * R + (AA - p) * i;
          let tA = rA - (rA % m + m) % m;
          for (; tA < BA; )
            for (const nA of j) {
              const wA = Math.abs(nA);
              if (nA > 0) {
                const iA = Math.max(tA, rA), nE = Math.min(tA + wA, BA);
                nE > iA + 1e-9 && w.push(
                  f + iA * R,
                  p + iA * i,
                  0,
                  f + nE * R,
                  p + nE * i,
                  0
                );
              } else nA === 0 && tA >= rA && tA <= BA && c.push(f + tA * R, p + tA * i, 0);
              tA += wA;
            }
        }
      }
    }
    if (w.length / 6 >= Yt) break;
  }
  return { segmentVertices: w, dotPositions: c };
};
function Wa(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!Le(E) || E.boundaryPaths.length === 0) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = CA(E.extrusionDirection);
  if (E.solid) {
    const c = Va(E.boundaryPaths, E.style);
    if (c.length === 0) return !1;
    const n = new I.Vector3();
    for (const a of c) {
      const o = a.extractPoints(12), D = I.ShapeUtils.triangulateShape(o.shape, o.holes);
      if (D.length === 0) continue;
      const R = o.shape.concat(...o.holes), i = [];
      for (const F of R)
        n.set(F.x, F.y, 0), w && n.applyMatrix4(w), g && n.applyMatrix4(g), i.push(n.x, n.y, n.z);
      const C = [];
      for (const F of D)
        C.push(F[0], F[1], F[2]);
      e.addMesh(t, Q, i, C);
    }
    return !0;
  } else {
    let c = E.boundaryPaths.map((R) => Oa(R)).filter((R) => R.length > 2);
    E.style && E.style > 0 && (c = ma(c, E.style));
    const n = E.patternLines && E.patternLines.length > 0, a = n ? E.patternLines : Pa[E.patternName.toUpperCase()], o = n ? 1 : E.patternScale, D = n ? 0 : E.patternAngle;
    if (a && c.length > 0) {
      const { segmentVertices: R, dotPositions: i } = La(
        a,
        c,
        o,
        D,
        n
      );
      if ((w || g) && R.length > 0) {
        const C = new I.Vector3();
        for (let F = 0; F < R.length; F += 3)
          C.set(R[F], R[F + 1], R[F + 2]), w && C.applyMatrix4(w), g && C.applyMatrix4(g), R[F] = C.x, R[F + 1] = C.y, R[F + 2] = C.z;
      }
      if (R.length > 0 && e.addLineSegments(t, Q, R), i.length > 0) {
        if (w || g) {
          const C = new I.Vector3();
          for (let F = 0; F < i.length; F += 3)
            C.set(i[F], i[F + 1], i[F + 2]), w && C.applyMatrix4(w), g && C.applyMatrix4(g), i[F] = C.x, i[F + 1] = C.y, i[F + 2] = C.z;
        }
        e.addPoints(t, Q, i);
      }
    } else
      for (const R of E.boundaryPaths) {
        const i = PB(R);
        i.length > 1 && VA(
          e,
          t,
          Q,
          JA(mE(i, w), g),
          r
        );
      }
    return !0;
  }
}
function Xa(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A, Q = E;
  if (!Q.vertices?.length || Q.vertices.length <= 1 || Q.numElements <= 0) return !1;
  const s = M ?? aA(E, B.layers, B.blockColor), w = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, c = CA(Q.extrusionDirection), n = (Q.flags & 2) !== 0;
  for (let a = 0; a < Q.numElements; a++) {
    const o = [];
    for (const D of Q.vertices) {
      const R = D.elementParams[a]?.params[0] ?? 0;
      o.push(new I.Vector3(
        D.x + R * D.miter.x,
        D.y + R * D.miter.y,
        (D.z || 0) + R * (D.miter.z || 0)
      ));
    }
    n && o.length > 1 && o.push(o[0].clone()), VA(
      e,
      t,
      s,
      JA(mE(o, c), g),
      w
    );
  }
  return !0;
}
function Sg(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A, Q = E;
  if (!Q.basePoint || !Q.direction) return !1;
  const s = M ?? aA(E, B.layers, B.blockColor), w = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, c = Q.basePoint, n = Q.direction, a = B.xlineClipSize ?? 1e3, o = E.type === "RAY" ? 0 : -a, D = [
    new I.Vector3(c.x + o * n.x, c.y + o * n.y, (c.z || 0) + o * (n.z || 0)),
    new I.Vector3(c.x + a * n.x, c.y + a * n.y, (c.z || 0) + a * (n.z || 0))
  ];
  return VA(e, t, s, JA(D, g), w), !0;
}
function Ka(A) {
  const { entity: E, colorCtx: B, collector: e, layer: t, worldMatrix: g, overrideColor: M } = A;
  if (!We(E) || !E.contourBoundary || E.contourBoundary.length === 0) return !1;
  const Q = M ?? aA(E, B.layers, B.blockColor), r = mA(
    E,
    B.layers,
    B.lineTypes,
    B.globalLtScale,
    B.blockLineType,
    B.headerLtScale
  )?.pattern, w = CA(E.contourExtrusionDirection);
  for (const c of E.contourBoundary) {
    const n = PB(c);
    n.length > 1 && VA(
      e,
      t,
      Q,
      JA(mE(n, w), g),
      r
    );
  }
  return !0;
}
function Ve(A, E, B, e, t) {
  const g = eB(A.textStyle, E.styles, E.serifFont, E.font), M = Et(A.textStyle, E.styles), Q = aA(A, E.layers, E.blockColor), s = A.text;
  if (s)
    if (A.type === "TEXT") {
      const r = A.height || A.textHeight || E.defaultTextHeight, w = CA(A.extrusionDirection), n = (A.halign && A.halign > 0 || A.valign && A.valign > 0) && A.endPoint ? A.endPoint : A.position || A.startPoint;
      if (!n) return;
      let a = LA(
        new I.Vector3(n.x, n.y, n.z || 0),
        w
      ), o = A.rotation ? RE(A.rotation) : 0, D = r, R, i;
      if (A.endPoint && A.startPoint) {
        const l = LA(
          new I.Vector3(A.endPoint.x, A.endPoint.y, A.endPoint.z || 0),
          w
        ), T = LA(
          new I.Vector3(A.startPoint.x, A.startPoint.y, A.startPoint.z || 0),
          w
        );
        (A.halign === YA.FIT || A.halign === YA.ALIGNED) && (a = T, R = l.x, i = l.y);
      }
      let C = 1;
      if (t) {
        if (a.applyMatrix4(t), R !== void 0 && i !== void 0) {
          const h = new I.Vector3(R, i, 0).applyMatrix4(t);
          R = h.x, i = h.y;
        }
        const l = t.elements, u = l[0] * l[5] - l[1] * l[4] < 0;
        o += u ? Math.atan2(-l[1], -l[0]) : Math.atan2(l[1], l[0]), D *= Math.sqrt(l[4] * l[4] + l[5] * l[5]), u && E.mirrText && (C = -1);
      }
      const F = OQ(s);
      TA({
        collector: B,
        layer: e,
        color: Q,
        font: g,
        text: F.text,
        height: D,
        posX: a.x,
        posY: a.y,
        posZ: a.z,
        rotation: o,
        hAlign: A.halign ?? YA.LEFT,
        vAlign: A.valign ?? tB.BASELINE,
        // STYLE.widthFactor (DXF code 41) is the fallback when the TEXT entity
        // doesn't carry its own xScale (code 41). Entity-level wins per DXF spec.
        widthFactor: (A.xScale ?? M.widthFactor ?? 1) * C,
        endPosX: R,
        endPosY: i,
        underline: F.underline,
        bold: M.bold,
        italic: M.italic
      });
    } else {
      const r = A.height || A.textHeight || E.defaultTextHeight, w = CA(A.extrusionDirection), c = A.position || A.startPoint;
      if (!c) return;
      let n = LA(
        new I.Vector3(c.x, c.y, c.z || 0),
        w
      ), a = A.rotation ? RE(A.rotation) : 0;
      !A.rotation && A.directionVector && (a = Math.atan2(A.directionVector.y, A.directionVector.x));
      let o = r;
      if (t) {
        n.applyMatrix4(t);
        const R = t.elements, C = R[0] * R[5] - R[1] * R[4] < 0;
        a += C ? Math.atan2(-R[1], -R[0]) : Math.atan2(R[1], R[0]), o *= Math.sqrt(R[4] * R[4] + R[5] * R[5]);
      }
      const D = KQ(s, o, M.widthFactor);
      xs({
        collector: B,
        layer: e,
        color: Q,
        font: g,
        lines: D,
        defaultHeight: o,
        posX: n.x,
        posY: n.y,
        posZ: n.z,
        rotation: a,
        attachmentPoint: A.attachmentPoint,
        // Enable word wrap only when width is meaningful relative to text height.
        // Very small positive widths (< 5% of height) appear in title block MTEXT
        // where width is a scaling artifact, not an intentional column constraint.
        width: A.width && A.width >= o * 0.05 ? A.width : void 0,
        serifFont: E.serifFont,
        lineSpacingFactor: A.lineSpacingFactor,
        bold: M.bold,
        italic: M.italic
      });
    }
}
function Za(A, E, B, e) {
  if (A.invisible) return;
  const t = A.text || A.tag;
  if (!t) return;
  const g = A.horizontalJustification ?? YA.LEFT, M = A.verticalJustification ?? tB.BASELINE, Q = g === YA.FIT || g === YA.ALIGNED, s = g > 0 || M > 0, r = Q ? A.startPoint : s && A.endPoint ? A.endPoint : A.startPoint;
  if (!r) return;
  const w = aA(A, E.layers, E.blockColor), c = A.textHeight || E.defaultTextHeight, n = CA(A.extrusionDirection), a = LA(
    new I.Vector3(r.x, r.y, r.z || 0),
    n
  );
  let o, D;
  if (Q && A.endPoint) {
    const F = LA(
      new I.Vector3(A.endPoint.x, A.endPoint.y, A.endPoint.z || 0),
      n
    );
    o = F.x, D = F.y;
  }
  const R = A.rotation ? RE(A.rotation) : 0, i = eB(A.textStyle, E.styles, E.serifFont, E.font), C = Et(A.textStyle, E.styles);
  TA({
    collector: B,
    layer: e,
    color: w,
    font: i,
    text: PE(t),
    height: c,
    posX: a.x,
    posY: a.y,
    posZ: a.z,
    rotation: R,
    hAlign: g,
    vAlign: M,
    widthFactor: A.scale ?? C.widthFactor,
    endPosX: o,
    endPosY: D,
    obliqueAngle: A.obliqueAngle,
    bold: C.bold,
    italic: C.italic
  });
}
function qa(A, E, B, e, t, g) {
  if (!yE(A)) return;
  const M = eB(A.styleName, B.styles, B.serifFont, B.font), Q = aA(A, B.layers, B.blockColor), s = (A.dimensionType ?? 0) & 15, r = g ? Array.from(g.elements) : void 0, w = g ?? new I.Matrix4(), c = A.styleName ? B.dimStyles?.[A.styleName] : void 0, n = c?.dimtxstyHandle ? B.styleHandleToName?.get(c.dimtxstyHandle) : void 0, a = (n ? B.styles?.[n]?.widthFactor : void 0) ?? 1;
  let o = B.dimVars ?? gt(void 0);
  c && (o = ds(o, c, E.header));
  const D = ks(o, A), R = c?.dimlunit ?? B.headerDimlunit, i = c?.dimzin ?? B.headerDimzin, C = A.dimdec ?? c?.dimdec ?? B.headerDimdec, F = A.dimadec ?? c?.dimadec ?? B.headerDimadec, l = R !== void 0 || i !== void 0 || C !== void 0 || F !== void 0 ? { dimlunit: R, dimzin: i, dimdec: C, dimadec: F } : void 0, T = (f) => f !== void 0 && f > 0 && f <= 255 ? kE(f) : Q, u = T(c?.dimclrd), h = T(c?.dimclre), x = T(c?.dimclrt);
  if (c) {
    const f = c.dimscale, p = E.header?.$DIMSCALE ?? 1, W = (A.dimScale ?? f ?? p) || 1;
    if (c.dimtsz !== void 0 && c.dimtsz > 0)
      D.arrowKind = "tick", D.tickSize = c.dimtsz * W;
    else if (c.dimblkHandle && B.blockHandleToName) {
      const J = B.blockHandleToName.get(c.dimblkHandle);
      D.arrowKind = tt(J) ?? "closed-filled", D.tickSize = D.arrowKind === "tick" ? D.arrowSize : 0;
    } else D.arrowKind === "tick" && c.dimtsz === 0 && (D.arrowKind = "closed-filled", D.tickSize = 0);
  }
  let U = null;
  const z = B.materials.resolveColor(Q), k = E.header?.$DIMSCALE ?? 1, P = c?.dimscale, y = (A.dimScale ?? P ?? k) || 1, G = c?.dimtih, d = c?.dimtoh, S = c?.dimtad ?? B.headerDimtad, v = c?.dimgap ?? B.headerDimgap, j = v !== void 0 ? v * y : void 0, m = c?.dimtmove ?? B.headerDimtmove, b = { entity: A, color: z, textColor: x, font: M, collector: e, layer: t, transform: r, dv: D, fmt: l, dimtih: G, dimtoh: d, dimtad: S, dimgap: j, dimtmove: m, widthFactor: a };
  if ((s & 14) === 6)
    U = Hs(b);
  else if (s === 2)
    U = bs(b);
  else if (s === 3)
    U = Vs(b);
  else if (s === 4)
    U = ms(b);
  else {
    const f = Ss(A, D, l);
    if (!f) return;
    let p = f.angle;
    if (s === 1 && p === 0) {
      const J = f.point2.x - f.point1.x, $ = f.point2.y - f.point1.y;
      p = Math.atan2($, J) * qB / Math.PI;
    }
    if (f.textPos && f.dimensionText && M) {
      const J = FE(M, f.dimensionText, f.textHeight, a), $ = f.textHeight * 0.5;
      D.textGap = Math.max(D.textGap, J + $);
    }
    if (U = [ps({
      point1: f.point1,
      point2: f.point2,
      anchorPoint: f.anchorPoint,
      textPos: f.textPos,
      textHeight: f.textHeight,
      isRadial: f.isRadial,
      color: z,
      angle: p,
      forceRotated: s === 0,
      dv: D
    })], f.textPos) {
      let J = p !== 0 ? RE(p) : 0;
      for (; J > Math.PI / 2; ) J -= Math.PI;
      for (; J < -Math.PI / 2; ) J += Math.PI;
      OA({
        collector: e,
        layer: t,
        color: x,
        font: M,
        rawText: f.dimensionText,
        height: f.textHeight,
        posX: f.textPos.x,
        posY: f.textPos.y,
        posZ: 0.2,
        rotation: J,
        hAlign: "center",
        transform: r,
        widthFactor: a
      });
    }
  }
  const N = (f) => f.userData?.dimPart === "ext" ? h : u;
  if (U)
    for (const f of U)
      if (f instanceof I.Group)
        f.updateMatrixWorld(!0), f.traverse((p) => {
          if (p === f || p instanceof I.Group) return;
          const W = p.geometry;
          if (!W) return;
          const J = W.getAttribute("position");
          if (!J) return;
          const $ = new I.Vector3(), QA = N(p);
          if (p instanceof I.LineSegments || p instanceof I.Line) {
            const Z = J.count;
            for (let _ = 0; _ < Z - 1; _ += p instanceof I.LineSegments ? 2 : 1) {
              $.fromBufferAttribute(J, _).applyMatrix4(p.matrixWorld).applyMatrix4(w);
              const MA = $.x, eA = $.y, V = $.z;
              $.fromBufferAttribute(J, _ + 1).applyMatrix4(p.matrixWorld).applyMatrix4(w), e.addLineSegments(t, QA, [MA, eA, V, $.x, $.y, $.z]);
            }
          } else if (p instanceof I.Mesh) {
            const Z = J.count, _ = [];
            for (let V = 0; V < Z; V++)
              $.fromBufferAttribute(J, V).applyMatrix4(p.matrixWorld).applyMatrix4(w), _.push($.x, $.y, $.z);
            const MA = W.getIndex(), eA = MA ? Array.from(MA.array) : [];
            if (eA.length === 0)
              for (let V = 0; V < Z; V++) eA.push(V);
            e.addOverlayMesh(t, QA, _, eA);
          }
        });
      else {
        const p = f.geometry;
        if (!p) continue;
        const W = p.getAttribute("position");
        if (!W) continue;
        const J = new I.Vector3(), $ = N(f);
        if (f instanceof I.LineSegments || f instanceof I.Line) {
          const QA = W.count;
          for (let Z = 0; Z < QA - 1; Z += f instanceof I.LineSegments ? 2 : 1) {
            J.fromBufferAttribute(W, Z).applyMatrix4(w);
            const _ = J.x, MA = J.y, eA = J.z;
            J.fromBufferAttribute(W, Z + 1).applyMatrix4(w), e.addLineSegments(t, $, [_, MA, eA, J.x, J.y, J.z]);
          }
        } else if (f instanceof I.Mesh) {
          const QA = W.count, Z = [];
          for (let eA = 0; eA < QA; eA++)
            J.fromBufferAttribute(W, eA).applyMatrix4(w), Z.push(J.x, J.y, J.z);
          const _ = p.getIndex(), MA = _ ? Array.from(_.array) : [];
          if (MA.length === 0)
            for (let eA = 0; eA < QA; eA++) MA.push(eA);
          e.addOverlayMesh(t, $, Z, MA);
        }
      }
}
const pg = (A, E = 12) => {
  if (A.length <= 2) return A;
  const B = [], e = A.length;
  for (let t = 0; t < e - 1; t++) {
    const g = A[Math.max(0, t - 1)], M = A[t], Q = A[t + 1], s = A[Math.min(e - 1, t + 2)];
    for (let r = 0; r < E; r++) {
      const w = r / E, c = w * w, n = c * w;
      B.push(new I.Vector3(
        0.5 * (2 * M.x + (-g.x + Q.x) * w + (2 * g.x - 5 * M.x + 4 * Q.x - s.x) * c + (-g.x + 3 * M.x - 3 * Q.x + s.x) * n),
        0.5 * (2 * M.y + (-g.y + Q.y) * w + (2 * g.y - 5 * M.y + 4 * Q.y - s.y) * c + (-g.y + 3 * M.y - 3 * Q.y + s.y) * n),
        0.5 * (2 * M.z + (-g.z + Q.z) * w + (2 * g.z - 5 * M.z + 4 * Q.z - s.z) * c + (-g.z + 3 * M.z - 3 * Q.z + s.z) * n)
      ));
    }
  }
  return B.push(A[e - 1]), B;
}, _a = (A, E, B, e = 24) => {
  const t = E.x - A.x, g = E.y - A.y, M = E.z - A.z, Q = Math.hypot(t, g, M);
  if (Q === 0) return [A.clone(), E.clone()];
  const s = Q / 3, r = new I.Vector3(
    A.x + t / Q * s,
    A.y + g / Q * s,
    A.z + M / Q * s
  ), w = Math.hypot(B.x, B.y, B.z) || 1, c = new I.Vector3(
    E.x - B.x / w * s,
    E.y - B.y / w * s,
    E.z - B.z / w * s
  ), n = [];
  for (let a = 0; a <= e; a++) {
    const o = a / e, D = 1 - o, R = D * D, i = R * D, C = o * o, F = C * o;
    n.push(new I.Vector3(
      i * A.x + 3 * R * o * r.x + 3 * D * C * c.x + F * E.x,
      i * A.y + 3 * R * o * r.y + 3 * D * C * c.y + F * E.y,
      i * A.z + 3 * R * o * r.z + 3 * D * C * c.z + F * E.z
    ));
  }
  return n;
};
function Je(A, E, B, e, t, g) {
  const M = zE(A) ? A.styleName : void 0, Q = eB(M, B.styles, B.serifFont, B.font);
  let s = aA(A, B.layers, B.blockColor);
  const r = g ?? new I.Matrix4(), w = new I.Vector3(), c = (C) => {
    for (let F = 0; F < C.length - 1; F++) {
      w.copy(C[F]).applyMatrix4(r);
      const l = w.x, T = w.y, u = w.z;
      w.copy(C[F + 1]).applyMatrix4(r), e.addLineSegments(t, s, [l, T, u, w.x, w.y, w.z]);
    }
  }, n = (C, F, l, T = "closed-filled") => {
    const u = Mt(s, B.materials), h = YB(s, B.materials), x = lE({ from: C, tip: F, size: l, kind: T, lineMaterial: u, fillMaterial: h });
    for (const U of x) {
      const z = U.geometry, k = z.getAttribute("position"), P = k.count;
      if (U instanceof I.LineSegments) {
        const y = [];
        for (let G = 0; G < P; G++)
          w.fromBufferAttribute(k, G).applyMatrix4(r), y.push(w.x, w.y, w.z);
        e.addLineSegments(t, s, y);
      } else if (U instanceof I.Line) {
        const y = [];
        for (let G = 0; G < P - 1; G++) {
          w.fromBufferAttribute(k, G).applyMatrix4(r);
          const d = w.x, S = w.y, v = w.z;
          w.fromBufferAttribute(k, G + 1).applyMatrix4(r), y.push(d, S, v, w.x, w.y, w.z);
        }
        e.addLineSegments(t, s, y);
      } else if (U instanceof I.Mesh) {
        const y = [];
        for (let S = 0; S < P; S++)
          w.fromBufferAttribute(k, S).applyMatrix4(r), y.push(w.x, w.y, w.z);
        const G = z.getIndex(), d = G ? Array.from(G.array) : [];
        if (d.length === 0)
          for (let S = 0; S < P; S++) d.push(S);
        e.addOverlayMesh(t, s, y, d);
      }
    }
  }, a = zE(A) ? A.styleName : void 0, o = a ? B.dimStyles?.[a] : void 0, D = B.dimVars ?? gt(void 0);
  let R;
  if (B.blockHandleToName) {
    const C = o?.dimldrblkHandle;
    C && (R = B.blockHandleToName.get(C));
  }
  const i = (C, F, l, T) => {
    const u = E.blocks?.[C];
    if (!u?.entities) return !1;
    const h = new I.Matrix4().makeTranslation(F.x, F.y, F.z).multiply(new I.Matrix4().makeRotationZ(l)).multiply(new I.Matrix4().makeScale(T, T, T));
    g && h.premultiply(g);
    for (const x of u.entities)
      if (x.type === "LINE" && "vertices" in x) {
        const U = x.vertices;
        if (U.length >= 2) {
          w.set(U[0].x, U[0].y, U[0].z || 0).applyMatrix4(h);
          const z = w.x, k = w.y, P = w.z;
          w.set(U[1].x, U[1].y, U[1].z || 0).applyMatrix4(h), e.addLineSegments(t, s, [z, k, P, w.x, w.y, w.z]);
        }
      }
    return !0;
  };
  if (A.type === "LEADER" && zE(A) && A.vertices.length >= 2) {
    const C = A.vertices.map(
      (l) => new I.Vector3(l.x, l.y, l.z || 0)
    ), F = A.pathType === 1 ? pg(C) : C;
    if (c(F), A.arrowHeadFlag !== 0 && C.length >= 2) {
      const l = A.arrowSize || D.arrowSize;
      let T = 1;
      for (let x = 1; x < F.length && (T = x, !((F[x].x - F[0].x) ** 2 + (F[x].y - F[0].y) ** 2 >= l * l)); x++)
        ;
      const u = Math.atan2(F[0].y - F[T].y, F[0].x - F[T].x), h = tt(R);
      h !== void 0 ? n(F[T], F[0], l, h) : R && i(R, F[0], u, l) || n(F[T], F[0], l);
    }
  } else if ((A.type === "MULTILEADER" || A.type === "MLEADER") && WB(A) && A.leaders.length > 0) {
    const C = A.styleHandle, F = C && B.mLeaderStyles ? B.mLeaderStyles[C.toUpperCase()] : void 0, l = A.propertyOverrideFlag ?? 0, T = yt(
      A.leaderLineColorRaw,
      (l & 2) !== 0,
      F?.leaderLineColorRaw,
      A,
      B.layers,
      B.blockColor
    ), u = yt(
      A.textColorRaw,
      (l & 32768) !== 0,
      F?.textColorRaw,
      A,
      B.layers,
      B.blockColor
    );
    s = T;
    const h = A.arrowSize || KB, x = A.leaderLineType === 2;
    for (const U of A.leaders)
      for (const z of U.lines) {
        const k = z.vertices.map(
          (y) => new I.Vector3(y.x, y.y, y.z || 0)
        );
        if (U.lastLeaderPoint && k.push(new I.Vector3(
          U.lastLeaderPoint.x,
          U.lastLeaderPoint.y,
          U.lastLeaderPoint.z || 0
        )), k.length < 2) continue;
        let P = k;
        x && (k.length === 2 && U.doglegVector ? P = _a(
          k[0],
          k[1],
          new I.Vector3(
            U.doglegVector.x,
            U.doglegVector.y,
            U.doglegVector.z || 0
          )
        ) : k.length >= 3 && (P = pg(k))), c(P), A.hasArrowHead !== !1 && P.length >= 2 && n(P[1], P[0], h);
      }
    if (A.text && A.textPosition) {
      const U = A.textHeight || B.defaultTextHeight, z = PE(A.text);
      if (z) {
        let k = A.textPosition.x, P = A.textPosition.y;
        g && (w.set(k, P, 0).applyMatrix4(g), k = w.x, P = w.y), TA({
          collector: e,
          layer: t,
          color: u,
          font: Q,
          text: z,
          height: U,
          posX: k,
          posY: P,
          posZ: 0,
          hAlign: YA.LEFT,
          vAlign: tB.MIDDLE
        });
      }
    }
  }
}
const $a = 10, Ao = 16, Eo = () => new Promise((A) => setTimeout(A, 0)), Pg = /* @__PURE__ */ new Set([
  "LINE",
  "CIRCLE",
  "ARC",
  "ELLIPSE",
  "LWPOLYLINE",
  "POLYLINE",
  "SPLINE",
  "POINT",
  "SOLID",
  "3DFACE",
  "HATCH",
  "MLINE",
  "XLINE",
  "RAY"
]);
function vg(A, E, B, e, t) {
  for (const g of A) {
    if (g.invisible) continue;
    const M = g.text;
    if (!M) continue;
    const Q = aA(g, E.layers, t), s = g.textHeight || E.defaultTextHeight, r = g.horizontalJustification ?? YA.LEFT, w = r === YA.FIT || r === YA.ALIGNED, c = g.horizontalJustification && g.horizontalJustification > 0 || g.verticalJustification && g.verticalJustification > 0, n = w ? g.startPoint : c && g.endPoint ? g.endPoint : g.startPoint;
    if (!n) continue;
    const a = CA(g.extrusionDirection), o = LA(
      new I.Vector3(n.x, n.y, 0),
      a
    );
    let D, R;
    if (w && g.endPoint) {
      const l = LA(
        new I.Vector3(g.endPoint.x, g.endPoint.y, g.endPoint.z || 0),
        a
      );
      D = l.x, R = l.y;
    }
    const i = g.rotation ? RE(g.rotation) : 0, C = eB(g.textStyle, E.styles, E.serifFont, E.font), F = Et(g.textStyle, E.styles);
    TA({
      collector: B,
      layer: e,
      color: Q,
      font: C,
      text: PE(M),
      height: s,
      posX: o.x,
      posY: o.y,
      posZ: o.z,
      rotation: i,
      hAlign: r,
      vAlign: g.verticalJustification ?? tB.BASELINE,
      widthFactor: g.scale ?? F.widthFactor,
      endPosX: D,
      endPosY: R,
      obliqueAngle: g.obliqueAngle,
      bold: F.bold,
      italic: F.italic
    });
  }
}
async function be(A, E, B, e, t, g, M, Q, s, r, w, c, n) {
  if (!yE(A)) return;
  if ((A.block && E.blocks ? E.blocks[A.block] : void 0)?.entities?.length) {
    const o = {
      type: "INSERT",
      name: A.block,
      position: { x: 0, y: 0, z: 0 },
      xScale: 1,
      yScale: 1,
      zScale: 1,
      rotation: 0,
      columnCount: 1,
      rowCount: 1,
      layer: A.layer,
      colorIndex: A.colorIndex,
      color: A.color,
      handle: A.handle
    };
    await vB(
      o,
      E,
      B,
      e,
      t,
      g,
      M,
      Q,
      s,
      r,
      w,
      c,
      n
    );
    return;
  }
  qa(A, E, B, e, t, g ?? void 0);
}
async function vB(A, E, B, e, t, g, M, Q, s, r, w, c, n) {
  if (Q > $a || !tE(A) || !E.blocks || typeof E.blocks != "object") return;
  const a = E.blocks[A.name];
  if (!a?.entities?.length) return;
  const o = A.columnCount ?? 1, D = A.rowCount ?? 1, R = A.columnSpacing ?? 0, i = A.rowSpacing ?? 0, C = aA(A, B.layers, B.blockColor), F = {
    ...B,
    blockColor: C,
    blockLineType: A.lineType || B.blockLineType
  };
  for (let l = 0; l < D; l++)
    for (let T = 0; T < o; T++) {
      const u = A.position, h = E.header?.$INSUNITS ?? 0, U = E.tables?.blockRecord?.blockRecords?.[A.name]?.units ?? 0, z = bg(h, U), k = new I.Matrix4().compose(
        new I.Vector3(
          u.x + T * R,
          u.y + l * i,
          u.z || 0
        ),
        new I.Quaternion().setFromAxisAngle(
          new I.Vector3(0, 0, 1),
          A.rotation ? RE(A.rotation) : 0
        ),
        new I.Vector3(
          (A.xScale || 1) * z,
          (A.yScale || 1) * z,
          (A.zScale || 1) * z
        )
      ), P = CA(A.extrusionDirection);
      P && k.premultiply(P);
      const y = g ? new I.Matrix4().multiplyMatrices(g, k) : k, G = r?.get(A.name);
      if (G) {
        const d = w?.get(A.name);
        d ? Zs(d, M, t, C, y, B, B.originOffset) : Xs(G, e, t, C, y);
        for (const S of G.fallbackEntityIndices) {
          const v = a.entities[S];
          if (v.visible !== !1)
            try {
              const j = !v.layer || v.layer === "0" ? t : v.layer;
              if (v.type === "INSERT" && tE(v)) {
                await vB(v, E, F, e, j, y, M, Q + 1, s, r, w, c, n);
                continue;
              }
              if (Pg.has(v.type) && c({ entity: v, colorCtx: F, collector: e, layer: j, worldMatrix: y }))
                continue;
              if ((v.type === "TEXT" || v.type === "MTEXT") && YE(v)) {
                Ve(v, F, e, j, y);
                continue;
              }
              if (v.type === "DIMENSION" && yE(v)) {
                await be(
                  v,
                  E,
                  F,
                  e,
                  j,
                  y,
                  M,
                  Q + 1,
                  s,
                  r,
                  w,
                  c,
                  n
                );
                continue;
              }
              if (v.type === "LEADER" || v.type === "MULTILEADER" || v.type === "MLEADER") {
                Je(v, E, F, e, j, y);
                continue;
              }
            } catch (j) {
              console.warn(`Error processing fallback entity in block "${A.name}":`, j);
            }
        }
        l === 0 && T === 0 && A.attribs && A.attribs.length > 0 && vg(A.attribs, B, e, t, C);
        continue;
      }
      for (const d of a.entities)
        if (d.visible !== !1) {
          try {
            const S = !d.layer || d.layer === "0" ? t : d.layer;
            if (d.type === "INSERT" && tE(d)) {
              await vB(d, E, F, e, S, y, M, Q + 1, s, r, w, c, n);
              continue;
            }
            if (Pg.has(d.type) && c({ entity: d, colorCtx: F, collector: e, layer: S, worldMatrix: y }))
              continue;
            if ((d.type === "TEXT" || d.type === "MTEXT") && YE(d)) {
              Ve(d, F, e, S, y);
              continue;
            }
            if (d.type === "DIMENSION" && yE(d)) {
              await be(
                d,
                E,
                F,
                e,
                S,
                y,
                M,
                Q + 1,
                s,
                r,
                w,
                c,
                n
              );
              continue;
            }
            if (d.type === "LEADER" || d.type === "MULTILEADER" || d.type === "MLEADER") {
              Je(d, E, F, e, S, y);
              continue;
            }
          } catch (S) {
            console.warn(`Error processing entity in block "${A.name}":`, S);
          }
          if (performance.now() - s.lastYield > Ao) {
            if (s.signal?.aborted) return;
            await Eo(), s.lastYield = performance.now();
          }
        }
      l === 0 && T === 0 && A.attribs && A.attribs.length > 0 && vg(A.attribs, B, e, t, C);
    }
}
const Bo = {
  LINE: la,
  CIRCLE: xa,
  ARC: Ta,
  ELLIPSE: ha,
  SPLINE: ua,
  LWPOLYLINE: dg,
  POLYLINE: dg,
  POINT: Ga,
  SOLID: ya,
  "3DFACE": pa,
  HATCH: Wa,
  MLINE: Xa,
  XLINE: Sg,
  RAY: Sg,
  REGION: Ka
};
function DB(A) {
  const E = Bo[A.entity.type];
  return E ? E(A) : !1;
}
const eo = /* @__PURE__ */ new Set([
  "LINE",
  "CIRCLE",
  "ARC",
  "ELLIPSE",
  "LWPOLYLINE",
  "POLYLINE",
  "SPLINE",
  "POINT",
  "SOLID",
  "3DFACE",
  "HATCH",
  "MLINE",
  "XLINE",
  "RAY",
  "REGION"
]), to = /* @__PURE__ */ new Set([
  "VIEWPORT",
  "IMAGE",
  "WIPEOUT",
  "3DSOLID",
  "REGION"
]), go = () => new Promise((A) => setTimeout(A, 0)), Mo = 16;
async function fi(A, E) {
  gs(), ss();
  const B = E?.signal, e = E?.onProgress, t = E?.darkTheme, g = E?.font ?? Ra(), M = new I.Group();
  if (!A.entities || A.entities.length === 0)
    return console.warn("DXF does not contain entities!"), { group: M, materials: new St(), originOffset: { x: 0, y: 0, z: 0 } };
  const Q = {};
  A.tables?.layer?.layers && Object.assign(Q, A.tables.layer.layers);
  const s = A.tables?.lineType?.lineTypes ?? {}, r = A.header?.$LTSCALE ?? 1, w = r === 1 ? JQ(A.header, s) : r, c = A.header?.$PDMODE ?? 0, n = c !== 0 ? da(A.header) : void 0, a = gt(A.header), o = A.header?.$TEXTSIZE, D = o && o > 0 ? o : UQ, R = A.header?.$MIRRTEXT === 1, i = A.tables?.style?.styles;
  let C;
  if (g) {
    let V = !1;
    if (i && (V = Object.values(i).some(
      (H) => H.fontFile && zB(H.fontFile) === "serif"
    )), !V) {
      const H = /\\f([^|;]*)/g, AA = (rA) => {
        let BA;
        for (; (BA = H.exec(rA)) !== null; )
          if (zB(BA[1]) === "serif") return !0;
        return !1;
      };
      for (const rA of A.entities)
        if (rA.type === "MTEXT" && YE(rA) && rA.text && AA(rA.text)) {
          V = !0;
          break;
        }
      if (!V && A.blocks) {
        A:
          for (const rA of Object.values(A.blocks))
            for (const BA of rA.entities ?? [])
              if (BA.type === "MTEXT" && YE(BA) && BA.text && AA(BA.text)) {
                V = !0;
                break A;
              }
      }
    }
    V && (C = await Ca());
  }
  const F = A.tables?.dimStyle?.dimStyles, l = A.objects?.mLeaderStyles, T = A.header?.$DIMLUNIT, u = A.header?.$DIMDEC, h = A.header?.$DIMADEC, x = A.header?.$DIMZIN, U = A.header?.$DIMTAD, z = A.header?.$DIMTIH, k = A.header?.$DIMTOH, P = A.header?.$DIMGAP, y = A.header?.$DIMTMOVE;
  let G;
  const d = A.tables?.blockRecord?.blockRecords;
  if (d) {
    G = /* @__PURE__ */ new Map();
    for (const V of Object.values(d))
      V.handle && G.set(V.handle, V.name);
  }
  let S;
  const v = A.tables?.style?.styles;
  if (v) {
    S = /* @__PURE__ */ new Map();
    for (const V of Object.values(v))
      V.handle && S.set(V.handle.toUpperCase(), V.name);
  }
  const j = new St();
  j.darkTheme = t ?? !1;
  const m = {
    layers: Q,
    materials: j,
    lineTypes: s,
    globalLtScale: w,
    headerLtScale: r,
    font: g,
    serifFont: C,
    styles: i,
    pdMode: c,
    pointDisplaySize: n,
    dimVars: a,
    defaultTextHeight: D,
    mirrText: R,
    dimStyles: F,
    mLeaderStyles: l,
    headerDimlunit: T,
    headerDimdec: u,
    headerDimadec: h,
    headerDimzin: x,
    headerDimtad: U,
    headerDimtih: z,
    headerDimtoh: k,
    headerDimgap: P,
    headerDimtmove: y,
    blockHandleToName: G,
    styleHandleToName: S
  }, b = A.header?.$EXTMIN, N = A.header?.$EXTMAX;
  if (b && N && N.x > b.x && N.y > b.y) {
    const V = N.x - b.x, H = N.y - b.y;
    m.xlineClipSize = Math.sqrt(V * V + H * H) * 2;
  }
  const f = { x: 0, y: 0, z: 0 };
  b && N && N.x > b.x && N.y > b.y && (f.x = (b.x + N.x) / 2, f.y = (b.y + N.y) / 2), m.originOffset = f;
  const p = new bA(f), W = [], J = [], $ = { lastYield: performance.now(), signal: B }, QA = /* @__PURE__ */ new Map();
  for (const V of A.entities)
    V.type === "INSERT" && !V.inPaperSpace && tE(V) && QA.set(V.name, (QA.get(V.name) ?? 0) + 1);
  if (A.blocks) {
    const V = /* @__PURE__ */ new Set(), H = [...QA.keys()];
    for (; H.length > 0; ) {
      const AA = H.shift();
      if (V.has(AA)) continue;
      V.add(AA);
      const rA = QA.get(AA) ?? 0;
      if (rA === 0) continue;
      const BA = A.blocks[AA];
      if (BA?.entities)
        for (const tA of BA.entities)
          tA.type === "INSERT" && tE(tA) && (QA.set(tA.name, (QA.get(tA.name) ?? 0) + rA), V.has(tA.name) || H.push(tA.name));
    }
  }
  const Z = /* @__PURE__ */ new Map();
  if (A.blocks) {
    for (const [V, H] of QA)
      if (H >= js) {
        const AA = A.blocks[V];
        AA?.entities?.length && Z.set(V, Ws(V, AA.entities, m, DB));
      }
  }
  const _ = /* @__PURE__ */ new Map();
  for (const [V, H] of Z)
    _.set(V, Ks(H));
  for (let V = 0; V < A.entities.length; V++) {
    if (B?.aborted)
      return m.materials.disposeAll(), { group: M, materials: j, originOffset: f };
    const H = A.entities[V];
    performance.now() - $.lastYield > Mo && (e?.(V / A.entities.length), await go(), $.lastYield = performance.now());
    try {
      if (H.inPaperSpace || H.visible === !1) continue;
      const AA = H.layer || "0";
      if (H.type === "INSERT") {
        await vB(H, A, m, p, AA, null, M, 0, $, Z, _, DB, void 0);
        continue;
      }
      if (eo.has(H.type) && DB({ entity: H, colorCtx: m, collector: p, layer: AA }))
        continue;
      if ((H.type === "TEXT" || H.type === "MTEXT") && YE(H)) {
        Ve(H, m, p, AA);
        continue;
      }
      if (H.type === "ATTDEF" && Og(H)) {
        Za(H, m, p, AA);
        continue;
      }
      if (H.type === "DIMENSION" && yE(H)) {
        await be(
          H,
          A,
          m,
          p,
          AA,
          null,
          M,
          0,
          $,
          Z,
          _,
          DB,
          void 0
        );
        continue;
      }
      if (H.type === "LEADER" || H.type === "MULTILEADER" || H.type === "MLEADER") {
        Je(H, A, m, p, AA);
        continue;
      }
      if (to.has(H.type))
        continue;
      J.push(`Entity ${V}: ${H.type || "unknown type"}`);
    } catch (AA) {
      const rA = AA instanceof Error ? AA.message : "Unknown error";
      W.push(`Entity ${V} (${H.type || "unknown type"}): ${rA}`);
    }
  }
  if (e?.(1), B?.aborted)
    return m.materials.disposeAll(), { group: M, materials: j, originOffset: f };
  const MA = p.flush(m.materials);
  for (const V of MA)
    M.add(V);
  M.children.sort((V, H) => V.renderOrder - H.renderOrder);
  const eA = W.length + J.length;
  if (eA > 0) {
    const V = [];
    W.length > 0 && V.push(
      `${W.length} errors: ${W.slice(0, 2).join("; ")}${W.length > 2 ? "..." : ""}`
    ), J.length > 0 && V.push(
      `${J.length} unsupported types: ${J.slice(0, 2).join("; ")}${J.length > 2 ? "..." : ""}`
    );
    const H = `Failed to process ${eA} of ${A.entities.length} objects. ${V.join(", ")}`;
    return {
      group: M,
      materials: j,
      originOffset: f,
      warnings: H,
      unsupportedEntities: J.length > 0 ? J : void 0
    };
  }
  return { group: M, materials: j, originOffset: f };
}
const Qo = 10;
function Ui(A) {
  const E = [], B = { instancePath: "", instanceCounter: { n: 0 } };
  for (const g of A.entities ?? [])
    g.inPaperSpace || g.visible !== !1 && Oe(g, A, null, g.layer || "0", E, 0, B);
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  for (const g of E) {
    t.has(g.id) || t.set(g.id, g);
    let M = e.get(g.handle);
    M || (M = [], e.set(g.handle, M)), M.push(g);
  }
  return { entries: E, byHandle: e, byId: t };
}
function Oe(A, E, B, e, t, g, M) {
  const Q = !A.layer || A.layer === "0" ? e : A.layer;
  if (A.type === "INSERT" && tE(A)) {
    if (g > Qo) return;
    so(A, E, B, Q, t, g, M);
    return;
  }
  const s = tQ(A.handle);
  if (!s) return;
  const r = ro(A);
  if (!r || r.isEmpty()) return;
  const w = "extrusionDirection" in A ? CA(A.extrusionDirection) : null, c = Fo(B, w), n = c ? r.clone().applyMatrix4(c) : r.clone(), o = { id: M.instancePath ? `${s}@${M.instancePath}` : s, handle: s, type: A.type, layer: Q, bbox: n };
  c && (o.worldMatrix = c), t.push(o);
}
function so(A, E, B, e, t, g, M) {
  if (!tE(A)) return;
  const s = E.blocks?.[A.name]?.entities ?? [], r = A.columnCount ?? 1, w = A.rowCount ?? 1, c = A.columnSpacing ?? 0, n = A.rowSpacing ?? 0, a = E.header?.$INSUNITS ?? 0, D = E.tables?.blockRecord?.blockRecords?.[A.name]?.units ?? 0, R = bg(a, D);
  for (let i = 0; i < w; i++)
    for (let C = 0; C < r; C++) {
      const F = A.position, l = new I.Matrix4().compose(
        new I.Vector3(
          F.x + C * c,
          F.y + i * n,
          F.z || 0
        ),
        new I.Quaternion().setFromAxisAngle(
          new I.Vector3(0, 0, 1),
          A.rotation ? RE(A.rotation) : 0
        ),
        new I.Vector3(
          (A.xScale ?? 1) * R,
          (A.yScale ?? 1) * R,
          (A.zScale ?? 1) * R
        )
      ), T = CA(A.extrusionDirection);
      T && l.premultiply(T);
      const u = B ? new I.Matrix4().multiplyMatrices(B, l) : l, h = tQ(A.handle), x = t.length, U = w > 1 || r > 1 ? `:${i}:${C}` : "", z = (h ?? `i${++M.instanceCounter.n}`) + U, k = {
        instancePath: M.instancePath ? `${M.instancePath}/${z}` : z,
        instanceCounter: M.instanceCounter
      };
      for (const P of s)
        P.visible !== !1 && Oe(P, E, u, e, t, g + 1, k);
      if (i === 0 && C === 0 && A.attribs?.length)
        for (const P of A.attribs)
          P.invisible || Oe(P, E, u, e, t, g + 1, k);
      if (h && t.length - x > 0) {
        const y = new I.Box3();
        for (let G = x; G < t.length; G++)
          y.union(t[G].bbox);
        if (!y.isEmpty()) {
          const G = M.instancePath ? `${h}@${M.instancePath}${U}` : h + U, d = [];
          for (let S = x; S < t.length; S++) d.push(t[S].id);
          t.push({
            id: G,
            handle: h,
            type: "INSERT",
            layer: e,
            bbox: y,
            worldMatrix: u,
            childIds: d
          });
        }
      }
    }
}
function ro(A) {
  if (HB(A))
    return PA([A.vertices[0], A.vertices[1]]);
  if (VB(A)) {
    const E = A.center, B = A.radius;
    return new I.Box3(
      new I.Vector3(E.x - B, E.y - B, (E.z ?? 0) - B),
      new I.Vector3(E.x + B, E.y + B, (E.z ?? 0) + B)
    );
  }
  if (mB(A))
    return no(A.center, A.radius, A.startAngle, A.endAngle);
  if (JB(A))
    return co(A);
  if (OB(A))
    return PA(A.vertices);
  if (bB(A)) {
    const E = A.fitPoints?.length ? A.fitPoints : A.controlPoints;
    return E?.length ? PA(E) : null;
  }
  if (je(A)) {
    const E = A.position, B = E.z ?? 0;
    return new I.Box3(
      new I.Vector3(E.x, E.y, B),
      new I.Vector3(E.x, E.y, B)
    );
  }
  if (jB(A))
    return PA(A.points);
  if (LB(A))
    return PA(A.vertices);
  if (Le(A))
    return Hg(A);
  if (We(A))
    return A.contourBoundary?.length ? Hg({ boundaryPaths: A.contourBoundary }) : null;
  if (Xe(A))
    return PA(A.vertices);
  if (cQ(A))
    return null;
  if (YE(A))
    return ao(A, A.type);
  if (Og(A) || aQ(A)) {
    const E = A.startPoint ?? A.endPoint;
    if (!E) return null;
    const B = A.textHeight ?? 1, e = (A.text ?? A.tag ?? "").length * B * 0.6;
    return new I.Box3(
      new I.Vector3(E.x, E.y, 0),
      new I.Vector3(E.x + e, E.y + B, 0)
    );
  }
  if (yE(A))
    return Io(A);
  if (zE(A))
    return PA(A.vertices);
  if (WB(A)) {
    const E = [];
    for (const B of A.leaders ?? []) {
      for (const e of B.lines ?? [])
        E.push(...e.vertices);
      B.lastLeaderPoint && E.push(B.lastLeaderPoint);
    }
    return A.textPosition && E.push(A.textPosition), E.length ? PA(E) : null;
  }
  return null;
}
function PA(A) {
  if (!A.length) return null;
  const E = new I.Box3();
  for (const B of A)
    E.expandByPoint(new I.Vector3(B.x, B.y, B.z ?? 0));
  return E;
}
function no(A, E, B, e) {
  const t = Math.PI * 2, g = A.z ?? 0, M = A.x, Q = A.y, s = Ng(B), r = Ng(e), w = new I.Box3();
  w.expandByPoint(Te(M, Q, E, s, g)), w.expandByPoint(Te(M, Q, E, r, g));
  const c = [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2];
  for (const n of c)
    wo(n, s, r, t) && w.expandByPoint(Te(M, Q, E, n, g));
  return w;
}
function Ng(A) {
  const E = Math.PI * 2;
  let B = A % E;
  return B < 0 && (B += E), B;
}
function Te(A, E, B, e, t) {
  return new I.Vector3(A + B * Math.cos(e), E + B * Math.sin(e), t);
}
function wo(A, E, B, e) {
  if (E === B) return !0;
  const t = (B - E + e) % e, g = (A - E + e) % e;
  return g > 0 && g < t;
}
function co(A) {
  const E = A.center, B = A.majorAxisEndPoint, e = Math.hypot(B.x, B.y), t = e * (A.axisRatio || 1), g = Math.max(e, t), M = E.z ?? 0;
  return new I.Box3(
    new I.Vector3(E.x - g, E.y - g, M),
    new I.Vector3(E.x + g, E.y + g, M)
  );
}
function Hg(A) {
  const E = [];
  for (const B of A.boundaryPaths ?? []) {
    B.polylineVertices?.length && E.push(...B.polylineVertices);
    for (const e of B.edges ?? []) {
      const t = e;
      t.start && E.push(t.start), t.end && E.push(t.end), t.center && t.radius && E.push(
        { x: t.center.x - t.radius, y: t.center.y - t.radius, z: t.center.z ?? 0 },
        { x: t.center.x + t.radius, y: t.center.y + t.radius, z: t.center.z ?? 0 }
      );
    }
  }
  return E.length ? PA(E) : null;
}
function ao(A, E) {
  const e = E === "TEXT" && ((A.halign ?? 0) !== 0 || (A.valign ?? 0) !== 0) && A.endPoint != null ? A.endPoint : A.position ?? A.startPoint ?? A.endPoint;
  if (!e) return null;
  const t = A.height ?? A.textHeight ?? 1, g = A.text ?? "", M = E === "MTEXT" ? g.split(/\\P/) : [g], Q = M.map(io), s = E === "TEXT" ? A.xScale ?? 1 : 1, r = t * 0.7 * s, w = E === "MTEXT" && A.width && A.width > 0 ? A.width : 1 / 0;
  let c = 1, n = 0, a = 0;
  for (let l = 0; l < M.length; l++) {
    const T = oo(M[l], c, t);
    c = T.endingMul;
    const u = r * T.maxMul, h = Q[l].length * u, x = t * T.maxMul * (5 / 3), U = /\s/.test(Q[l]);
    let z;
    w === 1 / 0 || h <= w || !U ? z = 1 : z = Math.max(1, Math.ceil(h * 1.3 / w)), n += x * z;
    const k = !U || w === 1 / 0 ? h : Math.min(h, w);
    k > a && (a = k);
  }
  n <= 0 && (n = t * (5 / 3));
  const o = a > 0 ? a : r, D = t * 0.7;
  let R = 0, i = o, C = -n, F = 0;
  if (E === "MTEXT") {
    const l = A.attachmentPoint ?? 1, T = (l - 1) % 3, u = Math.floor((l - 1) / 3);
    T === 0 ? (R = 0, i = o) : T === 1 ? (R = -o / 2, i = o / 2) : (R = -o, i = 0), u === 0 ? (F = 0, C = -n) : u === 1 ? (F = n / 2, C = -n / 2) : (F = n, C = 0);
  } else {
    const l = A.halign ?? 0, T = A.valign ?? 0;
    l === 1 || l === 4 ? (R = -o / 2, i = o / 2) : l === 2 ? (R = -o, i = 0) : (R = 0, i = o), T === 0 || T === 1 ? (C = 0, F = t) : T === 2 ? (C = -t / 2, F = t / 2) : (C = -t, F = 0);
  }
  return new I.Box3(
    new I.Vector3(e.x + R - D, e.y + C, 0),
    new I.Vector3(e.x + i + D, e.y + F, 0)
  );
}
function oo(A, E, B) {
  let e = E, t = E;
  const g = /\\H([\d.]+)(x?);/g;
  let M;
  for (; (M = g.exec(A)) !== null; ) {
    const Q = parseFloat(M[1]);
    !isFinite(Q) || Q <= 0 || (e = M[2] === "x" ? e * Q : Q / B, e > t && (t = e));
  }
  return { endingMul: e, maxMul: t };
}
function io(A) {
  return A.replace(/\\[LOlo]/g, "").replace(/\\[A-Za-z][^\\;]*;/g, "").replace(/[{}]/g, "").replace(/\\~/g, " ").replace(/%%[a-zA-Z0-9]/g, "X");
}
function Io(A) {
  const E = [];
  for (const B of [
    "anchorPoint",
    "middleOfText",
    "insertionPoint",
    "linearOrAngularPoint1",
    "linearOrAngularPoint2",
    "diameterOrRadiusPoint",
    "arcPoint"
  ]) {
    const e = A[B];
    e && E.push(e);
  }
  return E.length ? PA(E) : null;
}
function Fo(A, E) {
  return !A && !E ? null : A ? E ? new I.Matrix4().multiplyMatrices(A, E) : A : E;
}
function tQ(A) {
  return A == null ? null : typeof A == "string" ? A : A.toString(16).toUpperCase();
}
const he = 0.5;
function zi(A, E) {
  const B = new I.Group();
  B.name = "dxf-picking-group", B.visible = !1, B.userData.isPickingGroup = !0;
  const e = E?.x ?? 0, t = E?.y ?? 0, g = E?.z ?? 0, M = new I.MeshBasicMaterial({
    visible: !1,
    depthWrite: !1,
    depthTest: !1,
    side: I.DoubleSide
  });
  for (const Q of A.entries) {
    const s = new I.Vector3();
    Q.bbox.getSize(s);
    const r = new I.Vector3();
    Q.bbox.getCenter(r);
    const w = Math.max(s.x, he), c = Math.max(s.y, he), n = Math.max(s.z, he), a = new I.BoxGeometry(w, c, n), o = new I.Mesh(a, M);
    o.position.set(r.x - e, r.y - t, r.z - g), o.frustumCulled = !1, o.userData.pickId = Q.id, o.userData.handle = Q.handle, o.userData.dxfType = Q.type, o.userData.layerName = Q.layer, B.add(o);
  }
  return B;
}
function Yi(A) {
  A.traverse((E) => {
    if (E instanceof I.Mesh) {
      E.geometry.dispose();
      const B = E.userData.debugMaterial;
      B && B.dispose();
    }
  }), A.clear();
}
function ki(A, E) {
  A.visible = E, A.traverse((B) => {
    if (B instanceof I.Mesh)
      if (E) {
        let e = B.userData.debugMaterial;
        e || (e = new I.MeshBasicMaterial({
          color: 16711935,
          wireframe: !0,
          transparent: !0,
          opacity: 0.4,
          depthTest: !1,
          depthWrite: !1
        }), B.userData.debugMaterial = e, B.userData.realMaterial = B.material), B.material = e;
      } else {
        const e = B.userData.realMaterial;
        e && (B.material = e);
      }
  });
}
function Qe(A) {
  const E = /* @__PURE__ */ new Map();
  for (const B of A.entities ?? [])
    if (ue(B, E), tE(B) && B.attribs)
      for (const e of B.attribs)
        ue(e, E);
  if (A.blocks)
    for (const B of Object.values(A.blocks))
      for (const e of B.entities ?? [])
        ue(e, E);
  return E;
}
function ue(A, E) {
  const B = Ro(A.handle);
  B && !E.has(B) && E.set(B, A);
}
function Ro(A) {
  return A == null ? null : typeof A == "string" ? A : A.toString(16).toUpperCase();
}
function uB(A) {
  switch (A.type) {
    case "TEXT":
    case "MTEXT":
      return A.text;
    case "ATTRIB":
    case "ATTDEF":
      return A.text ?? A.tag;
    case "DIMENSION":
      return A.text;
    case "MULTILEADER":
    case "MLEADER":
      return A.text;
    default:
      return;
  }
}
function di(A, E) {
  const B = Co(A);
  if (B === null)
    return { polylines: [], fallbackToBBox: !0 };
  if (B.length === 0)
    return { polylines: [], fallbackToBBox: !1 };
  if (E)
    for (const e of B)
      for (const t of e) t.applyMatrix4(E);
  return { polylines: B, fallbackToBBox: !1 };
}
function Co(A) {
  if (HB(A)) {
    const E = A.vertices[0], B = A.vertices[1];
    return !E || !B ? null : [[UA(E), UA(B)]];
  }
  if (VB(A)) {
    const E = A.center;
    return [$M(E.x, E.y, E.z ?? 0, A.radius)];
  }
  if (mB(A)) {
    const E = A.center;
    return [
      AQ(E.x, E.y, E.z ?? 0, A.radius, A.startAngle, A.endAngle)
    ];
  }
  if (JB(A)) {
    const E = A.center, B = A.majorAxisEndPoint, e = nB(
      E.x,
      E.y,
      E.z ?? 0,
      B.x,
      B.y,
      A.axisRatio,
      A.startAngle,
      A.endAngle
    );
    return e.length > 0 ? [e] : null;
  }
  if (OB(A)) {
    const E = BQ(A);
    return E.length > 1 ? [E] : null;
  }
  if (bB(A)) {
    const E = EQ(A);
    return E && E.length > 1 ? [E] : null;
  }
  if (jB(A)) {
    const E = A.points;
    return [[UA(E[0]), UA(E[1]), UA(E[3]), UA(E[2]), UA(E[0])]];
  }
  if (LB(A)) {
    const E = A.vertices;
    if (E.length < 3) return null;
    const B = E.map(UA);
    return B.push(UA(E[0])), [B];
  }
  if (Le(A)) {
    const E = [];
    for (const B of A.boundaryPaths ?? []) {
      const e = PB(B);
      e.length > 1 && E.push(e);
    }
    return E.length > 0 ? E : null;
  }
  if (We(A)) {
    if (!A.contourBoundary?.length) return null;
    const E = [];
    for (const B of A.contourBoundary) {
      const e = PB(B);
      e.length > 1 && E.push(e);
    }
    return E.length > 0 ? E : null;
  }
  if (Xe(A)) {
    const E = A.vertices.map(UA);
    return E.length > 1 ? [E] : null;
  }
  if (zE(A)) {
    const E = A.vertices.map(UA);
    return E.length > 1 ? [E] : null;
  }
  if (WB(A)) {
    const E = [];
    for (const B of A.leaders ?? [])
      for (const e of B.lines ?? []) {
        const t = e.vertices.map(UA);
        t.length > 1 && E.push(t);
      }
    return E.length > 0 ? E : null;
  }
  return A.type === "XLINE" || A.type === "RAY" ? [] : null;
}
function UA(A) {
  return new I.Vector3(A.x, A.y, A.z ?? 0);
}
const Do = {
  endpoint: 0,
  midpoint: 1,
  center: 2,
  node: 2,
  quadrant: 3
};
function lo(A, E) {
  const B = xo(A);
  if (E && B.length > 0) {
    const e = new I.Vector3();
    for (const t of B)
      e.set(t.point.x, t.point.y, t.point.z ?? 0).applyMatrix4(E), t.point = { x: e.x, y: e.y, z: e.z };
  }
  return B;
}
function Gi(A, E, B, e, t) {
  if (!Number.isFinite(e) || e <= 0) return null;
  const g = t?.types, M = t?.visibleLayers, Q = e * e;
  let s = 1 / 0, r = 1 / 0, w = null;
  for (const c of A.entries) {
    if (c.type === "INSERT" || M && !M.has(c.layer)) continue;
    const n = c.bbox;
    if (B.x < n.min.x - e || B.x > n.max.x + e || B.y < n.min.y - e || B.y > n.max.y + e) continue;
    const a = E.get(c.handle);
    if (!a) continue;
    const o = lo(a, c.worldMatrix ?? null);
    for (const D of o) {
      if (g && !g.includes(D.type)) continue;
      const R = D.point.x - B.x, i = D.point.y - B.y, C = R * R + i * i;
      if (C > Q) continue;
      const F = Do[D.type];
      (F < s || F === s && C < r) && (s = F, r = C, w = {
        type: D.type,
        point: D.point,
        handle: c.handle,
        distance: Math.sqrt(C)
      });
    }
  }
  return w;
}
function xo(A) {
  if (HB(A)) {
    const E = A.vertices[0], B = A.vertices[1];
    return !E || !B ? [] : [
      zA(E),
      zA(B),
      gQ(E, B)
    ];
  }
  if (VB(A))
    return [xt(A.center), ...ho(A.center, A.radius)];
  if (mB(A))
    return uo(A.center, A.radius, A.startAngle, A.endAngle);
  if (JB(A))
    return fo(A);
  if (OB(A))
    return lB(A.vertices, A.shape === !0);
  if (bB(A)) {
    const E = A.fitPoints?.length ? A.fitPoints : A.controlPoints;
    return !E || E.length < 2 ? E?.length ? [zA(E[0])] : [] : [zA(E[0]), zA(E[E.length - 1])];
  }
  if (jB(A))
    return A.points.map(zA);
  if (LB(A))
    return A.vertices.map(zA);
  if (je(A))
    return [To(A.position)];
  if (Xe(A) || zE(A))
    return lB(A.vertices, !1);
  if (WB(A)) {
    const E = [];
    for (const B of A.leaders ?? []) {
      for (const e of B.lines ?? [])
        E.push(...lB(e.vertices, !1));
      B.lastLeaderPoint && E.push(zA(B.lastLeaderPoint));
    }
    return E;
  }
  return [];
}
function zA(A) {
  return { type: "endpoint", point: { x: A.x, y: A.y, z: A.z ?? 0 } };
}
function To(A) {
  return { type: "node", point: { x: A.x, y: A.y, z: A.z ?? 0 } };
}
function xt(A) {
  return { type: "center", point: { x: A.x, y: A.y, z: A.z ?? 0 } };
}
function gQ(A, E) {
  return {
    type: "midpoint",
    point: {
      x: (A.x + E.x) / 2,
      y: (A.y + E.y) / 2,
      z: ((A.z ?? 0) + (E.z ?? 0)) / 2
    }
  };
}
function lB(A, E) {
  const B = A.length;
  if (B === 0) return [];
  const e = [];
  for (const g of A) e.push(zA(g));
  const t = E ? B : B - 1;
  for (let g = 0; g < t; g++) {
    const M = A[g], Q = A[(g + 1) % B];
    (M.bulge ?? 0) === 0 && e.push(gQ(M, Q));
  }
  return e;
}
function ho(A, E) {
  const B = A.z ?? 0;
  return [
    { type: "quadrant", point: { x: A.x + E, y: A.y, z: B } },
    { type: "quadrant", point: { x: A.x, y: A.y + E, z: B } },
    { type: "quadrant", point: { x: A.x - E, y: A.y, z: B } },
    { type: "quadrant", point: { x: A.x, y: A.y - E, z: B } }
  ];
}
const xA = Math.PI * 2;
function uo(A, E, B, e) {
  const t = A.z ?? 0, g = NB(B), M = NB(e), Q = g === M ? xA : (M - g + xA) % xA, s = [xt(A)];
  s.push(zA(mg(A, E, g, t))), s.push(zA(mg(A, E, M, t))), s.push({ type: "midpoint", point: Vg(A, E, g + Q / 2, t) });
  for (const r of [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2]) {
    const w = (r - g + xA) % xA;
    w > 0 && w < Q && s.push({ type: "quadrant", point: Vg(A, E, r, t) });
  }
  return s;
}
function fo(A) {
  const E = A.center, B = E.z ?? 0, e = A.majorAxisEndPoint.x, t = A.majorAxisEndPoint.y, g = A.axisRatio || 1, M = -t * g, Q = e * g, s = (o) => ({
    x: E.x + Math.cos(o) * e + Math.sin(o) * M,
    y: E.y + Math.cos(o) * t + Math.sin(o) * Q,
    z: B
  }), r = NB(A.startAngle), w = NB(A.endAngle), c = r === w || Math.abs((w - r) % xA) < 1e-9, n = c ? xA : (w - r + xA) % xA, a = [xt(E)];
  c || (a.push({ type: "endpoint", point: s(r) }), a.push({ type: "endpoint", point: s(w) }));
  for (const o of [0, Math.PI / 2, Math.PI, 3 * Math.PI / 2]) {
    const D = (o - r + xA) % xA;
    (c || D >= 0 && D <= n) && a.push({ type: "quadrant", point: s(o) });
  }
  return a;
}
function mg(A, E, B, e) {
  return { x: A.x + E * Math.cos(B), y: A.y + E * Math.sin(B), z: e };
}
function Vg(A, E, B, e) {
  return { x: A.x + E * Math.cos(B), y: A.y + E * Math.sin(B), z: e };
}
function NB(A) {
  let E = A % xA;
  return E < 0 && (E += xA), E;
}
function Uo(A, E, B) {
  if (!E || E.length === 0) return null;
  const e = B?.originOffset, t = new I.Vector3(-(e?.x ?? 0), -(e?.y ?? 0), -(e?.z ?? 0)), g = new I.Box3();
  let M = !1;
  for (const w of E) {
    const c = A.byHandle.get(w);
    if (c)
      for (const n of c)
        g.union(n.bbox.clone().translate(t)), M = !0;
  }
  if (!M || g.isEmpty()) return null;
  const Q = B?.paddingRatio ?? 0.2, s = g.getSize(new I.Vector3()), r = Math.max(s.x, s.y, 1) * Q;
  return g.expandByScalar(r), g;
}
function yi(A, E, B) {
  if (!E) return null;
  const e = B?.caseSensitive ?? !0, t = e ? E : E.toLowerCase(), g = [];
  for (const M of A.entries)
    (e ? M.layer : M.layer.toLowerCase()) === t && g.push(M.handle);
  return g.length === 0 ? null : Uo(A, g, B);
}
function Si(A, E, B) {
  const e = E?.trim();
  if (!e) return [];
  const t = zo(e, B), g = Qe(A), M = [];
  for (const [Q, s] of g) {
    const r = uB(s);
    r && t(r) && M.push(Q);
  }
  return M;
}
function zo(A, E) {
  if (E?.regex) {
    const e = new RegExp(A, E.caseSensitive ? "" : "i");
    return (t) => e.test(t);
  }
  if (E?.caseSensitive)
    return (e) => e.includes(A);
  const B = A.toLowerCase();
  return (e) => e.toLowerCase().includes(B);
}
function pi(A, E, B) {
  const e = E?.trim();
  if (!e) return [];
  const t = B?.caseSensitive ?? !0, g = t ? e : e.toLowerCase(), M = Qe(A), Q = [];
  for (const [s, r] of M) {
    const w = r.layer;
    if (!w) continue;
    (t ? w : w.toLowerCase()) === g && Q.push(s);
  }
  return Q;
}
function Pi(A, E) {
  const B = Array.isArray(E) ? E : [E], e = /* @__PURE__ */ new Set();
  for (const M of B)
    if (M && typeof M == "string") {
      const Q = M.trim();
      Q && e.add(Q.toUpperCase());
    }
  if (e.size === 0) return [];
  const t = Qe(A), g = [];
  for (const [M, Q] of t)
    e.has(Q.type) && g.push(M);
  return g;
}
function vi(A, E, B = {}) {
  const e = B.mode ?? "crossing", t = B.granularity ?? "aggregate", g = [];
  for (const M of A.entries) {
    if (t === "aggregate") {
      if (Yo(M)) continue;
    } else if (M.childIds) continue;
    const Q = M.bbox;
    e === "window" ? Q.min.x >= E.minX && Q.max.x <= E.maxX && Q.min.y >= E.minY && Q.max.y <= E.maxY && g.push(M) : Q.max.x >= E.minX && Q.min.x <= E.maxX && Q.max.y >= E.minY && Q.min.y <= E.maxY && g.push(M);
  }
  return g;
}
function Yo(A) {
  return A.id.includes("@") && !A.childIds;
}
function Ni(A) {
  const E = [], B = Qe(A);
  for (const e of A.entities ?? []) {
    const t = OE(e.handle);
    if (t)
      switch (e.type) {
        case "MULTILEADER":
        case "MLEADER": {
          const g = e.text;
          g && E.push({
            id: `mleader:${t}`,
            kind: "mleader",
            primary: t,
            members: [t],
            text: g,
            source: "inline"
          });
          break;
        }
        case "LEADER": {
          const g = OE(
            e.annotationHandle
          ), M = g ? B.get(g) : void 0;
          g && M && E.push({
            id: `leader:${t}`,
            kind: "leader",
            primary: t,
            members: [t, g],
            text: uB(M),
            source: "handle-ref"
          });
          break;
        }
        case "INSERT": {
          const g = e.attribs ?? [], M = [t], Q = [];
          for (const s of g) {
            const r = OE(s.handle);
            r && M.push(r);
            const w = uB(s);
            w && Q.push(w);
          }
          M.length > 1 && E.push({
            id: `block-attribs:${t}`,
            kind: "block-attribs",
            primary: t,
            members: M,
            text: Q.length > 0 ? Q.join(" ") : void 0,
            source: "attribs"
          });
          break;
        }
        case "DIMENSION": {
          const g = uB(e), M = e.actualMeasurement, Q = g && g.length > 0 && g !== "<>" ? g : M != null ? String(M) : void 0;
          E.push({
            id: `dimension:${t}`,
            kind: "dimension",
            primary: t,
            members: [t],
            text: Q,
            source: "inline"
          });
          break;
        }
      }
  }
  for (const e of Object.values(A.objects?.groups ?? {})) {
    const t = OE(e.handle);
    if (!t) continue;
    const g = [];
    for (const M of e.entityHandles) {
      const Q = OE(M);
      Q && B.has(Q) && g.push(Q);
    }
    g.length !== 0 && E.push({
      id: `group:${t}`,
      kind: "group",
      primary: t,
      members: g,
      text: e.name,
      source: "group-dict"
    });
  }
  return E;
}
function OE(A) {
  return A == null ? null : typeof A == "string" ? A : A.toString(16).toUpperCase();
}
function Hi() {
  let A = !1;
  const E = (g, M) => {
    if (g.isEmpty()) {
      M.position.set(0, 0, Ut), M.zoom = 1, M.updateProjectionMatrix();
      return;
    }
    const Q = g.getCenter(new I.Vector3()), s = g.getSize(new I.Vector3());
    M.position.set(Q.x, Q.y, Ut), M.lookAt(Q.x, Q.y, 0);
    const r = M.top - M.bottom, c = (M.right - M.left) / (s.x * zt), n = r / (s.y * zt);
    M.zoom = Math.min(c, n), M.updateProjectionMatrix();
  };
  return {
    fitCameraToBox: E,
    fitCameraToObject: (g, M) => {
      E(new I.Box3().setFromObject(g), M);
    },
    handleResize: (g, M, Q, s, r) => {
      A || (A = !0, requestAnimationFrame(() => {
        if (A = !1, !M || !Q || !s)
          return;
        const w = g.clientWidth, c = g.clientHeight;
        if (w <= 0 || c <= 0)
          return;
        const n = w / c, a = 100;
        M.left = a * n / -2, M.right = a * n / 2, M.top = a / 2, M.bottom = a / -2, M.updateProjectionMatrix(), Q.setSize(w, c), r ? r(w, c) : Q.render(s, M);
      }));
    },
    resetResizing: () => {
      A = !1;
    }
  };
}
const ko = !1, Go = 0.05, yo = 1e-5, So = 1e3, po = 1, Po = 1, vo = {
  LEFT: I.MOUSE.PAN,
  MIDDLE: I.MOUSE.PAN,
  RIGHT: I.MOUSE.PAN
};
function No() {
  let A = null;
  return {
    initControls: (Q, s) => (A = new FQ(Q, s), A.enableDamping = ko, A.dampingFactor = Go, A.minZoom = yo, A.maxZoom = So, A.panSpeed = po, A.zoomSpeed = Po, A.mouseButtons = vo, A.enableRotate = !1, A.enablePan = !0, A.enableZoom = !0, A.minPolarAngle = Math.PI / 2, A.maxPolarAngle = Math.PI / 2, A.screenSpacePanning = !0, A),
    getControls: () => A,
    setTarget: (Q, s, r) => {
      A && (A.target.set(Q, s, r), A.update());
    },
    saveState: () => {
      A && A.saveState();
    },
    resetCamera: () => {
      A && A.reset();
    },
    cleanup: () => {
      A && (A.dispose(), A = null);
    }
  };
}
const mi = No;
function Vi(A = {}) {
  const { aaMode: E = "msaa", alpha: B = !0, preserveDrawingBuffer: e = !0 } = A, t = new I.WebGLRenderer({
    antialias: E === "msaa",
    alpha: B,
    preserveDrawingBuffer: e
  });
  return t.sortObjects = !1, t;
}
function Ji(A) {
  const { aaMode: E, scene: B, camera: e, renderer: t } = A;
  if (E === "msaa" || E === "none")
    return { composer: null, taaPass: null };
  const g = new RQ(t);
  let M = null;
  if (E === "taa") {
    const Q = new CQ(B, e);
    Q.accumulate = !0, g.addPass(Q), M = Q;
  } else if (E === "ssaa")
    g.addPass(new DQ(B, e));
  else if (E === "smaa") {
    g.addPass(new ht(B, e));
    const Q = new lQ(), s = new I.Vector2();
    t.getSize(s);
    const r = t.getPixelRatio();
    Q.setSize(s.x * r, s.y * r), g.addPass(Q);
  } else if (E === "fxaa") {
    g.addPass(new ht(B, e));
    const Q = new xQ(), s = new I.Vector2();
    t.getSize(s);
    const r = t.getPixelRatio();
    Q.setSize(s.x * r, s.y * r), g.addPass(Q);
  }
  return g.addPass(new TQ()), { composer: g, taaPass: M };
}
function bi() {
  return typeof window > "u" || !window.matchMedia ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Ho(A, E) {
  const B = E.x - A.x, e = E.y - A.y, t = (E.z ?? 0) - (A.z ?? 0), g = Math.sqrt(B * B + e * e + t * t);
  return Number.isFinite(g) ? g : 0;
}
function mo(A) {
  const E = A.length;
  if (E < 3) return 0;
  let B = 0;
  for (let e = 0; e < E; e++) {
    const t = A[e], g = A[(e + 1) % E];
    if (!Number.isFinite(t.x) || !Number.isFinite(t.y)) return 0;
    B += t.x * g.y - g.x * t.y;
  }
  return B / 2;
}
function Oi(A) {
  return Math.abs(mo(A));
}
function ji(A) {
  const E = A.length;
  if (E < 2) return 0;
  let B = 0;
  for (let e = 0; e < E; e++) {
    const t = A[e], g = A[(e + 1) % E];
    if (!Number.isFinite(t.x) || !Number.isFinite(t.y)) return 0;
    B += Ho(t, g);
  }
  return B;
}
function xB(A, E, B) {
  return (E.x - A.x) * (B.y - A.y) - (E.y - A.y) * (B.x - A.x);
}
function Li(A) {
  const E = A.length;
  if (E < 4) return !1;
  for (let e = 0; e < E; e++)
    if (!Number.isFinite(A[e].x) || !Number.isFinite(A[e].y))
      return !1;
  const B = (e, t, g, M) => {
    const Q = xB(g, M, e), s = xB(g, M, t), r = xB(e, t, g), w = xB(e, t, M);
    return (Q > 0 && s < 0 || Q < 0 && s > 0) && (r > 0 && w < 0 || r < 0 && w > 0);
  };
  for (let e = 0; e < E; e++) {
    const t = A[e], g = A[(e + 1) % E];
    for (let M = e + 2; M < E; M++) {
      if (e === 0 && M === E - 1) continue;
      const Q = A[M], s = A[(M + 1) % E];
      if (B(t, g, Q, s)) return !0;
    }
  }
  return !1;
}
function Wi(A, E, B) {
  const e = E.x - A.x, t = E.y - A.y, g = (E.z ?? 0) - (A.z ?? 0), M = B.x - A.x, Q = B.y - A.y, s = (B.z ?? 0) - (A.z ?? 0), r = Math.sqrt(e * e + t * t + g * g), w = Math.sqrt(M * M + Q * Q + s * s);
  if (r === 0 || w === 0) return 0;
  const c = (e * M + t * Q + g * s) / (r * w), n = c < -1 ? -1 : c > 1 ? 1 : c, a = Math.acos(n);
  return Number.isFinite(a) ? a : 0;
}
function Xi(A, E, B) {
  const e = E.x - A.x, t = E.y - A.y, g = B.x - A.x, M = B.y - A.y;
  if (!Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(g) || !Number.isFinite(M) || e === 0 && t === 0 || g === 0 && M === 0) return 0;
  const Q = Math.PI * 2, r = ((Math.atan2(M, g) - Math.atan2(t, e)) % Q + Q) % Q;
  return Number.isFinite(r) ? r : 0;
}
function Ki(A) {
  return A * 180 / Math.PI;
}
function Zi(A) {
  return A * Math.PI / 180;
}
const Vo = /[-_]/, Jo = 2;
function bo(A) {
  return typeof A == "string" ? A : A.name;
}
function Oo(A, E) {
  let B;
  if (typeof E == "string")
    B = E.length === 0 ? -1 : A.indexOf(E);
  else {
    const t = (E.global || E.sticky ? new RegExp(E.source, E.flags.replace(/[gy]/g, "")) : E).exec(A);
    B = t ? t.index : -1;
  }
  return B > 0 ? A.slice(0, B) : "";
}
function qi(A, E) {
  if (!A || A.length === 0) return [];
  const B = E?.separator ?? Vo, e = Math.max(1, E?.minGroupSize ?? Jo), t = /* @__PURE__ */ new Map(), g = new Array(A.length);
  for (let r = 0; r < A.length; r++) {
    const w = Oo(bo(A[r]), B);
    g[r] = w, w !== "" && t.set(w, (t.get(w) ?? 0) + 1);
  }
  const M = /* @__PURE__ */ new Map(), Q = [];
  for (let r = 0; r < A.length; r++) {
    const w = g[r];
    if (w !== "" && (t.get(w) ?? 0) >= e) {
      let n = M.get(w);
      n || (n = { prefix: w, layers: [] }, M.set(w, n)), n.layers.push(A[r]);
    } else
      Q.push(A[r]);
  }
  const s = Array.from(M.values());
  return s.sort((r, w) => r.prefix < w.prefix ? -1 : r.prefix > w.prefix ? 1 : 0), Q.length > 0 && s.push({ prefix: "", layers: Q }), s;
}
export {
  fB as ACI7_COLOR,
  Jg as ACI_PALETTE,
  ci as ANGLE_ARC_MAX_PX,
  wi as ANGLE_ARC_MIN_PX,
  ni as ANGLE_ARC_RADIUS_FRACTION,
  ai as ANGLE_ARC_SEGMENTS_PER_TURN,
  Ke as ARROW_BASE_WIDTH_DIVISOR,
  KB as ARROW_SIZE,
  PQ as AUTO_LTSCALE_DIVISOR,
  vQ as AUTO_LTSCALE_MIN_EXTENT,
  Fi as CAMERA_FAR_PLANE,
  Ut as CAMERA_INITIAL_Z_POSITION,
  Ii as CAMERA_NEAR_PLANE,
  zt as CAMERA_PADDING,
  GQ as CATMULL_ROM_SEGMENTS_MULTIPLIER,
  WA as CIRCLE_SEGMENTS,
  ti as CLICK_DISTANCE_THRESHOLD_PX,
  Di as DEFAULT_ENTITY_COLOR,
  li as DEFAULT_ENTITY_COLOR_DARK,
  qB as DEGREES_TO_RADIANS_DIVISOR,
  YQ as DIM_TEXT_DECIMAL_PLACES,
  zQ as DIM_TEXT_GAP,
  SE as DIM_TEXT_GAP_MULTIPLIER,
  XB as DIM_TEXT_HEIGHT,
  Mi as DOUBLE_CLICK_DISTANCE_PX,
  gi as DOUBLE_CLICK_MS,
  q as EPSILON,
  Ze as EXTENSION_LINE_DASH_SIZE,
  _e as EXTENSION_LINE_EXTENSION,
  qe as EXTENSION_LINE_GAP_SIZE,
  Xg as LINETYPE_DOT_SIZE,
  pQ as MAX_HATCH_LINES_PER_PATTERN,
  Yt as MAX_HATCH_SEGMENTS,
  NQ as MAX_LINETYPE_REPETITIONS,
  oi as MEASUREMENT_OVERLAY_RENDER_ORDER,
  gE as MIN_ARC_SEGMENTS,
  yQ as MIN_CATMULL_ROM_SEGMENTS,
  dQ as MIN_NURBS_SEGMENTS,
  St as MaterialCacheStore,
  kQ as NURBS_SEGMENTS_MULTIPLIER,
  Qi as ORIGIN_SNAP_RADIUS_PX,
  ZB as OUTSIDE_ARROW_TAIL_RATIO,
  Wg as OUTSIDE_ARROW_THRESHOLD_RATIO,
  SQ as POINT_MARKER_SIZE,
  fe as POINT_SYMBOL_DEFAULT_SIZE,
  re as POINT_SYMBOL_SEGMENTS,
  Ri as SCENE_BG_COLOR,
  Ci as SCENE_BG_COLOR_DARK,
  ri as SNAP_MARKER_PX,
  ii as SNAP_OVERLAY_RENDER_ORDER,
  si as SNAP_TOLERANCE_PX,
  UQ as TEXT_HEIGHT,
  VQ as applyLinetypePattern,
  Ni as buildAssociations,
  Qe as buildEntityIndex,
  di as buildHighlightGeometry,
  Ui as buildPickingIndex,
  AI as collectDXFStatistics,
  BQ as computePolylinePoints,
  Ji as createComposer,
  zi as createPickingGroup,
  Vi as createRenderer,
  fi as createThreeObjectsFromDXF,
  Yi as disposePickingGroup,
  uB as extractEntityText,
  pi as findEntitiesByLayer,
  Si as findEntitiesByText,
  Pi as findEntitiesByType,
  vi as findEntriesInRect,
  Gi as findSnapPoint,
  ui as getDefaultFont,
  lo as getEntitySnapPoints,
  bg as getInsUnitsScale,
  hi as getSerifFont,
  EI as getUnitsToMmFactor,
  Uo as getZoomBox,
  yi as getZoomBoxForLayer,
  qi as groupLayersByPrefix,
  LB as is3DFaceEntity,
  mB as isArcEntity,
  Og as isAttdefEntity,
  aQ as isAttribEntity,
  VB as isCircleEntity,
  yE as isDimensionEntity,
  JB as isEllipseEntity,
  Le as isHatchEntity,
  tE as isInsertEntity,
  zE as isLeaderEntity,
  HB as isLineEntity,
  WB as isMLeaderEntity,
  Xe as isMlineEntity,
  je as isPointEntity,
  OB as isPolylineEntity,
  bi as isReducedMotionPreferred,
  jB as isSolidEntity,
  bB as isSplineEntity,
  YE as isTextEntity,
  KA as isThemeAdaptiveColor,
  cQ as isXlineEntity,
  Ra as loadDefaultFont,
  Ti as loadFont,
  Ca as loadSerifFont,
  Wi as measureAngle,
  Oi as measureArea,
  Xi as measureDirectedAngle,
  Ho as measureDistance,
  ji as measurePerimeter,
  mo as measureSignedArea,
  wQ as parseDxf,
  Bi as parseDxfAsync,
  Li as polygonSelfIntersects,
  xi as resolveAci7Hex,
  aA as resolveEntityColor,
  mA as resolveEntityLinetype,
  kt as resolveThemeColor,
  _B as rgbNumberToHex,
  mQ as scalePattern,
  ki as setPickingGroupDebug,
  ei as terminateParserWorker,
  Ki as toDegrees,
  Zi as toRadians,
  Hi as useCamera,
  No as useControls,
  mi as useOrbitControls
};
